export default [
    {"value": "阿拉尔津汇村镇银行", "abbreviationName": "阿拉尔津汇村镇银行", "code": "ALEJHCUNZB"}, {
        "value": "阿拉善农村商业银行",
        "abbreviationName": "阿拉善农商",
        "code": "ALSRCB"
    }, {"value": "阿拉善左旗方大村镇银行", "abbreviationName": "阿拉善左旗方大村镇银行", "code": "ALSZQFDCUNZB"}, {
        "value": "阿拉善左旗黄河村镇银行",
        "abbreviationName": "阿拉善左旗黄河村镇银行",
        "code": "ALSZQHHCUNZB"
    }, {"value": "埃及国民银行", "abbreviationName": "埃及国民", "code": "NBE"}, {
        "value": "安达幸福村镇银行",
        "abbreviationName": "安达幸福村镇银行",
        "code": "ADXFCUNZB"
    }, {"value": "安国中成村镇银行", "abbreviationName": "安国中成村镇银行", "code": "AGZCCUNZB"}, {
        "value": "安徽巢湖扬子村镇银行",
        "abbreviationName": "安徽巢湖扬子村镇银行",
        "code": "AHCHYZCUNZB"
    }, {"value": "安徽枞阳农村商业银行", "abbreviationName": "安徽枞阳农商", "code": "AHZYRCB"}, {
        "value": "安徽当涂新华村镇银行",
        "abbreviationName": "安徽当涂新华村镇银行",
        "code": "AHDTXHCUNZB"
    }, {"value": "安徽砀山农村商业银行", "abbreviationName": "安徽砀山农商", "code": "AHDSRCB"}, {
        "value": "安徽定远民丰村镇银行",
        "abbreviationName": "安徽定远民丰村镇银行",
        "code": "AHDYMFCUNZB"
    }, {"value": "安徽定远农村商业银行", "abbreviationName": "安徽定远农商", "code": "AHDYRCB"}, {
        "value": "安徽东至农村商业银行",
        "abbreviationName": "安徽东至农商",
        "code": "AHDZRCB"
    }, {"value": "安徽东至扬子村镇银行", "abbreviationName": "安徽东至扬子村镇银行", "code": "AHDZYZCUNZB"}, {
        "value": "安徽繁昌农村商业银行",
        "abbreviationName": "安徽繁昌农商",
        "code": "AHFCRCB"
    }, {"value": "安徽肥东湖商村镇银行", "abbreviationName": "安徽肥东湖商村镇银行", "code": "AHFDHSCUNZB"}, {
        "value": "安徽肥东农村商业银行",
        "abbreviationName": "安徽肥东农商",
        "code": "AHFDRCB"
    }, {"value": "安徽肥西农村商业银行", "abbreviationName": "安徽肥西农商", "code": "AHFXRCB"}, {
        "value": "安徽肥西石银村镇银行",
        "abbreviationName": "安徽肥西石银村镇银行",
        "code": "AHFXSYCUNZB"
    }, {"value": "安徽凤台农村商业银行", "abbreviationName": "安徽凤台农商", "code": "AHFTRCB"}, {
        "value": "安徽凤台通商村镇银行",
        "abbreviationName": "安徽凤台通商村镇银行",
        "code": "AHFTTSCUNZB"
    }, {"value": "安徽凤阳利民村镇银行", "abbreviationName": "安徽凤阳利民村镇银行", "code": "AHFYLMCUNZB"}, {
        "value": "安徽凤阳农村商业银行",
        "abbreviationName": "安徽凤阳农商",
        "code": "AHFYRCB"
    }, {"value": "安徽阜南农村商业银行", "abbreviationName": "安徽阜南农商", "code": "AHFNRCB"}, {
        "value": "安徽固镇农村商业银行",
        "abbreviationName": "安徽固镇农商",
        "code": "AHGZRCB"
    }, {"value": "安徽固镇新淮河村镇银行", "abbreviationName": "安徽固镇新淮河村镇银行", "code": "AHGZXHCUNZB"}, {
        "value": "安徽广德农村商业银行",
        "abbreviationName": "安徽广德农商",
        "code": "AHGDRCB"
    }, {"value": "安徽广德扬子村镇银行", "abbreviationName": "安徽广德扬子村镇银行", "code": "AHGDYZCUNZB"}, {
        "value": "安徽含山农村商业银行",
        "abbreviationName": "安徽含山农商",
        "code": "AHHSRCB"
    }, {"value": "安徽和县农村商业银行", "abbreviationName": "安徽和县农商", "code": "AHHXRCB"}, {
        "value": "安徽和县新华村镇银行",
        "abbreviationName": "安徽和县新华村镇银行",
        "code": "AHHXXHCUNZB"
    }, {"value": "安徽怀宁江淮村镇银行", "abbreviationName": "安徽怀宁江淮村镇银行", "code": "AHHNJHCUNZB"}, {
        "value": "安徽怀宁农村商业银行",
        "abbreviationName": "安徽怀宁农商",
        "code": "AHHNRCB"
    }, {"value": "安徽怀远本富村镇银行", "abbreviationName": "安徽怀远本富村镇银行", "code": "AHHYBFCUNZB"}, {
        "value": "安徽怀远农村商业银行",
        "abbreviationName": "安徽怀远农商",
        "code": "AHHYRCB"
    }, {"value": "安徽黄山金桥村镇银行", "abbreviationName": "安徽黄山金桥村镇银行", "code": "AHHSJQCUNZB"}, {
        "value": "安徽徽州铜源村镇银行",
        "abbreviationName": "安徽徽州铜源村镇银行",
        "code": "AHHZTYCUNZB"
    }, {"value": "安徽霍邱联合村镇银行", "abbreviationName": "安徽霍邱联合村镇银行", "code": "AHHQLHCUNZB"}, {
        "value": "安徽霍邱农村商业银行",
        "abbreviationName": "安徽霍邱农商",
        "code": "AHQHRCB"
    }, {"value": "安徽霍山联合村镇银行", "abbreviationName": "安徽霍山联合村镇银行", "code": "AHHSLHCUNZB"}, {
        "value": "安徽霍山农村商业银行",
        "abbreviationName": "安徽霍山农商",
        "code": "AHHUOSRCB"
    }, {"value": "安徽绩溪农村商业银行", "abbreviationName": "安徽绩溪农商", "code": "AHJXIRCB"}, {
        "value": "安徽界首农村商业银行",
        "abbreviationName": "安徽界首农商",
        "code": "AHJSRCB"
    }, {"value": "安徽金寨江淮村镇银行", "abbreviationName": "安徽金寨江淮村镇银行", "code": "AHJZJHCUNZB"}, {
        "value": "安徽金寨农村商业银行",
        "abbreviationName": "安徽金寨农商",
        "code": "AHJZRCB"
    }, {"value": "安徽泾县农村商业银行", "abbreviationName": "安徽泾县农商", "code": "AHJXRCB"}, {
        "value": "安徽泾县铜源村镇银行",
        "abbreviationName": "安徽泾县铜源村镇银行",
        "code": "AHZXTYCUNZB"
    }, {"value": "安徽旌德农村商业银行", "abbreviationName": "安徽旌德农商", "code": "AHJDRCB"}, {
        "value": "安徽来安农村商业银行",
        "abbreviationName": "安徽来安农商",
        "code": "AHLARCB"
    }, {"value": "安徽郎溪农村商业银行", "abbreviationName": "安徽郎溪农商", "code": "AHLXRCB"}, {
        "value": "安徽郎溪新华村镇银行",
        "abbreviationName": "安徽郎溪新华村镇银行",
        "code": "AHLXXHCUNZB"
    }, {"value": "安徽利辛湖商村镇银行", "abbreviationName": "安徽利辛湖商村镇银行", "code": "AHLXHSCUNZB"}, {
        "value": "安徽利辛农村商业银行",
        "abbreviationName": "安徽利辛农商",
        "code": "AHLIXRCB"
    }, {"value": "安徽临泉农村商业银行", "abbreviationName": "安徽临泉农商", "code": "AHLQRCB"}, {
        "value": "安徽灵璧本富村镇银行",
        "abbreviationName": "安徽灵璧本富村镇银行",
        "code": "AHLZBFCUNZB"
    }, {"value": "安徽灵璧农村商业银行", "abbreviationName": "安徽灵璧农商", "code": "AHLBRCB"}, {
        "value": "安徽庐江农村商业银行",
        "abbreviationName": "安徽庐江农商",
        "code": "AHLJRCB"
    }, {"value": "安徽马鞍山农村商业银行", "abbreviationName": "安徽马鞍山农商", "code": "AHMASRCB"}, {
        "value": "安徽蒙城湖商村镇银行",
        "abbreviationName": "安徽蒙城湖商村镇银行",
        "code": "AHMCHSCUNZB"
    }, {"value": "安徽蒙城农村商业银行", "abbreviationName": "安徽蒙城农商", "code": "AHMCRCB"}, {
        "value": "安徽明光民丰村镇银行",
        "abbreviationName": "安徽明光民丰村镇银行",
        "code": "AHMGMFCUNZB"
    }, {"value": "安徽明光农村商业银行", "abbreviationName": "安徽明光农商", "code": "AHMGRCB"}, {
        "value": "安徽南陵农村商业银行",
        "abbreviationName": "安徽南陵农商",
        "code": "AHNLRCB"
    }, {"value": "安徽宁国农村商业银行", "abbreviationName": "安徽宁国农商", "code": "AHNGRCB"}, {
        "value": "安徽祁门农村商业银行",
        "abbreviationName": "安徽祁门农商",
        "code": "AHQMRCB"
    }, {"value": "安徽祁门铜源村镇银行", "abbreviationName": "安徽祁门铜源村镇银行", "code": "AHQMTYCUNZB"}, {
        "value": "安徽潜山江淮村镇银行",
        "abbreviationName": "安徽潜山江淮村镇银行",
        "code": "AHQSJHCUNZB"
    }, {"value": "安徽潜山农村商业银行", "abbreviationName": "安徽潜山农商", "code": "AHQSRCB"}, {
        "value": "安徽谯城湖商村镇银行",
        "abbreviationName": "安徽谯城湖商村镇银行",
        "code": "AHZCHSCUNZB"
    }, {"value": "安徽青阳九华村镇银行", "abbreviationName": "安徽青阳九华村镇银行", "code": "AHQYJHCUNZB"}, {
        "value": "安徽青阳农村商业银行",
        "abbreviationName": "安徽青阳农商",
        "code": "AHQYRCB"
    }, {"value": "安徽全椒农村商业银行", "abbreviationName": "安徽全椒农商", "code": "AHQJRCB"}, {
        "value": "安徽歙县嘉银村镇银行",
        "abbreviationName": "安徽歙县嘉银村镇银行",
        "code": "AHZXJYCUNZB"
    }, {"value": "安徽歙县农村商业银行", "abbreviationName": "安徽歙县农商", "code": "AHXIXRCB"}, {
        "value": "安徽省农村信用社联合社",
        "abbreviationName": "安徽农信社",
        "code": "AHNXS"
    }, {"value": "安徽石台农村商业银行", "abbreviationName": "安徽石台农商", "code": "AHSTRCB"}, {
        "value": "安徽石台扬子村镇银行",
        "abbreviationName": "安徽石台扬子村镇银行",
        "code": "AHSTYZCUNZB"
    }, {"value": "安徽寿县联合村镇银行", "abbreviationName": "安徽寿县联合村镇银行", "code": "AHSXLHCUNZB"}, {
        "value": "安徽寿县农村商业银行",
        "abbreviationName": "安徽寿县农商",
        "code": "AHSXRCB"
    }, {"value": "安徽舒城农村商业银行", "abbreviationName": "安徽舒城农商", "code": "AHSCRCB"}, {
        "value": "安徽舒城正兴村镇银行",
        "abbreviationName": "安徽舒城正兴村镇银行",
        "code": "AHSCZXCUNZB"
    }, {"value": "安徽泗县农村商业银行", "abbreviationName": "安徽泗县农商", "code": "AHSIXRCB"}, {
        "value": "安徽宿松民丰村镇银行",
        "abbreviationName": "安徽宿松民丰村镇银行",
        "code": "AHSSMFCUNZB"
    }, {"value": "安徽宿松农村商业银行", "abbreviationName": "安徽宿松农商", "code": "AHSSRCB"}, {
        "value": "安徽宿州淮海村镇银行",
        "abbreviationName": "安徽宿州淮海村镇银行",
        "code": "AHSZHHCUNZB"
    }, {"value": "安徽宿州农村商业银行", "abbreviationName": "安徽宿州农商", "code": "AHSZRCB"}, {
        "value": "安徽濉溪湖商村镇银行",
        "abbreviationName": "安徽濉溪湖商村镇银行",
        "code": "AHZXHSCUNZB"
    }, {"value": "安徽濉溪农村商业银行", "abbreviationName": "安徽濉溪农商", "code": "AHSXIRCB"}, {
        "value": "安徽太和农村商业银行",
        "abbreviationName": "安徽太和农商",
        "code": "AHTHRCB"
    }, {"value": "安徽太湖江淮村镇银行", "abbreviationName": "安徽太湖江淮村镇银行", "code": "AHTHJHCUNZB"}, {
        "value": "安徽太湖农村商业银行",
        "abbreviationName": "安徽太湖农商",
        "code": "AHTHURCB"
    }, {"value": "安徽天长农村商业银行", "abbreviationName": "安徽天长农商", "code": "AHTCRCB"}, {
        "value": "安徽桐城江淮村镇银行",
        "abbreviationName": "安徽桐城江淮村镇银行",
        "code": "AHTCJHCUNZB"
    }, {"value": "安徽桐城农村商业银行", "abbreviationName": "安徽桐城农商", "code": "AHTONGCRCB"}, {
        "value": "安徽铜陵铜源村镇银行",
        "abbreviationName": "安徽铜陵铜源村镇银行",
        "code": "AHTLTYCUNZB"
    }, {"value": "安徽望江农村商业银行", "abbreviationName": "安徽望江农商", "code": "AHWJRCB"}, {
        "value": "安徽涡阳湖商村镇银行",
        "abbreviationName": "安徽涡阳湖商村镇银行",
        "code": "AHWYHSCUNZB"
    }, {"value": "安徽涡阳农村商业银行", "abbreviationName": "安徽涡阳农商", "code": "AHWYRCB"}, {
        "value": "安徽无为农村商业银行",
        "abbreviationName": "安徽无为农商",
        "code": "AHWWRCB"
    }, {"value": "安徽五河农村商业银行", "abbreviationName": "安徽五河农商", "code": "AHWHRCB"}, {
        "value": "安徽五河永泰村镇银行",
        "abbreviationName": "安徽五河永泰村镇银行",
        "code": "AHWHYTCUNZB"
    }, {"value": "安徽萧县农村商业银行", "abbreviationName": "安徽萧县农商", "code": "AHXXRCB"}, {
        "value": "安徽新安银行",
        "abbreviationName": "安徽新安",
        "code": "AHXAYH"
    }, {"value": "安徽休宁大地村镇银行", "abbreviationName": "安徽休宁大地村镇银行", "code": "AHXNDDCUNZB"}, {
        "value": "安徽休宁农村商业银行",
        "abbreviationName": "安徽休宁农商",
        "code": "AHXNRCB"
    }, {"value": "安徽宣州湖商村镇银行", "abbreviationName": "安徽宣州湖商村镇银行", "code": "AHXZHSCUNZB"}, {
        "value": "安徽叶集农村商业银行",
        "abbreviationName": "安徽叶集农商",
        "code": "AHYJRCB"
    }, {"value": "安徽黟县农村商业银行", "abbreviationName": "安徽黟县农商", "code": "AHYXRCB"}, {
        "value": "安徽黟县新淮河村镇银行",
        "abbreviationName": "安徽黟县新淮河村镇银行",
        "code": "AHZXXHHCUNZB"
    }, {"value": "安徽颍上农村商业银行", "abbreviationName": "安徽颍上农商", "code": "AHYSRCB"}, {
        "value": "安徽裕安盛平村镇银行",
        "abbreviationName": "安徽裕安盛平村镇银行",
        "code": "AHYASPCUNZB"
    }, {"value": "安徽岳西湖商村镇银行", "abbreviationName": "安徽岳西湖商村镇银行", "code": "AHYXHSCUNZB"}, {
        "value": "安徽岳西农村商业银行",
        "abbreviationName": "安徽岳西农商",
        "code": "AHYXIRCB"
    }, {"value": "安徽长丰科源村镇银行", "abbreviationName": "安徽长丰科源村镇银行", "code": "AHCFKYCUNZB"}, {
        "value": "安徽长丰农村商业银行",
        "abbreviationName": "安徽长丰农商",
        "code": "AHCFRCB"
    }, {"value": "安康农村商业银行", "abbreviationName": "安康农商", "code": "AKRCB"}, {
        "value": "安龙兴龙村镇银行",
        "abbreviationName": "安龙兴龙村镇银行",
        "code": "ALXLCUNZB"
    }, {"value": "安陆楚农商村镇银行", "abbreviationName": "安陆楚农商村镇银行", "code": "ALCNSCUNZB"}, {
        "value": "安平惠民村镇银行",
        "abbreviationName": "安平惠民村镇银行",
        "code": "APHMCUNZB"
    }, {"value": "安庆农村商业银行", "abbreviationName": "安庆农商", "code": "AQRCB"}, {
        "value": "安丘北海村镇银行",
        "abbreviationName": "安丘北海村镇银行",
        "code": "AQBHCUNZB"
    }, {"value": "安塞农银村镇银行", "abbreviationName": "安塞农银村镇银行", "code": "ASNYCUNZB"}, {
        "value": "安顺农村商业银行",
        "abbreviationName": "安顺农商",
        "code": "ASRCB"
    }, {"value": "安顺西航南马村镇银行", "abbreviationName": "安顺西航南马村镇银行", "code": "ASXHNMCUNZB"}, {
        "value": "安顺西秀富民村镇银行",
        "abbreviationName": "安顺西秀富民村镇银行",
        "code": "ASXXFMCUNZB"
    }, {"value": "安图农商村镇银行", "abbreviationName": "安图农商村镇银行", "code": "ATNSCUNZB"}, {
        "value": "安溪民生村镇银行",
        "abbreviationName": "安溪民生村镇银行",
        "code": "AXMSCUNZB"
    }, {"value": "安新大商村镇银行", "abbreviationName": "安新大商村镇银行", "code": "AXDSCUNZB"}, {
        "value": "安阳珠江村镇银行",
        "abbreviationName": "安阳珠江村镇银行",
        "code": "AYZJCUNZB"
    }, {"value": "安义融兴村镇银行", "abbreviationName": "安义融兴村镇银行", "code": "AYRXCUNZB"}, {
        "value": "鞍山农村商业银行",
        "abbreviationName": "鞍山农商",
        "code": "ASHANRCB"
    }, {"value": "鞍山银行", "abbreviationName": "鞍山", "code": "ASYH"}, {
        "value": "敖汉惠农村镇银行",
        "abbreviationName": "敖汉惠农村镇银行",
        "code": "AHHNCUNZB"
    }, {"value": "奥地利奥合国际银行", "abbreviationName": "奥地利奥合国际", "code": "RBIAG"}, {
        "value": "澳大利亚和新西兰银行集团",
        "abbreviationName": "澳大利亚和新西兰集团",
        "code": "ADLYHXXL"
    }, {"value": "澳大利亚西太平洋银行", "abbreviationName": "澳大利亚西太平洋", "code": "WESTPAC"}, {
        "value": "澳门国际银行",
        "abbreviationName": "澳门国际",
        "code": "LUSOBANK"
    }, {"value": "澳洲联邦银行", "abbreviationName": "澳洲联邦", "code": "CBA"}, {
        "value": "巴基斯坦哈比银行",
        "abbreviationName": "巴基斯坦哈比",
        "code": "HBL"
    }, {"value": "巴彦淖尔河套农村商业银行", "abbreviationName": "巴彦淖尔河套农商", "code": "BYNEHTRCB"}, {
        "value": "巴彦淖尔市临河黄河村镇银行",
        "abbreviationName": "巴彦淖尔市临河黄河村镇银行",
        "code": "BYNESLHHHCUNZB"
    }, {"value": "巴彦淖尔市乌拉特村镇银行", "abbreviationName": "巴彦淖尔市乌拉特村镇银行", "code": "BYNESWLTCUNZB"}, {
        "value": "巴彦融兴村镇银行",
        "abbreviationName": "巴彦融兴村镇银行",
        "code": "BYRXCUNZB"
    }, {"value": "巴中农村商业银行", "abbreviationName": "巴中农商", "code": "BZRCB"}, {
        "value": "霸州舜丰村镇银行",
        "abbreviationName": "霸州舜丰村镇银行",
        "code": "BZSFCUNZB"
    }, {"value": "白城农村商业银行", "abbreviationName": "白城农商", "code": "BCRCB"}, {
        "value": "白城洮北惠民村镇银行",
        "abbreviationName": "白城洮北惠民村镇银行",
        "code": "BCZBHMCUNZB"
    }, {"value": "白山浑江恒泰村镇银行", "abbreviationName": "白山浑江恒泰村镇银行", "code": "BSHJHTCUNZB"}, {
        "value": "白山江源汇恒村镇银行",
        "abbreviationName": "白山江源汇恒村镇银行",
        "code": "BSJYHHCUNZB"
    }, {"value": "白山江源农村商业银行", "abbreviationName": "白山江源农商", "code": "BSJYRCB"}, {
        "value": "百色靖西长江村镇银行",
        "abbreviationName": "百色靖西长江村镇银行",
        "code": "BSJXCJCUNZB"
    }, {"value": "百色右江华润村镇银行", "abbreviationName": "百色右江华润村镇银行", "code": "BSYJHRCUNZB"}, {
        "value": "柏乡融信村镇银行",
        "abbreviationName": "柏乡融信村镇银行",
        "code": "BXRXCUNZB"
    }, {"value": "拜泉融兴村镇银行", "abbreviationName": "拜泉融兴村镇银行", "code": "BQRXCUNZB"}, {
        "value": "蚌埠农村商业银行",
        "abbreviationName": "蚌埠农商",
        "code": "BBRCB"
    }, {"value": "包头农村商业银行", "abbreviationName": "包头农商", "code": "BTRCB"}, {
        "value": "包头青山河套村镇银行",
        "abbreviationName": "包头青山河套村镇银行",
        "code": "QSHTCUNZB"
    }, {"value": "包头市东河金谷村镇银行", "abbreviationName": "包头市东河金谷村镇银行", "code": "BTSDHJGCUNZB"}, {
        "value": "包头市高新银通村镇银行",
        "abbreviationName": "包头市高新银通村镇银行",
        "code": "BTSGXYTCUNZB"
    }, {"value": "包头市九原立农村镇银行", "abbreviationName": "包头市九原立农村镇银行", "code": "BTSJYLNCUNZB"}, {
        "value": "包头市昆都仑蒙银村镇银行",
        "abbreviationName": "包头市昆都仑蒙银村镇银行",
        "code": "BTSKDLMYCUNZB"
    }, {"value": "宝丰豫丰村镇银行", "abbreviationName": "宝丰豫丰村镇银行", "code": "BFYFCUNZB"}, {
        "value": "宝清广益村镇银行",
        "abbreviationName": "宝清广益村镇银行",
        "code": "BQGYCUNZB"
    }, {"value": "保德县慧融村镇银行", "abbreviationName": "保德县慧融村镇银行", "code": "BDXHRCUNZB"}, {
        "value": "保定满城区利丰村镇银行",
        "abbreviationName": "保定满城区利丰村镇银行",
        "code": "BDMCQLFCUNZB"
    }, {"value": "保定清苑区邢农商村镇银行", "abbreviationName": "保定清苑区邢农商村镇银行", "code": "BDQYQXNSCUNZB"}, {
        "value": "保定银行",
        "abbreviationName": "保定",
        "code": "BDYH"
    }, {"value": "保康楚农商村镇银行", "abbreviationName": "保康楚农商村镇银行", "code": "BKCNSCUNZB"}, {
        "value": "保山昌宁长江村镇银行",
        "abbreviationName": "保山昌宁长江村镇银行",
        "code": "BSCNCJCUNZB"
    }, {"value": "保山龙陵长江村镇银行", "abbreviationName": "保山龙陵长江村镇银行", "code": "BSLLCJCUNZB"}, {
        "value": "保山隆阳沪农商村镇银行",
        "abbreviationName": "保山隆阳沪农商村镇银行",
        "code": "BSLYHNSCUNZB"
    }, {"value": "保山施甸长江村镇银行", "abbreviationName": "保山施甸长江村镇银行", "code": "BSSDCJCUNZB"}, {
        "value": "北京昌平发展村镇银行",
        "abbreviationName": "北京昌平发展村镇银行",
        "code": "BJCPBSCUNZB"
    }, {"value": "北京大兴华夏村镇银行", "abbreviationName": "北京大兴华夏村镇银行", "code": "BJDXHXCUNZB"}, {
        "value": "北京大兴九银村镇银行",
        "abbreviationName": "北京大兴九银村镇银行",
        "code": "BJDXJYCUNZB"
    }, {"value": "北京房山沪农商村镇银行", "abbreviationName": "北京房山沪农商村镇银行", "code": "BJFSHNSCUNZB"}, {
        "value": "北京怀柔融兴村镇银行",
        "abbreviationName": "北京怀柔融兴村镇银行",
        "code": "BJHRRXCUNZB"
    }, {"value": "北京门头沟珠江村镇银行", "abbreviationName": "北京门头沟珠江村镇银行", "code": "BJMTGZJCUNZB"}, {
        "value": "北京密云汇丰村镇银行",
        "abbreviationName": "北京密云汇丰村镇银行",
        "code": "BJMYHFCUNZB"
    }, {"value": "北京农村商业银行", "abbreviationName": "北京农商", "code": "BRCB"}, {
        "value": "北京平谷新华村镇银行",
        "abbreviationName": "北京平谷新华村镇银行",
        "code": "BJPGXHCUNZB"
    }, {"value": "北京顺义银座村镇银行", "abbreviationName": "北京顺义银座村镇银行", "code": "SYYZCUNZB"}, {
        "value": "北京延庆村镇银行",
        "abbreviationName": "北京延庆村镇银行",
        "code": "BJYQCUNZB"
    }, {"value": "北京银行", "abbreviationName": "北京", "code": "BCCB"}, {
        "value": "北京中关村银行",
        "abbreviationName": "中关村",
        "code": "ZGCBANK"
    }, {"value": "北票盛都村镇银行", "abbreviationName": "北票盛都村镇银行", "code": "BPSDCUNZB"}, {
        "value": "北屯国民村镇银行",
        "abbreviationName": "北屯国民村镇银行",
        "code": "BTGMCUNZB"
    }, {"value": "本溪丰泰村镇银行", "abbreviationName": "本溪丰泰村镇银行", "code": "BXFTCUNZB"}, {
        "value": "本溪丰业村镇银行",
        "abbreviationName": "本溪丰业村镇银行",
        "code": "BXFYCUNZB"
    }, {"value": "本溪禾丰村镇银行", "abbreviationName": "本溪禾丰村镇银行", "code": "BXHFCUNZB"}, {
        "value": "本溪市商业银行",
        "abbreviationName": "本溪",
        "code": "BXSCCB"
    }, {"value": "本溪同盛村镇银行", "abbreviationName": "本溪同盛村镇银行", "code": "BXTSCUNZB"}, {
        "value": "比利时联合银行",
        "abbreviationName": "比利时联合",
        "code": "KBC"
    }, {"value": "毕节发展村镇银行", "abbreviationName": "毕节发展村镇银行", "code": "BJFZCUNZB"}, {
        "value": "宾阳北部湾村镇银行",
        "abbreviationName": "宾阳北部湾村镇银行",
        "code": "BYBBWCUNZB"
    }, {"value": "滨州河海村镇银行", "abbreviationName": "滨州河海村镇银行", "code": "BZHHCUNZB"}, {
        "value": "滨州农村商业银行",
        "abbreviationName": "滨州农商",
        "code": "BINZRCB"
    }, {"value": "亳州药都农村商业银行", "abbreviationName": "亳州药都农商", "code": "BZYDRCB"}, {
        "value": "博乐国民村镇银行",
        "abbreviationName": "博乐国民村镇银行",
        "code": "BLGMCUNZB"
    }, {"value": "渤海银行", "abbreviationName": "渤海", "code": "CBHB"}, {
        "value": "苍梧深通村镇银行",
        "abbreviationName": "苍梧深通村镇银行",
        "code": "CWSTCUNZB"
    }, {"value": "沧县吉银村镇银行", "abbreviationName": "沧县吉银村镇银行", "code": "CXJYCUNZB"}, {
        "value": "沧州海兴新华村镇银行",
        "abbreviationName": "沧州海兴新华村镇银行",
        "code": "CZHXXHCUNZB"
    }, {"value": "沧州市运河青隆村镇银行", "abbreviationName": "沧州市运河青隆村镇银行", "code": "CZSYHQLCUNZB"}, {
        "value": "沧州盐山新华村镇银行",
        "abbreviationName": "沧州盐山新华村镇银行",
        "code": "CZYSXHCUNZB"
    }, {"value": "沧州银行", "abbreviationName": "沧州", "code": "CZYH"}, {
        "value": "册亨富民村镇银行",
        "abbreviationName": "册亨富民村镇银行",
        "code": "CHFMCUNZB"
    }, {"value": "岑溪市北部湾村镇银行", "abbreviationName": "岑溪市北部湾村镇银行", "code": "ZXSBBWCUNZB"}, {
        "value": "茶陵浦发村镇银行",
        "abbreviationName": "茶陵浦发村镇银行",
        "code": "CLPFCUNZB"
    }, {"value": "察哈尔右翼前旗蒙银村镇银行", "abbreviationName": "察哈尔右翼前旗蒙银村镇银行", "code": "CHEYYQQMYCUNZB"}, {
        "value": "昌吉国民村镇银行",
        "abbreviationName": "昌吉国民村镇银行",
        "code": "CJGMCUNZB"
    }, {"value": "昌乐乐安村镇银行", "abbreviationName": "昌乐乐安村镇银行", "code": "CLLACUNZB"}, {
        "value": "昌黎家银村镇银行",
        "abbreviationName": "昌黎家银村镇银行",
        "code": "CLJYCUNZB"
    }, {"value": "昌图民祥村镇银行", "abbreviationName": "昌图民祥村镇银行", "code": "CTMXCUNZB"}, {
        "value": "昌邑北海村镇银行",
        "abbreviationName": "昌邑北海村镇银行",
        "code": "CYBHCUNZB"
    }, {"value": "常德农村商业银行", "abbreviationName": "常德农商", "code": "CDERCB"}, {
        "value": "常宁珠江村镇银行",
        "abbreviationName": "常宁珠江村镇银行",
        "code": "CNZJCUNZB"
    }, {"value": "常州新北中成村镇银行", "abbreviationName": "常州新北中成村镇银行", "code": "CZXBZCCUNZB"}, {
        "value": "常州钟楼长江村镇银行",
        "abbreviationName": "常州钟楼长江村镇银行",
        "code": "CZZLCJCUNZB"
    }, {"value": "巢湖农村商业银行", "abbreviationName": "巢湖农商", "code": "CHRCB"}, {
        "value": "朝阳柳城村镇银行",
        "abbreviationName": "朝阳柳城村镇银行",
        "code": "CYLCCUNZB"
    }, {"value": "朝阳银行", "abbreviationName": "朝阳", "code": "CYYH"}, {
        "value": "潮州潮安长江村镇银行",
        "abbreviationName": "潮州潮安长江村镇银行",
        "code": "CZCACJCUNZB"
    }, {"value": "郴州农村商业银行", "abbreviationName": "郴州农商", "code": "CZRCB"}, {
        "value": "成安齐鲁村镇银行",
        "abbreviationName": "成安齐鲁村镇银行",
        "code": "CAQLCUNZB"
    }, {"value": "成都农村商业银行", "abbreviationName": "成都农商", "code": "CDRCB"}, {
        "value": "成都青白江融兴村镇银行",
        "abbreviationName": "成都青白江融兴村镇银行",
        "code": "CDQBJRXCUNZB"
    }, {"value": "成都双流诚民村镇银行", "abbreviationName": "成都双流诚民村镇银行", "code": "CDSLCMCUNZB"}, {
        "value": "成都银行",
        "abbreviationName": "成都",
        "code": "CDYH"
    }, {"value": "承德县恒升村镇银行", "abbreviationName": "承德县恒升村镇银行", "code": "CDXHSCUNZB"}, {
        "value": "承德银行",
        "abbreviationName": "承德",
        "code": "CDBANK"
    }, {"value": "池州贵池民生村镇银行", "abbreviationName": "池州贵池民生村镇银行", "code": "CZGCMSCUNZB"}, {
        "value": "池州九华农村商业银行",
        "abbreviationName": "池州九华农商",
        "code": "CZJHRCB"
    }, {"value": "茌平沪农商村镇银行", "abbreviationName": "茌平沪农商村镇银行", "code": "CPHNSCUNZB"}, {
        "value": "赤城家银村镇银行",
        "abbreviationName": "赤城家银村镇银行",
        "code": "CCJYCUNZB"
    }, {"value": "赤峰市红山玉龙村镇银行", "abbreviationName": "赤峰市红山玉龙村镇银行", "code": "CFSHSYLCUNZB"}, {
        "value": "赤峰市松山立农村镇银行",
        "abbreviationName": "赤峰市松山立农村镇银行",
        "code": "CFSSSLNCUNZB"
    }, {"value": "赤峰市元宝山玉龙村镇银行", "abbreviationName": "赤峰市元宝山玉龙村镇银行", "code": "CFSYBSYLCUNZB"}, {
        "value": "赤峰松山农村商业银行",
        "abbreviationName": "赤峰松山农商",
        "code": "CFSSRCB"
    }, {"value": "赤峰元宝山农村商业银行", "abbreviationName": "赤峰元宝山农商", "code": "CFYBSRCB"}, {
        "value": "崇仁九银村镇银行",
        "abbreviationName": "崇仁九银村镇银行",
        "code": "CRJYCUNZB"
    }, {"value": "崇阳楚农商村镇银行", "abbreviationName": "崇阳楚农商村镇银行", "code": "CYCNSCUNZB"}, {
        "value": "崇义农村商业银行",
        "abbreviationName": "崇义农商",
        "code": "CYRCB"
    }, {"value": "崇州上银村镇银行", "abbreviationName": "崇州上银村镇银行", "code": "CZSYCUNZB"}, {
        "value": "崇左大新长江村镇银行",
        "abbreviationName": "崇左大新长江村镇银行",
        "code": "CZDXCJCUNZB"
    }, {"value": "滁州皖东农村商业银行", "abbreviationName": "滁州皖东农商", "code": "CZWDRCB"}, {
        "value": "楚雄红塔村镇银行",
        "abbreviationName": "楚雄红塔村镇银行",
        "code": "CXHTCUNZB"
    }, {"value": "创兴银行有限公司", "abbreviationName": "创兴", "code": "CXYHYXGS"}, {
        "value": "慈利沪农商村镇银行",
        "abbreviationName": "慈利沪农商村镇银行",
        "code": "CLHNSCUNZB"
    }, {"value": "慈溪民生村镇银行", "abbreviationName": "慈溪民生村镇银行", "code": "CXMSCUNZB"}, {
        "value": "磁县齐鲁村镇银行",
        "abbreviationName": "磁县齐鲁村镇银行",
        "code": "CXQLCUNZB"
    }, {"value": "枞阳泰业村镇银行", "abbreviationName": "枞阳泰业村镇银行", "code": "ZYTYCUNZB"}, {
        "value": "从江月明村镇银行",
        "abbreviationName": "从江月明村镇银行",
        "code": "CJYMCUNZB"
    }, {"value": "达尔罕茂明安联合旗蒙商村镇银行", "abbreviationName": "达尔罕茂明安联合旗蒙商村镇银行", "code": "DEHMMALHQBSCUNZB"}, {
        "value": "达州农村商业银行",
        "abbreviationName": "达州农商",
        "code": "DZRCB"
    }, {"value": "达州银行", "abbreviationName": "达州", "code": "DZYX"}, {
        "value": "大安惠民村镇银行",
        "abbreviationName": "大安惠民村镇银行",
        "code": "DAHMCUNZB"
    }, {"value": "大厂回族自治县新华村镇银行", "abbreviationName": "大厂回族自治县新华村镇银行", "code": "DCHZZZXXHCUNZB"}, {
        "value": "大城舜丰村镇银行",
        "abbreviationName": "大城舜丰村镇银行",
        "code": "DCSFCUNZB"
    }, {"value": "大方富民村镇银行", "abbreviationName": "大方富民村镇银行", "code": "DFFMCUNZB"}, {
        "value": "大丰银行",
        "abbreviationName": "大丰",
        "code": "DFYX"
    }, {"value": "大华银行（中国）有限公司", "abbreviationName": "大华", "code": "UOBCHINA"}, {
        "value": "大理宾川长江村镇银行",
        "abbreviationName": "大理宾川长江村镇银行",
        "code": "DLBCCJCUNZB"
    }, {"value": "大理洱源长江村镇银行", "abbreviationName": "大理洱源长江村镇银行", "code": "DLEYCJCUNZB"}, {
        "value": "大理古城中成村镇银行",
        "abbreviationName": "大理古城中成村镇银行",
        "code": "DLGCZCCUNZB"
    }, {"value": "大理巍山长江村镇银行", "abbreviationName": "大理巍山长江村镇银行", "code": "DLWSCJCUNZB"}, {
        "value": "大连保税区珠江村镇银行",
        "abbreviationName": "大连保税区珠江村镇银行",
        "code": "DLBSQZJCUNZB"
    }, {"value": "大连甘井子浦发村镇银行", "abbreviationName": "大连甘井子浦发村镇银行", "code": "DLGJZPFCUNZB"}, {
        "value": "大连金州联丰村镇银行",
        "abbreviationName": "大连金州联丰村镇银行",
        "code": "DLJZLFCUNZB"
    }, {"value": "大连经济技术开发区鑫汇村镇银行", "abbreviationName": "大连经济技术开发区鑫汇村镇银行", "code": "DLJJJSKFQZHCUNZB"}, {
        "value": "大连旅顺口蒙银村镇银行",
        "abbreviationName": "大连旅顺口蒙银村镇银行",
        "code": "DLLSKMYCUNZB"
    }, {"value": "大连农村商业银行", "abbreviationName": "大连农商", "code": "DLRCB"}, {
        "value": "大连普兰店汇丰村镇银行",
        "abbreviationName": "大连普兰店汇丰村镇银行",
        "code": "DLPLDHFCUNZB"
    }, {"value": "大连银行", "abbreviationName": "大连", "code": "DLYH"}, {
        "value": "大名恒升村镇银行",
        "abbreviationName": "大名恒升村镇银行",
        "code": "DMHSCUNZB"
    }, {"value": "大庆农村商业银行", "abbreviationName": "大庆农商", "code": "DQRCB"}, {
        "value": "大同农村商业银行",
        "abbreviationName": "大同农商",
        "code": "DTRCB"
    }, {"value": "大同市南郊区京都村镇银行", "abbreviationName": "大同市南郊区京都村镇银行", "code": "DTSNJQJDCUNZB"}, {
        "value": "大同银行",
        "abbreviationName": "大同",
        "code": "DTYH"
    }, {"value": "大洼恒丰村镇银行", "abbreviationName": "大洼恒丰村镇银行", "code": "DWHFCUNZB"}, {
        "value": "大悟楚农商村镇银行",
        "abbreviationName": "大悟楚农商村镇银行",
        "code": "DWCNSCUNZB"
    }, {"value": "大西洋银行", "abbreviationName": "大西洋", "code": "BNU"}, {
        "value": "大新银行（中国）有限公司",
        "abbreviationName": "大新",
        "code": "DAHSING"
    }, {"value": "大兴安岭农村商业银行", "abbreviationName": "大兴安岭农商", "code": "DXALRCB"}, {
        "value": "大邑交银兴民村镇银行",
        "abbreviationName": "大邑交银兴民村镇银行",
        "code": "DYJYXMCUNZB"
    }, {"value": "大众银行（香港）有限公司", "abbreviationName": "大众", "code": "DZYHXGYXGS"}, {
        "value": "代县泓都村镇银行",
        "abbreviationName": "代县泓都村镇银行",
        "code": "DXZDCUNZB"
    }, {"value": "丹东鼎安村镇银行", "abbreviationName": "丹东鼎安村镇银行", "code": "DDDACUNZB"}, {
        "value": "丹东鼎元村镇银行",
        "abbreviationName": "丹东鼎元村镇银行",
        "code": "DDDYCUNZB"
    }, {"value": "丹东福汇村镇银行", "abbreviationName": "丹东福汇村镇银行", "code": "DDFHCUNZB"}, {
        "value": "丹东农村商业银行",
        "abbreviationName": "丹东农商",
        "code": "DDRCB"
    }, {"value": "丹东银行", "abbreviationName": "丹东", "code": "DDYH"}, {
        "value": "丹江口楚农商村镇银行",
        "abbreviationName": "丹江口楚农商村镇银行",
        "code": "DJKCNSCUNZB"
    }, {"value": "丹寨富民村镇银行", "abbreviationName": "丹寨富民村镇银行", "code": "DZFMCUNZB"}, {
        "value": "德国北德意志州银行",
        "abbreviationName": "德国北德意志州",
        "code": "NORDLB"
    }, {"value": "德国商业银行", "abbreviationName": "德国", "code": "COMMERZBANK"}, {
        "value": "德宏芒市长江村镇银行",
        "abbreviationName": "德宏芒市长江村镇银行",
        "code": "DHMSCJCUNZB"
    }, {"value": "德惠敦银村镇银行", "abbreviationName": "德惠敦银村镇银行", "code": "DHDYCUNZB"}, {
        "value": "德江长征村镇银行",
        "abbreviationName": "德江长征村镇银行",
        "code": "DJCZCUNZB"
    }, {"value": "德庆华润村镇银行", "abbreviationName": "德庆华润村镇银行", "code": "DQHRCUNZB"}, {
        "value": "德兴蓝海村镇银行",
        "abbreviationName": "德兴蓝海村镇银行",
        "code": "DXLHCUNZB"
    }, {"value": "德阳农村商业银行", "abbreviationName": "德阳农商", "code": "DEYRCB"}, {
        "value": "德意志银行（中国）有限公司",
        "abbreviationName": "德意志",
        "code": "DB"
    }, {"value": "德州陵城农村商业银行", "abbreviationName": "德州陵城农商", "code": "DZLCRCB"}, {
        "value": "德州陵城圆融村镇银行",
        "abbreviationName": "德州陵城圆融村镇银行",
        "code": "DZLCYRCUNZB"
    }, {"value": "德州农村商业银行", "abbreviationName": "德州农商", "code": "DEZRCB"}, {
        "value": "德州银行",
        "abbreviationName": "德州",
        "code": "DZYH"
    }, {"value": "登封齐鲁村镇银行", "abbreviationName": "登封齐鲁村镇银行", "code": "DFQLCUNZB"}, {
        "value": "磴口蒙银村镇银行",
        "abbreviationName": "磴口蒙银村镇银行",
        "code": "ZKMYCUNZB"
    }, {"value": "第一商业银行", "abbreviationName": "第一", "code": "FIRSTBANK"}, {
        "value": "调兵山惠民村镇银行",
        "abbreviationName": "调兵山惠民村镇银行",
        "code": "DBSHMCUNZB"
    }, {"value": "定安合丰村镇银行", "abbreviationName": "定安合丰村镇银行", "code": "DAHFCUNZB"}, {
        "value": "定陶河海村镇银行",
        "abbreviationName": "定陶河海村镇银行",
        "code": "DTHHCUNZB"
    }, {"value": "定西农村商业银行", "abbreviationName": "定西农商", "code": "DXRCB"}, {
        "value": "定兴丰源村镇银行",
        "abbreviationName": "定兴丰源村镇银行",
        "code": "DXFYCUNZB"
    }, {"value": "定州中成村镇银行", "abbreviationName": "定州中成村镇银行", "code": "DZZCCUNZB"}, {
        "value": "东阿青隆村镇银行",
        "abbreviationName": "东阿青隆村镇银行",
        "code": "DAQLCUNZB"
    }, {"value": "东方汇理银行（中国）有限公司", "abbreviationName": "东方汇理", "code": "BI"}, {
        "value": "东方惠丰村镇银行",
        "abbreviationName": "东方惠丰村镇银行",
        "code": "DFHFCUNZB"
    }, {"value": "东丰吉银村镇银行", "abbreviationName": "东丰吉银村镇银行", "code": "DFJYCUNZB"}, {
        "value": "东港同合村镇银行",
        "abbreviationName": "东港同合村镇银行",
        "code": "DGTHCUNZB"
    }, {"value": "东莞常平新华村镇银行", "abbreviationName": "东莞常平新华村镇银行", "code": "DZCPXHCUNZB"}, {
        "value": "东莞大朗东盈村镇银行",
        "abbreviationName": "东莞大朗东盈村镇银行",
        "code": "DZDLDYCUNZB"
    }, {"value": "东莞厚街华业村镇银行", "abbreviationName": "东莞厚街华业村镇银行", "code": "DZHJHYCUNZB"}, {
        "value": "东莞虎门长江村镇银行",
        "abbreviationName": "东莞虎门长江村镇银行",
        "code": "DZHMCJCUNZB"
    }, {"value": "东莞黄江珠江村镇银行", "abbreviationName": "东莞黄江珠江村镇银行", "code": "DZHJZJCUNZB"}, {
        "value": "东莞农村商业银行",
        "abbreviationName": "东莞农商",
        "code": "DGRCB"
    }, {"value": "东莞银行", "abbreviationName": "东莞", "code": "DGYH"}, {
        "value": "东莞长安村镇银行",
        "abbreviationName": "东莞长安村镇银行",
        "code": "DZCACUNZB"
    }, {"value": "东光青隆村镇银行", "abbreviationName": "东光青隆村镇银行", "code": "DGQLCUNZB"}, {
        "value": "东辽农商村镇银行",
        "abbreviationName": "东辽农商村镇银行",
        "code": "DLNSCUNZB"
    }, {"value": "东宁润生村镇银行", "abbreviationName": "东宁润生村镇银行", "code": "DNRSCUNZB"}, {
        "value": "东平沪农商村镇银行",
        "abbreviationName": "东平沪农商村镇银行",
        "code": "DPHNSCUNZB"
    }, {"value": "东山润鑫村镇银行", "abbreviationName": "东山润鑫村镇银行", "code": "DSRZCUNZB"}, {
        "value": "东乌珠穆沁农信开元村镇银行",
        "abbreviationName": "东乌珠穆沁农信开元村镇银行",
        "code": "DWZMQNXKYCUNZB"
    }, {"value": "东兴国民村镇银行", "abbreviationName": "东兴国民村镇银行", "code": "DXGMCUNZB"}, {
        "value": "东亚银行（中国）有限公司",
        "abbreviationName": "东亚",
        "code": "HKBEA"
    }, {"value": "东营河口中成村镇银行", "abbreviationName": "东营河口中成村镇银行", "code": "DYHKZCCUNZB"}, {
        "value": "东营莱商村镇银行",
        "abbreviationName": "东营莱商村镇银行",
        "code": "DYLSCUNZB"
    }, {"value": "东营农村商业银行", "abbreviationName": "东营农商", "code": "DYRCB"}, {
        "value": "东营融和村镇银行",
        "abbreviationName": "东营融和村镇银行",
        "code": "DYRHCUNZB"
    }, {"value": "东营银行", "abbreviationName": "东营", "code": "DOYYH"}, {
        "value": "东源泰业村镇银行",
        "abbreviationName": "东源泰业村镇银行",
        "code": "DYTYCUNZB"
    }, {"value": "都昌九银村镇银行", "abbreviationName": "都昌九银村镇银行", "code": "DCJYCUNZB"}, {
        "value": "都江堰金都村镇银行",
        "abbreviationName": "都江堰金都村镇银行",
        "code": "DJYJDCUNZB"
    }, {"value": "都匀融通村镇银行", "abbreviationName": "都匀融通村镇银行", "code": "DYRTCUNZB"}, {
        "value": "独山富民村镇银行",
        "abbreviationName": "独山富民村镇银行",
        "code": "DSFMCUNZB"
    }, {"value": "杜尔伯特润生村镇银行", "abbreviationName": "杜尔伯特润生村镇银行", "code": "DEBTRSCUNZB"}, {
        "value": "敦化江南村镇银行",
        "abbreviationName": "敦化江南村镇银行",
        "code": "DHJNCUNZB"
    }, {"value": "敦煌市金盛村镇银行", "abbreviationName": "敦煌市金盛村镇银行", "code": "DHSJSCUNZB"}, {
        "value": "俄罗斯外贸银行",
        "abbreviationName": "俄罗斯外贸",
        "code": "VTB"
    }, {"value": "峨眉山中成村镇银行", "abbreviationName": "峨眉山中成村镇银行", "code": "EMSZCCUNZB"}, {
        "value": "鄂尔多斯农村商业银行",
        "abbreviationName": "鄂尔多斯农商",
        "code": "EEDSRCB"
    }, {"value": "鄂尔多斯市东胜蒙银村镇银行", "abbreviationName": "鄂尔多斯市东胜蒙银村镇银行", "code": "EEDSSDSMYCUNZB"}, {
        "value": "鄂尔多斯市罕台村镇银行",
        "abbreviationName": "鄂尔多斯市罕台村镇银行",
        "code": "EEDSSHTCUNZB"
    }, {"value": "鄂尔多斯市康巴什村镇银行", "abbreviationName": "鄂尔多斯市康巴什村镇银行", "code": "EEDSSKBSCUNZB"}, {
        "value": "鄂尔多斯市塔拉壕金谷村镇银行",
        "abbreviationName": "鄂尔多斯市塔拉壕金谷村镇银行",
        "code": "EEDSSTLHJGCUNZB"
    }, {"value": "鄂尔多斯市天骄蒙银村镇银行", "abbreviationName": "鄂尔多斯市天骄蒙银村镇银行", "code": "EEDSSTJMYCUNZB"}, {
        "value": "鄂尔多斯市铁西蒙银村镇银行",
        "abbreviationName": "鄂尔多斯市铁西蒙银村镇银行",
        "code": "EEDSSTXMYCUNZB"
    }, {"value": "鄂尔多斯银行", "abbreviationName": "鄂尔多斯", "code": "EEDSYH"}, {
        "value": "鄂托克旗汇泽村镇银行",
        "abbreviationName": "鄂托克旗汇泽村镇银行",
        "code": "ETKQHZCUNZB"
    }, {"value": "鄂托克前旗蒙银村镇银行", "abbreviationName": "鄂托克前旗蒙银村镇银行", "code": "ETKQQMYCUNZB"}, {
        "value": "鄂托克兴生源村镇银行",
        "abbreviationName": "鄂托克兴生源村镇银行",
        "code": "ETKXSYCUNZB"
    }, {"value": "鄂温克蒙商村镇银行", "abbreviationName": "鄂温克蒙商村镇银行", "code": "EWKBSCUNZB"}, {
        "value": "二连浩特农村合作银行",
        "abbreviationName": "二连浩特农村合作银行",
        "code": "ELHTRCU"
    }, {"value": "法国巴黎银行（中国）有限公司", "abbreviationName": "法国巴黎", "code": "BNPPARIBAS"}, {
        "value": "法国外贸银行",
        "abbreviationName": "法国外贸",
        "code": "NBPBK"
    }, {"value": "法国兴业银行", "abbreviationName": "法国兴业", "code": "SOCIETEGENERATE"}, {
        "value": "繁峙县新田村镇银行",
        "abbreviationName": "繁峙县新田村镇银行",
        "code": "FZXXTCUNZB"
    }, {"value": "范县德商村镇银行", "abbreviationName": "范县德商村镇银行", "code": "FXDSCUNZB"}, {
        "value": "防城港防城国民村镇银行",
        "abbreviationName": "防城港防城国民村镇银行",
        "code": "FCGFCGMCUNZB"
    }, {"value": "房县楚农商村镇银行", "abbreviationName": "房县楚农商村镇银行", "code": "FXCNSCUNZB"}, {
        "value": "菲律宾首都银行及信托",
        "abbreviationName": "菲律宾首都",
        "code": "PHILIPPINESCB"
    }, {"value": "费县梁邹村镇银行", "abbreviationName": "费县梁邹村镇银行", "code": "FXLZCUNZB"}, {
        "value": "分宜九银村镇银行",
        "abbreviationName": "分宜九银村镇银行",
        "code": "FYJYCUNZB"
    }, {"value": "汾西县太行村镇银行", "abbreviationName": "汾西县太行村镇银行", "code": "FXXTXCUNZB"}, {
        "value": "汾西县亿通村镇银行",
        "abbreviationName": "汾西县亿通村镇银行",
        "code": "FXXYTCUNZB"
    }, {"value": "汾阳市九都村镇银行", "abbreviationName": "汾阳市九都村镇银行", "code": "FYSJDCUNZB"}, {
        "value": "丰城顺银村镇银行",
        "abbreviationName": "丰城顺银村镇银行",
        "code": "FCSYCUNZB"
    }, {"value": "凤城丰益村镇银行", "abbreviationName": "凤城丰益村镇银行", "code": "FCFYCUNZB"}, {
        "value": "奉化罗蒙村镇银行",
        "abbreviationName": "奉化罗蒙村镇银行",
        "code": "FHLMCUNZB"
    }, {"value": "奉新九银村镇银行", "abbreviationName": "奉新九银村镇银行", "code": "FXJYCUNZB"}, {
        "value": "扶风浦发村镇银行",
        "abbreviationName": "扶风浦发村镇银行",
        "code": "FFPFCUNZB"
    }, {"value": "扶沟郑银村镇银行", "abbreviationName": "扶沟郑银村镇银行", "code": "FGZYCUNZB"}, {
        "value": "扶绥深通村镇银行",
        "abbreviationName": "扶绥深通村镇银行",
        "code": "FSSTCUNZB"
    }, {"value": "扶余惠民村镇银行", "abbreviationName": "扶余惠民村镇银行", "code": "FYHMCUNZB"}, {
        "value": "佛山高明顺银村镇银行",
        "abbreviationName": "佛山高明顺银村镇银行",
        "code": "FSGMSYCUNZB"
    }, {"value": "佛山南海新华村镇银行", "abbreviationName": "佛山南海新华村镇银行", "code": "FSNHXHCUNZB"}, {
        "value": "佛山农村商业银行",
        "abbreviationName": "佛山农商",
        "code": "FSRCB"
    }, {"value": "浮梁农商村镇银行", "abbreviationName": "浮梁农商村镇银行", "code": "FLNSCUNZB"}, {
        "value": "福建安溪农村商业银行",
        "abbreviationName": "福建安溪农商",
        "code": "FJAXRCB"
    }, {"value": "福建大田晋农商村镇银行", "abbreviationName": "福建大田晋农商村镇银行", "code": "FJDTJNSCUNZB"}, {
        "value": "福建德化成功村镇银行",
        "abbreviationName": "福建德化成功村镇银行",
        "code": "FJDHCGCUNZB"
    }, {"value": "福建福安渝农商村镇银行", "abbreviationName": "福建福安渝农商村镇银行", "code": "FJFAYNSCUNZB"}, {
        "value": "福建福鼎恒兴村镇银行",
        "abbreviationName": "福建福鼎恒兴村镇银行",
        "code": "FJFDHXCUNZB"
    }, {"value": "福建福清汇通农村商业银行", "abbreviationName": "福建福清汇通农商", "code": "FJFQHTRCB"}, {
        "value": "福建福清泰隆村镇银行",
        "abbreviationName": "福建福清泰隆村镇银行",
        "code": "FJFQTLCUNZB"
    }, {"value": "福建福州农村商业银行", "abbreviationName": "福建福州农商", "code": "FJFZRCB"}, {
        "value": "福建海峡银行",
        "abbreviationName": "福建海峡",
        "code": "FJHXYH"
    }, {"value": "福建华安长信村镇银行", "abbreviationName": "福建华安长信村镇银行", "code": "FJHACXCUNZB"}, {
        "value": "福建华通银行",
        "abbreviationName": "福建华通",
        "code": "FJHTB"
    }, {"value": "福建建瓯农村商业银行", "abbreviationName": "福建建瓯农商", "code": "FJJORCB"}, {
        "value": "福建建瓯瑞狮村镇银行",
        "abbreviationName": "福建建瓯瑞狮村镇银行",
        "code": "FJJORSCUNZB"
    }, {"value": "福建建阳瑞狮村镇银行", "abbreviationName": "福建建阳瑞狮村镇银行", "code": "FJJYRSCUNZB"}, {
        "value": "福建将乐成功村镇银行",
        "abbreviationName": "福建将乐成功村镇银行",
        "code": "FJJLCGCUNZB"
    }, {"value": "福建蕉城刺桐红村镇银行", "abbreviationName": "福建蕉城刺桐红村镇银行", "code": "FJJCCTHCUNZB"}, {
        "value": "福建晋江农村商业银行",
        "abbreviationName": "福建晋江农商",
        "code": "FJJJRCB"
    }, {"value": "福建连城杭兴村镇银行", "abbreviationName": "福建连城杭兴村镇银行", "code": "FJLCHXCUNZB"}, {
        "value": "福建连江恒欣村镇银行",
        "abbreviationName": "福建连江恒欣村镇银行",
        "code": "FJLJHXCUNZB"
    }, {"value": "福建连江农村商业银行", "abbreviationName": "福建连江农商", "code": "FJLJRCB"}, {
        "value": "福建龙海农村商业银行",
        "abbreviationName": "福建龙海农商",
        "code": "FJLHRCB"
    }, {"value": "福建龙海泰隆村镇银行", "abbreviationName": "福建龙海泰隆村镇银行", "code": "FJLHTLCUNZB"}, {
        "value": "福建龙岩农村商业银行",
        "abbreviationName": "福建龙岩农商",
        "code": "FJLYRCB"
    }, {"value": "福建罗源汇融村镇银行", "abbreviationName": "福建罗源汇融村镇银行", "code": "FJLYHRCUNZB"}, {
        "value": "福建闽侯民本村镇银行",
        "abbreviationName": "福建闽侯民本村镇银行",
        "code": "FJMHMBCUNZB"
    }, {"value": "福建闽清瑞狮村镇银行", "abbreviationName": "福建闽清瑞狮村镇银行", "code": "FJMQRSCUNZB"}, {
        "value": "福建南安汇通村镇银行",
        "abbreviationName": "福建南安汇通村镇银行",
        "code": "FJNAHTCUNZB"
    }, {"value": "福建南安农村商业银行", "abbreviationName": "福建南安农商", "code": "FJNARCB"}, {
        "value": "福建南平农村商业银行",
        "abbreviationName": "福建南平农商",
        "code": "FJNPRCB"
    }, {"value": "福建宁德农村商业银行", "abbreviationName": "福建宁德农商", "code": "FJNDRCB"}, {
        "value": "福建宁化成功村镇银行",
        "abbreviationName": "福建宁化成功村镇银行",
        "code": "FJNHCGCUNZB"
    }, {"value": "福建平潭农村商业银行", "abbreviationName": "福建平潭农商", "code": "FJPTANRCB"}, {
        "value": "福建平潭渝农商村镇银行",
        "abbreviationName": "福建平潭渝农商村镇银行",
        "code": "FJPTYNSCUNZB"
    }, {"value": "福建莆田农村商业银行", "abbreviationName": "福建莆田农商", "code": "FJPTRCB"}, {
        "value": "福建泉州台商投资区晋农商村镇银行",
        "abbreviationName": "福建泉州台商投资区晋农商村镇银行",
        "code": "FJQZTSTZQJNSCUNZB"
    }, {"value": "福建三明农村商业银行", "abbreviationName": "福建三明农商", "code": "FJSMRCB"}, {
        "value": "福建沙县农村商业银行",
        "abbreviationName": "福建沙县农商",
        "code": "FJSXRCB"
    }, {"value": "福建沙县渝农商村镇银行", "abbreviationName": "福建沙县渝农商村镇银行", "code": "FJSXYNSCUNZB"}, {
        "value": "福建上杭农村商业银行",
        "abbreviationName": "福建上杭农商",
        "code": "FJSHRCB"
    }, {"value": "福建邵武农村商业银行", "abbreviationName": "福建邵武农商", "code": "FJSWRCB"}, {
        "value": "福建省农村信用社联合社",
        "abbreviationName": "福建农信社",
        "code": "FJNXS"
    }, {"value": "福建石狮农村商业银行", "abbreviationName": "福建石狮农商", "code": "FJSSRCB"}, {
        "value": "福建石狮渝农商村镇银行",
        "abbreviationName": "福建石狮渝农商村镇银行",
        "code": "FJSSYRSCUNZB"
    }, {"value": "福建松溪长信村镇银行", "abbreviationName": "福建松溪长信村镇银行", "code": "FJSXCXCUNZB"}, {
        "value": "福建泰宁晋农商村镇银行",
        "abbreviationName": "福建泰宁晋农商村镇银行",
        "code": "FJTNJNSCUNZB"
    }, {"value": "福建武平杭兴村镇银行", "abbreviationName": "福建武平杭兴村镇银行", "code": "FJWPHXCUNZB"}, {
        "value": "福建武夷山农村商业银行",
        "abbreviationName": "福建武夷山农商",
        "code": "FJWYSRCB"
    }, {"value": "福建仙游农村商业银行", "abbreviationName": "福建仙游农商", "code": "FJXYRCB"}, {
        "value": "福建仙游瑞狮村镇银行",
        "abbreviationName": "福建仙游瑞狮村镇银行",
        "code": "FJXYRSCUNZB"
    }, {"value": "福建新罗晋农商村镇银行", "abbreviationName": "福建新罗晋农商村镇银行", "code": "FJXLJNSCUNZB"}, {
        "value": "福建永安汇丰村镇银行",
        "abbreviationName": "福建永安汇丰村镇银行",
        "code": "FJYAHFCUNZB"
    }, {"value": "福建永安农村商业银行", "abbreviationName": "福建永安农商", "code": "FJYARCB"}, {
        "value": "福建永春漳农商村镇银行",
        "abbreviationName": "福建永春漳农商村镇银行",
        "code": "FJYCZNSCUNZB"
    }, {"value": "福建永定瑞狮村镇银行", "abbreviationName": "福建永定瑞狮村镇银行", "code": "FJYDRSCUNZB"}, {
        "value": "福建永泰长信村镇银行",
        "abbreviationName": "福建永泰长信村镇银行",
        "code": "FJYTCXRCB"
    }, {"value": "福建尤溪成功村镇银行", "abbreviationName": "福建尤溪成功村镇银行", "code": "FJYXCGCUNZB"}, {
        "value": "福建漳平民泰村镇银行",
        "abbreviationName": "福建漳平民泰村镇银行",
        "code": "FJZPMTCUNZB"
    }, {"value": "福建漳平农村商业银行", "abbreviationName": "福建漳平农商", "code": "FJZPRCB"}, {
        "value": "福建漳浦农村商业银行",
        "abbreviationName": "福建漳浦农商",
        "code": "FJZPURCB"
    }, {"value": "福建漳州农村商业银行", "abbreviationName": "福建漳州农商", "code": "FJZZRCB"}, {
        "value": "福建长乐农村商业银行",
        "abbreviationName": "福建长乐农商",
        "code": "FJCLRCB"
    }, {"value": "福建长乐泰隆村镇银行", "abbreviationName": "福建长乐泰隆村镇银行", "code": "FJCLTLCUNZB"}, {
        "value": "福建诏安汇通村镇银行",
        "abbreviationName": "福建诏安汇通村镇银行",
        "code": "FJZAHTCUNZB"
    }, {"value": "福建政和泰隆村镇银行", "abbreviationName": "福建政和泰隆村镇银行", "code": "FJZHTLCUNZB"}, {
        "value": "福泉富民村镇银行",
        "abbreviationName": "福泉富民村镇银行",
        "code": "FQFMCUNZB"
    }, {"value": "抚顺东洲抚银村镇银行", "abbreviationName": "抚顺东洲抚银村镇银行", "code": "FSDZFYCUNZB"}, {
        "value": "抚顺市清原村镇银行",
        "abbreviationName": "抚顺市清原村镇银行",
        "code": "FSSQYCUNZB"
    }, {"value": "抚顺顺城抚银村镇银行", "abbreviationName": "抚顺顺城抚银村镇银行", "code": "FSSCFYCUNZB"}, {
        "value": "抚顺望花抚银村镇银行",
        "abbreviationName": "抚顺望花抚银村镇银行",
        "code": "FSWHFYCUNZB"
    }, {"value": "抚顺新宾抚银村镇银行", "abbreviationName": "抚顺新宾抚银村镇银行", "code": "FSXBFYCUNZB"}, {
        "value": "抚顺银行",
        "abbreviationName": "抚顺",
        "code": "FSYH"
    }, {"value": "抚松榆银村镇银行", "abbreviationName": "抚松榆银村镇银行", "code": "FSYYCUNZB"}, {
        "value": "抚州东乡富民村镇银行",
        "abbreviationName": "抚州东乡富民村镇银行",
        "code": "FZDXFMCUNZB"
    }, {"value": "抚州农村商业银行", "abbreviationName": "抚州农商", "code": "FZRCB"}, {
        "value": "阜城家银村镇银行",
        "abbreviationName": "阜城家银村镇银行",
        "code": "FCJYCUNZB"
    }, {"value": "阜康津汇村镇银行", "abbreviationName": "阜康津汇村镇银行", "code": "FKJHCUNZB"}, {
        "value": "阜宁民生村镇银行",
        "abbreviationName": "阜宁民生村镇银行",
        "code": "FNMSCUNZB"
    }, {"value": "阜平大商村镇银行", "abbreviationName": "阜平大商村镇银行", "code": "FPDSCUNZB"}, {
        "value": "阜新农村商业银行",
        "abbreviationName": "阜新农商",
        "code": "FXRCB"
    }, {"value": "阜新农商村镇银行", "abbreviationName": "阜新农商村镇银行", "code": "FXNSCUNZB"}, {
        "value": "阜新银行",
        "abbreviationName": "阜新",
        "code": "FXYH"
    }, {"value": "阜阳颍东农村商业银行", "abbreviationName": "阜阳颍东农商", "code": "FYYDRCB"}, {
        "value": "阜阳颍淮农村商业银行",
        "abbreviationName": "阜阳颍淮农商",
        "code": "FYYHRCB"
    }, {"value": "阜阳颍泉农村商业银行", "abbreviationName": "阜阳颍泉农商", "code": "FYYQRCB"}, {
        "value": "富滇银行",
        "abbreviationName": "富滇",
        "code": "FDYH"
    }, {"value": "富锦幸福村镇银行", "abbreviationName": "富锦幸福村镇银行", "code": "FJXFCUNZB"}, {
        "value": "富民浦发村镇银行",
        "abbreviationName": "富民浦发村镇银行",
        "code": "FMPFCUNZB"
    }, {"value": "富蕴中成村镇银行", "abbreviationName": "富蕴中成村镇银行", "code": "FYZCCUNZB"}, {
        "value": "甘肃崇信农村商业银行",
        "abbreviationName": "甘肃崇信农商",
        "code": "GSCXRCB"
    }, {"value": "甘肃敦煌农村商业银行", "abbreviationName": "甘肃敦煌农商", "code": "GSDHRCB"}, {
        "value": "甘肃高台农村商业银行",
        "abbreviationName": "甘肃高台农商",
        "code": "GSGTRCB"
    }, {"value": "甘肃古浪农村商业银行", "abbreviationName": "甘肃古浪农商", "code": "GSGLRCB"}, {
        "value": "甘肃瓜州农村商业银行",
        "abbreviationName": "甘肃瓜州农商",
        "code": "GSGZRCB"
    }, {"value": "甘肃华亭农村商业银行", "abbreviationName": "甘肃华亭农商", "code": "GSHTRCB"}, {
        "value": "甘肃会宁农村商业银行",
        "abbreviationName": "甘肃会宁农商",
        "code": "GSHNRCB"
    }, {"value": "甘肃泾川农村商业银行", "abbreviationName": "甘肃泾川农商", "code": "GSJCRCB"}, {
        "value": "甘肃靖远农村商业银行",
        "abbreviationName": "甘肃靖远农商",
        "code": "GSJYRCB"
    }, {"value": "甘肃静宁农村商业银行", "abbreviationName": "甘肃静宁农商", "code": "GSJNRCB"}, {
        "value": "甘肃康县农村商业银行",
        "abbreviationName": "甘肃康县农商",
        "code": "GSKXRCB"
    }, {"value": "甘肃礼县农村商业银行", "abbreviationName": "甘肃礼县农商", "code": "GSLIXRCB"}, {
        "value": "甘肃两当农村商业银行",
        "abbreviationName": "甘肃两当农商",
        "code": "GSLDRCB"
    }, {"value": "甘肃临洮农村商业银行", "abbreviationName": "甘肃临洮农商", "code": "GSLINTRCB"}, {
        "value": "甘肃临夏农村商业银行",
        "abbreviationName": "甘肃临夏农商",
        "code": "GSLXRCB"
    }, {"value": "甘肃临泽农村商业银行", "abbreviationName": "甘肃临泽农商", "code": "GSLZRCB"}, {
        "value": "甘肃灵台农村商业银行",
        "abbreviationName": "甘肃灵台农商",
        "code": "GSLTRCB"
    }, {"value": "甘肃陇西农村合作银行", "abbreviationName": "甘肃陇西农村合作银行", "code": "GSLXRCU"}, {
        "value": "甘肃陇西农村商业银行",
        "abbreviationName": "甘肃陇西农商",
        "code": "GSLXIRCB"
    }, {"value": "甘肃民乐农村商业银行", "abbreviationName": "甘肃民乐农商", "code": "GSMLRCB"}, {
        "value": "甘肃民勤农村商业银行",
        "abbreviationName": "甘肃民勤农商",
        "code": "GSMQRCB"
    }, {"value": "甘肃岷县农村商业银行", "abbreviationName": "甘肃岷县农商", "code": "GSMXRCB"}, {
        "value": "甘肃宁县农村合作银行",
        "abbreviationName": "甘肃宁县农村合作银行",
        "code": "GSNXRCU"
    }, {"value": "甘肃秦安农村商业银行", "abbreviationName": "甘肃秦安农商", "code": "GSQARCB"}, {
        "value": "甘肃山丹农村商业银行",
        "abbreviationName": "甘肃山丹农商",
        "code": "GSSDRCB"
    }, {"value": "甘肃省农村信用社联合社", "abbreviationName": "甘肃农信社", "code": "GSNXS"}, {
        "value": "甘肃天祝农村商业银行",
        "abbreviationName": "甘肃天祝农商",
        "code": "GSTZRCB"
    }, {"value": "甘肃西固金城村镇银行", "abbreviationName": "甘肃西固金城村镇银行", "code": "GSXGJCCUNZB"}, {
        "value": "甘肃西和农村商业银行",
        "abbreviationName": "甘肃西和农商",
        "code": "GSXHRCB"
    }, {"value": "甘肃银行", "abbreviationName": "甘肃", "code": "GSYH"}, {
        "value": "甘肃永昌农村商业银行",
        "abbreviationName": "甘肃永昌农商",
        "code": "GSYCRCB"
    }, {"value": "甘肃榆中农村合作银行", "abbreviationName": "甘肃榆中农村合作银行", "code": "GSYZRCU"}, {
        "value": "甘肃玉门农村商业银行",
        "abbreviationName": "甘肃玉门农商",
        "code": "GSYMRCB"
    }, {"value": "甘肃庄浪农村合作银行", "abbreviationName": "甘肃庄浪农村合作银行", "code": "GSZLRCU"}, {
        "value": "甘肃庄浪农村商业银行",
        "abbreviationName": "甘肃庄浪农商",
        "code": "GSZLRCB"
    }, {"value": "甘孜农村商业银行", "abbreviationName": "甘孜农商", "code": "SCGZRCB"}, {
        "value": "赣州农村商业银行",
        "abbreviationName": "赣州农商",
        "code": "GANZRCB"
    }, {"value": "赣州银行", "abbreviationName": "赣州", "code": "GZBC"}, {
        "value": "高碑店中成村镇银行",
        "abbreviationName": "高碑店中成村镇银行",
        "code": "GBDZCCUNZB"
    }, {"value": "高密惠民村镇银行", "abbreviationName": "高密惠民村镇银行", "code": "GMHMCUNZB"}, {
        "value": "高平市太行村镇银行",
        "abbreviationName": "高平市太行村镇银行",
        "code": "GPSTXCUNZB"
    }, {"value": "高唐青隆村镇银行", "abbreviationName": "高唐青隆村镇银行", "code": "GTQLCUNZB"}, {
        "value": "藁城恒升村镇银行",
        "abbreviationName": "藁城恒升村镇银行",
        "code": "ZCHSCUNZB"
    }, {"value": "个旧沪农商村镇银行", "abbreviationName": "个旧沪农商村镇银行", "code": "GJHNSCUNZB"}, {
        "value": "公主岭华兴村镇银行",
        "abbreviationName": "公主岭华兴村镇银行",
        "code": "GZLHXCUNZB"
    }, {"value": "公主岭浦发村镇银行", "abbreviationName": "公主岭浦发村镇银行", "code": "GZLPFCUNZB"}, {
        "value": "巩义浦发村镇银行",
        "abbreviationName": "巩义浦发村镇银行",
        "code": "GYPFCUNZB"
    }, {"value": "共青农村商业银行", "abbreviationName": "共青农商", "code": "GQRCB"}, {
        "value": "古交市阜民村镇银行",
        "abbreviationName": "古交市阜民村镇银行",
        "code": "GJSFMCUNZB"
    }, {"value": "古交市汇泽村镇银行", "abbreviationName": "古交市汇泽村镇银行", "code": "GJSHZCUNZB"}, {
        "value": "古田刺桐红村镇银行",
        "abbreviationName": "古田刺桐红村镇银行",
        "code": "GTCTHCUNZB"
    }, {"value": "固安恒升村镇银行", "abbreviationName": "固安恒升村镇银行", "code": "GAHSCUNZB"}, {
        "value": "固始天骄村镇银行",
        "abbreviationName": "固始天骄村镇银行",
        "code": "GSTJCUNZB"
    }, {"value": "固阳蒙商村镇银行", "abbreviationName": "固阳蒙商村镇银行", "code": "GYBSCUNZB"}, {
        "value": "故城家银村镇银行",
        "abbreviationName": "故城家银村镇银行",
        "code": "GCJYCUNZB"
    }, {"value": "关岭恒升村镇银行", "abbreviationName": "关岭恒升村镇银行", "code": "GLHSCUNZB"}, {
        "value": "光泽刺桐红村镇银行",
        "abbreviationName": "光泽刺桐红村镇银行",
        "code": "GZCTHCUNZB"
    }, {"value": "广安恒丰村镇银行", "abbreviationName": "广安恒丰村镇银行", "code": "GAHFCUNZB"}, {
        "value": "广安农村商业银行",
        "abbreviationName": "广安农商",
        "code": "GARCB"
    }, {"value": "广安思源农村商业银行", "abbreviationName": "广安思源农商", "code": "GASYRCB"}, {
        "value": "广昌南银村镇银行",
        "abbreviationName": "广昌南银村镇银行",
        "code": "GCNYCUNZB"
    }, {"value": "广东博罗农村商业银行", "abbreviationName": "广东博罗农商", "code": "GDBLRCB"}, {
        "value": "广东潮阳农村商业银行",
        "abbreviationName": "广东潮阳农商",
        "code": "GDCYRCB"
    }, {"value": "广东潮州农村商业银行", "abbreviationName": "广东潮州农商", "code": "GDCZRCB"}, {
        "value": "广东澄海潮商村镇银行",
        "abbreviationName": "广东澄海潮商村镇银行",
        "code": "GDCHCSCUNZB"
    }, {"value": "广东澄海农村商业银行", "abbreviationName": "广东澄海农商", "code": "GDCHRCB"}, {
        "value": "广东大埔农村商业银行",
        "abbreviationName": "广东大埔农商",
        "code": "GDDPRCB"
    }, {"value": "广东德庆农村商业银行", "abbreviationName": "广东德庆农商", "code": "GDDQRCB"}, {
        "value": "广东东源农村商业银行",
        "abbreviationName": "广东东源农商",
        "code": "GDDYRCB"
    }, {"value": "广东恩平汇丰村镇银行", "abbreviationName": "广东恩平汇丰村镇银行", "code": "GDEPHFCUNZB"}, {
        "value": "广东丰顺农村商业银行",
        "abbreviationName": "广东丰顺农商",
        "code": "GDFSRCB"
    }, {"value": "广东封开农村商业银行", "abbreviationName": "广东封开农商", "code": "GDFKRCB"}, {
        "value": "广东佛冈农村商业银行",
        "abbreviationName": "广东佛冈农商",
        "code": "GDFGRCB"
    }, {"value": "广东高州农村商业银行", "abbreviationName": "广东高州农商", "code": "GDGZRCB"}, {
        "value": "广东广宁农村商业银行",
        "abbreviationName": "广东广宁农商",
        "code": "GDGNRCB"
    }, {"value": "广东海丰农村商业银行", "abbreviationName": "广东海丰农商", "code": "GDHFRCB"}, {
        "value": "广东和平农村商业银行",
        "abbreviationName": "广东和平农商",
        "code": "GDHPRCB"
    }, {"value": "广东河源农村商业银行", "abbreviationName": "广东河源农商", "code": "GDHYNRCB"}, {
        "value": "广东鹤山农村商业银行",
        "abbreviationName": "广东鹤山农商",
        "code": "GDHSRCB"
    }, {"value": "广东华兴银行", "abbreviationName": "广东华兴", "code": "GDHXYH"}, {
        "value": "广东化州农村商业银行",
        "abbreviationName": "广东化州农商",
        "code": "GDHUAZRCB"
    }, {"value": "广东怀集农村商业银行", "abbreviationName": "广东怀集农商", "code": "GDHJRCB"}, {
        "value": "广东惠东农村商业银行",
        "abbreviationName": "广东惠东农商",
        "code": "GDHDRCB"
    }, {"value": "广东惠来农村商业银行", "abbreviationName": "广东惠来农商", "code": "GDHLRCB"}, {
        "value": "广东惠州农村商业银行",
        "abbreviationName": "广东惠州农商",
        "code": "GDHZRCB"
    }, {"value": "广东蕉岭农村商业银行", "abbreviationName": "广东蕉岭农商", "code": "GDJLRCB"}, {
        "value": "广东揭东农村商业银行",
        "abbreviationName": "广东揭东农商",
        "code": "GDJDRCB"
    }, {"value": "广东揭西农村商业银行", "abbreviationName": "广东揭西农商", "code": "GDJXRCB"}, {
        "value": "广东揭阳农村商业银行",
        "abbreviationName": "广东揭阳农商",
        "code": "GDJYRCB"
    }, {"value": "广东开平农村商业银行", "abbreviationName": "广东开平农商", "code": "GDKPRCB"}, {
        "value": "广东乐昌农村商业银行",
        "abbreviationName": "广东乐昌农商",
        "code": "GDLECRCB"
    }, {"value": "广东雷州农村商业银行", "abbreviationName": "广东雷州农商", "code": "GDLEIZRCB"}, {
        "value": "广东连南农村商业银行",
        "abbreviationName": "广东连南农商",
        "code": "GDLNRCB"
    }, {"value": "广东连平农村商业银行", "abbreviationName": "广东连平农商", "code": "GDLPRCB"}, {
        "value": "广东连山农村商业银行",
        "abbreviationName": "广东连山农商",
        "code": "GDLSRCB"
    }, {"value": "广东连州农村商业银行", "abbreviationName": "广东连州农商", "code": "GDLZRCB"}, {
        "value": "广东廉江农村商业银行",
        "abbreviationName": "广东廉江农商",
        "code": "GDLJRCB"
    }, {"value": "广东龙川农村商业银行", "abbreviationName": "广东龙川农商", "code": "GDLCRCB"}, {
        "value": "广东龙门农村商业银行",
        "abbreviationName": "广东龙门农商",
        "code": "GDLMRCB"
    }, {"value": "广东陆丰农村商业银行", "abbreviationName": "广东陆丰农商", "code": "GDLFRCB"}, {
        "value": "广东陆河农村商业银行",
        "abbreviationName": "广东陆河农商",
        "code": "GDLHRCB"
    }, {"value": "广东罗定农村商业银行", "abbreviationName": "广东罗定农商", "code": "GDLDRCB"}, {
        "value": "广东茂名农村商业银行",
        "abbreviationName": "广东茂名农商",
        "code": "GDMMRCB"
    }, {"value": "广东梅州农村商业银行", "abbreviationName": "广东梅州农商", "code": "GDMZRCB"}, {
        "value": "广东南澳农村商业银行",
        "abbreviationName": "广东南澳农商",
        "code": "GDNARCB"
    }, {"value": "广东南海农村商业银行", "abbreviationName": "广东南海农商", "code": "GDNHRCB"}, {
        "value": "广东南雄农村商业银行",
        "abbreviationName": "广东南雄农商",
        "code": "GDNXRCB"
    }, {"value": "广东南粤银行", "abbreviationName": "南粤", "code": "GDNYYH"}, {
        "value": "广东平远农村商业银行",
        "abbreviationName": "广东平远农商",
        "code": "GDPYRCB"
    }, {"value": "广东普宁汇成村镇银行", "abbreviationName": "广东普宁汇成村镇银行", "code": "GDPNHCCUNZB"}, {
        "value": "广东普宁农村商业银行",
        "abbreviationName": "广东普宁农商",
        "code": "GDPNRCB"
    }, {"value": "广东清新农村商业银行", "abbreviationName": "广东清新农商", "code": "GDQXRCB"}, {
        "value": "广东清远农村商业银行",
        "abbreviationName": "广东清远农商",
        "code": "GDQYRCB"
    }, {"value": "广东仁化农村商业银行", "abbreviationName": "广东仁化农商", "code": "GDRHRCB"}, {
        "value": "广东乳源农村商业银行",
        "abbreviationName": "广东乳源农商",
        "code": "GDRYRCB"
    }, {"value": "广东韶关农村商业银行", "abbreviationName": "广东韶关农商", "code": "GDSGRCB"}, {
        "value": "广东省农村信用社联合社",
        "abbreviationName": "广东农信社",
        "code": "GDNXS"
    }, {"value": "广东始兴农村商业银行", "abbreviationName": "广东始兴农商", "code": "GDSXRCB"}, {
        "value": "广东四会农村商业银行",
        "abbreviationName": "广东四会农商",
        "code": "GDSHRCB"
    }, {"value": "广东四会泰隆村镇银行", "abbreviationName": "广东四会泰隆村镇银行", "code": "GDSHTLCUNZB"}, {
        "value": "广东遂溪农村商业银行",
        "abbreviationName": "广东遂溪农商",
        "code": "GDSXIRCB"
    }, {"value": "广东台山农村商业银行", "abbreviationName": "广东台山农商", "code": "GDTSRCB"}, {
        "value": "广东翁源农村商业银行",
        "abbreviationName": "广东翁源农商",
        "code": "GDWYRCB"
    }, {"value": "广东吴川农村商业银行", "abbreviationName": "广东吴川农商", "code": "GDWCRCB"}, {
        "value": "广东五华农村商业银行",
        "abbreviationName": "广东五华农商",
        "code": "GDWHRCB"
    }, {"value": "广东新丰农村商业银行", "abbreviationName": "广东新丰农商", "code": "GDXFRCB"}, {
        "value": "广东新兴农村商业银行",
        "abbreviationName": "广东新兴农商",
        "code": "GDXXRCB"
    }, {"value": "广东信宜农村商业银行", "abbreviationName": "广东信宜农商", "code": "GDXYRCB"}, {
        "value": "广东兴宁农村商业银行",
        "abbreviationName": "广东兴宁农商",
        "code": "GDXNRCB"
    }, {"value": "广东徐闻农村商业银行", "abbreviationName": "广东徐闻农商", "code": "GDXWRCB"}, {
        "value": "广东阳春农村商业银行",
        "abbreviationName": "广东阳春农商",
        "code": "GDYCRCB"
    }, {"value": "广东阳江农村商业银行", "abbreviationName": "广东阳江农商", "code": "GDYJRCB"}, {
        "value": "广东阳山农村商业银行",
        "abbreviationName": "广东阳山农商",
        "code": "GDYSRCB"
    }, {"value": "广东阳西农村商业银行", "abbreviationName": "广东阳西农商", "code": "GDYXRCB"}, {
        "value": "广东英德农村商业银行",
        "abbreviationName": "广东英德农商",
        "code": "GDYDERCB"
    }, {"value": "广东英德泰隆村镇银行", "abbreviationName": "广东英德泰隆村镇银行", "code": "GDYDTLRCB"}, {
        "value": "广东郁南农村商业银行",
        "abbreviationName": "广东郁南农商",
        "code": "GDYNRCB"
    }, {"value": "广东云浮农村商业银行", "abbreviationName": "广东云浮农商", "code": "GDYFRCB"}, {
        "value": "广东紫金农村商业银行",
        "abbreviationName": "广东紫金农商",
        "code": "GDZJRCB"
    }, {"value": "广发银行", "abbreviationName": "广发", "code": "CGB"}, {
        "value": "广丰广信村镇银行",
        "abbreviationName": "广丰广信村镇银行",
        "code": "GFGXCUNZB"
    }, {"value": "广汉珠江村镇银行", "abbreviationName": "广汉珠江村镇银行", "code": "GHZJCUNZB"}, {
        "value": "广饶梁邹村镇银行",
        "abbreviationName": "广饶梁邹村镇银行",
        "code": "GRLZCUNZB"
    }, {"value": "广水楚农商村镇银行", "abbreviationName": "广水楚农商村镇银行", "code": "GSCNSCUNZB"}, {
        "value": "广西巴马农村商业银行",
        "abbreviationName": "广西巴马农商",
        "code": "GXBMRCB"
    }, {"value": "广西百色右江农村合作银行", "abbreviationName": "广西百色右江农村合作银行", "code": "GXBSYJRCU"}, {
        "value": "广西北部湾银行",
        "abbreviationName": "北部湾",
        "code": "BBWYH"
    }, {"value": "广西北流柳银村镇银行", "abbreviationName": "广西北流柳银村镇银行", "code": "GXBLLYCUNZB"}, {
        "value": "广西宾阳农村商业银行",
        "abbreviationName": "广西宾阳农商",
        "code": "GXBYRCB"
    }, {"value": "广西博白柳银村镇银行", "abbreviationName": "广西博白柳银村镇银行", "code": "GXBBLYCUNZB"}, {
        "value": "广西苍梧农村商业银行",
        "abbreviationName": "广西苍梧农商",
        "code": "GXCWRCB"
    }, {"value": "广西岑溪农村商业银行", "abbreviationName": "广西岑溪农商", "code": "GXCXRCB"}, {
        "value": "广西崇左农村商业银行",
        "abbreviationName": "广西崇左农商",
        "code": "GXCZGNRCB"
    }, {"value": "广西大新农村商业银行", "abbreviationName": "广西大新农商", "code": "GXDAXRCB"}, {
        "value": "广西东兴农村商业银行",
        "abbreviationName": "广西东兴农商",
        "code": "GXDXRCB"
    }, {"value": "广西都安农村商业银行", "abbreviationName": "广西都安农商", "code": "GXDARCB"}, {
        "value": "广西扶绥农村商业银行",
        "abbreviationName": "广西扶绥农商",
        "code": "GXFSRCB"
    }, {"value": "广西富川农村商业银行", "abbreviationName": "广西富川农商", "code": "GXFCRCB"}, {
        "value": "广西恭城农村商业银行",
        "abbreviationName": "广西恭城农商",
        "code": "GXGCRCB"
    }, {"value": "广西灌阳农村商业银行", "abbreviationName": "广西灌阳农商", "code": "GXGYRCB"}, {
        "value": "广西贵港农村商业银行",
        "abbreviationName": "广西贵港农商",
        "code": "GXGGRCB"
    }, {"value": "广西桂林漓江农村合作银行", "abbreviationName": "广西桂林漓江农村合作银行", "code": "GXGLLJRCU"}, {
        "value": "广西桂平桂银村镇银行",
        "abbreviationName": "广西桂平桂银村镇银行",
        "code": "GXGPGYCUNZB"
    }, {"value": "广西贺州桂东农村合作银行", "abbreviationName": "广西贺州桂东农村合作银行", "code": "GXHZGDRCU"}, {
        "value": "广西横县桂商村镇银行",
        "abbreviationName": "广西横县桂商村镇银行",
        "code": "GXHXGSCUNZB"
    }, {"value": "广西金秀农村商业银行", "abbreviationName": "广西金秀农商", "code": "GXJINXRCB"}, {
        "value": "广西靖西农村商业银行",
        "abbreviationName": "广西靖西农商",
        "code": "GXJXRCB"
    }, {"value": "广西来宾桂中农村合作银行", "abbreviationName": "广西来宾桂中农村合作银行", "code": "GXLBGZRCU"}, {
        "value": "广西乐业农村商业银行",
        "abbreviationName": "广西乐业农商",
        "code": "GXLEYRCB"
    }, {"value": "广西荔浦农村商业银行", "abbreviationName": "广西荔浦农商", "code": "GXLPRCB"}, {
        "value": "广西临桂农村商业银行",
        "abbreviationName": "广西临桂农商",
        "code": "GXLGRCB"
    }, {"value": "广西灵川农村商业银行", "abbreviationName": "广西灵川农商", "code": "GXLINGCRCB"}, {
        "value": "广西凌云农村商业银行",
        "abbreviationName": "广西凌云农商",
        "code": "GXLYRCB"
    }, {"value": "广西柳城农村商业银行", "abbreviationName": "广西柳城农商", "code": "GXLCRCU"}, {
        "value": "广西柳江柳银村镇银行",
        "abbreviationName": "广西柳江柳银村镇银行",
        "code": "GXLJLYCUNZB"
    }, {"value": "广西柳江农村合作银行", "abbreviationName": "广西柳江农村合作银行", "code": "GXLJRCU"}, {
        "value": "广西龙胜农村商业银行",
        "abbreviationName": "广西龙胜农商",
        "code": "GXLSRCB"
    }, {"value": "广西龙州农村商业银行", "abbreviationName": "广西龙州农商", "code": "GXLZRCB"}, {
        "value": "广西隆安农村商业银行",
        "abbreviationName": "广西隆安农商",
        "code": "GXLARCB"
    }, {"value": "广西隆林农村商业银行", "abbreviationName": "广西隆林农商", "code": "GXLLRCB"}, {
        "value": "广西陆川柳银村镇银行",
        "abbreviationName": "广西陆川柳银村镇银行",
        "code": "GXLCLYCUNZB"
    }, {"value": "广西陆川农村商业银行", "abbreviationName": "广西陆川农商", "code": "GXLCRCB"}, {
        "value": "广西鹿寨农村商业银行",
        "abbreviationName": "广西鹿寨农商",
        "code": "GXLUZRCB"
    }, {"value": "广西鹿寨渝农商村镇银行", "abbreviationName": "广西鹿寨渝农商村镇银行", "code": "GXLZYNSCUNZB"}, {
        "value": "广西罗城农村商业银行",
        "abbreviationName": "广西罗城农商",
        "code": "GXLUOCRCB"
    }, {"value": "广西马山农村商业银行", "abbreviationName": "广西马山农商", "code": "GXMASRCB"}, {
        "value": "广西蒙山农村商业银行",
        "abbreviationName": "广西蒙山农商",
        "code": "GXMSRCB"
    }, {"value": "广西那坡农村商业银行", "abbreviationName": "广西那坡农商", "code": "GXNPRCB"}, {
        "value": "广西宁明农村商业银行",
        "abbreviationName": "广西宁明农商",
        "code": "GXNMRCB"
    }, {"value": "广西平果农村合作银行", "abbreviationName": "广西平果农村合作银行", "code": "GXPGRCU"}, {
        "value": "广西平乐农村合作银行",
        "abbreviationName": "广西平乐农村合作银行",
        "code": "GXPLRCU"
    }, {"value": "广西平南桂银村镇银行", "abbreviationName": "广西平南桂银村镇银行", "code": "GXPNGYCUNZB"}, {
        "value": "广西凭祥农村商业银行",
        "abbreviationName": "广西凭祥农商",
        "code": "GXPXRCB"
    }, {"value": "广西浦北国民村镇银行", "abbreviationName": "广西浦北国民村镇银行", "code": "GXPBGMCUNZB"}, {
        "value": "广西浦北农村商业银行",
        "abbreviationName": "广西浦北农商",
        "code": "GXPBRCB"
    }, {"value": "广西钦州市钦南国民村镇银行", "abbreviationName": "广西钦州市钦南国民村镇银行", "code": "GXQZSQNGMCUNZB"}, {
        "value": "广西全州农村合作银行",
        "abbreviationName": "广西全州农村合作银行",
        "code": "GXQZRCU"
    }, {"value": "广西容县桂银村镇银行", "abbreviationName": "广西容县桂银村镇银行", "code": "GXRXGYCUNZB"}, {
        "value": "广西融安农村商业银行",
        "abbreviationName": "广西融安农商",
        "code": "GXRARCB"
    }, {"value": "广西融水柳银村镇银行", "abbreviationName": "广西融水柳银村镇银行", "code": "GXRSLYCUNZB"}, {
        "value": "广西融水农村商业银行",
        "abbreviationName": "广西融水农商",
        "code": "GXRSRCB"
    }, {"value": "广西三江农村商业银行", "abbreviationName": "广西三江农商", "code": "GXSJRCB"}, {
        "value": "广西上林国民村镇银行",
        "abbreviationName": "广西上林国民村镇银行",
        "code": "GXSLGMCUNZB"
    }, {"value": "广西上林农村商业银行", "abbreviationName": "广西上林农商", "code": "GXSLRCB"}, {
        "value": "广西上思农村商业银行",
        "abbreviationName": "广西上思农商",
        "code": "GXSSRCB"
    }, {"value": "广西藤县桂银村镇银行", "abbreviationName": "广西藤县桂银村镇银行", "code": "GXTXGYCUNZB"}, {
        "value": "广西天等农村商业银行",
        "abbreviationName": "广西天等农商",
        "code": "GXTDRCB"
    }, {"value": "广西天峨农村商业银行", "abbreviationName": "广西天峨农商", "code": "GXTERCB"}, {
        "value": "广西田东农村商业银行",
        "abbreviationName": "广西田东农商",
        "code": "GXTDONGRCB"
    }, {"value": "广西田林农村商业银行", "abbreviationName": "广西田林农商", "code": "GXTLRCB"}, {
        "value": "广西田阳农村商业银行",
        "abbreviationName": "广西田阳农商",
        "code": "GXTYRCB"
    }, {"value": "广西武宣农村商业银行", "abbreviationName": "广西武宣农商", "code": "GXWXRCB"}, {
        "value": "广西西林农村商业银行",
        "abbreviationName": "广西西林农商",
        "code": "GXXLRCB"
    }, {"value": "广西象州农村合作银行", "abbreviationName": "广西象州农村合作银行", "code": "GXXZRCU"}, {
        "value": "广西兴安民兴村镇银行",
        "abbreviationName": "广西兴安民兴村镇银行",
        "code": "GXXAMXCUNZB"
    }, {"value": "广西兴安农村合作银行", "abbreviationName": "广西兴安农村合作银行", "code": "GXXARCU"}, {
        "value": "广西兴业柳银村镇银行",
        "abbreviationName": "广西兴业柳银村镇银行",
        "code": "GXXYLYCUNZB"
    }, {"value": "广西阳朔农村合作银行", "abbreviationName": "广西阳朔农村合作银行", "code": "GXYSRCU"}, {
        "value": "广西宜州农村合作银行",
        "abbreviationName": "广西宜州农村合作银行",
        "code": "GXYZRCU"
    }, {"value": "广西银海国民村镇银行", "abbreviationName": "广西银海国民村镇银行", "code": "GXYHGMCUNZB"}, {
        "value": "广西永福农村商业银行",
        "abbreviationName": "广西永福农商",
        "code": "GXYFRCU"
    }, {"value": "广西鱼峰信合村镇银行", "abbreviationName": "广西鱼峰信合村镇银行", "code": "GXYFXHCUNZB"}, {
        "value": "广西昭平农村商业银行",
        "abbreviationName": "广西昭平农商",
        "code": "GXZPRCB"
    }, {"value": "广西壮族自治区农村信用社联合社", "abbreviationName": "广西农信社", "code": "GXNXS"}, {
        "value": "广西资源农村商业银行",
        "abbreviationName": "广西资源农商",
        "code": "GXZYRCB"
    }, {"value": "广元市发展村镇银行", "abbreviationName": "广元市发展村镇银行", "code": "GYSBSGMCUNZB"}, {
        "value": "广元市贵商村镇银行",
        "abbreviationName": "广元市贵商村镇银行",
        "code": "GYSGSCUNZB"
    }, {"value": "广州白云民泰村镇银行", "abbreviationName": "广州白云民泰村镇银行", "code": "GZBYMTCUNZB"}, {
        "value": "广州从化柳银村镇银行",
        "abbreviationName": "广州从化柳银村镇银行",
        "code": "GZCHLYCUNZB"
    }, {"value": "广州番禺新华村镇银行", "abbreviationName": "广州番禺新华村镇银行", "code": "GZFZXHCUNZB"}, {
        "value": "广州花都稠州村镇银行",
        "abbreviationName": "广州花都稠州村镇银行",
        "code": "GZHDCZCUNZB"
    }, {"value": "广州黄埔惠民村镇银行", "abbreviationName": "广州黄埔惠民村镇银行", "code": "GZHPHMCUNZB"}, {
        "value": "广州黄埔融和村镇银行",
        "abbreviationName": "广州黄埔融和村镇银行",
        "code": "GZHPRHCUNZB"
    }, {"value": "广州农村商业银行", "abbreviationName": "广州农商", "code": "GZRCB"}, {
        "value": "广州银行",
        "abbreviationName": "广州",
        "code": "GUAZYH"
    }, {"value": "广州增城长江村镇银行", "abbreviationName": "广州增城长江村镇银行", "code": "GZZCCJCUNZB"}, {
        "value": "贵安新区发展村镇银行",
        "abbreviationName": "贵安新区发展村镇银行",
        "code": "GAXQFZCUNZB"
    }, {"value": "贵定恒升村镇银行", "abbreviationName": "贵定恒升村镇银行", "code": "GDHSCUNZB"}, {
        "value": "贵溪九银村镇银行",
        "abbreviationName": "贵溪九银村镇银行",
        "code": "GXJYCUNZB"
    }, {"value": "贵阳白云德信村镇银行", "abbreviationName": "贵阳白云德信村镇银行", "code": "GYBYDXCUNZB"}, {
        "value": "贵阳观山湖富民村镇银行",
        "abbreviationName": "贵阳观山湖富民村镇银行",
        "code": "GYGSHFMCUNZB"
    }, {"value": "贵阳花溪建设村镇银行", "abbreviationName": "贵阳花溪建设村镇银行", "code": "GYHXJSCUNZB"}, {
        "value": "贵阳南明富民村镇银行",
        "abbreviationName": "贵阳南明富民村镇银行",
        "code": "GYNMFMCUNZB"
    }, {"value": "贵阳农村商业银行", "abbreviationName": "贵阳农商", "code": "GYRCB"}, {
        "value": "贵阳乌当富民村镇银行",
        "abbreviationName": "贵阳乌当富民村镇银行",
        "code": "GYWDFMCUNZB"
    }, {"value": "贵阳小河科技村镇银行", "abbreviationName": "贵阳小河科技村镇银行", "code": "GYXHKJCUNZB"}, {
        "value": "贵阳银行",
        "abbreviationName": "贵阳",
        "code": "GYYH"
    }, {"value": "贵阳云岩富民村镇银行", "abbreviationName": "贵阳云岩富民村镇银行", "code": "GYYYFMCUNZB"}, {
        "value": "贵州安龙农村商业银行",
        "abbreviationName": "贵州安龙农商",
        "code": "GZALRCB"
    }, {"value": "贵州毕节农村商业银行", "abbreviationName": "贵州毕节农商", "code": "GZBJRCB"}, {
        "value": "贵州册亨农村商业银行",
        "abbreviationName": "贵州册亨农商",
        "code": "GZCHRCB"
    }, {"value": "贵州从江农村商业银行", "abbreviationName": "贵州从江农商", "code": "GZCJRCB"}, {
        "value": "贵州大方农村商业银行",
        "abbreviationName": "贵州大方农商",
        "code": "GZDFRCB"
    }, {"value": "贵州丹寨农村商业银行", "abbreviationName": "贵州丹寨农商", "code": "GZDZRCB"}, {
        "value": "贵州道真农村商业银行",
        "abbreviationName": "贵州道真农商",
        "code": "GZDAOZRCB"
    }, {"value": "贵州都匀农村商业银行", "abbreviationName": "贵州都匀农商", "code": "GZDYRCB"}, {
        "value": "贵州独山农村商业银行",
        "abbreviationName": "贵州独山农商",
        "code": "GZDSRCB"
    }, {"value": "贵州凤冈农村商业银行", "abbreviationName": "贵州凤冈农商", "code": "GZFGRCB"}, {
        "value": "贵州福泉农村商业银行",
        "abbreviationName": "贵州福泉农商",
        "code": "GZFQRCB"
    }, {"value": "贵州关岭农村商业银行", "abbreviationName": "贵州关岭农商", "code": "GZGLRCB"}, {
        "value": "贵州贵定农村商业银行",
        "abbreviationName": "贵州贵定农商",
        "code": "GZGDRCB"
    }, {"value": "贵州赫章农村商业银行", "abbreviationName": "贵州赫章农商", "code": "GZHZRCB"}, {
        "value": "贵州花溪农村商业银行",
        "abbreviationName": "贵州花溪农商",
        "code": "GZHXRCB"
    }, {"value": "贵州黄平农村商业银行", "abbreviationName": "贵州黄平农商", "code": "GZHPRCB"}, {
        "value": "贵州惠水农村商业银行",
        "abbreviationName": "贵州惠水农商",
        "code": "GZHSRCB"
    }, {"value": "贵州剑河农村商业银行", "abbreviationName": "贵州剑河农商", "code": "GZJHRCB"}, {
        "value": "贵州凯里农村商业银行",
        "abbreviationName": "贵州凯里农商",
        "code": "GZKLRCB"
    }, {"value": "贵州黎平农村商业银行", "abbreviationName": "贵州黎平农商", "code": "GZLPRCB"}, {
        "value": "贵州荔波农村商业银行",
        "abbreviationName": "贵州荔波农商",
        "code": "GZLBRCB"
    }, {"value": "贵州龙里农村商业银行", "abbreviationName": "贵州龙里农商", "code": "GZLLRCB"}, {
        "value": "贵州麻江农村商业银行",
        "abbreviationName": "贵州麻江农商",
        "code": "GZMJRCB"
    }, {"value": "贵州湄潭农村商业银行", "abbreviationName": "贵州湄潭农商", "code": "GZMTRCB"}, {
        "value": "贵州平塘农村商业银行",
        "abbreviationName": "贵州平塘农商",
        "code": "GZPTRCB"
    }, {"value": "贵州普安农村商业银行", "abbreviationName": "贵州普安农商", "code": "GZPARCB"}, {
        "value": "贵州普定农村商业银行",
        "abbreviationName": "贵州普定农商",
        "code": "GZPDRCB"
    }, {"value": "贵州黔西农村商业银行", "abbreviationName": "贵州黔西农商", "code": "GZQXRCB"}, {
        "value": "贵州清镇农村商业银行",
        "abbreviationName": "贵州清镇农商",
        "code": "GZQZRCB"
    }, {"value": "贵州晴隆农村商业银行", "abbreviationName": "贵州晴隆农商", "code": "GZQLRCB"}, {
        "value": "贵州仁怀茅台农村商业银行",
        "abbreviationName": "贵州仁怀茅台农商",
        "code": "GZRHMRCB"
    }, {"value": "贵州三都农村商业银行", "abbreviationName": "贵州三都农商", "code": "GZSDRCB"}, {
        "value": "贵州三穗农村商业银行",
        "abbreviationName": "贵州三穗农商",
        "code": "GZSSRCB"
    }, {"value": "贵州省农村信用社联合社", "abbreviationName": "贵州农信社", "code": "GZNXS"}, {
        "value": "贵州思南农村商业银行",
        "abbreviationName": "贵州思南农商",
        "code": "GZSNRCB"
    }, {"value": "贵州天柱农村商业银行", "abbreviationName": "贵州天柱农商", "code": "GZTZRCB"}, {
        "value": "贵州桐梓农村商业银行",
        "abbreviationName": "贵州桐梓农商",
        "code": "GZTZIRCB"
    }, {"value": "贵州望谟农村商业银行", "abbreviationName": "贵州望谟农商", "code": "GZWMRCB"}, {
        "value": "贵州瓮安农村商业银行",
        "abbreviationName": "贵州瓮安农商",
        "code": "GZWARCB"
    }, {"value": "贵州乌当农村商业银行", "abbreviationName": "贵州乌当农商", "code": "GZWDRCB"}, {
        "value": "贵州务川农村商业银行",
        "abbreviationName": "贵州务川农商",
        "code": "GZWCRCB"
    }, {"value": "贵州息烽农村商业银行", "abbreviationName": "贵州息烽农商", "code": "GZXFRCB"}, {
        "value": "贵州习水农村商业银行",
        "abbreviationName": "贵州习水农商",
        "code": "GZXSRCB"
    }, {"value": "贵州兴仁农村商业银行", "abbreviationName": "贵州兴仁农商", "code": "GZXRRCB"}, {
        "value": "贵州兴义农村商业银行",
        "abbreviationName": "贵州兴义农商",
        "code": "GZXYRCB"
    }, {"value": "贵州修文农村商业银行", "abbreviationName": "贵州修文农商", "code": "GZXWRCB"}, {
        "value": "贵州银行",
        "abbreviationName": "贵州",
        "code": "GUZYH"
    }, {"value": "贵州印江农村商业银行", "abbreviationName": "贵州印江农商", "code": "GZYJRCB"}, {
        "value": "贵州余庆农村商业银行",
        "abbreviationName": "贵州余庆农商",
        "code": "GZYQRCB"
    }, {"value": "贵州玉屏农村商业银行", "abbreviationName": "贵州玉屏农商", "code": "GZYPRCB"}, {
        "value": "贵州贞丰农村商业银行",
        "abbreviationName": "贵州贞丰农商",
        "code": "GZZFRCB"
    }, {"value": "贵州镇宁农村商业银行", "abbreviationName": "贵州镇宁农商", "code": "GZZNRCB"}, {
        "value": "贵州镇远农村商业银行",
        "abbreviationName": "贵州镇远农商",
        "code": "GZZYUANRCB"
    }, {"value": "贵州织金农村商业银行", "abbreviationName": "贵州织金农商", "code": "GZZJRCB"}, {
        "value": "贵州紫云农村商业银行",
        "abbreviationName": "贵州紫云农商",
        "code": "GZZYRCB"
    }, {"value": "贵州遵义红花岗农村商业银行", "abbreviationName": "贵州遵义红花岗农商", "code": "GZZYHHGRCB"}, {
        "value": "贵州遵义汇川农村商业银行",
        "abbreviationName": "贵州遵义汇川农商",
        "code": "GZZYHCRCB"
    }, {"value": "贵州遵义农村商业银行", "abbreviationName": "贵州遵义农商", "code": "GZZYIRCB"}, {
        "value": "桂林国民村镇银行",
        "abbreviationName": "桂林国民村镇银行",
        "code": "GLGMCUNZB"
    }, {"value": "桂林银行", "abbreviationName": "桂林", "code": "GLYH"}, {
        "value": "桂阳沪农商村镇银行",
        "abbreviationName": "桂阳沪农商村镇银行",
        "code": "GYHNSCUNZB"
    }, {"value": "国家开发银行", "abbreviationName": "国开", "code": "CDBB"}, {
        "value": "国民银行（中国）有限公司",
        "abbreviationName": "国民",
        "code": "GMYHZHYXGS"
    }, {"value": "国泰世华商业银行", "abbreviationName": "国泰世华", "code": "CATHAYBK"}, {
        "value": "哈尔滨阿城农商村镇银行",
        "abbreviationName": "哈尔滨阿城农商村镇银行",
        "code": "HEBACNSCUNZB"
    }, {"value": "哈尔滨宾洲村镇银行", "abbreviationName": "哈尔滨宾洲村镇银行", "code": "HEBBZCUNZB"}, {
        "value": "哈尔滨呼兰浦发村镇银行",
        "abbreviationName": "哈尔滨呼兰浦发村镇银行",
        "code": "HEBHLPFCUNZB"
    }, {"value": "哈尔滨农村商业银行", "abbreviationName": "哈尔滨农商", "code": "HEBRCB"}, {
        "value": "哈尔滨农信村镇银行",
        "abbreviationName": "哈尔滨农信村镇银行",
        "code": "HEBNXCUNZB"
    }, {"value": "哈尔滨幸福村镇银行", "abbreviationName": "哈尔滨幸福村镇银行", "code": "HEBXFCUNZB"}, {
        "value": "哈尔滨银行",
        "abbreviationName": "哈尔滨",
        "code": "HEBYH"
    }, {"value": "哈密红星国民村镇银行", "abbreviationName": "哈密红星国民村镇银行", "code": "HMHXGMCUNZB"}, {
        "value": "哈密市商业银行",
        "abbreviationName": "哈密",
        "code": "HMSCCB"
    }, {"value": "哈密天山村镇银行", "abbreviationName": "哈密天山村镇银行", "code": "HMTSCUNZB"}, {
        "value": "海口联合农村商业银行",
        "abbreviationName": "海口联合农商",
        "code": "HKLHRCB"
    }, {"value": "海口农村商业银行", "abbreviationName": "海口农商", "code": "HKRCB"}, {
        "value": "海口苏南村镇银行",
        "abbreviationName": "海口苏南村镇银行",
        "code": "HKSNCUNZB"
    }, {"value": "海林远东村镇银行", "abbreviationName": "海林远东村镇银行", "code": "HLYDCUNZB"}, {
        "value": "海伦惠丰村镇银行",
        "abbreviationName": "海伦惠丰村镇银行",
        "code": "HLHFCUNZB"
    }, {"value": "海南白沙农村商业银行", "abbreviationName": "海南白沙农商", "code": "HNBSRCB"}, {
        "value": "海南白沙长江村镇银行",
        "abbreviationName": "海南白沙长江村镇银行",
        "code": "HNBSCJCUNZB"
    }, {"value": "海南保亭融兴村镇银行", "abbreviationName": "海南保亭融兴村镇银行", "code": "HNBTRXCUNZB"}, {
        "value": "海南昌江长江村镇银行",
        "abbreviationName": "海南昌江长江村镇银行",
        "code": "HNCJCJCUNZB"
    }, {"value": "海南澄迈农村商业银行", "abbreviationName": "海南澄迈农商", "code": "HNCMRCB"}, {
        "value": "海南澄迈长江村镇银行",
        "abbreviationName": "海南澄迈长江村镇银行",
        "code": "HNCMCJCUNZB"
    }, {"value": "海南儋州绿色村镇银行", "abbreviationName": "海南儋州绿色村镇银行", "code": "HNZZLSCUNZB"}, {
        "value": "海南临高农村商业银行",
        "abbreviationName": "海南临高农商",
        "code": "HNLGRCB"
    }, {"value": "海南琼中长江村镇银行", "abbreviationName": "海南琼中长江村镇银行", "code": "HNQZCJCUNZB"}, {
        "value": "海南省农村信用社联合社",
        "abbreviationName": "海南农信社",
        "code": "HNNXS"
    }, {"value": "海南屯昌农村商业银行", "abbreviationName": "海南屯昌农商", "code": "HNTCRCB"}, {
        "value": "海南屯昌长江村镇银行",
        "abbreviationName": "海南屯昌长江村镇银行",
        "code": "HNTCCJCUNZB"
    }, {"value": "海南万宁农村商业银行", "abbreviationName": "海南万宁农商", "code": "HNWNRCB"}, {
        "value": "海南文昌农村商业银行",
        "abbreviationName": "海南文昌农商",
        "code": "HNWCRCB"
    }, {"value": "海南五指山长江村镇银行", "abbreviationName": "海南五指山长江村镇银行", "code": "HNWZSCJCUNZB"}, {
        "value": "海南银行",
        "abbreviationName": "海南",
        "code": "HNYH"
    }, {"value": "海阳珠江村镇银行", "abbreviationName": "海阳珠江村镇银行", "code": "HYZJCUNZB"}, {
        "value": "邯郸肥乡恒升村镇银行",
        "abbreviationName": "邯郸肥乡恒升村镇银行",
        "code": "HDFXHSCUNZB"
    }, {"value": "邯郸邯山齐鲁村镇银行", "abbreviationName": "邯郸邯山齐鲁村镇银行", "code": "HDHSQLCUNZB"}, {
        "value": "邯郸银行",
        "abbreviationName": "邯郸",
        "code": "HDCB"
    }, {"value": "邯郸永年齐鲁村镇银行", "abbreviationName": "邯郸永年齐鲁村镇银行", "code": "HDYNQLCUNZB"}, {
        "value": "含山惠民村镇银行",
        "abbreviationName": "含山惠民村镇银行",
        "code": "HSHMCUNZB"
    }, {"value": "韩城浦发村镇银行", "abbreviationName": "韩城浦发村镇银行", "code": "HCPFCUNZB"}, {
        "value": "韩国产业银行",
        "abbreviationName": "韩国产业",
        "code": "KDBK"
    }, {"value": "韩国大邱银行", "abbreviationName": "韩国大邱", "code": "DGB"}, {
        "value": "韩国釜山银行",
        "abbreviationName": "韩国釜山",
        "code": "BSB"
    }, {"value": "韩亚银行（中国）有限公司", "abbreviationName": "韩亚", "code": "HYYH"}, {
        "value": "汉口银行",
        "abbreviationName": "汉口",
        "code": "HKYH"
    }, {"value": "汉中汉台铺镇聚利村镇银行", "abbreviationName": "汉中汉台铺镇聚利村镇银行", "code": "HZHTPZJLCUNZB"}, {
        "value": "杭锦大众村镇银行",
        "abbreviationName": "杭锦大众村镇银行",
        "code": "HJDZCUNZB"
    }, {"value": "杭锦后旗河套村镇银行", "abbreviationName": "杭锦后旗河套村镇银行", "code": "HJHQHTCUNZB"}, {
        "value": "杭州联合农村商业银行",
        "abbreviationName": "杭州联合农商",
        "code": "HZLHRCB"
    }, {"value": "杭州银行", "abbreviationName": "杭州", "code": "HZYH"}, {
        "value": "合肥科技农村商业银行",
        "abbreviationName": "合肥科技农商",
        "code": "HFKJRCB"
    }, {"value": "合浦国民村镇银行", "abbreviationName": "合浦国民村镇银行", "code": "HPGMCUNZB"}, {
        "value": "合水县金城村镇银行",
        "abbreviationName": "合水县金城村镇银行",
        "code": "HSXJCCUNZB"
    }, {"value": "合阳惠民村镇银行", "abbreviationName": "合阳惠民村镇银行", "code": "HYHMCUNZB"}, {
        "value": "合作金库商业银行",
        "abbreviationName": "合作金库商业银行",
        "code": "TCBBANK"
    }, {"value": "和龙敦银村镇银行", "abbreviationName": "和龙敦银村镇银行", "code": "HLDYCUNZB"}, {
        "value": "和顺县贵都村镇银行",
        "abbreviationName": "和顺县贵都村镇银行",
        "code": "HSXGDCUNZB"
    }, {"value": "和政神舟村镇银行", "abbreviationName": "和政神舟村镇银行", "code": "HZSZCUNZB"}, {
        "value": "河北安国农村商业银行",
        "abbreviationName": "河北安国农商",
        "code": "HBAGRCB"
    }, {"value": "河北安平农村商业银行", "abbreviationName": "河北安平农商", "code": "HBAPRCB"}, {
        "value": "河北霸州农村商业银行",
        "abbreviationName": "河北霸州农商",
        "code": "HBBZRCB"
    }, {"value": "河北柏乡农村商业银行", "abbreviationName": "河北柏乡农商", "code": "HBBXRCB"}, {
        "value": "河北保定农村商业银行",
        "abbreviationName": "河北保定农商",
        "code": "HEBBDRCB"
    }, {"value": "河北沧州农村商业银行", "abbreviationName": "河北沧州农商", "code": "HBCZRCB"}, {
        "value": "河北承德热河农村商业银行",
        "abbreviationName": "河北承德热河农商",
        "code": "HBCDRHRCB"
    }, {"value": "河北大厂农村商业银行", "abbreviationName": "河北大厂农商", "code": "HBDCRCB"}, {
        "value": "河北大名农村商业银行",
        "abbreviationName": "河北大名农商",
        "code": "HBDMRCB"
    }, {"value": "河北定州农村商业银行", "abbreviationName": "河北定州农商", "code": "HBDZRCB"}, {
        "value": "河北丰宁农村商业银行",
        "abbreviationName": "河北丰宁农商",
        "code": "HBFNRCB"
    }, {"value": "河北阜城农村商业银行", "abbreviationName": "河北阜城农商", "code": "HBFCRCB"}, {
        "value": "河北高碑店农村商业银行",
        "abbreviationName": "河北高碑店农商",
        "code": "HBGBDRCB"
    }, {"value": "河北沽源农村商业银行", "abbreviationName": "河北沽源农商", "code": "HBGYRCB"}, {
        "value": "河北固安农村商业银行",
        "abbreviationName": "河北固安农商",
        "code": "HEBGARCB"
    }, {"value": "河北广宗农村商业银行", "abbreviationName": "河北广宗农商", "code": "HBGZRCB"}, {
        "value": "河北邯郸农村商业银行",
        "abbreviationName": "河北邯郸农商",
        "code": "HBHDRCB"
    }, {"value": "河北衡水农村商业银行", "abbreviationName": "河北衡水农商", "code": "HBHSRCB"}, {
        "value": "河北怀来农村商业银行",
        "abbreviationName": "河北怀来农商",
        "code": "HBHLRCB"
    }, {"value": "河北黄骅农村商业银行", "abbreviationName": "河北黄骅农商", "code": "HBHHRCB"}, {
        "value": "河北鸡泽农村商业银行",
        "abbreviationName": "河北鸡泽农商",
        "code": "HBJIZRCB"
    }, {"value": "河北冀州农村商业银行", "abbreviationName": "河北冀州农商", "code": "HBYZRCB"}, {
        "value": "河北晋州农村商业银行",
        "abbreviationName": "河北晋州农商",
        "code": "HBJINZRCB"
    }, {"value": "河北井陉农村商业银行", "abbreviationName": "河北井陉农商", "code": "HBJJRCB"}, {
        "value": "河北景州农村商业银行",
        "abbreviationName": "河北景州农商",
        "code": "HBJZRCB"
    }, {"value": "河北巨鹿农村商业银行", "abbreviationName": "河北巨鹿农商", "code": "HEBJLRCB"}, {
        "value": "河北宽城农村商业银行",
        "abbreviationName": "河北宽城农商",
        "code": "HBKCRCB"
    }, {"value": "河北涞水农村商业银行", "abbreviationName": "河北涞水农商", "code": "HBLSRCB"}, {
        "value": "河北蠡州北银农村商业银行",
        "abbreviationName": "河北蠡州北银农商",
        "code": "HBLZBYRCB"
    }, {"value": "河北临城农村商业银行", "abbreviationName": "河北临城农商", "code": "HBLCRCB"}, {
        "value": "河北临西农村商业银行",
        "abbreviationName": "河北临西农商",
        "code": "HBLXRCB"
    }, {"value": "河北灵寿农村商业银行", "abbreviationName": "河北灵寿农商", "code": "HBLINGSRCB"}, {
        "value": "河北卢龙农村商业银行",
        "abbreviationName": "河北卢龙农商",
        "code": "HBLLRCB"
    }, {"value": "河北滦南农村商业银行", "abbreviationName": "河北滦南农商", "code": "HBLNRCB"}, {
        "value": "河北滦平农村商业银行",
        "abbreviationName": "河北滦平农商",
        "code": "HBLPRCB"
    }, {"value": "河北滦州农村商业银行", "abbreviationName": "河北滦州农商", "code": "HBLZRCB"}, {
        "value": "河北南和农村商业银行",
        "abbreviationName": "河北南和农商",
        "code": "HBNHRCB"
    }, {"value": "河北南皮农村商业银行", "abbreviationName": "河北南皮农商", "code": "HBNPRCB"}, {
        "value": "河北宁晋农村商业银行",
        "abbreviationName": "河北宁晋农商",
        "code": "HBNJRCB"
    }, {"value": "河北平山农村商业银行", "abbreviationName": "河北平山农商", "code": "HBPSRCB"}, {
        "value": "河北迁安农村商业银行",
        "abbreviationName": "河北迁安农商",
        "code": "HBQARCB"
    }, {"value": "河北清河农村商业银行", "abbreviationName": "河北清河农商", "code": "HBQHRCB"}, {
        "value": "河北任县农村商业银行",
        "abbreviationName": "河北任县农商",
        "code": "HBRXRCB"
    }, {"value": "河北三河农村商业银行", "abbreviationName": "河北三河农商", "code": "HEBSHRCB"}, {
        "value": "河北沙河农村商业银行",
        "abbreviationName": "河北沙河农商",
        "code": "HBSHRCB"
    }, {"value": "河北涉县农村商业银行", "abbreviationName": "河北涉县农商", "code": "HBSXRCB"}, {
        "value": "河北深州农村商业银行",
        "abbreviationName": "河北深州农商",
        "code": "HEBSZRCB"
    }, {"value": "河北省农村信用社联合社", "abbreviationName": "河北农信社", "code": "HEBNXS"}, {
        "value": "河北唐山曹妃甸农村商业银行",
        "abbreviationName": "河北唐山曹妃甸农商",
        "code": "HBTSCFDRCB"
    }, {"value": "河北唐山农村商业银行", "abbreviationName": "河北唐山农商", "code": "HBTSRCB"}, {
        "value": "河北围场农村商业银行",
        "abbreviationName": "河北围场农商",
        "code": "HBWCRCB"
    }, {"value": "河北文安农村商业银行", "abbreviationName": "河北文安农商", "code": "HBWARCB"}, {
        "value": "河北武强农村商业银行",
        "abbreviationName": "河北武强农商",
        "code": "HBWUQRCB"
    }, {"value": "河北献县农村商业银行", "abbreviationName": "河北献县农商", "code": "HBXXRCB"}, {
        "value": "河北香河农村商业银行",
        "abbreviationName": "河北香河农商",
        "code": "HBXHRCB"
    }, {"value": "河北辛集农村商业银行", "abbreviationName": "河北辛集农商", "code": "HBXJRCB"}, {
        "value": "河北邢台农村商业银行",
        "abbreviationName": "河北邢台农商",
        "code": "HBXTRCB"
    }, {"value": "河北邢州农村商业银行", "abbreviationName": "河北邢州农商", "code": "HBXZRCB"}, {
        "value": "河北阳原农村商业银行",
        "abbreviationName": "河北阳原农商",
        "code": "HBYYRCB"
    }, {"value": "河北银行", "abbreviationName": "河北", "code": "HBYH"}, {
        "value": "河北永清农村商业银行",
        "abbreviationName": "河北永清农商",
        "code": "HBYQRCB"
    }, {"value": "河北玉田农村商业银行", "abbreviationName": "河北玉田农商", "code": "HBYTRCB"}, {
        "value": "河北元氏农村商业银行",
        "abbreviationName": "河北元氏农商",
        "code": "HEBYSRCB"
    }, {"value": "河北枣强农村商业银行", "abbreviationName": "河北枣强农商", "code": "HBZQRCB"}, {
        "value": "河北张北农村商业银行",
        "abbreviationName": "河北张北农商",
        "code": "HBZBRCB"
    }, {"value": "河北正定农村商业银行", "abbreviationName": "河北正定农商", "code": "HBZDRCB"}, {
        "value": "河北涿鹿农村商业银行",
        "abbreviationName": "河北涿鹿农商",
        "code": "HBZLRCB"
    }, {"value": "河北涿州农村商业银行", "abbreviationName": "河北涿州农商", "code": "HBZZRCB"}, {
        "value": "河间融惠村镇银行",
        "abbreviationName": "河间融惠村镇银行",
        "code": "HJRHCUNZB"
    }, {"value": "河津市龙都村镇银行", "abbreviationName": "河津市龙都村镇银行", "code": "HJSLDCUNZB"}, {
        "value": "河南安阳商都农村商业银行",
        "abbreviationName": "河南安阳商都农商",
        "code": "HNAYSDRCB"
    }, {"value": "河南安阳相州农村商业银行", "abbreviationName": "河南安阳相州农商", "code": "HNAYXZRCB"}, {
        "value": "河南宝丰农村商业银行",
        "abbreviationName": "河南宝丰农商",
        "code": "HNBFRCB"
    }, {"value": "河南汴京农村商业银行", "abbreviationName": "河南汴京农商", "code": "HNBJRCB"}, {
        "value": "河南博爱农村商业银行",
        "abbreviationName": "河南博爱农商",
        "code": "HNBARCB"
    }, {"value": "河南登封农村商业银行", "abbreviationName": "河南登封农商", "code": "HNDFRCB"}, {
        "value": "河南邓州农村商业银行",
        "abbreviationName": "河南邓州农商",
        "code": "HNDZRCB"
    }, {"value": "河南范县农村商业银行", "abbreviationName": "河南范县农商", "code": "HNFXRCB"}, {
        "value": "河南方城凤裕村镇银行",
        "abbreviationName": "河南方城凤裕村镇银行",
        "code": "HNFCFYCUNZB"
    }, {"value": "河南扶沟农村商业银行", "abbreviationName": "河南扶沟农商", "code": "HNFGRCB"}, {
        "value": "河南巩义农村商业银行",
        "abbreviationName": "河南巩义农商",
        "code": "HNGYRCB"
    }, {"value": "河南固始农村商业银行", "abbreviationName": "河南固始农商", "code": "HNGSRCB"}, {
        "value": "河南光山农村商业银行",
        "abbreviationName": "河南光山农商",
        "code": "HNGSHRCB"
    }, {"value": "河南滑县农村商业银行", "abbreviationName": "河南滑县农商", "code": "HNHUAXRCB"}, {
        "value": "河南淮滨农村商业银行",
        "abbreviationName": "河南淮滨农商",
        "code": "HNHBRCB"
    }, {"value": "河南潢川农村商业银行", "abbreviationName": "河南潢川农商", "code": "HNHCRCB"}, {
        "value": "河南辉县农村商业银行",
        "abbreviationName": "河南辉县农商",
        "code": "HNHXRCB"
    }, {"value": "河南获嘉农村商业银行", "abbreviationName": "河南获嘉农商", "code": "HNHJRCB"}, {
        "value": "河南济源农村商业银行",
        "abbreviationName": "河南济源农商",
        "code": "HNJYRCB"
    }, {"value": "河南浚县农村商业银行", "abbreviationName": "河南浚县农商", "code": "HNXUNXRCB"}, {
        "value": "河南兰考农村商业银行",
        "abbreviationName": "河南兰考农商",
        "code": "HNLKRCB"
    }, {"value": "河南林州农村商业银行", "abbreviationName": "河南林州农商", "code": "HNLZRCB"}, {
        "value": "河南灵宝农村商业银行",
        "abbreviationName": "河南灵宝农商",
        "code": "HNLBRCB"
    }, {"value": "河南卢氏农村商业银行", "abbreviationName": "河南卢氏农商", "code": "HNLUSRCB"}, {
        "value": "河南鹿邑农村商业银行",
        "abbreviationName": "河南鹿邑农商",
        "code": "HNLUYRCB"
    }, {"value": "河南栾川民丰村镇银行", "abbreviationName": "河南栾川民丰村镇银行", "code": "HNZCMFCUNZB"}, {
        "value": "河南栾川农村商业银行",
        "abbreviationName": "河南栾川农商",
        "code": "HNLCRCB"
    }, {"value": "河南罗山农村商业银行", "abbreviationName": "河南罗山农商", "code": "HNLUOSRCB"}, {
        "value": "河南洛宁农村商业银行",
        "abbreviationName": "河南洛宁农商",
        "code": "HNLNRCB"
    }, {"value": "河南孟津农村商业银行", "abbreviationName": "河南孟津农商", "code": "HNMJRCB"}, {
        "value": "河南孟州农村商业银行",
        "abbreviationName": "河南孟州农商",
        "code": "HNMZRCB"
    }, {"value": "河南泌阳农村商业银行", "abbreviationName": "河南泌阳农商", "code": "HNBYRCB"}, {
        "value": "河南渑池农村商业银行",
        "abbreviationName": "河南渑池农商",
        "code": "HNMCRCB"
    }, {"value": "河南民权农村商业银行", "abbreviationName": "河南民权农商", "code": "HNMQRCB"}, {
        "value": "河南南乐农村商业银行",
        "abbreviationName": "河南南乐农商",
        "code": "HNNLRCB"
    }, {"value": "河南南召农村商业银行", "abbreviationName": "河南南召农商", "code": "HNNZRCB"}, {
        "value": "河南内乡农村商业银行",
        "abbreviationName": "河南内乡农商",
        "code": "HNNEIXRCB"
    }, {"value": "河南平舆农村商业银行", "abbreviationName": "河南平舆农商", "code": "HNPYRCB"}, {
        "value": "河南濮阳开州农村商业银行",
        "abbreviationName": "河南濮阳开州农商",
        "code": "HNPYKZRCB"
    }, {"value": "河南杞县农村商业银行", "abbreviationName": "河南杞县农商", "code": "HNQXRCB"}, {
        "value": "河南沁阳江南村镇银行",
        "abbreviationName": "河南沁阳江南村镇银行",
        "code": "HNQYJNCUNZB"
    }, {"value": "河南沁阳农村商业银行", "abbreviationName": "河南沁阳农商", "code": "HNQINYRCB"}, {
        "value": "河南清丰农村商业银行",
        "abbreviationName": "河南清丰农商",
        "code": "HNQFRCB"
    }, {"value": "河南确山农村商业银行", "abbreviationName": "河南确山农商", "code": "HNQSRCB"}, {
        "value": "河南汝南农村商业银行",
        "abbreviationName": "河南汝南农商",
        "code": "HNNNRCB"
    }, {"value": "河南汝南泰隆村镇银行", "abbreviationName": "河南汝南泰隆村镇银行", "code": "HNRNTLCUNZB"}, {
        "value": "河南汝阳农村商业银行",
        "abbreviationName": "河南汝阳农商",
        "code": "HNRYRCB"
    }, {"value": "河南汝州农村商业银行", "abbreviationName": "河南汝州农商", "code": "HNRZRCB"}, {
        "value": "河南商水农村商业银行",
        "abbreviationName": "河南商水农商",
        "code": "HNSSRCB"
    }, {"value": "河南商水厦农商村镇银行", "abbreviationName": "河南商水厦农商村镇银行", "code": "HNSSXNSCUNZB"}, {
        "value": "河南上蔡农村商业银行",
        "abbreviationName": "河南上蔡农商",
        "code": "HNSCRCB"
    }, {"value": "河南社旗农村商业银行", "abbreviationName": "河南社旗农商", "code": "HNSHEQRCB"}, {
        "value": "河南沈丘农村商业银行",
        "abbreviationName": "河南沈丘农商",
        "code": "HNSQRCB"
    }, {"value": "河南省农村信用社联合社", "abbreviationName": "河南农信社", "code": "HENNXS"}, {
        "value": "河南嵩县农村商业银行",
        "abbreviationName": "河南嵩县农商",
        "code": "HNSXRCB"
    }, {"value": "河南遂平农村商业银行", "abbreviationName": "河南遂平农商", "code": "HNSUIPRCB"}, {
        "value": "河南台前农村商行银行",
        "abbreviationName": "河南台前农商",
        "code": "HNTQRCB"
    }, {"value": "河南太康农村商业银行", "abbreviationName": "河南太康农商", "code": "HNTKRCB"}, {
        "value": "河南汤阴农村商业银行",
        "abbreviationName": "河南汤阴农商",
        "code": "HNTYRCB"
    }, {"value": "河南通许农村商业银行", "abbreviationName": "河南通许农商", "code": "HNTXRCB"}, {
        "value": "河南桐柏农村商业银行",
        "abbreviationName": "河南桐柏农商",
        "code": "HNTBRCB"
    }, {"value": "河南卫辉农村商业银行", "abbreviationName": "河南卫辉农商", "code": "HNWHRCB"}, {
        "value": "河南尉氏农村商业银行",
        "abbreviationName": "河南尉氏农商",
        "code": "HNWSRCB"
    }, {"value": "河南武陟农村商业银行", "abbreviationName": "河南武陟农商", "code": "HNWZRCB"}, {
        "value": "河南舞钢农村商业银行",
        "abbreviationName": "河南舞钢农商",
        "code": "HNWGRCB"
    }, {"value": "河南西华厦农商村镇银行", "abbreviationName": "河南西华厦农商村镇银行", "code": "HNXHXNSCUNZB"}, {
        "value": "河南西平农村商业银行",
        "abbreviationName": "河南西平农商",
        "code": "HNXPRCB"
    }, {"value": "河南西峡农村商业银行", "abbreviationName": "河南西峡农商", "code": "HNXIXRCB"}, {
        "value": "河南息县农村商业银行",
        "abbreviationName": "河南息县农商",
        "code": "HENXXRCB"
    }, {"value": "河南淅川农村商业银行", "abbreviationName": "河南淅川农商", "code": "HNXICRCB"}, {
        "value": "河南襄城农村商业银行",
        "abbreviationName": "河南襄城农商",
        "code": "HNXIANGCRCB"
    }, {"value": "河南项城农村商业银行", "abbreviationName": "河南项城农商", "code": "HENXCRCB"}, {
        "value": "河南新安农村商业银行",
        "abbreviationName": "河南新安农商",
        "code": "HNXARCB"
    }, {"value": "河南新蔡农村商业银行", "abbreviationName": "河南新蔡农商", "code": "HNXCRCB"}, {
        "value": "河南新密农村商业银行",
        "abbreviationName": "河南新密农商",
        "code": "HNXMRCB"
    }, {"value": "河南新县农村商业银行", "abbreviationName": "河南新县农商", "code": "HNXXRCB"}, {
        "value": "河南新乡平原农村商业银行",
        "abbreviationName": "河南新乡平原农商",
        "code": "XXPYRCB"
    }, {"value": "河南新野农村商业银行", "abbreviationName": "河南新野农商", "code": "HNXYERCB"}, {
        "value": "河南新郑农村商业银行",
        "abbreviationName": "河南新郑农商",
        "code": "HNXZRCB"
    }, {"value": "河南荥阳农村商业银行", "abbreviationName": "河南荥阳农商", "code": "HNXYRCB"}, {
        "value": "河南修武农村商业银行",
        "abbreviationName": "河南修武农商",
        "code": "HNXWRCB"
    }, {"value": "河南许昌许都农村商业银行", "abbreviationName": "河南许昌许都农商", "code": "HNXCXDRCB"}, {
        "value": "河南鄢陵农村商业银行",
        "abbreviationName": "河南鄢陵农商",
        "code": "HNYLRCB"
    }, {"value": "河南延津农村商业银行", "abbreviationName": "河南延津农商", "code": "HENYJRCB"}, {
        "value": "河南偃师农村商业银行",
        "abbreviationName": "河南偃师农商",
        "code": "HNYSRCB"
    }, {"value": "河南叶县农村商业银行", "abbreviationName": "河南叶县农商", "code": "HNYEXRCB"}, {
        "value": "河南叶县泰隆村镇银行",
        "abbreviationName": "河南叶县泰隆村镇银行",
        "code": "HNYXTLCUNZB"
    }, {"value": "河南伊川农村商业银行", "abbreviationName": "河南伊川农商", "code": "HNYICRCB"}, {
        "value": "河南宜阳农村商业银行",
        "abbreviationName": "河南宜阳农商",
        "code": "HNYYRCB"
    }, {"value": "河南义马农村商业银行", "abbreviationName": "河南义马农商", "code": "HNYMRCB"}, {
        "value": "河南永城农村商业银行",
        "abbreviationName": "河南永城农商",
        "code": "HNYCRCB"
    }, {"value": "河南原阳农村商业银行", "abbreviationName": "河南原阳农商", "code": "HNYYANRCB"}, {
        "value": "河南长葛农村商业银行",
        "abbreviationName": "河南长葛农商",
        "code": "HNCGRCB"
    }, {"value": "河南长垣农村商业银行", "abbreviationName": "河南长垣农商", "code": "HNCYRCB"}, {
        "value": "河南柘城农村商业银行",
        "abbreviationName": "河南柘城农商",
        "code": "HNZCRCB"
    }, {"value": "河南镇平农村商业银行", "abbreviationName": "河南镇平农商", "code": "HNZPRCB"}, {
        "value": "河南正阳农村商业银行",
        "abbreviationName": "河南正阳农商",
        "code": "HNZYRCB"
    }, {"value": "河南中牟农村商业银行", "abbreviationName": "河南中牟农商", "code": "HNZMRCB"}, {
        "value": "荷兰安智银行",
        "abbreviationName": "荷兰安智",
        "code": "HLAZYH"
    }, {"value": "荷兰合作银行", "abbreviationName": "荷兰合作", "code": "HLHZYH"}, {
        "value": "菏泽牡丹北海村镇银行",
        "abbreviationName": "菏泽牡丹北海村镇银行",
        "code": "HZMDBHCUNZB"
    }, {"value": "菏泽农村商业银行", "abbreviationName": "菏泽农商", "code": "HZRCB"}, {
        "value": "贺州八步东盈村镇银行",
        "abbreviationName": "贺州八步东盈村镇银行",
        "code": "HZBBDYCUNZB"
    }, {"value": "赫章富民村镇银行", "abbreviationName": "赫章富民村镇银行", "code": "HZFMCUNZB"}, {
        "value": "鹤壁农村商业银行",
        "abbreviationName": "鹤壁农商",
        "code": "HEBIRCB"
    }, {"value": "鹤山珠江村镇银行", "abbreviationName": "鹤山珠江村镇银行", "code": "HSZJCUNZB"}, {
        "value": "黑河农村商业银行",
        "abbreviationName": "黑河农商",
        "code": "HHERCB"
    }, {"value": "黑龙江安达农村商业银行", "abbreviationName": "黑龙江安达农商", "code": "HLJADRCB"}, {
        "value": "黑龙江宝清农村商业银行",
        "abbreviationName": "黑龙江宝清农商",
        "code": "HLJBQRCB"
    }, {"value": "黑龙江北安农村商业银行", "abbreviationName": "黑龙江北安农商", "code": "HLJBARCB"}, {
        "value": "黑龙江宾州农村商业银行",
        "abbreviationName": "黑龙江宾州农商",
        "code": "HLJBZRCB"
    }, {"value": "黑龙江东宁农村商业银行", "abbreviationName": "黑龙江东宁农商", "code": "HLJDNRCB"}, {
        "value": "黑龙江杜尔伯特农村商业银行",
        "abbreviationName": "黑龙江杜尔伯特农商",
        "code": "HLJDEBTRCB"
    }, {"value": "黑龙江方正农村商业银行", "abbreviationName": "黑龙江方正农商", "code": "HLJFZRCB"}, {
        "value": "黑龙江抚远农村商业银行",
        "abbreviationName": "黑龙江抚远农商",
        "code": "HLJFYRCB"
    }, {"value": "黑龙江富裕农村商业银行", "abbreviationName": "黑龙江富裕农商", "code": "HLJFYURCB"}, {
        "value": "黑龙江甘南农村商业银行",
        "abbreviationName": "黑龙江甘南农商",
        "code": "HLJGNRCB"
    }, {"value": "黑龙江呼玛农村商业银行", "abbreviationName": "黑龙江呼玛农商", "code": "HLJHMRCB"}, {
        "value": "黑龙江虎林农村商业银行",
        "abbreviationName": "黑龙江虎林农商",
        "code": "HLJHLRCB"
    }, {"value": "黑龙江鸡东农村商业银行", "abbreviationName": "黑龙江鸡东农商", "code": "HLJJDRCB"}, {
        "value": "黑龙江鸡西农村商业银行",
        "abbreviationName": "黑龙江鸡西农商",
        "code": "HLJJIXRCB"
    }, {"value": "黑龙江集贤农村商业银行", "abbreviationName": "黑龙江集贤农商", "code": "HLJJXRCB"}, {
        "value": "黑龙江建三江农村商业银行",
        "abbreviationName": "黑龙江建三江农商",
        "code": "HLJJSJRCB"
    }, {"value": "黑龙江克东农村商业银行", "abbreviationName": "黑龙江克东农商", "code": "HLJKDRCB"}, {
        "value": "黑龙江克山农村商业银行",
        "abbreviationName": "黑龙江克山农商",
        "code": "HLJKSRCB"
    }, {"value": "黑龙江林甸农村商业银行", "abbreviationName": "黑龙江林甸农商", "code": "HLJLDRCB"}, {
        "value": "黑龙江萝北农村商业银行",
        "abbreviationName": "黑龙江萝北农商",
        "code": "HLJLBRCB"
    }, {"value": "黑龙江密山农村商业银行", "abbreviationName": "黑龙江密山农商", "code": "HLJMISRCB"}, {
        "value": "黑龙江明水农村商业银行",
        "abbreviationName": "黑龙江明水农商",
        "code": "HLJMSRCB"
    }, {"value": "黑龙江漠河农村商业银行", "abbreviationName": "黑龙江漠河农商", "code": "HLJMHRCB"}, {
        "value": "黑龙江讷河农村商业银行",
        "abbreviationName": "黑龙江讷河农商",
        "code": "HLJNHRCB"
    }, {"value": "黑龙江嫩江农村商业银行", "abbreviationName": "黑龙江嫩江农商", "code": "HLJNJRCB"}, {
        "value": "黑龙江庆安农村商业银行",
        "abbreviationName": "黑龙江庆安农商",
        "code": "HLJQARCB"
    }, {"value": "黑龙江饶河农村商业银行", "abbreviationName": "黑龙江饶河农商", "code": "HLJRHRCB"}, {
        "value": "黑龙江省农村信用社联合社",
        "abbreviationName": "黑龙江农信社",
        "code": "HLJNXS"
    }, {"value": "黑龙江绥滨农村商业银行", "abbreviationName": "黑龙江绥滨农商", "code": "HLJSBRCB"}, {
        "value": "黑龙江绥芬河农村商业银行",
        "abbreviationName": "黑龙江绥芬河农商",
        "code": "HLJSFHRCB"
    }, {"value": "黑龙江绥化农村商业银行", "abbreviationName": "黑龙江绥化农商", "code": "HLJSHRCB"}, {
        "value": "黑龙江绥棱农村商业银行",
        "abbreviationName": "黑龙江绥棱农商",
        "code": "HLJSLRCB"
    }, {"value": "黑龙江孙吴农村商业银行", "abbreviationName": "黑龙江孙吴农商", "code": "HLJSWRCB"}, {
        "value": "黑龙江塔河农村商业银行",
        "abbreviationName": "黑龙江塔河农商",
        "code": "HLJTHRCB"
    }, {"value": "黑龙江泰来农村商业银行", "abbreviationName": "黑龙江泰来农商", "code": "HLJTLRCB"}, {
        "value": "黑龙江汤原农村商业银行",
        "abbreviationName": "黑龙江汤原农商",
        "code": "HLJTYRCB"
    }, {"value": "黑龙江通河农村商业银行", "abbreviationName": "黑龙江通河农商", "code": "HLJTONGHRCB"}, {
        "value": "黑龙江同江农村商业银行",
        "abbreviationName": "黑龙江同江农商",
        "code": "HLJTJRCB"
    }, {"value": "黑龙江五常农村商业银行", "abbreviationName": "黑龙江五常农商", "code": "HLJWCRCB"}, {
        "value": "黑龙江五大连池农村商业银行",
        "abbreviationName": "黑龙江五大连池农商",
        "code": "HLJWDLCRCB"
    }, {"value": "黑龙江逊克农村商业银行", "abbreviationName": "黑龙江逊克农商", "code": "HLJXKRCB"}, {
        "value": "黑龙江延寿农村商业银行",
        "abbreviationName": "黑龙江延寿农商",
        "code": "HLJYSRCB"
    }, {"value": "黑龙江友谊农村商业银行", "abbreviationName": "黑龙江友谊农商", "code": "HLJYYRCB"}, {
        "value": "黑龙江肇源农村商业银行",
        "abbreviationName": "黑龙江肇源农商",
        "code": "HLJZYRCB"
    }, {"value": "黑龙江肇州农村商业银行", "abbreviationName": "黑龙江肇州农商", "code": "HLJZZRCB"}, {
        "value": "恒丰银行",
        "abbreviationName": "恒丰",
        "code": "EGB"
    }, {"value": "恒生银行（中国）有限公司", "abbreviationName": "恒生", "code": "HSB"}, {
        "value": "横峰恒通村镇银行",
        "abbreviationName": "横峰恒通村镇银行",
        "code": "HFHTCUNZB"
    }, {"value": "衡南浦发村镇银行", "abbreviationName": "衡南浦发村镇银行", "code": "HNPFCUNZB"}, {
        "value": "衡水冀州丰源村镇银行",
        "abbreviationName": "衡水冀州丰源村镇银行",
        "code": "HSJZFYCUNZB"
    }, {"value": "衡水银行", "abbreviationName": "衡水", "code": "HSYH"}, {
        "value": "衡阳农村商业银行",
        "abbreviationName": "衡阳农商",
        "code": "HYRCB"
    }, {"value": "衡阳县沪农商村镇银行", "abbreviationName": "衡阳县沪农商村镇银行", "code": "HYXHNSCUNZB"}, {
        "value": "洪洞县洪都村镇银行",
        "abbreviationName": "洪洞县洪都村镇银行",
        "code": "HDXHDCUNZB"
    }, {"value": "洪湖融兴村镇银行", "abbreviationName": "洪湖融兴村镇银行", "code": "HHRXCUNZB"}, {
        "value": "侯马市太行村镇银行",
        "abbreviationName": "侯马市太行村镇银行",
        "code": "HMSTXCUNZB"
    }, {"value": "呼和浩特金桥河套村镇银行", "abbreviationName": "呼和浩特金桥河套村镇银行", "code": "HHHTJQHTCUNZB"}, {
        "value": "呼和浩特市如意蒙银村镇银行",
        "abbreviationName": "呼和浩特市如意蒙银村镇银行",
        "code": "HHHTSRYMYCUNZB"
    }, {"value": "呼和浩特市赛罕金谷村镇银行", "abbreviationName": "呼和浩特市赛罕金谷村镇银行", "code": "HHHTSSHJGCUNZB"}, {
        "value": "呼和浩特市赛罕蒙银村镇银行",
        "abbreviationName": "呼和浩特市赛罕蒙银村镇银行",
        "code": "HHHTSSHMYCUNZB"
    }, {"value": "呼和浩特市新城蒙银村镇银行", "abbreviationName": "呼和浩特市新城蒙银村镇银行", "code": "HHHTSXCMYCUNZB"}, {
        "value": "呼和浩特市玉泉蒙银村镇银行",
        "abbreviationName": "呼和浩特市玉泉蒙银村镇银行",
        "code": "HHHTSYQMYCUNZB"
    }, {"value": "呼伦贝尔农村商业银行", "abbreviationName": "呼伦贝尔农商", "code": "HLBERCB"}, {
        "value": "呼图壁津汇村镇银行",
        "abbreviationName": "呼图壁津汇村镇银行",
        "code": "HTBJHCUNZB"
    }, {"value": "壶关县晋融村镇银行", "abbreviationName": "壶关县晋融村镇银行", "code": "HGXJRCUNZB"}, {
        "value": "葫芦岛国信村镇银行",
        "abbreviationName": "葫芦岛国信村镇银行",
        "code": "HLDGXCUNZB"
    }, {"value": "葫芦岛农村商业银行", "abbreviationName": "葫芦岛农商", "code": "HLDRCB"}, {
        "value": "葫芦岛银行",
        "abbreviationName": "葫芦岛",
        "code": "HLDYH"
    }, {"value": "湖北安陆农村商业银行", "abbreviationName": "湖北安陆农商", "code": "HBALRCB"}, {
        "value": "湖北巴东农村商业银行",
        "abbreviationName": "湖北巴东农商",
        "code": "HBBDRCB"
    }, {"value": "湖北保康农村商业银行", "abbreviationName": "湖北保康农商", "code": "HBBKRCB"}, {
        "value": "湖北赤壁农村商业银行",
        "abbreviationName": "湖北赤壁农商",
        "code": "HBCBRCB"
    }, {"value": "湖北赤壁长江村镇银行", "abbreviationName": "湖北赤壁长江村镇银行", "code": "HBCBCJCUNZB"}, {
        "value": "湖北崇阳农村商业银行",
        "abbreviationName": "湖北崇阳农商",
        "code": "HBCYRCB"
    }, {"value": "湖北大悟农村商业银行", "abbreviationName": "湖北大悟农商", "code": "HBDWRCB"}, {
        "value": "湖北大冶农村商业银行",
        "abbreviationName": "湖北大冶农商",
        "code": "HBDAYRCB"
    }, {"value": "湖北大冶泰隆村镇银行", "abbreviationName": "湖北大冶泰隆村镇银行", "code": "HBDYTLCUNZB"}, {
        "value": "湖北丹江口农村商业银行",
        "abbreviationName": "湖北丹江口农商",
        "code": "HBDJKRCB"
    }, {"value": "湖北当阳农村商业银行", "abbreviationName": "湖北当阳农商", "code": "HBDYRCB"}, {
        "value": "湖北鄂州农村商业银行",
        "abbreviationName": "湖北鄂州农商",
        "code": "HBEZRCB"
    }, {"value": "湖北恩施农村商业银行", "abbreviationName": "湖北恩施农商", "code": "HBESRCB"}, {
        "value": "湖北房县农村商业银行",
        "abbreviationName": "湖北房县农商",
        "code": "HBFXRCB"
    }, {"value": "湖北公安农村商业银行", "abbreviationName": "湖北公安农商", "code": "HBGARCB"}, {
        "value": "湖北谷城农村商业银行",
        "abbreviationName": "湖北谷城农商",
        "code": "HBGCRCB"
    }, {"value": "湖北广水农村商业银行", "abbreviationName": "湖北广水农商", "code": "HBGSRCB"}, {
        "value": "湖北汉川农村商业银行",
        "abbreviationName": "湖北汉川农商",
        "code": "HBHCRCB"
    }, {"value": "湖北汉川农银村镇银行", "abbreviationName": "湖北汉川农银村镇银行", "code": "HBHCNYCUNZB"}, {
        "value": "湖北鹤峰农村商业银行",
        "abbreviationName": "湖北鹤峰农商",
        "code": "HBHFRCB"
    }, {"value": "湖北红安农村商业银行", "abbreviationName": "湖北红安农商", "code": "HBHARCB"}, {
        "value": "湖北红安长江村镇银行",
        "abbreviationName": "湖北红安长江村镇银行",
        "code": "HBHACJCUNZB"
    }, {"value": "湖北洪湖农村商业银行", "abbreviationName": "湖北洪湖农商", "code": "HUBHHRCB"}, {
        "value": "湖北黄冈农村商业银行",
        "abbreviationName": "湖北黄冈农商",
        "code": "HBHGRCB"
    }, {"value": "湖北黄梅农村商业银行", "abbreviationName": "湖北黄梅农商", "code": "HBHMRCB"}, {
        "value": "湖北嘉鱼农村商业银行",
        "abbreviationName": "湖北嘉鱼农商",
        "code": "HBJYRCB"
    }, {"value": "湖北嘉鱼吴江村镇银行", "abbreviationName": "湖北嘉鱼吴江村镇银行", "code": "HBJYWJCUNZB"}, {
        "value": "湖北监利农村商业银行",
        "abbreviationName": "湖北监利农商",
        "code": "HBJLIRCB"
    }, {"value": "湖北建始农村商业银行", "abbreviationName": "湖北建始农商", "code": "HBJSRCB"}, {
        "value": "湖北江陵农村商业银行",
        "abbreviationName": "湖北江陵农商",
        "code": "HBJLRCB"
    }, {"value": "湖北京山农村商业银行", "abbreviationName": "湖北京山农商", "code": "HBJINGSRCB"}, {
        "value": "湖北荆门掇刀德通村镇银行",
        "abbreviationName": "湖北荆门掇刀德通村镇银行",
        "code": "HBJMDDBSCUNZB"
    }, {"value": "湖北荆门农村商业银行", "abbreviationName": "湖北荆门农商", "code": "HBJMRCB"}, {
        "value": "湖北荆州农村商业银行",
        "abbreviationName": "湖北荆州农商",
        "code": "HUBJZRCB"
    }, {"value": "湖北来凤农村商业银行", "abbreviationName": "湖北来凤农商", "code": "HBLFRCB"}, {
        "value": "湖北老河口农村商业银行",
        "abbreviationName": "湖北老河口农商",
        "code": "HBLHKRCB"
    }, {"value": "湖北利川农村商业银行", "abbreviationName": "湖北利川农商", "code": "HUBLCRCB"}, {
        "value": "湖北罗田农村商业银行",
        "abbreviationName": "湖北罗田农商",
        "code": "HBLTRCB"
    }, {"value": "湖北麻城汇丰村镇银行", "abbreviationName": "湖北麻城汇丰村镇银行", "code": "HBMCHFCUNZB"}, {
        "value": "湖北麻城农村商业银行",
        "abbreviationName": "湖北麻城农商",
        "code": "HBMCRCB"
    }, {"value": "湖北南漳农村商业银行", "abbreviationName": "湖北南漳农商", "code": "HBNZRCB"}, {
        "value": "湖北蕲春农村商业银行",
        "abbreviationName": "湖北蕲春农商",
        "code": "HBQCRCB"
    }, {"value": "湖北潜江农村商业银行", "abbreviationName": "湖北潜江农商", "code": "HBQJRCB"}, {
        "value": "湖北三峡农村商业银行",
        "abbreviationName": "湖北三峡农商",
        "code": "HBSXIARCB"
    }, {"value": "湖北沙洋农村商业银行", "abbreviationName": "湖北沙洋农商", "code": "HBSYRCB"}, {
        "value": "湖北神农架农村商业银行",
        "abbreviationName": "湖北神农架农商",
        "code": "HBSNJRCB"
    }, {"value": "湖北省农村信用社联合社", "abbreviationName": "湖北农信社", "code": "HBNXS"}, {
        "value": "湖北十堰农村商业银行",
        "abbreviationName": "湖北十堰农商",
        "code": "HBSHIYRCB"
    }, {"value": "湖北石首农村商业银行", "abbreviationName": "湖北石首农商", "code": "HBSSRCB"}, {
        "value": "湖北松滋农村商业银行",
        "abbreviationName": "湖北松滋农商",
        "code": "HBSZIRCB"
    }, {"value": "湖北随州曾都汇丰村镇银行", "abbreviationName": "湖北随州曾都汇丰村镇银行", "code": "HBSZZDHFCUNZB"}, {
        "value": "湖北随州农村商业银行",
        "abbreviationName": "湖北随州农商",
        "code": "HBSZRCB"
    }, {"value": "湖北天门汇丰村镇银行", "abbreviationName": "湖北天门汇丰村镇银行", "code": "HBTMHFCUNZB"}, {
        "value": "湖北天门农村商业银行",
        "abbreviationName": "湖北天门农商",
        "code": "HBTMRCB"
    }, {"value": "湖北通城农村商业银行", "abbreviationName": "湖北通城农商", "code": "HBTCRCB"}, {
        "value": "湖北通山农村商业银行",
        "abbreviationName": "湖北通山农商",
        "code": "HBTONGSRCB"
    }, {"value": "湖北团风农村商业银行", "abbreviationName": "湖北团风农商", "code": "HBTFRCB"}, {
        "value": "湖北五峰农村商业银行",
        "abbreviationName": "湖北五峰农商",
        "code": "HBWFRCB"
    }, {"value": "湖北武当山农村商业银行", "abbreviationName": "湖北武当山农商", "code": "HBWDSRCB"}, {
        "value": "湖北武穴农村商业银行",
        "abbreviationName": "湖北武穴农商",
        "code": "HBWXRCB"
    }, {"value": "湖北浠水农村商业银行", "abbreviationName": "湖北浠水农商", "code": "HBXISRCB"}, {
        "value": "湖北仙桃农村商业银行",
        "abbreviationName": "湖北仙桃农商",
        "code": "HUBXTRCB"
    }, {"value": "湖北咸安武农商村镇银行", "abbreviationName": "湖北咸安武农商村镇银行", "code": "HBXAWNSCUNZB"}, {
        "value": "湖北咸安长江村镇银行",
        "abbreviationName": "湖北咸安长江村镇银行",
        "code": "HBXACJCUNZB"
    }, {"value": "湖北咸丰农村商业银行", "abbreviationName": "湖北咸丰农商", "code": "HBXFRCB"}, {
        "value": "湖北咸宁农村商业银行",
        "abbreviationName": "湖北咸宁农商",
        "code": "HBXNRCB"
    }, {"value": "湖北襄阳农村商业银行", "abbreviationName": "湖北襄阳农商", "code": "HBXYRCB"}, {
        "value": "湖北孝昌农村商业银行",
        "abbreviationName": "湖北孝昌农商",
        "code": "HBXCRCB"
    }, {"value": "湖北孝感农村商业银行", "abbreviationName": "湖北孝感农商", "code": "HBXGRCB"}, {
        "value": "湖北兴山农村商业银行",
        "abbreviationName": "湖北兴山农商",
        "code": "HBXSRCB"
    }, {"value": "湖北宣恩农村商业银行", "abbreviationName": "湖北宣恩农商", "code": "HBXERCB"}, {
        "value": "湖北阳新农村商业银行",
        "abbreviationName": "湖北阳新农商",
        "code": "HBYXRCB"
    }, {"value": "湖北宜城农村商业银行", "abbreviationName": "湖北宜城农商", "code": "HBYICRCB"}, {
        "value": "湖北宜都农村商业银行",
        "abbreviationName": "湖北宜都农商",
        "code": "HBYDRCB"
    }, {"value": "湖北银行", "abbreviationName": "湖北", "code": "HUBYH"}, {
        "value": "湖北应城农村商业银行",
        "abbreviationName": "湖北应城农商",
        "code": "HBYCRCB"
    }, {"value": "湖北英山农村商业银行", "abbreviationName": "湖北英山农商", "code": "HBYSRCB"}, {
        "value": "湖北英山长江村镇银行",
        "abbreviationName": "湖北英山长江村镇银行",
        "code": "HBYSCJCUNZB"
    }, {"value": "湖北远安农村商业银行", "abbreviationName": "湖北远安农商", "code": "HBYARCB"}, {
        "value": "湖北云梦农村商业银行",
        "abbreviationName": "湖北云梦农商",
        "code": "HBYMRCB"
    }, {"value": "湖北郧西农村商业银行", "abbreviationName": "湖北郧西农商", "code": "HBYXIRCB"}, {
        "value": "湖北郧县农村商业银行",
        "abbreviationName": "湖北郧县农商",
        "code": "HBYUNXRCB"
    }, {"value": "湖北枣阳农村商业银行", "abbreviationName": "湖北枣阳农商", "code": "HBZYRCB"}, {
        "value": "湖北长阳农村商业银行",
        "abbreviationName": "湖北长阳农商",
        "code": "HBCYANRCB"
    }, {"value": "湖北枝江农村商业银行", "abbreviationName": "湖北枝江农商", "code": "HBZJRCB"}, {
        "value": "湖北钟祥农村商业银行",
        "abbreviationName": "湖北钟祥农商",
        "code": "HBZXRCB"
    }, {"value": "湖北竹山农村商业银行", "abbreviationName": "湖北竹山农商", "code": "HBZSRCB"}, {
        "value": "湖北竹溪农村商业银行",
        "abbreviationName": "湖北竹溪农商",
        "code": "HBZXIRCB"
    }, {"value": "湖北秭归农村商业银行", "abbreviationName": "湖北秭归农商", "code": "HBZGRCB"}, {
        "value": "湖口九银村镇银行",
        "abbreviationName": "湖口九银村镇银行",
        "code": "HKJYCUNZB"
    }, {"value": "湖南安化农村商业银行", "abbreviationName": "湖南安化农商", "code": "HNAHRCB"}, {
        "value": "湖南安化湘淮村镇银行",
        "abbreviationName": "湖南安化湘淮村镇银行",
        "code": "HNAHXHCUNZB"
    }, {"value": "湖南安仁农村商业银行", "abbreviationName": "湖南安仁农商", "code": "HNARRCB"}, {
        "value": "湖南安仁新阳村镇银行",
        "abbreviationName": "湖南安仁新阳村镇银行",
        "code": "HNARXYCUNZB"
    }, {"value": "湖南安乡农村商业银行", "abbreviationName": "湖南安乡农商", "code": "HNAXRCB"}, {
        "value": "湖南保靖农村商业银行",
        "abbreviationName": "湖南保靖农商",
        "code": "HUNBJRCB"
    }, {"value": "湖南茶陵农村商业银行", "abbreviationName": "湖南茶陵农商", "code": "HNCLRCB"}, {
        "value": "湖南常宁农村商业银行",
        "abbreviationName": "湖南常宁农商",
        "code": "HNCNRCB"
    }, {"value": "湖南辰溪农村商业银行", "abbreviationName": "湖南辰溪农商", "code": "HNCXRCB"}, {
        "value": "湖南城步农村商业银行",
        "abbreviationName": "湖南城步农商",
        "code": "HNCBRCB"
    }, {"value": "湖南慈利农村商业银行", "abbreviationName": "湖南慈利农商", "code": "HNCILRCB"}, {
        "value": "湖南道县农村商业银行",
        "abbreviationName": "湖南道县农商",
        "code": "HNDXRCB"
    }, {"value": "湖南道县神农村镇银行", "abbreviationName": "湖南道县神农村镇银行", "code": "HNDXSRCUNZB"}, {
        "value": "湖南东安农村商业银行",
        "abbreviationName": "湖南东安农商",
        "code": "HNDARCB"
    }, {"value": "湖南东安星龙村镇银行", "abbreviationName": "湖南东安星龙村镇银行", "code": "HNDAXLCUNZB"}, {
        "value": "湖南洞口农村商业银行",
        "abbreviationName": "湖南洞口农商",
        "code": "HNDKRCB"
    }, {"value": "湖南洞口潭农商村镇银行", "abbreviationName": "湖南洞口潭农商村镇银行", "code": "HNDKTNSCUNZB"}, {
        "value": "湖南凤凰农村商业银行",
        "abbreviationName": "湖南凤凰农商",
        "code": "HNFHRCB"
    }, {"value": "湖南古丈农村商业银行", "abbreviationName": "湖南古丈农商", "code": "HNGZRCB"}, {
        "value": "湖南桂东农村商业银行",
        "abbreviationName": "湖南桂东农商",
        "code": "HNGDRCB"
    }, {"value": "湖南桂阳农村商业银行", "abbreviationName": "湖南桂阳农商", "code": "HUNGYRCB"}, {
        "value": "湖南汉寿农村商业银行",
        "abbreviationName": "湖南汉寿农商",
        "code": "HNHANSRCB"
    }, {"value": "湖南汉寿星龙村镇银行", "abbreviationName": "湖南汉寿星龙村镇银行", "code": "HNHSXLCUNZB"}, {
        "value": "湖南衡东农村商业银行",
        "abbreviationName": "湖南衡东农商",
        "code": "HNHDRCB"
    }, {"value": "湖南衡东新阳村镇银行", "abbreviationName": "湖南衡东新阳村镇银行", "code": "HNHDXYCUNZB"}, {
        "value": "湖南衡南农村商业银行",
        "abbreviationName": "湖南衡南农商",
        "code": "HNHNRCB"
    }, {"value": "湖南衡山农村商业银行", "abbreviationName": "湖南衡山农商", "code": "HNHSRCB"}, {
        "value": "湖南衡山潭农商村镇银行",
        "abbreviationName": "湖南衡山潭农商村镇银行",
        "code": "HNHSTNSCUNZB"
    }, {"value": "湖南衡阳衡州农村商业银行", "abbreviationName": "湖南衡阳衡州农商", "code": "HNHYHZRCB"}, {
        "value": "湖南洪江农村商业银行",
        "abbreviationName": "湖南洪江农商",
        "code": "HUNHJRCB"
    }, {"value": "湖南洪江湘农村镇银行", "abbreviationName": "湖南洪江湘农村镇银行", "code": "HNHJXNCUNZB"}, {
        "value": "湖南花垣农村商业银行",
        "abbreviationName": "湖南花垣农商",
        "code": "HNHYRCB"
    }, {"value": "湖南华容农村商业银行", "abbreviationName": "湖南华容农商", "code": "HNHRRCB"}, {
        "value": "湖南华容星龙村镇银行",
        "abbreviationName": "湖南华容星龙村镇银行",
        "code": "HNHRXLCUNZB"
    }, {"value": "湖南会同农村商业银行", "abbreviationName": "湖南会同农商", "code": "HNHTRCB"}, {
        "value": "湖南吉首农村商业银行",
        "abbreviationName": "湖南吉首农商",
        "code": "HNJISRCB"
    }, {"value": "湖南嘉禾农村商业银行", "abbreviationName": "湖南嘉禾农商", "code": "HNJHERCB"}, {
        "value": "湖南江华农村商业银行",
        "abbreviationName": "湖南江华农商",
        "code": "HNJHRCB"
    }, {"value": "湖南江华新阳村镇银行", "abbreviationName": "湖南江华新阳村镇银行", "code": "HNJHXYCUNZB"}, {
        "value": "湖南江永农村商业银行",
        "abbreviationName": "湖南江永农商",
        "code": "HNJYONGRCB"
    }, {"value": "湖南江永湘农村镇银行", "abbreviationName": "湖南江永湘农村镇银行", "code": "HNJYXNCUNZB"}, {
        "value": "湖南津市农村商业银行",
        "abbreviationName": "湖南津市农商",
        "code": "HNJSRCB"
    }, {"value": "湖南津市湘淮村镇银行", "abbreviationName": "湖南津市湘淮村镇银行", "code": "HNJSXHCUNZB"}, {
        "value": "湖南靖州农村商业银行",
        "abbreviationName": "湖南靖州农商",
        "code": "HNJZRCB"
    }, {"value": "湖南蓝山农村商业银行", "abbreviationName": "湖南蓝山农商", "code": "HNLANSRCB"}, {
        "value": "湖南蓝山神农村镇银行",
        "abbreviationName": "湖南蓝山神农村镇银行",
        "code": "HNLSSNCUNZB"
    }, {"value": "湖南耒阳农村商业银行", "abbreviationName": "湖南耒阳农商", "code": "HNLEIYRCB"}, {
        "value": "湖南冷水江农村商业银行",
        "abbreviationName": "湖南冷水江农商",
        "code": "HNLSJRCB"
    }, {"value": "湖南冷水江湘淮村镇银行", "abbreviationName": "湖南冷水江湘淮村镇银行", "code": "HNLSJXHCUNZB"}, {
        "value": "湖南澧县农村商业银行",
        "abbreviationName": "湖南澧县农商",
        "code": "HNLIXRCB"
    }, {"value": "湖南醴陵农村商业银行", "abbreviationName": "湖南醴陵农商", "code": "HNLLRCB"}, {
        "value": "湖南涟源农村商业银行",
        "abbreviationName": "湖南涟源农商",
        "code": "HNLYRCB"
    }, {"value": "湖南临澧农村商业银行", "abbreviationName": "湖南临澧农商", "code": "HNLLIRCB"}, {
        "value": "湖南临武农村商业银行",
        "abbreviationName": "湖南临武农商",
        "code": "HNLWRCB"
    }, {"value": "湖南临湘农村商业银行", "abbreviationName": "湖南临湘农商", "code": "HNLXRCB"}, {
        "value": "湖南浏阳江淮村镇银行",
        "abbreviationName": "湖南浏阳江淮村镇银行",
        "code": "HNZYJHCUNZB"
    }, {"value": "湖南浏阳农村商业银行", "abbreviationName": "湖南浏阳农商", "code": "HNLYANGRCB"}, {
        "value": "湖南龙山农村商业银行",
        "abbreviationName": "湖南龙山农商",
        "code": "HNLSRCB"
    }, {"value": "湖南隆回农村商业银行", "abbreviationName": "湖南隆回农商", "code": "HNLHRCB"}, {
        "value": "湖南隆回湘江村镇银行",
        "abbreviationName": "湖南隆回湘江村镇银行",
        "code": "HNLHXJCUNZB"
    }, {"value": "湖南娄底农村商业银行", "abbreviationName": "湖南娄底农商", "code": "HNLDRCB"}, {
        "value": "湖南泸溪农村商业银行",
        "abbreviationName": "湖南泸溪农商",
        "code": "HNLUXRCB"
    }, {"value": "湖南麻阳农村商业银行", "abbreviationName": "湖南麻阳农商", "code": "HNMYRCB"}, {
        "value": "湖南汨罗农村商业银行",
        "abbreviationName": "湖南汨罗农商",
        "code": "HNMLRCB"
    }, {"value": "湖南南县农村商业银行", "abbreviationName": "湖南南县农商", "code": "HNNANXRCB"}, {
        "value": "湖南南县湘江村镇银行",
        "abbreviationName": "湖南南县湘江村镇银行",
        "code": "HNNXXJCUNZB"
    }, {"value": "湖南南岳农村商业银行", "abbreviationName": "湖南南岳农商", "code": "HNNANYRCB"}, {
        "value": "湖南宁乡农村商业银行",
        "abbreviationName": "湖南宁乡农商",
        "code": "HNNXRCB"
    }, {"value": "湖南宁远农村商业银行", "abbreviationName": "湖南宁远农商", "code": "HNNYRCB"}, {
        "value": "湖南宁远潭农商村镇银行",
        "abbreviationName": "湖南宁远潭农商村镇银行",
        "code": "HNNYTNSCUNZB"
    }, {"value": "湖南平江汇丰村镇银行", "abbreviationName": "湖南平江汇丰村镇银行", "code": "HNPJHFCUNZB"}, {
        "value": "湖南平江农村商业银行",
        "abbreviationName": "湖南平江农商",
        "code": "HNPJRCB"
    }, {"value": "湖南祁东农村商业银行", "abbreviationName": "湖南祁东农商", "code": "HNQDRCB"}, {
        "value": "湖南祁阳农村商业银行",
        "abbreviationName": "湖南祁阳农商",
        "code": "HNQYRCB"
    }, {"value": "湖南汝城农村商业银行", "abbreviationName": "湖南汝城农商", "code": "HNRCRCB"}, {
        "value": "湖南汝城新阳村镇银行",
        "abbreviationName": "湖南汝城新阳村镇银行",
        "code": "HNRCXYCUNZB"
    }, {"value": "湖南三湘银行股份有限公司", "abbreviationName": "三湘", "code": "csxbank"}, {
        "value": "湖南桑植农村商业银行",
        "abbreviationName": "湖南桑植农商",
        "code": "HNSZRCB"
    }, {"value": "湖南桑植湘农村镇银行", "abbreviationName": "湖南桑植湘农村镇银行", "code": "HNSZXNCUNZB"}, {
        "value": "湖南韶山农村商业银行",
        "abbreviationName": "湖南韶山农商",
        "code": "HUNSSRCB"
    }, {"value": "湖南邵东农村商业银行", "abbreviationName": "湖南邵东农商", "code": "HNSDRCB"}, {
        "value": "湖南邵东湘淮村镇银行",
        "abbreviationName": "湖南邵东湘淮村镇银行",
        "code": "HNSDXHCUNZB"
    }, {"value": "湖南邵阳湘江村镇银行", "abbreviationName": "湖南邵阳湘江村镇银行", "code": "HNSYXJCUNZB"}, {
        "value": "湖南邵阳昭阳农村商业银行",
        "abbreviationName": "湖南邵阳昭阳农商",
        "code": "HUNSYRCB"
    }, {"value": "湖南省农村信用社联合社", "abbreviationName": "湖南农信社", "code": "HUNNXS"}, {
        "value": "湖南石门农村商业银行",
        "abbreviationName": "湖南石门农商",
        "code": "HNSMRCB"
    }, {"value": "湖南双峰农村商业银行", "abbreviationName": "湖南双峰农商", "code": "HNSFRCB"}, {
        "value": "湖南双牌农村商业银行",
        "abbreviationName": "湖南双牌农商",
        "code": "HNSPRCB"
    }, {"value": "湖南双牌湘农村镇银行", "abbreviationName": "湖南双牌湘农村镇银行", "code": "HNSPXNCUNZB"}, {
        "value": "湖南绥宁农村商业银行",
        "abbreviationName": "湖南绥宁农商",
        "code": "HNSNRCB"
    }, {"value": "湖南绥宁湘农村镇银行", "abbreviationName": "湖南绥宁湘农村镇银行", "code": "HNSNXNCUNZB"}, {
        "value": "湖南桃江农村商业银行",
        "abbreviationName": "湖南桃江农商",
        "code": "HNTJRCB"
    }, {"value": "湖南桃源农村商业银行", "abbreviationName": "湖南桃源农商", "code": "HUNTYRCB"}, {
        "value": "湖南桃源湘淮村镇银行",
        "abbreviationName": "湖南桃源湘淮村镇银行",
        "code": "HNTYXHCUNZB"
    }, {"value": "湖南通道农村商业银行", "abbreviationName": "湖南通道农商", "code": "HNTDRCB"}, {
        "value": "湖南武冈农村商业银行",
        "abbreviationName": "湖南武冈农商",
        "code": "HUNWGRCB"
    }, {"value": "湖南湘江新区农村商业银行", "abbreviationName": "湖南湘江新区农商", "code": "HNXJXQRCB"}, {
        "value": "湖南湘潭天易农村商业银行",
        "abbreviationName": "湖南湘潭天易农商",
        "code": "HNXTTYRCB"
    }, {"value": "湖南湘潭湘淮村镇银行", "abbreviationName": "湖南湘潭湘淮村镇银行", "code": "HNXTXHCUNZB"}, {
        "value": "湖南湘乡农村商业银行",
        "abbreviationName": "湖南湘乡农商",
        "code": "HUNXXRCB"
    }, {"value": "湖南湘阴农村商业银行", "abbreviationName": "湖南湘阴农商", "code": "HUNXYRCB"}, {
        "value": "湖南湘阴星龙村镇银行",
        "abbreviationName": "湖南湘阴星龙村镇银行",
        "code": "HNXYXLCUNZB"
    }, {"value": "湖南新化农村商业银行", "abbreviationName": "湖南新化农商", "code": "HNXHRCB"}, {
        "value": "湖南新化星龙村镇银行",
        "abbreviationName": "湖南新化星龙村镇银行",
        "code": "HNXHXLCUNZB"
    }, {"value": "湖南新晃农村商业银行", "abbreviationName": "湖南新晃农商", "code": "HNXHUANGRCB"}, {
        "value": "湖南新宁农村商业银行",
        "abbreviationName": "湖南新宁农商",
        "code": "HNXNRCB"
    }, {"value": "湖南新宁潭农商村镇银行", "abbreviationName": "湖南新宁潭农商村镇银行", "code": "HNXNTNSCUNZB"}, {
        "value": "湖南新邵农村商业银行",
        "abbreviationName": "湖南新邵农商",
        "code": "HNXINSRCB"
    }, {"value": "湖南新邵湘淮村镇银行", "abbreviationName": "湖南新邵湘淮村镇银行", "code": "HNXSXHCUNZB"}, {
        "value": "湖南新田农村商业银行",
        "abbreviationName": "湖南新田农商",
        "code": "HNXTRCB"
    }, {"value": "湖南新田湘农村镇银行", "abbreviationName": "湖南新田湘农村镇银行", "code": "HNXTXNCUNZB"}, {
        "value": "湖南星沙农村商业银行",
        "abbreviationName": "湖南星沙农商",
        "code": "HNXSRCB"
    }, {"value": "湖南溆浦农村商业银行", "abbreviationName": "湖南溆浦农商", "code": "HUNXPRCB"}, {
        "value": "湖南溆浦湘江村镇银行",
        "abbreviationName": "湖南溆浦湘江村镇银行",
        "code": "HNXPXJCUNZB"
    }, {"value": "湖南炎陵农村商业银行", "abbreviationName": "湖南炎陵农商", "code": "HUNYANLRCB"}, {
        "value": "湖南炎陵星龙村镇银行",
        "abbreviationName": "湖南炎陵星龙村镇银行",
        "code": "HNYLXLCUNZB"
    }, {"value": "湖南宜章农村商业银行", "abbreviationName": "湖南宜章农商", "code": "HNYZRCB"}, {
        "value": "湖南永顺农村商业银行",
        "abbreviationName": "湖南永顺农商",
        "code": "HUNYSRCB"
    }, {"value": "湖南永兴农村商业银行", "abbreviationName": "湖南永兴农商", "code": "HNYXRCB"}, {
        "value": "湖南攸县农村商业银行",
        "abbreviationName": "湖南攸县农商",
        "code": "HNYOUXRCB"
    }, {"value": "湖南攸县潭农商村镇银行", "abbreviationName": "湖南攸县潭农商村镇银行", "code": "HNYXTNSCUNZB"}, {
        "value": "湖南沅江农村商业银行",
        "abbreviationName": "湖南沅江农商",
        "code": "HNYJRCB"
    }, {"value": "湖南沅陵农村商业银行", "abbreviationName": "湖南沅陵农商", "code": "HUNYLRCB"}, {
        "value": "湖南沅陵新阳村镇银行",
        "abbreviationName": "湖南沅陵新阳村镇银行",
        "code": "HNYLXYCUNZB"
    }, {"value": "湖南岳阳巴陵农村商业银行", "abbreviationName": "湖南岳阳巴陵农商", "code": "HNYYBLRCB"}, {
        "value": "湖南岳阳农村商业银行",
        "abbreviationName": "湖南岳阳农商",
        "code": "HUNYYRCB"
    }, {"value": "湖南岳阳湘江村镇银行", "abbreviationName": "湖南岳阳湘江村镇银行", "code": "HNYYXJCUNZB"}, {
        "value": "湖南芷江农村商业银行",
        "abbreviationName": "湖南芷江农商",
        "code": "HNZJRCB"
    }, {"value": "湖南芷江湘江村镇银行", "abbreviationName": "湖南芷江湘江村镇银行", "code": "HNZJXJCUNZB"}, {
        "value": "湖南中方农村商业银行",
        "abbreviationName": "湖南中方农商",
        "code": "HNZFRCB"
    }, {"value": "湖南中方新阳村镇银行", "abbreviationName": "湖南中方新阳村镇银行", "code": "HNZFXYCUNZB"}, {
        "value": "湖南株洲珠江农村商业银行",
        "abbreviationName": "湖南株洲珠江农商",
        "code": "HNZZZJRCB"
    }, {"value": "湖南资兴农村商业银行", "abbreviationName": "湖南资兴农商", "code": "HNZXRCB"}, {
        "value": "湖州吴兴农村商业银行",
        "abbreviationName": "湖州吴兴农商",
        "code": "HZWXRCB"
    }, {"value": "湖州银行", "abbreviationName": "湖州", "code": "HUZYH"}, {
        "value": "花旗银行",
        "abbreviationName": "花旗",
        "code": "CITIBANK"
    }, {"value": "华美银行", "abbreviationName": "华美", "code": "EASTWESTBANK"}, {
        "value": "华南商业银行",
        "abbreviationName": "华南",
        "code": "HNCCB"
    }, {"value": "华侨永亨银行（中国）有限公司", "abbreviationName": "华侨永亨", "code": "OCBC"}, {
        "value": "华融湘江银行",
        "abbreviationName": "华融湘江",
        "code": "HRXJYH"
    }, {"value": "华商银行", "abbreviationName": "华商", "code": "CMBCN"}, {"value": "华夏银行", "abbreviationName": "华夏", "code": "HXB"}, {
        "value": "华一银行",
        "abbreviationName": "华一",
        "code": "COB"
    }, {"value": "化德蒙商村镇银行", "abbreviationName": "化德蒙商村镇银行", "code": "HDBSCUNZB"}, {
        "value": "桦川融兴村镇银行",
        "abbreviationName": "桦川融兴村镇银行",
        "code": "ZCRXCUNZB"
    }, {"value": "桦甸惠民村镇银行", "abbreviationName": "桦甸惠民村镇银行", "code": "ZDHMCUNZB"}, {
        "value": "桦南融兴村镇银行",
        "abbreviationName": "桦南融兴村镇银行",
        "code": "ZNRXCUNZB"
    }, {"value": "怀化农村商业银行", "abbreviationName": "怀化农商", "code": "HHRCB"}, {
        "value": "怀来利丰村镇银行",
        "abbreviationName": "怀来利丰村镇银行",
        "code": "HLLFCUNZB"
    }, {"value": "怀仁县慧融村镇银行", "abbreviationName": "怀仁县慧融村镇银行", "code": "HRXRHCUNZB"}, {
        "value": "淮北农村商业银行",
        "abbreviationName": "淮北农商",
        "code": "HBRCB"
    }, {"value": "淮南淮河农村商业银行", "abbreviationName": "淮南淮河农商", "code": "HNHHRCB"}, {
        "value": "淮南通商农村商业银行",
        "abbreviationName": "淮南通商农商",
        "code": "HNTSRCB"
    }, {"value": "桓台青隆村镇银行", "abbreviationName": "桓台青隆村镇银行", "code": "HTQLCUNZB"}, {
        "value": "黄骅青隆村镇银行",
        "abbreviationName": "黄骅青隆村镇银行",
        "code": "HZQLCUNZB"
    }, {"value": "黄平振兴村镇银行", "abbreviationName": "黄平振兴村镇银行", "code": "HPZXCUNZB"}, {
        "value": "黄山徽州农村商业银行",
        "abbreviationName": "黄山徽州农商",
        "code": "HSHZRCB"
    }, {"value": "黄山太平农村商业银行", "abbreviationName": "黄山太平农商", "code": "HSTPRCB"}, {
        "value": "黄山屯溪农村商业银行",
        "abbreviationName": "黄山屯溪农商",
        "code": "HSTXRCB"
    }, {"value": "黄石农村商业银行", "abbreviationName": "黄石农商", "code": "HSRCB"}, {
        "value": "珲春吉银村镇银行",
        "abbreviationName": "珲春吉银村镇银行",
        "code": "ZCJYCUNZB"
    }, {"value": "辉南榆银村镇银行", "abbreviationName": "辉南榆银村镇银行", "code": "HNYYCUNZB"}, {
        "value": "辉县珠江村镇银行",
        "abbreviationName": "辉县珠江村镇银行",
        "code": "HXZJCUNZB"
    }, {"value": "徽商银行", "abbreviationName": "徽商", "code": "AHCB"}, {
        "value": "汇丰银行（中国）有限公司",
        "abbreviationName": "汇丰",
        "code": "HFB"
    }, {"value": "会宁会师村镇银行", "abbreviationName": "会宁会师村镇银行", "code": "HNHSCUNZB"}, {
        "value": "惠安中成村镇银行",
        "abbreviationName": "惠安中成村镇银行",
        "code": "HAZCCUNZB"
    }, {"value": "惠东惠民村镇银行", "abbreviationName": "惠东惠民村镇银行", "code": "HDHMCUNZB"}, {
        "value": "惠水恒升村镇银行",
        "abbreviationName": "惠水恒升村镇银行",
        "code": "HSHSCUNZB"
    }, {"value": "惠州博罗长江村镇银行", "abbreviationName": "惠州博罗长江村镇银行", "code": "HZBLCJCUNZB"}, {
        "value": "惠州仲恺东盈村镇银行",
        "abbreviationName": "惠州仲恺东盈村镇银行",
        "code": "HZZZDYCUNZB"
    }, {"value": "浑源县慧融村镇银行", "abbreviationName": "浑源县慧融村镇银行", "code": "HYXHRCUNZB"}, {
        "value": "霍林郭勒蒙银村镇银行",
        "abbreviationName": "霍林郭勒蒙银村镇银行",
        "code": "HLGLMYCUNZB"
    }, {"value": "吉安稠州村镇银行", "abbreviationName": "吉安稠州村镇银行", "code": "JACZCUNZB"}, {
        "value": "吉安农村商业银行",
        "abbreviationName": "吉安农商",
        "code": "JARCB"
    }, {"value": "吉林安图农村商业银行", "abbreviationName": "吉林安图农商", "code": "JLATRCB"}, {
        "value": "吉林昌邑榆银村镇银行",
        "abbreviationName": "吉林昌邑榆银村镇银行",
        "code": "JLCYYYCUNZB"
    }, {"value": "吉林船营惠民村镇银行", "abbreviationName": "吉林船营惠民村镇银行", "code": "JLCYHMCUNZB"}, {
        "value": "吉林春城农村商业银行",
        "abbreviationName": "吉林春城农商",
        "code": "JLCCRCB"
    }, {"value": "吉林大安农村商业银行", "abbreviationName": "吉林大安农商", "code": "JLDARCB"}, {
        "value": "吉林德惠农村商业银行",
        "abbreviationName": "吉林德惠农商",
        "code": "JLHDNCYH"
    }, {"value": "吉林东丰农村商业银行", "abbreviationName": "吉林东丰农商", "code": "JLDFRCB"}, {
        "value": "吉林敦化农村商业银行",
        "abbreviationName": "吉林敦化农商",
        "code": "JLDHRCB"
    }, {"value": "吉林丰满惠民村镇银行", "abbreviationName": "吉林丰满惠民村镇银行", "code": "JLFMHMCUNZB"}, {
        "value": "吉林公主岭农村商业银行",
        "abbreviationName": "吉林公主岭农商",
        "code": "JLGZLRCB"
    }, {"value": "吉林郭尔罗斯农村商业银行", "abbreviationName": "吉林郭尔罗斯农商", "code": "JLGELSRCB"}, {
        "value": "吉林和龙农村商业银行",
        "abbreviationName": "吉林和龙农商",
        "code": "JLHLRCB"
    }, {"value": "吉林桦甸农村商业银行", "abbreviationName": "吉林桦甸农商", "code": "JLHDRCB"}, {
        "value": "吉林环城农村商业银行",
        "abbreviationName": "吉林环城农商",
        "code": "JLHCRCB"
    }, {"value": "吉林珲春农村商业银行", "abbreviationName": "吉林珲春农商", "code": "JLHCHUNRCB"}, {
        "value": "吉林辉南农村商业银行",
        "abbreviationName": "吉林辉南农商",
        "code": "JLHNRCB"
    }, {"value": "吉林浑江农村商业银行", "abbreviationName": "吉林浑江农商", "code": "JLHJRCB"}, {
        "value": "吉林集安农村商业银行",
        "abbreviationName": "吉林集安农商",
        "code": "JLJARCB"
    }, {"value": "吉林蛟河农村商业银行", "abbreviationName": "吉林蛟河农商", "code": "JLJHRCB"}, {
        "value": "吉林靖宇农村商业银行",
        "abbreviationName": "吉林靖宇农商",
        "code": "JLJYRCB"
    }, {"value": "吉林九台农村商业银行", "abbreviationName": "吉林九台农商", "code": "JLJTRCB"}, {
        "value": "吉林临江农村商业银行",
        "abbreviationName": "吉林临江农商",
        "code": "JLLJRCB"
    }, {"value": "吉林柳河农村商业银行", "abbreviationName": "吉林柳河农商", "code": "JLLHRCB"}, {
        "value": "吉林龙井农村商业银行",
        "abbreviationName": "吉林龙井农商",
        "code": "JLLONGJRCB"
    }, {"value": "吉林龙潭华益村镇银行", "abbreviationName": "吉林龙潭华益村镇银行", "code": "JLLTHYCUNZB"}, {
        "value": "吉林农安农村商业银行",
        "abbreviationName": "吉林农安农商",
        "code": "JLNARCB"
    }, {"value": "吉林磐石农村商业银行", "abbreviationName": "吉林磐石农商", "code": "JLPSRCB"}, {
        "value": "吉林省农村信用社联合社",
        "abbreviationName": "吉林农信社",
        "code": "JLNXS"
    }, {"value": "吉林舒兰农村商业银行", "abbreviationName": "吉林舒兰农商", "code": "JLSLRCB"}, {
        "value": "吉林双阳农村商业银行",
        "abbreviationName": "吉林双阳农商",
        "code": "JLSYRCB"
    }, {"value": "吉林通化海科农村商业银行", "abbreviationName": "吉林通化海科农商", "code": "JLTHHKRCB"}, {
        "value": "吉林通榆农村商业银行",
        "abbreviationName": "吉林通榆农商",
        "code": "JLTYRCB"
    }, {"value": "吉林汪清农村商业银行", "abbreviationName": "吉林汪清农商", "code": "JLWQRCB"}, {
        "value": "吉林亿联银行",
        "abbreviationName": "吉林亿联",
        "code": "JLYLYH"
    }, {"value": "吉林银行", "abbreviationName": "吉林", "code": "JLYH"}, {
        "value": "吉林永吉农村商业银行",
        "abbreviationName": "吉林永吉农商",
        "code": "JLYJRCB"
    }, {"value": "吉林榆树农村商业银行", "abbreviationName": "吉林榆树农商", "code": "JLYSRCB"}, {
        "value": "吉林镇赉农村商业银行",
        "abbreviationName": "吉林镇赉农商",
        "code": "JLZLRCB"
    }, {"value": "吉水庐陵村镇银行", "abbreviationName": "吉水庐陵村镇银行", "code": "JSLLCUNZB"}, {
        "value": "吉县新田村镇银行",
        "abbreviationName": "吉县新田村镇银行",
        "code": "JXXTCUNZB"
    }, {"value": "吉州珠江村镇银行", "abbreviationName": "吉州珠江村镇银行", "code": "JZZJCUNZB"}, {
        "value": "集安惠鑫村镇银行",
        "abbreviationName": "集安惠鑫村镇银行",
        "code": "JAHZCUNZB"
    }, {"value": "集贤润生村镇银行", "abbreviationName": "集贤润生村镇银行", "code": "JXRSCUNZB"}, {
        "value": "集友银行有限公司",
        "abbreviationName": "集友",
        "code": "CHIYUBANK"
    }, {"value": "济南高新北海村镇银行", "abbreviationName": "济南高新北海村镇银行", "code": "JNGXBHCUNZB"}, {
        "value": "济南槐荫沪农商村镇银行",
        "abbreviationName": "济南槐荫沪农商村镇银行",
        "code": "JNHYHNSCUNZB"
    }, {"value": "济南农村商业银行", "abbreviationName": "济南农商", "code": "JNRCB"}, {
        "value": "济南长清沪农商村镇银行",
        "abbreviationName": "济南长清沪农商村镇银行",
        "code": "JNCQHNSCUNZB"
    }, {"value": "济宁高新村镇银行", "abbreviationName": "济宁高新村镇银行", "code": "JNGXCUNZB"}, {
        "value": "济宁蓝海村镇银行",
        "abbreviationName": "济宁蓝海村镇银行",
        "code": "JNLHCUNZB"
    }, {"value": "济宁农村商业银行", "abbreviationName": "济宁农商", "code": "JNINGRCB"}, {
        "value": "济宁儒商村镇银行",
        "abbreviationName": "济宁儒商村镇银行",
        "code": "JNRSCUNZB"
    }, {"value": "济宁银行", "abbreviationName": "济宁", "code": "JNYH"}, {
        "value": "济阳北海村镇银行",
        "abbreviationName": "济阳北海村镇银行",
        "code": "JYBHCUNZB"
    }, {"value": "济源齐鲁村镇银行", "abbreviationName": "济源齐鲁村镇银行", "code": "JYQLCUNZB"}, {
        "value": "稷山县河东村镇银行",
        "abbreviationName": "稷山县河东村镇银行",
        "code": "JSXHDCUNZB"
    }, {"value": "加拿大丰业银行", "abbreviationName": "加拿大丰业", "code": "SCTABK"}, {
        "value": "嘉兴银行",
        "abbreviationName": "嘉兴",
        "code": "JXCCB"
    }, {"value": "嘉峪关农村商业银行", "abbreviationName": "嘉峪关农商", "code": "JYGRCB"}, {
        "value": "郏县广天村镇银行",
        "abbreviationName": "郏县广天村镇银行",
        "code": "ZXGTCUNZB"
    }, {"value": "犍为中成村镇银行", "abbreviationName": "犍为中成村镇银行", "code": "QWZCCUNZB"}, {
        "value": "建昌恒昌村镇银行",
        "abbreviationName": "建昌恒昌村镇银行",
        "code": "JCHCCUNZB"
    }, {"value": "建湖中成村镇银行", "abbreviationName": "建湖中成村镇银行", "code": "JHZCCUNZB"}, {
        "value": "建宁刺桐红村镇银行",
        "abbreviationName": "建宁刺桐红村镇银行",
        "code": "JNCTHCUNZB"
    }, {"value": "建平红山村镇银行", "abbreviationName": "建平红山村镇银行", "code": "JPHSCUNZB"}, {
        "value": "建水沪农商村镇银行",
        "abbreviationName": "建水沪农商村镇银行",
        "code": "JSHNSCUNZB"
    }, {"value": "剑河富民村镇银行", "abbreviationName": "剑河富民村镇银行", "code": "JHFMCUNZB"}, {
        "value": "江口长征村镇银行",
        "abbreviationName": "江口长征村镇银行",
        "code": "JKCZCUNZB"
    }, {"value": "江陵楚农商村镇银行", "abbreviationName": "江陵楚农商村镇银行", "code": "JLCNSCUNZB"}, {
        "value": "江门开平长江村镇银行",
        "abbreviationName": "江门开平长江村镇银行",
        "code": "JMKPCJCUNZB"
    }, {"value": "江门农村商业银行", "abbreviationName": "江门农商", "code": "JMRCB"}, {
        "value": "江门新会新华村镇银行",
        "abbreviationName": "江门新会新华村镇银行",
        "code": "JMXHXHCUNZB"
    }, {"value": "江苏宝应锦程村镇银行", "abbreviationName": "江苏宝应锦程村镇银行", "code": "JSBYJCCUNZB"}, {
        "value": "江苏宝应农村商业银行",
        "abbreviationName": "江苏宝应农商",
        "code": "JSBYRCB"
    }, {"value": "江苏滨海农村商业银行", "abbreviationName": "江苏滨海农商", "code": "JSBHRCB"}, {
        "value": "江苏常熟农村商业银行",
        "abbreviationName": "江苏常熟农商",
        "code": "CSRCB"
    }, {"value": "江苏大丰江南村镇银行", "abbreviationName": "江苏大丰江南村镇银行", "code": "JSDFJNCUNZB"}, {
        "value": "江苏大丰农村商业银行",
        "abbreviationName": "江苏大丰农商",
        "code": "JSDFRCB"
    }, {"value": "江苏丹徒蒙银村镇银行", "abbreviationName": "江苏丹徒蒙银村镇银行", "code": "JSDTMYCUNZB"}, {
        "value": "江苏丹阳农村商业银行",
        "abbreviationName": "江苏丹阳农商",
        "code": "JSDYRCB"
    }, {"value": "江苏丹阳苏银村镇银行", "abbreviationName": "江苏丹阳苏银村镇银行", "code": "JSDYBDCUNZB"}, {
        "value": "江苏东海农村商业银行",
        "abbreviationName": "江苏东海农商",
        "code": "JSDHRCB"
    }, {"value": "江苏东海张农商村镇银行", "abbreviationName": "江苏东海张农商村镇银行", "code": "JSDHZNSCUNZB"}, {
        "value": "江苏东台稠州村镇银行",
        "abbreviationName": "江苏东台稠州村镇银行",
        "code": "JSDTCZCUNZB"
    }, {"value": "江苏东台农村商业银行", "abbreviationName": "江苏东台农商", "code": "JSDTRCB"}, {
        "value": "江苏丰县民丰村镇银行",
        "abbreviationName": "江苏丰县民丰村镇银行",
        "code": "JSFXMFCUNZB"
    }, {"value": "江苏丰县农村商业银行", "abbreviationName": "江苏丰县农商", "code": "JSFXRCB"}, {
        "value": "江苏阜宁农村商业银行",
        "abbreviationName": "江苏阜宁农商",
        "code": "JSFNRCB"
    }, {"value": "江苏赣榆农村商业银行", "abbreviationName": "江苏赣榆农商", "code": "JSGYRCB"}, {
        "value": "江苏赣榆通商村镇银行",
        "abbreviationName": "江苏赣榆通商村镇银行",
        "code": "JSGYTSCUNZB"
    }, {"value": "江苏高淳农村商业银行", "abbreviationName": "江苏高淳农商", "code": "JSGCRCB"}, {
        "value": "江苏高邮农村商业银行",
        "abbreviationName": "江苏高邮农商",
        "code": "JSGAOYRCB"
    }, {"value": "江苏灌南民丰村镇银行", "abbreviationName": "江苏灌南民丰村镇银行", "code": "JSGNMFCUNZB"}, {
        "value": "江苏灌南农村商业银行",
        "abbreviationName": "江苏灌南农商",
        "code": "JSGNRCB"
    }, {"value": "江苏灌云民丰村镇银行", "abbreviationName": "江苏灌云民丰村镇银行", "code": "JSGYMFCUNZB"}, {
        "value": "江苏灌云农村商业银行",
        "abbreviationName": "江苏灌云农商",
        "code": "JSGYUNRCB"
    }, {"value": "江苏海安农村商业银行", "abbreviationName": "江苏海安农商", "code": "HARCB"}, {
        "value": "江苏海安盐海村镇银行",
        "abbreviationName": "江苏海安盐海村镇银行",
        "code": "JSHAYHCUNZB"
    }, {"value": "江苏海门农村商业银行", "abbreviationName": "江苏海门农商", "code": "JSHMRCB"}, {
        "value": "江苏邗江联合村镇银行",
        "abbreviationName": "江苏邗江联合村镇银行",
        "code": "JSZJLHCUNZB"
    }, {"value": "江苏邗江民泰村镇银行", "abbreviationName": "江苏邗江民泰村镇银行", "code": "JSZJMTCUNZB"}, {
        "value": "江苏洪泽金阳光村镇银行",
        "abbreviationName": "江苏洪泽金阳光村镇银行",
        "code": "HZJYGCUNZB"
    }, {"value": "江苏洪泽农村商业银行", "abbreviationName": "江苏洪泽农商", "code": "JSHZRCB"}, {
        "value": "江苏淮安光大村镇银行",
        "abbreviationName": "江苏淮安光大村镇银行",
        "code": "HAGDCUNZB"
    }, {"value": "江苏淮安农村商业银行", "abbreviationName": "江苏淮安农商", "code": "JSHARCB"}, {
        "value": "江苏惠山民泰村镇银行",
        "abbreviationName": "江苏惠山民泰村镇银行",
        "code": "JSHSMTCUNZB"
    }, {"value": "江苏建湖农村商业银行", "abbreviationName": "江苏建湖农商", "code": "JSJIANHRCB"}, {
        "value": "江苏江都吉银村镇银行",
        "abbreviationName": "江苏江都吉银村镇银行",
        "code": "JSJDJYCUNZB"
    }, {"value": "江苏江都农村商业银行", "abbreviationName": "江苏江都农商", "code": "JSJDRCB"}, {
        "value": "江苏江南农村商业银行",
        "abbreviationName": "江苏江南农商",
        "code": "JSJNRCB"
    }, {"value": "江苏江宁上银村镇银行", "abbreviationName": "江苏江宁上银村镇银行", "code": "JSJNSYCUNZB"}, {
        "value": "江苏江阴农村商业银行",
        "abbreviationName": "江苏江阴农商",
        "code": "JSJYRCB"
    }, {"value": "江苏姜堰农村商业银行", "abbreviationName": "江苏姜堰农商", "code": "JSJYANRCB"}, {
        "value": "江苏金湖民泰村镇银行",
        "abbreviationName": "江苏金湖民泰村镇银行",
        "code": "JHMTCUNZB"
    }, {"value": "江苏金湖农村商业银行", "abbreviationName": "江苏金湖农商", "code": "JSJHRCB"}, {
        "value": "江苏靖江农村商业银行",
        "abbreviationName": "江苏靖江农商",
        "code": "JSJJRCB"
    }, {"value": "江苏靖江润丰村镇银行", "abbreviationName": "江苏靖江润丰村镇银行", "code": "JSJJRFCUNZB"}, {
        "value": "江苏句容农村商业银行",
        "abbreviationName": "江苏句容农商",
        "code": "JSJRRCB"
    }, {"value": "江苏昆山农村商业银行", "abbreviationName": "江苏昆山农商", "code": "KSRCB"}, {
        "value": "江苏溧水民丰村镇银行",
        "abbreviationName": "江苏溧水民丰村镇银行",
        "code": "JSZSMFCUNZB"
    }, {"value": "江苏溧水农村商业银行", "abbreviationName": "江苏溧水农商", "code": "JSLSRCB"}, {
        "value": "江苏涟水农村商业银行",
        "abbreviationName": "江苏涟水农商",
        "code": "JSLIANSRCB"
    }, {"value": "江苏涟水太商村镇银行", "abbreviationName": "江苏涟水太商村镇银行", "code": "LSTSCUNZB"}, {
        "value": "江苏民丰农村商业银行",
        "abbreviationName": "江苏民丰农商",
        "code": "JSMFRCB"
    }, {"value": "江苏南通农村商业银行", "abbreviationName": "江苏南通农商", "code": "JSNTRCB"}, {
        "value": "江苏沛县汉源村镇银行",
        "abbreviationName": "江苏沛县汉源村镇银行",
        "code": "JSPXHYCUNZB"
    }, {"value": "江苏沛县农村商业银行", "abbreviationName": "江苏沛县农商", "code": "JSPXRCB"}, {
        "value": "江苏邳州陇海村镇银行",
        "abbreviationName": "江苏邳州陇海村镇银行",
        "code": "JSZZLHCUNZB"
    }, {"value": "江苏邳州农村商业银行", "abbreviationName": "江苏邳州农商", "code": "JSPZRCB"}, {
        "value": "江苏启东农村商业银行",
        "abbreviationName": "江苏启东农商",
        "code": "JSQDRCB"
    }, {"value": "江苏启东珠江村镇银行", "abbreviationName": "江苏启东珠江村镇银行", "code": "JSQDZJCUNZB"}, {
        "value": "江苏如东农村商业银行",
        "abbreviationName": "江苏如东农商",
        "code": "JSRDRCB"
    }, {"value": "江苏如东融兴村镇银行", "abbreviationName": "江苏如东融兴村镇银行", "code": "JSRDRXCUNZB"}, {
        "value": "江苏如皋农村商业银行",
        "abbreviationName": "江苏如皋农商",
        "code": "JSRGRCB"
    }, {"value": "江苏射阳农村商业银行", "abbreviationName": "江苏射阳农商", "code": "JSSYRCB"}, {
        "value": "江苏射阳太商村镇银行",
        "abbreviationName": "江苏射阳太商村镇银行",
        "code": "JSSYTSCUNZB"
    }, {"value": "江苏省农村信用社联合社", "abbreviationName": "江苏农信社", "code": "JSNXS"}, {
        "value": "江苏沭阳东吴村镇银行",
        "abbreviationName": "江苏沭阳东吴村镇银行",
        "code": "JSSYDWCUNZB"
    }, {"value": "江苏沭阳农村商业银行", "abbreviationName": "江苏沭阳农商", "code": "JSSHUYRCB"}, {
        "value": "江苏泗洪东吴村镇银行",
        "abbreviationName": "江苏泗洪东吴村镇银行",
        "code": "JSSHDWCUNZB"
    }, {"value": "江苏泗洪农村商业银行", "abbreviationName": "江苏泗洪农商", "code": "JSSHRCB"}, {
        "value": "江苏泗阳东吴村镇银行",
        "abbreviationName": "江苏泗阳东吴村镇银行",
        "code": "JSSIYDWCUNZB"
    }, {"value": "江苏泗阳农村商业银行", "abbreviationName": "江苏泗阳农商", "code": "JSSIYRCB"}, {
        "value": "江苏苏宁银行",
        "abbreviationName": "江苏苏宁",
        "code": "SUNINGBANK"
    }, {"value": "江苏宿豫东吴村镇银行", "abbreviationName": "江苏宿豫东吴村镇银行", "code": "JSSUYDWCUNZB"}, {
        "value": "江苏睢宁农村商业银行",
        "abbreviationName": "江苏睢宁农商",
        "code": "JSSNRCB"
    }, {"value": "江苏泰兴农村商业银行", "abbreviationName": "江苏泰兴农商", "code": "JSTXRCB"}, {
        "value": "江苏泰州农村商业银行",
        "abbreviationName": "江苏泰州农商",
        "code": "JSTZRCB"
    }, {"value": "江苏通州华商村镇银行", "abbreviationName": "江苏通州华商村镇银行", "code": "JSTZHSCUNZB"}, {
        "value": "江苏铜山锡州村镇银行",
        "abbreviationName": "江苏铜山锡州村镇银行",
        "code": "JSTSXZCUNZB"
    }, {"value": "江苏响水农村商业银行", "abbreviationName": "江苏响水农商", "code": "JSXSRCB"}, {
        "value": "江苏新沂汉源村镇银行",
        "abbreviationName": "江苏新沂汉源村镇银行",
        "code": "JSXYHYCUNZB"
    }, {"value": "江苏新沂农村商业银行", "abbreviationName": "江苏新沂农商", "code": "JSXINYRCB"}, {
        "value": "江苏兴化农村商业银行",
        "abbreviationName": "江苏兴化农商",
        "code": "JSXHRCB"
    }, {"value": "江苏盱眙农村商业银行", "abbreviationName": "江苏盱眙农商", "code": "JSXYRCB"}, {
        "value": "江苏盱眙珠江村镇银行",
        "abbreviationName": "江苏盱眙珠江村镇银行",
        "code": "XYZJCUNZB"
    }, {"value": "江苏盐城农村商业银行", "abbreviationName": "江苏盐城农商", "code": "JSYCRCB"}, {
        "value": "江苏扬中农村商业银行",
        "abbreviationName": "江苏扬中农商",
        "code": "JSYANGZRCB"
    }, {"value": "江苏扬州农村商业银行", "abbreviationName": "江苏扬州农商", "code": "JISYZRCB"}, {
        "value": "江苏仪征农村商业银行",
        "abbreviationName": "江苏仪征农商",
        "code": "JSYZRCB"
    }, {"value": "江苏宜兴农村商业银行", "abbreviationName": "江苏宜兴农商", "code": "JSYXRCB"}, {
        "value": "江苏银行",
        "abbreviationName": "江苏",
        "code": "JSBCHINA"
    }, {"value": "江苏张家港农村商业银行", "abbreviationName": "江苏张家港农商", "code": "JSZJGRCB"}, {
        "value": "江苏张家港渝农商村镇银行",
        "abbreviationName": "江苏张家港渝农商村镇银行",
        "code": "JSZJGYNSCUNZB"
    }, {"value": "江苏长江商业银行", "abbreviationName": "江苏长江", "code": "JSCJCCB"}, {
        "value": "江苏镇江农村商业银行",
        "abbreviationName": "江苏镇江农商",
        "code": "JSZJRCB"
    }, {"value": "江苏紫金农村商业银行", "abbreviationName": "江苏紫金农商", "code": "JSZIJRCB"}, {
        "value": "江西安福农村商业银行",
        "abbreviationName": "江西安福农商",
        "code": "JXAFRCB"
    }, {"value": "江西安义农村商业银行", "abbreviationName": "江西安义农商", "code": "JXAYIRCB"}, {
        "value": "江西安远农村商业银行",
        "abbreviationName": "江西安远农商",
        "code": "JXAYRCB"
    }, {"value": "江西崇仁农村商业银行", "abbreviationName": "江西崇仁农商", "code": "JXCRRCB"}, {
        "value": "江西大余农村商业银行",
        "abbreviationName": "江西大余农商",
        "code": "JXDYRCB"
    }, {"value": "江西德兴农村商业银行", "abbreviationName": "江西德兴农商", "code": "JXDEXRCB"}, {
        "value": "江西定南农村商业银行",
        "abbreviationName": "江西定南农商",
        "code": "JXDNRCB"
    }, {"value": "江西东乡农村商业银行", "abbreviationName": "江西东乡农商", "code": "JXDXRCB"}, {
        "value": "江西都昌农村商业银行",
        "abbreviationName": "江西都昌农商",
        "code": "JXDCRCB"
    }, {"value": "江西丰城农村商业银行", "abbreviationName": "江西丰城农商", "code": "JXFCRCB"}, {
        "value": "江西奉新农村商业银行",
        "abbreviationName": "江西奉新农商",
        "code": "JXFXRCB"
    }, {"value": "江西赣昌农村商业银行", "abbreviationName": "江西赣昌农商", "code": "JXGANCRCB"}, {
        "value": "江西赣县农村商业银行",
        "abbreviationName": "江西赣县农商",
        "code": "JXGXRCB"
    }, {"value": "江西赣州银座村镇银行", "abbreviationName": "江西赣州银座村镇银行", "code": "GZYZCUNZB"}, {
        "value": "江西高安富民村镇银行",
        "abbreviationName": "江西高安富民村镇银行",
        "code": "JXGAFMCUNZB"
    }, {"value": "江西高安农村商业银行", "abbreviationName": "江西高安农商", "code": "JXGARCB"}, {
        "value": "江西广昌农村商业银行",
        "abbreviationName": "江西广昌农商",
        "code": "JXGCRCB"
    }, {"value": "江西广丰农村商业银行", "abbreviationName": "江西广丰农商", "code": "JXGFRCB"}, {
        "value": "江西广信农村商业银行",
        "abbreviationName": "江西广信农商",
        "code": "JXGXINRCB"
    }, {"value": "江西横峰农村商业银行", "abbreviationName": "江西横峰农商", "code": "JXHFRCB"}, {
        "value": "江西湖口农村商业银行",
        "abbreviationName": "江西湖口农商",
        "code": "JXHKRCB"
    }, {"value": "江西会昌农村商业银行", "abbreviationName": "江西会昌农商", "code": "JXHCRCB"}, {
        "value": "江西吉水农村商业银行",
        "abbreviationName": "江西吉水农商",
        "code": "JXJSRCB"
    }, {"value": "江西江州农村商业银行", "abbreviationName": "江西江州农商", "code": "JXJZRCB"}, {
        "value": "江西金溪农村商业银行",
        "abbreviationName": "江西金溪农商",
        "code": "JXJXIRCB"
    }, {"value": "江西进贤农村商业银行", "abbreviationName": "江西进贤农商", "code": "JXJXRCB"}, {
        "value": "江西井冈山农村商业银行",
        "abbreviationName": "江西井冈山农商",
        "code": "JXJGSRCB"
    }, {"value": "江西靖安农村商业银行", "abbreviationName": "江西靖安农商", "code": "JXJARCB"}, {
        "value": "江西乐安农村商业银行",
        "abbreviationName": "江西乐安农商",
        "code": "JXLARCB"
    }, {"value": "江西黎川农村商业银行", "abbreviationName": "江西黎川农商", "code": "JXLCRCB"}, {
        "value": "江西莲花富民村镇银行",
        "abbreviationName": "江西莲花富民村镇银行",
        "code": "JXLHFMCUNZB"
    }, {"value": "江西莲花农村商业银行", "abbreviationName": "江西莲花农商", "code": "JXLHRCB"}, {
        "value": "江西龙南农村商业银行",
        "abbreviationName": "江西龙南农商",
        "code": "JXLNRCB"
    }, {"value": "江西芦溪富民村镇银行", "abbreviationName": "江西芦溪富民村镇银行", "code": "JXLXFMCUNZB"}, {
        "value": "江西芦溪农村商业银行",
        "abbreviationName": "江西芦溪农商",
        "code": "JXLXRCB"
    }, {"value": "江西庐陵农村商业银行", "abbreviationName": "江西庐陵农商", "code": "JXLLRCB"}, {
        "value": "江西庐山农村商业银行",
        "abbreviationName": "江西庐山农商",
        "code": "JXLSRCB"
    }, {"value": "江西南城农村商业银行", "abbreviationName": "江西南城农商", "code": "JXNCRCB"}, {
        "value": "江西南丰农村商业银行",
        "abbreviationName": "江西南丰农商",
        "code": "JXNFRCB"
    }, {"value": "江西宁都农村商业银行", "abbreviationName": "江西宁都农商", "code": "JXNDRCB"}, {
        "value": "江西彭泽农村商业银行",
        "abbreviationName": "江西彭泽农商",
        "code": "JXPZRCB"
    }, {"value": "江西鄱阳农村商业银行", "abbreviationName": "江西鄱阳农商", "code": "JXPYRCB"}, {
        "value": "江西铅山农村商业银行",
        "abbreviationName": "江西铅山农商",
        "code": "JXQSRCB"
    }, {"value": "江西全南农村商业银行", "abbreviationName": "江西全南农商", "code": "JXQNRCB"}, {
        "value": "江西瑞昌农村商业银行",
        "abbreviationName": "江西瑞昌农商",
        "code": "JXRCRCB"
    }, {"value": "江西瑞金光大村镇银行", "abbreviationName": "江西瑞金光大村镇银行", "code": "JXRJGDCUNZB"}, {
        "value": "江西瑞金农村商业银行",
        "abbreviationName": "江西瑞金农商",
        "code": "JXRJRCB"
    }, {"value": "江西上高富民村镇银行", "abbreviationName": "江西上高富民村镇银行", "code": "JXSGFMCUNZB"}, {
        "value": "江西上高农村商业银行",
        "abbreviationName": "江西上高农商",
        "code": "JXSGRCB"
    }, {"value": "江西上栗富民村镇银行", "abbreviationName": "江西上栗富民村镇银行", "code": "JXSLFMCUNZB"}, {
        "value": "江西上栗农村商业银行",
        "abbreviationName": "江西上栗农商",
        "code": "JXSLRCB"
    }, {"value": "江西上犹农村商业银行", "abbreviationName": "江西上犹农商", "code": "JXSYRCB"}, {
        "value": "江西省农村信用社联合社",
        "abbreviationName": "江西农信社",
        "code": "JXNXS"
    }, {"value": "江西石城农村商业银行", "abbreviationName": "江西石城农商", "code": "JXSCRCB"}, {
        "value": "江西遂川农村商业银行",
        "abbreviationName": "江西遂川农商",
        "code": "JXSUICRCB"
    }, {"value": "江西泰和农村商业银行", "abbreviationName": "江西泰和农商", "code": "JXTHRCB"}, {
        "value": "江西铜鼓农村商业银行",
        "abbreviationName": "江西铜鼓农商",
        "code": "JXTGRCB"
    }, {"value": "江西湾里农村商业银行", "abbreviationName": "江西湾里农商", "code": "JXWLRCB"}, {
        "value": "江西万安农村商业银行",
        "abbreviationName": "江西万安农商",
        "code": "JXWARCB"
    }, {"value": "江西万年农村商业银行", "abbreviationName": "江西万年农商", "code": "JXWNRCB"}, {
        "value": "江西万载富民村镇银行",
        "abbreviationName": "江西万载富民村镇银行",
        "code": "JXWZFMCUNZB"
    }, {"value": "江西万载农村商业银行", "abbreviationName": "江西万载农商", "code": "JXWZRCB"}, {
        "value": "江西武宁农村商业银行",
        "abbreviationName": "江西武宁农商",
        "code": "JXWUNRCB"
    }, {"value": "江西婺源江淮村镇银行", "abbreviationName": "江西婺源江淮村镇银行", "code": "JXZYJHCUNZB"}, {
        "value": "江西婺源农村商业银行",
        "abbreviationName": "江西婺源农商",
        "code": "JXWYRCB"
    }, {"value": "江西峡江农村商业银行", "abbreviationName": "江西峡江农商", "code": "JXXJRCB"}, {
        "value": "江西新干农村商业银行",
        "abbreviationName": "江西新干农商",
        "code": "JXXGANRCB"
    }, {"value": "江西新建农村商业银行", "abbreviationName": "江西新建农商", "code": "JXXINJRCB"}, {
        "value": "江西信丰农村商业银行",
        "abbreviationName": "江西信丰农商",
        "code": "JXXFRCB"
    }, {"value": "江西信州江淮村镇银行", "abbreviationName": "江西信州江淮村镇银行", "code": "JXXZJHCUNZB"}, {
        "value": "江西兴国农村商业银行",
        "abbreviationName": "江西兴国农商",
        "code": "JXXGRCB"
    }, {"value": "江西兴国新华村镇银行", "abbreviationName": "江西兴国新华村镇银行", "code": "JXXGXHCUNZB"}, {
        "value": "江西修水农村商业银行",
        "abbreviationName": "江西修水农商",
        "code": "JXXSRCB"
    }, {"value": "江西寻乌农村商业银行", "abbreviationName": "江西寻乌农商", "code": "JXXWRCB"}, {
        "value": "江西宜丰农村商业银行",
        "abbreviationName": "江西宜丰农商",
        "code": "JXYIFRCB"
    }, {"value": "江西宜黄农村商业银行", "abbreviationName": "江西宜黄农商", "code": "JXYHRCB"}, {
        "value": "江西弋阳农村商业银行",
        "abbreviationName": "江西弋阳农商",
        "code": "JXYYRCB"
    }, {"value": "江西银行(南昌银行)", "abbreviationName": "江西", "code": "NCYH"}, {
        "value": "江西永丰农村商业银行",
        "abbreviationName": "江西永丰农商",
        "code": "JXYFRCB"
    }, {"value": "江西永新农村商业银行", "abbreviationName": "江西永新农商", "code": "JXYXRCB"}, {
        "value": "江西永修农村商业银行",
        "abbreviationName": "江西永修农商",
        "code": "JXYXIURCB"
    }, {"value": "江西于都农村商业银行", "abbreviationName": "江西于都农商", "code": "JXYDRCB"}, {
        "value": "江西余干农村商业银行",
        "abbreviationName": "江西余干农商",
        "code": "JXYGRCB"
    }, {"value": "江西玉山农村商业银行", "abbreviationName": "江西玉山农商", "code": "JXYSRCB"}, {
        "value": "江西裕民银行",
        "abbreviationName": "江西裕民",
        "code": "YMBANK"
    }, {"value": "江西樟树农村商业银行", "abbreviationName": "江西樟树农商", "code": "JXZSRCB"}, {
        "value": "江西资溪农村商业银行",
        "abbreviationName": "江西资溪农商",
        "code": "JXZXRCB"
    }, {"value": "江阴浦发村镇银行", "abbreviationName": "江阴浦发村镇银行", "code": "JYPFCUNZB"}, {
        "value": "交城县太行村镇银行",
        "abbreviationName": "交城县太行村镇银行",
        "code": "JCXTXCUNZB"
    }, {"value": "交口县融都村镇银行", "abbreviationName": "交口县融都村镇银行", "code": "JKXRDCUNZB"}, {
        "value": "交通银行",
        "abbreviationName": "交通",
        "code": "BOCO"
    }, {"value": "蛟河吉银村镇银行", "abbreviationName": "蛟河吉银村镇银行", "code": "ZHJYCUNZB"}, {
        "value": "焦作解放农村商业银行",
        "abbreviationName": "焦作解放农商",
        "code": "JZJFRCB"
    }, {"value": "焦作中旅银行", "abbreviationName": "焦作中旅", "code": "JZSCCB"}, {
        "value": "介休市华都村镇银行",
        "abbreviationName": "介休市华都村镇银行",
        "code": "JXSHDCUNZB"
    }, {"value": "金昌农村商业银行", "abbreviationName": "金昌农商", "code": "JINCRCB"}, {
        "value": "金华银行",
        "abbreviationName": "金华",
        "code": "JHYH"
    }, {"value": "金沙富民村镇银行", "abbreviationName": "金沙富民村镇银行", "code": "JSFMCUNZB"}, {
        "value": "金堂汇金村镇银行",
        "abbreviationName": "金堂汇金村镇银行",
        "code": "JTHJCUNZB"
    }, {"value": "金溪抚商村镇银行", "abbreviationName": "金溪抚商村镇银行", "code": "JXFSCUNZB"}, {
        "value": "金寨徽银村镇银行",
        "abbreviationName": "金寨徽银村镇银行",
        "code": "JZHYCUNZB"
    }, {"value": "锦州农村商业银行", "abbreviationName": "锦州农商", "code": "JZRCB"}, {
        "value": "锦州松山农商村镇银行",
        "abbreviationName": "锦州松山农商村镇银行",
        "code": "JZSSNSCUNZB"
    }, {"value": "锦州太和锦银村镇银行", "abbreviationName": "锦州太和锦银村镇银行", "code": "JZTHJYCUNZB"}, {
        "value": "锦州银行",
        "abbreviationName": "锦州",
        "code": "JINZYH"
    }, {"value": "进贤瑞丰村镇银行", "abbreviationName": "进贤瑞丰村镇银行", "code": "JXRFCUNZB"}, {
        "value": "晋城农村商业银行",
        "abbreviationName": "晋城农商",
        "code": "JCRCB"
    }, {"value": "晋城银行", "abbreviationName": "晋城", "code": "JCYH"}, {
        "value": "晋商银行",
        "abbreviationName": "晋商",
        "code": "JSYH"
    }, {"value": "晋中开发区农村商业银行", "abbreviationName": "晋中开发区农商", "code": "JZKFQRCB"}, {
        "value": "晋中市榆次融信村镇银行",
        "abbreviationName": "晋中市榆次融信村镇银行",
        "code": "JZSYCRXCUNZB"
    }, {"value": "晋中市左权华丰村镇银行", "abbreviationName": "晋中市左权华丰村镇银行", "code": "JZSZQHFCUNZB"}, {
        "value": "晋中银行",
        "abbreviationName": "晋中",
        "code": "JZYH"
    }, {"value": "晋州恒升村镇银行", "abbreviationName": "晋州恒升村镇银行", "code": "JZHSCUNZB"}, {
        "value": "荆门东宝惠民村镇银行",
        "abbreviationName": "荆门东宝惠民村镇银行",
        "code": "JMDBHMCUNZB"
    }, {"value": "旌德民商村镇银行", "abbreviationName": "旌德民商村镇银行", "code": "SDMSCUNZB"}, {
        "value": "井冈山九银村镇银行",
        "abbreviationName": "井冈山九银村镇银行",
        "code": "JGSJYCUNZB"
    }, {"value": "景德镇昌江九银村镇银行", "abbreviationName": "景德镇昌江九银村镇银行", "code": "JDZCJJYCUNZB"}, {
        "value": "景德镇农村商业银行",
        "abbreviationName": "景德镇农商",
        "code": "JDZRCB"
    }, {"value": "景洪民生村镇银行", "abbreviationName": "景洪民生村镇银行", "code": "JHMSCUNZB"}, {
        "value": "景县丰源村镇银行",
        "abbreviationName": "景县丰源村镇银行",
        "code": "JXFYCUNZB"
    }, {"value": "靖安九银村镇银行", "abbreviationName": "靖安九银村镇银行", "code": "JAJYCUNZB"}, {
        "value": "靖宇乾丰村镇银行",
        "abbreviationName": "靖宇乾丰村镇银行",
        "code": "JYQFCUNZB"
    }, {"value": "九江共青村镇银行", "abbreviationName": "九江共青村镇银行", "code": "JJGQCUNZB"}, {
        "value": "九江恒通村镇银行",
        "abbreviationName": "九江恒通村镇银行",
        "code": "JJHTCUNZB"
    }, {"value": "九江庐山浔银村镇银行", "abbreviationName": "九江庐山浔银村镇银行", "code": "JJLSZYCUNZB"}, {
        "value": "九江农村商业银行",
        "abbreviationName": "九江农商",
        "code": "JJRCB"
    }, {"value": "九江银行", "abbreviationName": "九江", "code": "JJYH"}, {
        "value": "九台龙嘉村镇银行",
        "abbreviationName": "九台龙嘉村镇银行",
        "code": "JTLJCUNZB"
    }, {"value": "酒泉农村商业银行", "abbreviationName": "酒泉农商", "code": "JQRCB"}, {
        "value": "莒县金谷村镇银行",
        "abbreviationName": "莒县金谷村镇银行",
        "code": "JXJGCUNZB"
    }, {"value": "巨鹿融信村镇银行", "abbreviationName": "巨鹿融信村镇银行", "code": "JLRXCUNZB"}, {
        "value": "句容苏南村镇银行",
        "abbreviationName": "句容苏南村镇银行",
        "code": "JRSNCUNZB"
    }, {"value": "鄄城牡丹村镇银行", "abbreviationName": "鄄城牡丹村镇银行", "code": "YCBSCUNZB"}, {
        "value": "浚县郑银村镇银行",
        "abbreviationName": "浚县郑银村镇银行",
        "code": "JXZYCUNZB"
    }, {"value": "喀喇沁玉龙村镇银行", "abbreviationName": "喀喇沁玉龙村镇银行", "code": "KLQYLCUNZB"}, {
        "value": "开封宋都农村商业银行",
        "abbreviationName": "开封宋都农商",
        "code": "KFSDRCB"
    }, {"value": "开封新东方村镇银行", "abbreviationName": "开封新东方村镇银行", "code": "KFXDFCUNZB"}, {
        "value": "开鲁蒙银村镇银行",
        "abbreviationName": "开鲁蒙银村镇银行",
        "code": "KLMYCUNZB"
    }, {"value": "开泰银行", "abbreviationName": "开泰", "code": "KASIKORNBANK"}, {
        "value": "开阳富民村镇银行",
        "abbreviationName": "开阳富民村镇银行",
        "code": "KYFMCUNZB"
    }, {"value": "开原象牙山村镇银行", "abbreviationName": "开原象牙山村镇银行", "code": "KYXYSCUNZB"}, {
        "value": "开远沪农商村镇银行",
        "abbreviationName": "开远沪农商村镇银行",
        "code": "KYHNSCUNZB"
    }, {"value": "凯里东南村镇银行", "abbreviationName": "凯里东南村镇银行", "code": "KLDNCUNZB"}, {
        "value": "康保银丰村镇银行",
        "abbreviationName": "康保银丰村镇银行",
        "code": "KBYFCUNZB"
    }, {"value": "克拉玛依金龙国民村镇银行", "abbreviationName": "克拉玛依金龙国民村镇银行", "code": "KLMYJLGMCUNZB"}, {
        "value": "克山润生村镇银行",
        "abbreviationName": "克山润生村镇银行",
        "code": "KSRSCUNZB"
    }, {"value": "垦利乐安村镇银行", "abbreviationName": "垦利乐安村镇银行", "code": "KLLACUNZB"}, {
        "value": "库车国民村镇银行",
        "abbreviationName": "库车国民村镇银行",
        "code": "KCGMCUNZB"
    }, {"value": "库尔勒市商业银行", "abbreviationName": "库尔勒", "code": "KELSCCB"}, {
        "value": "宽城融兴村镇银行",
        "abbreviationName": "宽城融兴村镇银行",
        "code": "KCRXCUNZB"
    }, {"value": "宽甸百丰村镇银行", "abbreviationName": "宽甸百丰村镇银行", "code": "KDBFCUNZB"}, {
        "value": "奎屯国民村镇银行",
        "abbreviationName": "奎屯国民村镇银行",
        "code": "KTGMCUNZB"
    }, {"value": "昆仑银行", "abbreviationName": "昆仑", "code": "KLYH"}, {
        "value": "昆明呈贡华夏村镇银行",
        "abbreviationName": "昆明呈贡华夏村镇银行",
        "code": "KMCGHXCUNZB"
    }, {"value": "昆明东川中成村镇银行", "abbreviationName": "昆明东川中成村镇银行", "code": "KMDCZCCUNZB"}, {
        "value": "昆明官渡沪农商村镇银行",
        "abbreviationName": "昆明官渡沪农商村镇银行",
        "code": "KMALHNSCUNZB"
    }, {"value": "昆明官渡农村合作银行", "abbreviationName": "昆明官渡农村合作银行", "code": "KMGDRCU"}, {
        "value": "昆明晋宁融丰村镇银行",
        "abbreviationName": "昆明晋宁融丰村镇银行",
        "code": "KMJNRFCUNZB"
    }, {"value": "昆明禄劝中成村镇银行", "abbreviationName": "昆明禄劝中成村镇银行", "code": "KMLQZCCUNZB"}, {
        "value": "昆明马金铺中成村镇银行",
        "abbreviationName": "昆明马金铺中成村镇银行",
        "code": "KMMJPZCCUNZB"
    }, {"value": "昆明石林中成村镇银行", "abbreviationName": "昆明石林中成村镇银行", "code": "KMSLZCCUNZB"}, {
        "value": "昆明五华长江村镇银行",
        "abbreviationName": "昆明五华长江村镇银行",
        "code": "KMWHCJCUNZB"
    }, {"value": "昆明宜良融丰村镇银行", "abbreviationName": "昆明宜良融丰村镇银行", "code": "KMYLRFCUNZB"}, {
        "value": "昆山鹿城村镇银行",
        "abbreviationName": "昆山鹿城村镇银行",
        "code": "KSLCCUNZB"
    }, {"value": "来宾象州长江村镇银行", "abbreviationName": "来宾象州长江村镇银行", "code": "LBXZCJCUNZB"}, {
        "value": "莱商银行",
        "abbreviationName": "莱商",
        "code": "ISBC"
    }, {"value": "莱芜中成村镇银行", "abbreviationName": "莱芜中成村镇银行", "code": "LWZCCUNZB"}, {
        "value": "莱芜珠江村镇银行",
        "abbreviationName": "莱芜珠江村镇银行",
        "code": "LWZJCUNZB"
    }, {"value": "莱阳胶东村镇银行", "abbreviationName": "莱阳胶东村镇银行", "code": "LYJDCUNZB"}, {
        "value": "莱州珠江村镇银行",
        "abbreviationName": "莱州珠江村镇银行",
        "code": "LZZJCUNZB"
    }, {"value": "涞水利丰村镇银行", "abbreviationName": "涞水利丰村镇银行", "code": "ZSLFCUNZB"}, {
        "value": "兰考齐鲁村镇银行",
        "abbreviationName": "兰考齐鲁村镇银行",
        "code": "LKQLCUNZB"
    }, {"value": "兰西农商村镇银行", "abbreviationName": "兰西农商村镇银行", "code": "LXNSCUNZB"}, {
        "value": "兰州安宁神舟村镇银行",
        "abbreviationName": "兰州安宁神舟村镇银行",
        "code": "LZANSZCUNZB"
    }, {"value": "兰州皋兰新华村镇银行", "abbreviationName": "兰州皋兰新华村镇银行", "code": "LZGLXHCUNZB"}, {
        "value": "兰州农村商业银行",
        "abbreviationName": "兰州农商",
        "code": "LZRCB"
    }, {"value": "兰州七里河新华村镇银行", "abbreviationName": "兰州七里河新华村镇银行", "code": "LZQLHXHCUNZB"}, {
        "value": "兰州银行",
        "abbreviationName": "兰州",
        "code": "LZYH"
    }, {"value": "兰州永登新华村镇银行", "abbreviationName": "兰州永登新华村镇银行", "code": "LZYDXHCUNZB"}, {
        "value": "岚县慧融村镇银行",
        "abbreviationName": "岚县慧融村镇银行",
        "code": "ZXHRCUNZB"
    }, {"value": "阆中融兴村镇银行", "abbreviationName": "阆中融兴村镇银行", "code": "ZZRXCUNZB"}, {
        "value": "廊坊开发区融商村镇银行",
        "abbreviationName": "廊坊开发区融商村镇银行",
        "code": "LFKFQRSCUNZB"
    }, {"value": "廊坊市安次区惠民村镇银行", "abbreviationName": "廊坊市安次区惠民村镇银行", "code": "LFSACQHMCUNZB"}, {
        "value": "廊坊市广阳舜丰村镇银行",
        "abbreviationName": "廊坊市广阳舜丰村镇银行",
        "code": "LFSGYSFCUNZB"
    }, {"value": "廊坊银行", "abbreviationName": "廊坊", "code": "LFYH"}, {
        "value": "乐安洪都村镇银行",
        "abbreviationName": "乐安洪都村镇银行",
        "code": "LAHDCUNZB"
    }, {"value": "乐东惠丰村镇银行", "abbreviationName": "乐东惠丰村镇银行", "code": "LDHFCUNZB"}, {
        "value": "乐陵圆融村镇银行",
        "abbreviationName": "乐陵圆融村镇银行",
        "code": "LLYRCUNZB"
    }, {"value": "乐平融兴村镇银行", "abbreviationName": "乐平融兴村镇银行", "code": "LPRXCUNZB"}, {
        "value": "乐山嘉州民富村镇银行",
        "abbreviationName": "乐山嘉州民富村镇银行",
        "code": "LSJZMFCUNZB"
    }, {"value": "乐山昆仑村镇银行", "abbreviationName": "乐山昆仑村镇银行", "code": "LSKLCUNZB"}, {
        "value": "乐山三江农村商业银行",
        "abbreviationName": "乐山三江农商",
        "code": "LSSJRCB"
    }, {"value": "乐山市商业银行", "abbreviationName": "乐山", "code": "LSSCCB"}, {
        "value": "乐亭舜丰村镇银行",
        "abbreviationName": "乐亭舜丰村镇银行",
        "code": "LTSFCUNZB"
    }, {"value": "雷州惠民村镇银行", "abbreviationName": "雷州惠民村镇银行", "code": "LZHMCUNZB"}, {
        "value": "耒阳融兴村镇银行",
        "abbreviationName": "耒阳融兴村镇银行",
        "code": "LYRXCUNZB"
    }, {"value": "梨树源泰村镇银行", "abbreviationName": "梨树源泰村镇银行", "code": "LSYTCUNZB"}, {
        "value": "黎川抚商村镇银行",
        "abbreviationName": "黎川抚商村镇银行",
        "code": "LCFSCUNZB"
    }, {"value": "澧县沪农商村镇银行", "abbreviationName": "澧县沪农商村镇银行", "code": "ZXHNSCUNZB"}, {
        "value": "醴陵沪农商村镇银行",
        "abbreviationName": "醴陵沪农商村镇银行",
        "code": "ZLHNSCUNZB"
    }, {"value": "丽江古城富滇村镇银行", "abbreviationName": "丽江古城富滇村镇银行", "code": "LJGCFDCUNZB"}, {
        "value": "丽江古城农村商业银行",
        "abbreviationName": "丽江古城农商",
        "code": "LJGCRCB"
    }, {"value": "丽江永胜长江村镇银行", "abbreviationName": "丽江永胜长江村镇银行", "code": "LJYSCJCUNZB"}, {
        "value": "丽江玉龙长江村镇银行",
        "abbreviationName": "丽江玉龙长江村镇银行",
        "code": "LJYLCJCUNZB"
    }, {"value": "荔波富民村镇银行", "abbreviationName": "荔波富民村镇银行", "code": "LBFMCUNZB"}, {
        "value": "溧阳浦发村镇银行",
        "abbreviationName": "溧阳浦发村镇银行",
        "code": "ZYPFCUNZB"
    }, {"value": "连云港东方农村商业银行", "abbreviationName": "连云港东方农商", "code": "LYGDFRCB"}, {
        "value": "涟源沪农商村镇银行",
        "abbreviationName": "涟源沪农商村镇银行",
        "code": "LYHNSCUNZB"
    }, {"value": "凉城县乌拉特村镇银行", "abbreviationName": "凉城县乌拉特村镇银行", "code": "LCXWLTCUNZB"}, {
        "value": "凉山农村商业银行",
        "abbreviationName": "凉山农商",
        "code": "LSRCB"
    }, {"value": "凉山州商业银行", "abbreviationName": "凉山", "code": "LSZCCB"}, {
        "value": "辽宁北镇锦银村镇银行",
        "abbreviationName": "辽宁北镇锦银村镇银行",
        "code": "LNBZJYCUNZB"
    }, {"value": "辽宁本溪南芬农村商业银行", "abbreviationName": "辽宁本溪南芬农商", "code": "LNBXNFRCB"}, {
        "value": "辽宁辰州汇通村镇银行",
        "abbreviationName": "辽宁辰州汇通村镇银行",
        "code": "LNCZHTCUNZB"
    }, {"value": "辽宁大石桥隆丰村镇银行", "abbreviationName": "辽宁大石桥隆丰村镇银行", "code": "LNDSQLFCUNZB"}, {
        "value": "辽宁大石桥农村商业银行",
        "abbreviationName": "辽宁大石桥农商",
        "code": "LNDSQRCB"
    }, {"value": "辽宁大洼农村商业银行", "abbreviationName": "辽宁大洼农商", "code": "LNDWRCB"}, {
        "value": "辽宁灯塔村镇银行",
        "abbreviationName": "辽宁灯塔村镇银行",
        "code": "LNDTCUNZB"
    }, {"value": "辽宁灯塔农村商业银行", "abbreviationName": "辽宁灯塔农商", "code": "LNDTRCB"}, {
        "value": "辽宁东港农村商业银行",
        "abbreviationName": "辽宁东港农商",
        "code": "LNDGRCB"
    }, {"value": "辽宁凤城农村商业银行", "abbreviationName": "辽宁凤城农商", "code": "LNFCRCB"}, {
        "value": "辽宁盖州农村商业银行",
        "abbreviationName": "辽宁盖州农商",
        "code": "LNGZRCB"
    }, {"value": "辽宁海城金海村镇银行", "abbreviationName": "辽宁海城金海村镇银行", "code": "LNHCJHCUNZB"}, {
        "value": "辽宁海城农村商业银行",
        "abbreviationName": "辽宁海城农商",
        "code": "LNHCRCB"
    }, {"value": "辽宁黑山锦银村镇银行", "abbreviationName": "辽宁黑山锦银村镇银行", "code": "LNHSJYCUNZB"}, {
        "value": "辽宁桓仁锦银村镇银行",
        "abbreviationName": "辽宁桓仁锦银村镇银行",
        "code": "LNHRJYCUNZB"
    }, {"value": "辽宁桓仁农村商业银行", "abbreviationName": "辽宁桓仁农商", "code": "LNHRRCB"}, {
        "value": "辽宁建平农村商业银行",
        "abbreviationName": "辽宁建平农商",
        "code": "LNJPRCB"
    }, {"value": "辽宁喀左锦银村镇银行", "abbreviationName": "辽宁喀左锦银村镇银行", "code": "LNKZJYCUNZB"}, {
        "value": "辽宁宽甸农村商业银行",
        "abbreviationName": "辽宁宽甸农商",
        "code": "LNKDRCB"
    }, {"value": "辽宁凌海锦银村镇银行", "abbreviationName": "辽宁凌海锦银村镇银行", "code": "LNLHJYCUNZB"}, {
        "value": "辽宁千山金泉村镇银行",
        "abbreviationName": "辽宁千山金泉村镇银行",
        "code": "LNQSJQCUNZB"
    }, {"value": "辽宁清原农村商业银行", "abbreviationName": "辽宁清原农商", "code": "LNQYRCB"}, {
        "value": "辽宁沈本农村商业银行",
        "abbreviationName": "辽宁沈本农商",
        "code": "LNSBRCB"
    }, {"value": "辽宁沈东村镇银行", "abbreviationName": "辽宁沈东村镇银行", "code": "LNSDCUNZB"}, {
        "value": "辽宁沈抚农村商业银行",
        "abbreviationName": "辽宁沈抚农商",
        "code": "LNSFRCB"
    }, {"value": "辽宁省农村信用社联合社", "abbreviationName": "辽宁农信社", "code": "LNNXS"}, {
        "value": "辽宁首山村镇银行",
        "abbreviationName": "辽宁首山村镇银行",
        "code": "LNSSCUNZB"
    }, {"value": "辽宁台安金安村镇银行", "abbreviationName": "辽宁台安金安村镇银行", "code": "LNTAJACUNZB"}, {
        "value": "辽宁太子河村镇银行",
        "abbreviationName": "辽宁太子河村镇银行",
        "code": "LNTZHCUNZB"
    }, {"value": "辽宁新宾农村商业银行", "abbreviationName": "辽宁新宾农商", "code": "LNXBRCB"}, {
        "value": "辽宁新民农村商业银行",
        "abbreviationName": "辽宁新民农商",
        "code": "LNXMRCB"
    }, {"value": "辽宁兴城农村商业银行", "abbreviationName": "辽宁兴城农商", "code": "LNXCRCB"}, {
        "value": "辽宁岫岩金玉村镇银行",
        "abbreviationName": "辽宁岫岩金玉村镇银行",
        "code": "LNZYJYCUNZB"
    }, {"value": "辽宁岫岩农村商业银行", "abbreviationName": "辽宁岫岩农商", "code": "LNXYRCB"}, {
        "value": "辽宁义县锦银村镇银行",
        "abbreviationName": "辽宁义县锦银村镇银行",
        "code": "LNYXJYCUNZB"
    }, {"value": "辽宁彰武金通村镇银行", "abbreviationName": "辽宁彰武金通村镇银行", "code": "LNZWJTCUNZB"}, {
        "value": "辽宁振兴银行",
        "abbreviationName": "辽宁振兴",
        "code": "LNZXYH"
    }, {"value": "辽沈银行", "abbreviationName": "辽沈", "code": "LSBANK"}, {
        "value": "辽阳辽东农村商业银行",
        "abbreviationName": "辽阳辽东农商",
        "code": "LYLDRCB"
    }, {"value": "辽阳农村商业银行", "abbreviationName": "辽阳农商", "code": "LYANGRCB"}, {
        "value": "辽阳银行",
        "abbreviationName": "辽阳",
        "code": "LYYH"
    }, {"value": "辽源龙山榆银村镇银行", "abbreviationName": "辽源龙山榆银村镇银行", "code": "LYLSYYCUNZB"}, {
        "value": "辽源农村商业银行",
        "abbreviationName": "辽源农商",
        "code": "LYRCB"
    }, {"value": "辽源西安区榆银村镇银行", "abbreviationName": "辽源西安区榆银村镇银行", "code": "LYXAQYYCUNZB"}, {
        "value": "聊城沪农商村镇银行",
        "abbreviationName": "聊城沪农商村镇银行",
        "code": "LCHNSCUNZB"
    }, {"value": "聊城农村商业银行", "abbreviationName": "聊城农商", "code": "LCRCB"}, {
        "value": "林芝民生村镇银行",
        "abbreviationName": "林芝民生村镇银行",
        "code": "LZMSCUNZB"
    }, {"value": "林州中原村镇银行", "abbreviationName": "林州中原村镇银行", "code": "LZZYCUNZB"}, {
        "value": "临沧临翔沪农商村镇银行",
        "abbreviationName": "临沧临翔沪农商村镇银行",
        "code": "LCLXHNSCUNZB"
    }, {"value": "临川浦发村镇银行", "abbreviationName": "临川浦发村镇银行", "code": "LCPFCUNZB"}, {
        "value": "临汾市尧都区惠都村镇银行",
        "abbreviationName": "临汾市尧都区惠都村镇银行",
        "code": "LFSYDQHDCUNZB"
    }, {"value": "临高惠丰村镇银行", "abbreviationName": "临高惠丰村镇银行", "code": "LGHFCUNZB"}, {
        "value": "临江蛟银村镇银行",
        "abbreviationName": "临江蛟银村镇银行",
        "code": "LJZYCUNZB"
    }, {"value": "临澧沪农商村镇银行", "abbreviationName": "临澧沪农商村镇银行", "code": "LZHNSCUNZB"}, {
        "value": "临清沪农商村镇银行",
        "abbreviationName": "临清沪农商村镇银行",
        "code": "LQHNSCUNZB"
    }, {"value": "临商银行", "abbreviationName": "临商", "code": "LSYH"}, {
        "value": "临沭民丰村镇银行",
        "abbreviationName": "临沭民丰村镇银行",
        "code": "LSMFCUNZB"
    }, {"value": "临洮县金城村镇银行", "abbreviationName": "临洮县金城村镇银行", "code": "LZXJCCUNZB"}, {
        "value": "临武浦发村镇银行",
        "abbreviationName": "临武浦发村镇银行",
        "code": "LWPFCUNZB"
    }, {"value": "临县泉都村镇银行", "abbreviationName": "临县泉都村镇银行", "code": "LXQDCUNZB"}, {
        "value": "临猗县新田村镇银行",
        "abbreviationName": "临猗县新田村镇银行",
        "code": "LZXXTCUNZB"
    }, {"value": "临沂河东齐商村镇银行", "abbreviationName": "临沂河东齐商村镇银行", "code": "LYHDQSCUNZB"}, {
        "value": "灵宝融丰村镇银行",
        "abbreviationName": "灵宝融丰村镇银行",
        "code": "LBRFCUNZB"
    }, {"value": "灵川深通村镇银行", "abbreviationName": "灵川深通村镇银行", "code": "LCSTCUNZB"}, {
        "value": "灵丘县长青村镇银行",
        "abbreviationName": "灵丘县长青村镇银行",
        "code": "LQXCQCUNZB"
    }, {"value": "灵山泰业村镇银行", "abbreviationName": "灵山泰业村镇银行", "code": "LSTYCUNZB"}, {
        "value": "灵石县汇民村镇银行",
        "abbreviationName": "灵石县汇民村镇银行",
        "code": "LSXHMCUNZB"
    }, {"value": "凌源天元村镇银行", "abbreviationName": "凌源天元村镇银行", "code": "LYTYCUNZB"}, {
        "value": "陵川县太行村镇银行",
        "abbreviationName": "陵川县太行村镇银行",
        "code": "LCXTXCUNZB"
    }, {"value": "陵水惠民村镇银行", "abbreviationName": "陵水惠民村镇银行", "code": "LSHMCUNZB"}, {
        "value": "柳河蒙银村镇银行",
        "abbreviationName": "柳河蒙银村镇银行",
        "code": "LHMYCUNZB"
    }, {"value": "柳林汇泽村镇银行", "abbreviationName": "柳林汇泽村镇银行", "code": "LLHZCUNZB"}, {
        "value": "柳州银行",
        "abbreviationName": "柳州",
        "code": "LIUZYH"
    }, {"value": "六安农村商业银行", "abbreviationName": "六安农商", "code": "LARCB"}, {
        "value": "六盘水六枝富民村镇银行",
        "abbreviationName": "六盘水六枝富民村镇银行",
        "code": "LPSLZFMCUNZB"
    }, {"value": "六盘水农村商业银行", "abbreviationName": "六盘水农商", "code": "LPSRCB"}, {
        "value": "六盘水钟山凉都村镇银行",
        "abbreviationName": "六盘水钟山凉都村镇银行",
        "code": "LPSZSLDCUNZB"
    }, {"value": "龙川融和村镇银行", "abbreviationName": "龙川融和村镇银行", "code": "LCRHCUNZB"}, {
        "value": "龙江银行",
        "abbreviationName": "龙江",
        "code": "LJYH"
    }, {"value": "龙井榆银村镇银行", "abbreviationName": "龙井榆银村镇银行", "code": "LJYYCUNZB"}, {
        "value": "龙里国丰村镇银行",
        "abbreviationName": "龙里国丰村镇银行",
        "code": "LLGFCUNZB"
    }, {"value": "隆德六盘山村镇银行", "abbreviationName": "隆德六盘山村镇银行", "code": "LDLPSCUNZB"}, {
        "value": "隆尧邢农商村镇银行",
        "abbreviationName": "隆尧邢农商村镇银行",
        "code": "LYXNCUNZB"
    }, {"value": "陇南市武都金桥村镇银行", "abbreviationName": "陇南市武都金桥村镇银行", "code": "LNSWDJQCUNZB"}, {
        "value": "陇南武都农村合作银行",
        "abbreviationName": "陇南武都农村合作银行",
        "code": "LNWDRCU"
    }, {"value": "陇西神舟村镇银行", "abbreviationName": "陇西神舟村镇银行", "code": "LXSZCUNZB"}, {
        "value": "娄烦县三禾村镇银行",
        "abbreviationName": "娄烦县三禾村镇银行",
        "code": "LFXSHCUNZB"
    }, {"value": "卢龙家银村镇银行", "abbreviationName": "卢龙家银村镇银行", "code": "LLJYCUNZB"}, {
        "value": "卢氏中原村镇银行",
        "abbreviationName": "卢氏中原村镇银行",
        "code": "LSZYCUNZB"
    }, {"value": "庐江惠民村镇银行", "abbreviationName": "庐江惠民村镇银行", "code": "LJHMCUNZB"}, {
        "value": "庐山九银艺术村镇银行",
        "abbreviationName": "庐山九银艺术村镇银行",
        "code": "LSJYYSCUNZB"
    }, {"value": "泸水中成村镇银行", "abbreviationName": "泸水中成村镇银行", "code": "LSZCCUNZB"}, {
        "value": "泸县元通村镇银行",
        "abbreviationName": "泸县元通村镇银行",
        "code": "ZXYTCUNZB"
    }, {"value": "泸州江阳农村商业银行", "abbreviationName": "泸州江阳农商", "code": "LZJYRCB"}, {
        "value": "泸州龙马潭农村商业银行",
        "abbreviationName": "泸州龙马潭农商",
        "code": "LZLMTRCB"
    }, {"value": "泸州农村商业银行", "abbreviationName": "泸州农商", "code": "LUZRCB"}, {
        "value": "泸州市商业银行",
        "abbreviationName": "泸州",
        "code": "HZSCCB"
    }, {"value": "鹿泉恒升村镇银行", "abbreviationName": "鹿泉恒升村镇银行", "code": "LQHSCUNZB"}, {
        "value": "禄丰龙城富滇村镇银行",
        "abbreviationName": "禄丰龙城富滇村镇银行",
        "code": "LFLCFDCUNZB"
    }, {"value": "滦南中成村镇银行", "abbreviationName": "滦南中成村镇银行", "code": "LNZCCUNZB"}, {
        "value": "滦平盛阳村镇银行",
        "abbreviationName": "滦平盛阳村镇银行",
        "code": "LPSYCUNZB"
    }, {"value": "滦州中成村镇银行", "abbreviationName": "滦州中成村镇银行", "code": "LXZCCUNZB"}, {
        "value": "罗甸发展村镇银行",
        "abbreviationName": "罗甸发展村镇银行",
        "code": "LDFZCUNZB"
    }, {"value": "罗田楚农商村镇银行", "abbreviationName": "罗田楚农商村镇银行", "code": "LTCNSCUNZB"}, {
        "value": "洛阳农村商业银行",
        "abbreviationName": "洛阳农商",
        "code": "LUOYRCB"
    }, {"value": "洛阳银行", "abbreviationName": "洛阳", "code": "LYBC"}, {
        "value": "漯河市郾城发展村镇银行",
        "abbreviationName": "漯河市郾城发展村镇银行",
        "code": "ZHSZCBSCUNZB"
    }, {"value": "吕梁孝义汇通村镇银行", "abbreviationName": "吕梁孝义汇通村镇银行", "code": "LLXYHTCUNZB"}, {
        "value": "马来西亚联昌银行",
        "abbreviationName": "马来西亚联昌",
        "code": "MLXYLCB"
    }, {"value": "马来西亚马来亚银行", "abbreviationName": "马来西亚马来亚", "code": "MALAYSIABANK"}, {
        "value": "满洲里农村商业银行",
        "abbreviationName": "满洲里农商",
        "code": "MZLRCB"
    }, {"value": "茂名电白长江村镇银行", "abbreviationName": "茂名电白长江村镇银行", "code": "MMDBCJCUNZB"}, {
        "value": "茂名高州长江村镇银行",
        "abbreviationName": "茂名高州长江村镇银行",
        "code": "MMGZCJCUNZB"
    }, {"value": "眉山农村商业银行", "abbreviationName": "眉山农商", "code": "MSRCB"}, {
        "value": "梅河口民生村镇银行",
        "abbreviationName": "梅河口民生村镇银行",
        "code": "MHKMSCUNZB"
    }, {"value": "梅州客家村镇银行", "abbreviationName": "梅州客家村镇银行", "code": "MXKJCUNZB"}, {
        "value": "梅州客商银行",
        "abbreviationName": "梅州客商",
        "code": "MZKSB"
    }, {"value": "美国道富银行", "abbreviationName": "美国道富", "code": "SSC"}, {
        "value": "美国建东银行",
        "abbreviationName": "美国建东",
        "code": "AMERICANBUILTEASTBANK"
    }, {"value": "美国银行有限公司", "abbreviationName": "美国", "code": "BAC"}, {
        "value": "蒙商银行(包商银行)",
        "abbreviationName": "蒙商",
        "code": "BTCB"
    }, {"value": "蒙特利尔银行", "abbreviationName": "蒙特利尔", "code": "BMOBK"}, {
        "value": "蒙自沪农商村镇银行",
        "abbreviationName": "蒙自沪农商村镇银行",
        "code": "MZHNSCUNZB"
    }, {"value": "孟村回族自治县融信村镇银行", "abbreviationName": "孟村回族自治县融信村镇银行", "code": "MCHZZZXRXCUNZB"}, {
        "value": "孟津民丰村镇银行",
        "abbreviationName": "孟津民丰村镇银行",
        "code": "MJMFCUNZB"
    }, {"value": "孟州射阳村镇银行", "abbreviationName": "孟州射阳村镇银行", "code": "MZSYCUNZB"}, {
        "value": "弥勒沪农商村镇银行",
        "abbreviationName": "弥勒沪农商村镇银行",
        "code": "MLHNSCUNZB"
    }, {"value": "泌阳玉川村镇银行", "abbreviationName": "泌阳玉川村镇银行", "code": "MYYCCUNZB"}, {
        "value": "密山民意村镇银行",
        "abbreviationName": "密山民意村镇银行",
        "code": "MSMYCUNZB"
    }, {"value": "绵阳市商业银行", "abbreviationName": "绵阳市商业", "code": "MYCCB"}, {
        "value": "绵竹浦发村镇银行",
        "abbreviationName": "绵竹浦发村镇银行",
        "code": "MZPFCUNZB"
    }, {"value": "渑池齐鲁村镇银行", "abbreviationName": "渑池齐鲁村镇银行", "code": "MCQLCUNZB"}, {
        "value": "民勤融信村镇银行",
        "abbreviationName": "民勤融信村镇银行",
        "code": "MQRXCUNZB"
    }, {"value": "民权德商村镇银行", "abbreviationName": "民权德商村镇银行", "code": "MQDSCUNZB"}, {
        "value": "摩根大通银行（中国）有限公司",
        "abbreviationName": "摩根大通",
        "code": "JPMC"
    }, {"value": "摩根士丹利国际", "abbreviationName": "摩根士丹利国际", "code": "MGSDL"}, {
        "value": "莫力达瓦蒙商村镇银行",
        "abbreviationName": "莫力达瓦蒙商村镇银行",
        "code": "MLDWBSCUNZB"
    }, {"value": "牟平胶东村镇银行", "abbreviationName": "牟平胶东村镇银行", "code": "MPJDCUNZB"}, {
        "value": "穆棱远东村镇银行",
        "abbreviationName": "穆棱远东村镇银行",
        "code": "MLYDCUNZB"
    }, {"value": "纳雍富民村镇银行", "abbreviationName": "纳雍富民村镇银行", "code": "NYFMCUNZB"}, {
        "value": "南部县中成村镇银行",
        "abbreviationName": "南部县中成村镇银行",
        "code": "NBXZCCUNZB"
    }, {"value": "南昌昌东九银村镇银行", "abbreviationName": "南昌昌东九银村镇银行", "code": "NCCDJYCUNZB"}, {
        "value": "南昌大丰村镇银行",
        "abbreviationName": "南昌大丰村镇银行",
        "code": "NCDFCUNZB"
    }, {"value": "南昌农村商业银行", "abbreviationName": "南昌农商", "code": "NCRCB"}, {
        "value": "南昌新建恒通村镇银行",
        "abbreviationName": "南昌新建恒通村镇银行",
        "code": "NCXJHTCUNZB"
    }, {"value": "南城富民村镇银行", "abbreviationName": "南城富民村镇银行", "code": "NCFMCUNZB"}, {
        "value": "南充嘉陵中成村镇银行",
        "abbreviationName": "南充嘉陵中成村镇银行",
        "code": "NCJLZCCUNZB"
    }, {"value": "南充农村商业银行", "abbreviationName": "南充农商", "code": "NCHONGRCB"}, {
        "value": "南丰桔都村镇银行",
        "abbreviationName": "南丰桔都村镇银行",
        "code": "NFJDCUNZB"
    }, {"value": "南和融信村镇银行", "abbreviationName": "南和融信村镇银行", "code": "NHRXCUNZB"}, {
        "value": "南江农科村镇银行",
        "abbreviationName": "南江农科村镇银行",
        "code": "NJNKCUNZB"
    }, {"value": "南京六合九银村镇银行", "abbreviationName": "南京六合九银村镇银行", "code": "NJLHJYCUNZB"}, {
        "value": "南京浦口靖发村镇银行",
        "abbreviationName": "南京浦口靖发村镇银行",
        "code": "NJPKJFCUNZB"
    }, {"value": "南京银行", "abbreviationName": "南京", "code": "NJYH"}, {
        "value": "南靖中成村镇银行",
        "abbreviationName": "南靖中成村镇银行",
        "code": "NJZCCUNZB"
    }, {"value": "南康赣商村镇银行", "abbreviationName": "南康赣商村镇银行", "code": "NKGSCUNZB"}, {
        "value": "南陵太平村镇银行",
        "abbreviationName": "南陵太平村镇银行",
        "code": "NLTPCUNZB"
    }, {"value": "南宁江南国民村镇银行", "abbreviationName": "南宁江南国民村镇银行", "code": "NNJNGMCUNZB"}, {
        "value": "南宁隆安长江村镇银行",
        "abbreviationName": "南宁隆安长江村镇银行",
        "code": "NNLACJCUNZB"
    }, {"value": "南宁马山长江村镇银行", "abbreviationName": "南宁马山长江村镇银行", "code": "NNMSCJCUNZB"}, {
        "value": "南宁武鸣漓江村镇银行",
        "abbreviationName": "南宁武鸣漓江村镇银行",
        "code": "NNWMLJCUNZB"
    }, {"value": "南宁兴宁长江村镇银行", "abbreviationName": "南宁兴宁长江村镇银行", "code": "NNXNCJCUNZB"}, {
        "value": "南皮融信村镇银行",
        "abbreviationName": "南皮融信村镇银行",
        "code": "NPRXCUNZB"
    }, {"value": "南通如皋润泽村镇银行", "abbreviationName": "南通如皋润泽村镇银行", "code": "JSNTRGBSCUNZB"}, {
        "value": "南阳村镇银行",
        "abbreviationName": "南阳村镇银行",
        "code": "NYCUNZB"
    }, {"value": "南洋商业银行（中国）有限公司", "abbreviationName": "南洋", "code": "NOBC"}, {
        "value": "讷河融兴村镇银行",
        "abbreviationName": "讷河融兴村镇银行",
        "code": "ZHRXCUNZB"
    }, {"value": "内江兴隆村镇银行", "abbreviationName": "内江兴隆村镇银行", "code": "NJXLCUNZB"}, {
        "value": "内蒙古阿巴嘎农村商业银行",
        "abbreviationName": "内蒙古阿巴嘎农商",
        "code": "NMGABGRCB"
    }, {"value": "内蒙古阿尔山农村商业银行", "abbreviationName": "内蒙古阿尔山农商", "code": "NMGAESRCB"}, {
        "value": "内蒙古阿鲁科尔沁农村商业银行",
        "abbreviationName": "内蒙古阿鲁科尔沁农商",
        "code": "NMGALKEQRCB"
    }, {"value": "内蒙古敖汉农村商业银行", "abbreviationName": "内蒙古敖汉农商", "code": "NMGAHRCB"}, {
        "value": "内蒙古察哈尔右翼前旗农村商业银行",
        "abbreviationName": "内蒙古察哈尔右翼前旗农商",
        "code": "NMGCHEYYQQRCB"
    }, {"value": "内蒙古鄂伦春农村商业银行", "abbreviationName": "内蒙古鄂伦春农商", "code": "NMGELCRCB"}, {
        "value": "内蒙古鄂托克农村商业银行",
        "abbreviationName": "内蒙古鄂托克农商",
        "code": "NMGETKRCB"
    }, {"value": "内蒙古鄂托克前旗农村商业银行", "abbreviationName": "内蒙古鄂托克前旗农商", "code": "NMGETKQQRCB"}, {
        "value": "内蒙古鄂温克农村商业银行",
        "abbreviationName": "内蒙古鄂温克农商",
        "code": "NMGEWKRCB"
    }, {"value": "内蒙古杭锦农村商业银行", "abbreviationName": "内蒙古杭锦农商", "code": "NMGHJRCB"}, {
        "value": "内蒙古和林格尔蒙商村镇银行",
        "abbreviationName": "内蒙古和林格尔蒙商村镇银行",
        "code": "NMGHLGEBSCUNZB"
    }, {"value": "内蒙古呼和浩特金谷农村商业银行", "abbreviationName": "内蒙古呼和浩特金谷农商", "code": "HHHTJGRCB"}, {
        "value": "内蒙古开鲁农村商业银行",
        "abbreviationName": "内蒙古开鲁农商",
        "code": "NMGKLURCB"
    }, {"value": "内蒙古克什克腾农村商业银行", "abbreviationName": "内蒙古克什克腾农商", "code": "NMGKSKTRCB"}, {
        "value": "内蒙古库伦农村商业银行",
        "abbreviationName": "内蒙古库伦农商",
        "code": "NMGKLRCB"
    }, {"value": "内蒙古林西农村商业银行", "abbreviationName": "内蒙古林西农商", "code": "NMGLXRCB"}, {
        "value": "内蒙古宁城农村商业银行",
        "abbreviationName": "内蒙古宁城农商",
        "code": "NMGNCRCB"
    }, {"value": "内蒙古陕坝农村商业银行", "abbreviationName": "内蒙古陕坝农商", "code": "NMGSBRCB"}, {
        "value": "内蒙古太仆寺农村商业银行",
        "abbreviationName": "内蒙古太仆寺农商",
        "code": "NMGTPSRCB"
    }, {"value": "内蒙古土默特右旗农村商业银行", "abbreviationName": "内蒙古土默特右旗农商", "code": "NMGTMTYQRCB"}, {
        "value": "内蒙古托克托立农村镇银行",
        "abbreviationName": "内蒙古托克托立农村镇银行",
        "code": "NMGTKTLNCUNZB"
    }, {"value": "内蒙古托克托农村商业银行", "abbreviationName": "内蒙古托克托农商", "code": "NMGTKTRCB"}, {
        "value": "内蒙古乌拉特农村商业银行",
        "abbreviationName": "内蒙古乌拉特农商",
        "code": "NMGWLTRCB"
    }, {"value": "内蒙古五原农村商业银行", "abbreviationName": "内蒙古五原农商", "code": "NMGWYRCB"}, {
        "value": "内蒙古西乌珠穆沁农村商业银行",
        "abbreviationName": "内蒙古西乌珠穆沁农商",
        "code": "NMGXWZMQRCB"
    }, {"value": "内蒙古牙克石农村商业银行", "abbreviationName": "内蒙古牙克石农商", "code": "NMGYKSRCB"}, {
        "value": "内蒙古伊金霍洛农村商业银行",
        "abbreviationName": "内蒙古伊金霍洛农商",
        "code": "NMGYJHLRCB"
    }, {"value": "内蒙古银行", "abbreviationName": "内蒙古", "code": "NMGYH"}, {
        "value": "内蒙古扎鲁特农村商业银行",
        "abbreviationName": "内蒙古扎鲁特农商",
        "code": "NMGZLTRCB"
    }, {"value": "内蒙古自治区农村信用社联合社", "abbreviationName": "内蒙古农信社", "code": "NMGNXS"}, {
        "value": "嫩江幸福村镇银行",
        "abbreviationName": "嫩江幸福村镇银行",
        "code": "NJXFCUNZB"
    }, {"value": "宁安融兴村镇银行", "abbreviationName": "宁安融兴村镇银行", "code": "NARXCUNZB"}, {
        "value": "宁波北仑农村商业银行",
        "abbreviationName": "宁波北仑农商",
        "code": "NBBLRCB"
    }, {"value": "宁波慈溪农村商业银行", "abbreviationName": "宁波慈溪农商", "code": "NBCXRCB"}, {
        "value": "宁波东海银行",
        "abbreviationName": "宁波东海",
        "code": "NBDHYH"
    }, {"value": "宁波奉化农村商业银行", "abbreviationName": "宁波奉化农商", "code": "NBFHRCB"}, {
        "value": "宁波海曙浦发村镇银行",
        "abbreviationName": "宁波海曙浦发村镇银行",
        "code": "NBHSPFCUNZB"
    }, {"value": "宁波江北富民村镇银行", "abbreviationName": "宁波江北富民村镇银行", "code": "NBJBFMCUNZB"}, {
        "value": "宁波宁海农村商业银行",
        "abbreviationName": "宁波宁海农商",
        "code": "NBNHRCB"
    }, {"value": "宁波市海曙国民村镇银行", "abbreviationName": "宁波市海曙国民村镇银行", "code": "NBSHZGMCUNZB"}, {
        "value": "宁波通商银行",
        "abbreviationName": "宁波通商",
        "code": "NBTSYH"
    }, {"value": "宁波银行", "abbreviationName": "宁波", "code": "NBYH"}, {
        "value": "宁波鄞州农村商业银行",
        "abbreviationName": "宁波鄞州农商",
        "code": "NBYZRCB"
    }, {"value": "宁波甬城农村商业银行", "abbreviationName": "宁波甬城农商", "code": "NBYCRCB"}, {
        "value": "宁波余姚农村商业银行",
        "abbreviationName": "宁波余姚农商",
        "code": "NBYYRCB"
    }, {"value": "宁波镇海农村商业银行", "abbreviationName": "宁波镇海农商", "code": "NBZHRCB"}, {
        "value": "宁城蒙商村镇银行",
        "abbreviationName": "宁城蒙商村镇银行",
        "code": "NCBSCUNZB"
    }, {"value": "宁国民生村镇银行", "abbreviationName": "宁国民生村镇银行", "code": "NGMSCUNZB"}, {
        "value": "宁津胶东村镇银行",
        "abbreviationName": "宁津胶东村镇银行",
        "code": "NJJDCUNZB"
    }, {"value": "宁晋民生村镇银行", "abbreviationName": "宁晋民生村镇银行", "code": "NJMSCUNZB"}, {
        "value": "宁陵德商村镇银行",
        "abbreviationName": "宁陵德商村镇银行",
        "code": "NLDSCUNZB"
    }, {"value": "宁武县瑞都村镇银行", "abbreviationName": "宁武县瑞都村镇银行", "code": "NWXRDCUNZB"}, {
        "value": "宁夏固原农村商业银行",
        "abbreviationName": "宁夏固原农商",
        "code": "NXGYRCB"
    }, {"value": "宁夏海原农村商业银行", "abbreviationName": "宁夏海原农商", "code": "NXHYRCB"}, {
        "value": "宁夏贺兰回商村镇银行",
        "abbreviationName": "宁夏贺兰回商村镇银行",
        "code": "NXHLHSCUNZB"
    }, {"value": "宁夏贺兰农村商业银行", "abbreviationName": "宁夏贺兰农商", "code": "NXHLRCB"}, {
        "value": "宁夏红寺堡汇发村镇银行",
        "abbreviationName": "宁夏红寺堡汇发村镇银行",
        "code": "NXHSBHFCUNZB"
    }, {"value": "宁夏红寺堡农村商业银行", "abbreviationName": "宁夏红寺堡农商", "code": "NXHSBRCB"}, {
        "value": "宁夏黄河农村商业银行",
        "abbreviationName": "宁夏黄河农商",
        "code": "NXHHRCB"
    }, {"value": "宁夏回族自治区农村信用社联合社", "abbreviationName": "宁夏农信社", "code": "NXNXS"}, {
        "value": "宁夏惠农贺兰山村镇银行",
        "abbreviationName": "宁夏惠农贺兰山村镇银行",
        "code": "NXHNHLSCUNZB"
    }, {"value": "宁夏泾源农村商业银行", "abbreviationName": "宁夏泾源农商", "code": "NXJYRCB"}, {
        "value": "宁夏灵武农村商业银行",
        "abbreviationName": "宁夏灵武农商",
        "code": "NXLWRCB"
    }, {"value": "宁夏隆德农村商业银行", "abbreviationName": "宁夏隆德农商", "code": "NXLDRCB"}, {
        "value": "宁夏宁东本富村镇银行",
        "abbreviationName": "宁夏宁东本富村镇银行",
        "code": "NXNDBFCUNZB"
    }, {"value": "宁夏彭阳贺兰山村镇银行", "abbreviationName": "宁夏彭阳贺兰山村镇银行", "code": "NXPYHLSCUNZB"}, {
        "value": "宁夏彭阳农村商业银行",
        "abbreviationName": "宁夏彭阳农商",
        "code": "NXPYRCB"
    }, {"value": "宁夏平罗农村商业银行", "abbreviationName": "宁夏平罗农商", "code": "NXPLRCB"}, {
        "value": "宁夏青铜峡贺兰山村镇银行",
        "abbreviationName": "宁夏青铜峡贺兰山村镇银行",
        "code": "NXQTXHLSCUNZB"
    }, {"value": "宁夏石嘴山农村商业银行", "abbreviationName": "宁夏石嘴山农商", "code": "NXSZSRCB"}, {
        "value": "宁夏同心津汇村镇银行",
        "abbreviationName": "宁夏同心津汇村镇银行",
        "code": "NXTXJHCUNZB"
    }, {"value": "宁夏同心农村商业银行", "abbreviationName": "宁夏同心农商", "code": "NXTXRCB"}, {
        "value": "宁夏吴忠农村商业银行",
        "abbreviationName": "宁夏吴忠农商",
        "code": "NXWZRCB"
    }, {"value": "宁夏西吉汇发村镇银行", "abbreviationName": "宁夏西吉汇发村镇银行", "code": "NXXJHFCUNZB"}, {
        "value": "宁夏西吉农村商业银行",
        "abbreviationName": "宁夏西吉农商",
        "code": "NXXJRCB"
    }, {"value": "宁夏西夏贺兰山村镇银行", "abbreviationName": "宁夏西夏贺兰山村镇银行", "code": "NXXXHLSCUNZB"}, {
        "value": "宁夏盐池汇发村镇银行",
        "abbreviationName": "宁夏盐池汇发村镇银行",
        "code": "NXYCHFCUNZB"
    }, {"value": "宁夏盐池农村商业银行", "abbreviationName": "宁夏盐池农商", "code": "NXYCRCB"}, {
        "value": "宁夏银行",
        "abbreviationName": "宁夏",
        "code": "NXYH"
    }, {"value": "宁夏永宁汇发村镇银行", "abbreviationName": "宁夏永宁汇发村镇银行", "code": "NXYNHFCUNZB"}, {
        "value": "宁夏原州津汇村镇银行",
        "abbreviationName": "宁夏原州津汇村镇银行",
        "code": "NXYZJHCUNZB"
    }, {"value": "宁夏中宁农村商业银行", "abbreviationName": "宁夏中宁农商", "code": "NXZNRCB"}, {
        "value": "宁夏中宁青银村镇银行",
        "abbreviationName": "宁夏中宁青银村镇银行",
        "code": "NXZNQYCUNZB"
    }, {"value": "宁夏中卫农村商业银行", "abbreviationName": "宁夏中卫农商", "code": "NXZWRCB"}, {
        "value": "宁乡沪农商村镇银行",
        "abbreviationName": "宁乡沪农商村镇银行",
        "code": "NXHNSCUNZB"
    }, {"value": "宁阳沪农商村镇银行", "abbreviationName": "宁阳沪农商村镇银行", "code": "NYHNSCUNZB"}, {
        "value": "农安北银村镇银行",
        "abbreviationName": "农安北银村镇银行",
        "code": "NABYCUNZB"
    }, {"value": "挪威银行公共", "abbreviationName": "挪威公共", "code": "NORWAYBANK"}, {
        "value": "攀枝花农村商业银行",
        "abbreviationName": "攀枝花农商",
        "code": "PZHRCB"
    }, {"value": "攀枝花市商业银行", "abbreviationName": "攀枝花", "code": "PZHCCB"}, {
        "value": "盘谷银行",
        "abbreviationName": "盘谷",
        "code": "BKB"
    }, {"value": "盘锦农村商业银行", "abbreviationName": "盘锦农商", "code": "PJRCB"}, {
        "value": "盘锦市商业银行",
        "abbreviationName": "盘锦",
        "code": "PJSCCB"
    }, {"value": "盘山安泰村镇银行", "abbreviationName": "盘山安泰村镇银行", "code": "PSATCUNZB"}, {
        "value": "盘州万和村镇银行",
        "abbreviationName": "盘州万和村镇银行",
        "code": "PZWHCUNZB"
    }, {"value": "磐石吉银村镇银行", "abbreviationName": "磐石吉银村镇银行", "code": "PSJYCUNZB"}, {
        "value": "彭山珠江村镇银行",
        "abbreviationName": "彭山珠江村镇银行",
        "code": "PSZJCUNZB"
    }, {"value": "彭泽九银村镇银行", "abbreviationName": "彭泽九银村镇银行", "code": "PZJYCUNZB"}, {
        "value": "彭州民生村镇银行",
        "abbreviationName": "彭州民生村镇银行",
        "code": "PZMSCUNZB"
    }, {"value": "蓬莱民生村镇银行", "abbreviationName": "蓬莱民生村镇银行", "code": "PLMSCUNZB"}, {
        "value": "平安银行(深圳发展银行)",
        "abbreviationName": "平安",
        "code": "SDB"
    }, {"value": "平坝鼎立村镇银行", "abbreviationName": "平坝鼎立村镇银行", "code": "PBDLCUNZB"}, {
        "value": "平昌农科村镇银行",
        "abbreviationName": "平昌农科村镇银行",
        "code": "PCNKCUNZB"
    }, {"value": "平顶山卫东农村商业银行", "abbreviationName": "平顶山卫东农商", "code": "PDSWDRCB"}, {
        "value": "平顶山银行",
        "abbreviationName": "平顶山",
        "code": "PDSYH"
    }, {"value": "平顶山鹰城农村商业银行", "abbreviationName": "平顶山鹰城农商", "code": "PDSYCRCB"}, {
        "value": "平定县昌都村镇银行",
        "abbreviationName": "平定县昌都村镇银行",
        "code": "PDCDCUNZB"
    }, {"value": "平果国民村镇银行", "abbreviationName": "平果国民村镇银行", "code": "PGGMCUNZB"}, {
        "value": "平和润丰村镇银行",
        "abbreviationName": "平和润丰村镇银行",
        "code": "PHRFCUNZB"
    }, {"value": "平凉崆峒融兴村镇银行", "abbreviationName": "平凉崆峒融兴村镇银行", "code": "PLZZRXCUNZB"}, {
        "value": "平凉农村商业银行",
        "abbreviationName": "平凉农商",
        "code": "PLRCB"
    }, {"value": "平凉市静宁成纪村镇银行", "abbreviationName": "平凉市静宁成纪村镇银行", "code": "PLSJNCJCUNZB"}, {
        "value": "平陆县河东村镇银行",
        "abbreviationName": "平陆县河东村镇银行",
        "code": "PLXHDCUNZB"
    }, {"value": "平罗沙湖村镇银行", "abbreviationName": "平罗沙湖村镇银行", "code": "PLSHCUNZB"}, {
        "value": "平泉恒升村镇银行",
        "abbreviationName": "平泉恒升村镇银行",
        "code": "PQHSCUNZB"
    }, {"value": "平山西柏坡冀银村镇银行", "abbreviationName": "平山西柏坡冀银村镇银行", "code": "PSXBPJYCUNZB"}, {
        "value": "平塘富民村镇银行",
        "abbreviationName": "平塘富民村镇银行",
        "code": "PTFMCUNZB"
    }, {"value": "平遥县晋融村镇银行", "abbreviationName": "平遥县晋融村镇银行", "code": "PYXJRCUNZB"}, {
        "value": "平阴蓝海村镇银行",
        "abbreviationName": "平阴蓝海村镇银行",
        "code": "PYLHCUNZB"
    }, {"value": "平舆玉川村镇银行", "abbreviationName": "平舆玉川村镇银行", "code": "PYYCCUNZB"}, {
        "value": "平原圆融村镇银行",
        "abbreviationName": "平原圆融村镇银行",
        "code": "PYYRCUNZB"
    }, {"value": "屏南刺桐红村镇银行", "abbreviationName": "屏南刺桐红村镇银行", "code": "PNCTHCUNZB"}, {
        "value": "萍乡安源富民村镇银行",
        "abbreviationName": "萍乡安源富民村镇银行",
        "code": "PXAYFMCUNZB"
    }, {"value": "萍乡农村商业银行", "abbreviationName": "萍乡农商", "code": "PXRCB"}, {
        "value": "萍乡湘东黄海村镇银行",
        "abbreviationName": "萍乡湘东黄海村镇银行",
        "code": "PXXDHHCUNZB"
    }, {"value": "鄱阳恒通村镇银行", "abbreviationName": "鄱阳恒通村镇银行", "code": "PYHTCUNZB"}, {
        "value": "濮阳农村商业银行",
        "abbreviationName": "濮阳农商",
        "code": "PYRCB"
    }, {"value": "濮阳中原村镇银行", "abbreviationName": "濮阳中原村镇银行", "code": "ZYZYCUNZB"}, {
        "value": "浦城中成村镇银行",
        "abbreviationName": "浦城中成村镇银行",
        "code": "PCZCCUNZB"
    }, {"value": "浦发硅谷银行", "abbreviationName": "浦发硅谷", "code": "SPDSV"}, {
        "value": "普安普惠村镇银行",
        "abbreviationName": "普安普惠村镇银行",
        "code": "PAPHCUNZB"
    }, {"value": "普定富民村镇银行", "abbreviationName": "普定富民村镇银行", "code": "PDFMCUNZB"}, {
        "value": "普洱民生村镇银行",
        "abbreviationName": "普洱民生村镇银行",
        "code": "PEMSCUNZB"
    }, {"value": "齐河胶东村镇银行", "abbreviationName": "齐河胶东村镇银行", "code": "QHJDCUNZB"}, {
        "value": "齐鲁银行",
        "abbreviationName": "齐鲁",
        "code": "QLYH"
    }, {"value": "齐齐哈尔农村商业银行", "abbreviationName": "齐齐哈尔农商", "code": "QQHERCB"}, {
        "value": "齐商银行",
        "abbreviationName": "齐商",
        "code": "QSYH"
    }, {"value": "祁东惠丰村镇银行", "abbreviationName": "祁东惠丰村镇银行", "code": "QDHFCUNZB"}, {
        "value": "祁县晋融村镇银行",
        "abbreviationName": "祁县晋融村镇银行",
        "code": "QXJRCUNZB"
    }, {"value": "祁阳村镇银行", "abbreviationName": "祁阳村镇银行", "code": "QYCUNZB"}, {
        "value": "奇台利丰村镇银行",
        "abbreviationName": "奇台利丰村镇银行",
        "code": "QTLFCUNZB"
    }, {"value": "淇县中原村镇银行", "abbreviationName": "淇县中原村镇银行", "code": "ZXZYCUNZB"}, {
        "value": "綦江民生村镇银行",
        "abbreviationName": "綦江民生村镇银行",
        "code": "ZJMSCUNZB"
    }, {"value": "企业银行（中国）有限公司", "abbreviationName": "企业", "code": "IBKK"}, {
        "value": "迁安襄隆村镇银行",
        "abbreviationName": "迁安襄隆村镇银行",
        "code": "QAXLCUNZB"
    }, {"value": "前郭县阳光村镇银行", "abbreviationName": "前郭县阳光村镇银行", "code": "QGXYGCUNZB"}, {
        "value": "乾安惠民村镇银行",
        "abbreviationName": "乾安惠民村镇银行",
        "code": "QAHMCUNZB"
    }, {"value": "黔西花都村镇银行", "abbreviationName": "黔西花都村镇银行", "code": "QXHDCUNZB"}, {
        "value": "黔西南义龙浦发村镇银行",
        "abbreviationName": "黔西南义龙浦发村镇银行",
        "code": "QXNYLPFCUNZB"
    }, {"value": "秦皇岛抚宁家银村镇银行", "abbreviationName": "秦皇岛抚宁家银村镇银行", "code": "QHDFNJYCUNZB"}, {
        "value": "秦皇岛银行",
        "abbreviationName": "秦皇岛",
        "code": "QHDYH"
    }, {"value": "沁源县长青村镇银行", "abbreviationName": "沁源县长青村镇银行", "code": "QYXCQCUNZB"}, {
        "value": "青岛城阳珠江村镇银行",
        "abbreviationName": "青岛城阳珠江村镇银行",
        "code": "QDCYZJCUNZB"
    }, {"value": "青岛黄岛舜丰村镇银行", "abbreviationName": "青岛黄岛舜丰村镇银行", "code": "QDHDSFCUNZB"}, {
        "value": "青岛即墨惠民村镇银行",
        "abbreviationName": "青岛即墨惠民村镇银行",
        "code": "QDJMHMCUNZB"
    }, {"value": "青岛胶州中成村镇银行", "abbreviationName": "青岛胶州中成村镇银行", "code": "QDJZZCCUNZB"}, {
        "value": "青岛莱西元泰村镇银行",
        "abbreviationName": "青岛莱西元泰村镇银行",
        "code": "QDLXYTCUNZB"
    }, {"value": "青岛崂山交银村镇银行", "abbreviationName": "青岛崂山交银村镇银行", "code": "QDZSJYCUNZB"}, {
        "value": "青岛农村商业银行",
        "abbreviationName": "青岛农商",
        "code": "QDRCB"
    }, {"value": "青岛平度惠民村镇银行", "abbreviationName": "青岛平度惠民村镇银行", "code": "QDPDHMCUNZB"}, {
        "value": "青岛西海岸海汇村镇银行",
        "abbreviationName": "青岛西海岸海汇村镇银行",
        "code": "QDXHAHHCUNZB"
    }, {"value": "青岛银行", "abbreviationName": "青岛", "code": "QDYH"}, {
        "value": "青海柴达木农村商业银行",
        "abbreviationName": "青海柴达木农商",
        "code": "QHCDMRCB"
    }, {"value": "青海大通农村商业银行", "abbreviationName": "青海大通农商", "code": "QHDTRCB"}, {
        "value": "青海都兰农村商业银行",
        "abbreviationName": "青海都兰农商",
        "code": "QHDLRCB"
    }, {"value": "青海刚察农村商业银行", "abbreviationName": "青海刚察农商", "code": "QHGCRCB"}, {
        "value": "青海格尔木农村商业银行",
        "abbreviationName": "青海格尔木农商",
        "code": "QHGEMRCB"
    }, {"value": "青海共和农村商业银行", "abbreviationName": "青海共和农商", "code": "QHGHRCB"}, {
        "value": "青海贵德农村商业银行",
        "abbreviationName": "青海贵德农商",
        "code": "QHGDRCB"
    }, {"value": "青海贵南农村商业银行", "abbreviationName": "青海贵南农商", "code": "QHGNRCB"}, {
        "value": "青海果洛农村商业银行",
        "abbreviationName": "青海果洛农商",
        "code": "QHGLRCB"
    }, {"value": "青海海东农村商业银行", "abbreviationName": "青海海东农商", "code": "QHHDPARCB"}, {
        "value": "青海海晏农村商业银行",
        "abbreviationName": "青海海晏农商",
        "code": "QHHYANRCB"
    }, {"value": "青海河南农村商业银行", "abbreviationName": "青海河南农商", "code": "QHHNRCB"}, {
        "value": "青海互助农村商业银行",
        "abbreviationName": "青海互助农商",
        "code": "QHHZRCB"
    }, {"value": "青海化隆农村商业银行", "abbreviationName": "青海化隆农商", "code": "QHHLRCB"}, {
        "value": "青海湟源农村商业银行",
        "abbreviationName": "青海湟源农商",
        "code": "QHHYRCB"
    }, {"value": "青海湟中农村商业银行", "abbreviationName": "青海湟中农商", "code": "QHHZHRCB"}, {
        "value": "青海湟中三江村镇银行",
        "abbreviationName": "青海湟中三江村镇银行",
        "code": "QHZZSJCUNZB"
    }, {"value": "青海尖扎农村商业银行", "abbreviationName": "青海尖扎农商", "code": "QHJZRCB"}, {
        "value": "青海乐都三江村镇银行",
        "abbreviationName": "青海乐都三江村镇银行",
        "code": "QHLDSJCUNZB"
    }, {"value": "青海门源大通村镇银行", "abbreviationName": "青海门源大通村镇银行", "code": "QHMYDTCUNZB"}, {
        "value": "青海门源农村商业银行",
        "abbreviationName": "青海门源农商",
        "code": "QHMYRCB"
    }, {"value": "青海民和农村商业银行", "abbreviationName": "青海民和农商", "code": "QHMHRCB"}, {
        "value": "青海平安大通村镇银行",
        "abbreviationName": "青海平安大通村镇银行",
        "code": "QHPADTCUNZB"
    }, {"value": "青海祁连农村商业银行", "abbreviationName": "青海祁连农商", "code": "QHQLRCB"}, {
        "value": "青海省农村信用社联合社",
        "abbreviationName": "青海农信社",
        "code": "QHNXS"
    }, {"value": "青海天峻农村商业银行", "abbreviationName": "青海天峻农商", "code": "QHTJRCB"}, {
        "value": "青海同德农村商业银行",
        "abbreviationName": "青海同德农商",
        "code": "QHTDRCB"
    }, {"value": "青海同仁农村商业银行", "abbreviationName": "青海同仁农商", "code": "QHTRRCB"}, {
        "value": "青海乌兰农村商业银行",
        "abbreviationName": "青海乌兰农商",
        "code": "QHWLRCB"
    }, {"value": "青海西宁农村商业银行", "abbreviationName": "青海西宁农商", "code": "QHXNRCB"}, {
        "value": "青海兴海农村商业银行",
        "abbreviationName": "青海兴海农商",
        "code": "QHXHRCB"
    }, {"value": "青海循化农村商业银行", "abbreviationName": "青海循化农商", "code": "QHXUNHRCB"}, {
        "value": "青海银行",
        "abbreviationName": "青海",
        "code": "QHYH"
    }, {"value": "青海玉树农村商业银行", "abbreviationName": "青海玉树农商", "code": "QHYSRCB"}, {
        "value": "青海泽库农村商业银行",
        "abbreviationName": "青海泽库农商",
        "code": "QHZJRCB"
    }, {"value": "青龙融兴村镇银行", "abbreviationName": "青龙融兴村镇银行", "code": "QLRXCUNZB"}, {
        "value": "青县青隆村镇银行",
        "abbreviationName": "青县青隆村镇银行",
        "code": "QXQLCUNZB"
    }, {"value": "青原庐陵村镇银行", "abbreviationName": "青原庐陵村镇银行", "code": "QYLLCUNZB"}, {
        "value": "清河金农村镇银行",
        "abbreviationName": "清河金农村镇银行",
        "code": "QHJNCUNZB"
    }, {"value": "清徐惠民村镇银行", "abbreviationName": "清徐惠民村镇银行", "code": "QXHMCUNZB"}, {
        "value": "清徐晋商村镇银行",
        "abbreviationName": "清徐晋商村镇银行",
        "code": "QXJSCUNZB"
    }, {"value": "清远清新惠民村镇银行", "abbreviationName": "清远清新惠民村镇银行", "code": "QYQXHMCUNZB"}, {
        "value": "清镇兴邦村镇银行",
        "abbreviationName": "清镇兴邦村镇银行",
        "code": "QZXBCUNZB"
    }, {"value": "晴隆兴安村镇银行", "abbreviationName": "晴隆兴安村镇银行", "code": "QLXACUNZB"}, {
        "value": "庆城县金城村镇银行",
        "abbreviationName": "庆城县金城村镇银行",
        "code": "QCXJCCUNZB"
    }, {"value": "庆阳农村商业银行", "abbreviationName": "庆阳农商", "code": "QYRCB"}, {
        "value": "庆阳市西峰瑞信村镇银行",
        "abbreviationName": "庆阳市西峰瑞信村镇银行",
        "code": "QYSXFRXCUNZB"
    }, {"value": "庆云乐安村镇银行", "abbreviationName": "庆云乐安村镇银行", "code": "QYLACUNZB"}, {
        "value": "邛崃国民村镇银行",
        "abbreviationName": "邛崃国民村镇银行",
        "code": "ZZGMCUNZB"
    }, {"value": "琼海大众村镇银行", "abbreviationName": "琼海大众村镇银行", "code": "QHDZCUNZB"}, {
        "value": "曲靖富源富滇村镇银行",
        "abbreviationName": "曲靖富源富滇村镇银行",
        "code": "QJFYFDCUNZB"
    }, {"value": "曲靖会泽长江村镇银行", "abbreviationName": "曲靖会泽长江村镇银行", "code": "QJHZCJCUNZB"}, {
        "value": "曲靖惠民村镇银行",
        "abbreviationName": "曲靖惠民村镇银行",
        "code": "QJHMCUNZB"
    }, {"value": "曲靖市商业银行", "abbreviationName": "曲靖", "code": "QJSCCB"}, {
        "value": "曲靖宣威长江村镇银行",
        "abbreviationName": "曲靖宣威长江村镇银行",
        "code": "QJXWCJCUNZB"
    }, {"value": "曲沃县新田村镇银行", "abbreviationName": "曲沃县新田村镇银行", "code": "QWXXTCUNZB"}, {
        "value": "曲阳中成村镇银行",
        "abbreviationName": "曲阳中成村镇银行",
        "code": "QYZCCUNZB"
    }, {"value": "曲周恒升村镇银行", "abbreviationName": "曲周恒升村镇银行", "code": "QZHSCUNZB"}, {
        "value": "泉州农村商业银行",
        "abbreviationName": "泉州农商",
        "code": "QZRCB"
    }, {"value": "泉州银行", "abbreviationName": "泉州", "code": "QZYH"}, {
        "value": "确山郑银村镇银行",
        "abbreviationName": "确山郑银村镇银行",
        "code": "QSZYCUNZB"
    }, {"value": "饶平融和村镇银行", "abbreviationName": "饶平融和村镇银行", "code": "RPRHCUNZB"}, {
        "value": "饶阳民商村镇银行",
        "abbreviationName": "饶阳民商村镇银行",
        "code": "RYMSCUNZB"
    }, {"value": "仁怀蒙银村镇银行", "abbreviationName": "仁怀蒙银村镇银行", "code": "RHMYCUNZB"}, {
        "value": "仁寿民富村镇银行",
        "abbreviationName": "仁寿民富村镇银行",
        "code": "RSMFCUNZB"
    }, {"value": "任丘村镇银行", "abbreviationName": "任丘村镇银行", "code": "RQCUNZB"}, {
        "value": "任县邢农商村镇银行",
        "abbreviationName": "任县邢农商村镇银行",
        "code": "RXXNSCUNZB"
    }, {"value": "日本横滨银行", "abbreviationName": "日本横滨", "code": "RBHBB"}, {
        "value": "日本名古屋银行",
        "abbreviationName": "日本名古屋",
        "code": "MEIGIN"
    }, {"value": "日本山口银行", "abbreviationName": "日本山口", "code": "JAPANYAMAGUCHIBANK"}, {
        "value": "日照东港农村商业银行",
        "abbreviationName": "日照东港农商",
        "code": "RZDGRCB"
    }, {"value": "日照沪农商村镇银行", "abbreviationName": "日照沪农商村镇银行", "code": "RZHNSCUNZB"}, {
        "value": "日照九银村镇银行",
        "abbreviationName": "日照九银村镇银行",
        "code": "RZJYCUNZB"
    }, {"value": "日照岚山农村商业银行", "abbreviationName": "日照岚山农商", "code": "RZLSRCB"}, {
        "value": "日照蓝海村镇银行",
        "abbreviationName": "日照蓝海村镇银行",
        "code": "RZLHCUNZB"
    }, {"value": "日照银行", "abbreviationName": "日照", "code": "RZYH"}, {
        "value": "容城邢农商村镇银行",
        "abbreviationName": "容城邢农商村镇银行",
        "code": "RCXNSCUNZB"
    }, {"value": "汝州玉川村镇银行", "abbreviationName": "汝州玉川村镇银行", "code": "RZYCCUNZB"}, {
        "value": "乳山天骄村镇银行",
        "abbreviationName": "乳山天骄村镇银行",
        "code": "RSTJCUNZB"
    }, {"value": "瑞昌九银村镇银行", "abbreviationName": "瑞昌九银村镇银行", "code": "RCJYCUNZB"}, {
        "value": "瑞典北欧斯安银行有限公司",
        "abbreviationName": "瑞典北欧斯安",
        "code": "RDBOSA"
    }, {"value": "瑞典银行有限公司", "abbreviationName": "瑞典", "code": "RDYHYXGS"}, {
        "value": "瑞丽沪农商村镇银行",
        "abbreviationName": "瑞丽沪农商村镇银行",
        "code": "RLHNSCUNZB"
    }, {"value": "瑞士信贷银行", "abbreviationName": "瑞士信贷", "code": "SWISSCB"}, {
        "value": "瑞士银行有限公司",
        "abbreviationName": "瑞士",
        "code": "UBS"
    }, {"value": "瑞穗实业银行（中国）有限公司", "abbreviationName": "瑞穗", "code": "RSSY"}, {
        "value": "三都富民村镇银行",
        "abbreviationName": "三都富民村镇银行",
        "code": "SDFMCUNZB"
    }, {"value": "三河蒙银村镇银行", "abbreviationName": "三河蒙银村镇银行", "code": "SHMYCUNZB"}, {
        "value": "三井住友银行（中国）有限公司",
        "abbreviationName": "三井住友",
        "code": "SMBC"
    }, {"value": "三菱东京日联银行", "abbreviationName": "三菱东京日联", "code": "TOKYOMITSUBISHIBANK"}, {
        "value": "三门峡湖滨农村商业银行",
        "abbreviationName": "三门峡湖滨农商",
        "code": "SMXHBRCB"
    }, {"value": "三门峡陕州农村商业银行", "abbreviationName": "三门峡陕州农商", "code": "SMXSZRCB"}, {
        "value": "三水珠江村镇银行",
        "abbreviationName": "三水珠江村镇银行",
        "code": "SSZJCUNZB"
    }, {"value": "三亚惠民村镇银行", "abbreviationName": "三亚惠民村镇银行", "code": "SYHMCUNZB"}, {
        "value": "三亚农村商业银行",
        "abbreviationName": "三亚农商",
        "code": "SYRCB"
    }, {"value": "沙河襄通村镇银行", "abbreviationName": "沙河襄通村镇银行", "code": "SHXTCUNZB"}, {
        "value": "厦门国际银行",
        "abbreviationName": "厦门国际",
        "code": "XIB"
    }, {"value": "厦门农村商业银行", "abbreviationName": "厦门农商", "code": "XMRCB"}, {
        "value": "厦门同安农银村镇银行",
        "abbreviationName": "厦门同安农银村镇银行",
        "code": "XMTANYCUNZB"
    }, {"value": "厦门翔安民生村镇银行", "abbreviationName": "厦门翔安民生村镇银行", "code": "XMXAMSCUNZB"}, {
        "value": "厦门银行",
        "abbreviationName": "厦门",
        "code": "XMYH"
    }, {"value": "山东安丘农村商业银行", "abbreviationName": "山东安丘农商", "code": "SDAQRCB"}, {
        "value": "山东博兴农村商业银行",
        "abbreviationName": "山东博兴农商",
        "code": "SDBXRCB"
    }, {"value": "山东博兴新华村镇银行", "abbreviationName": "山东博兴新华村镇银行", "code": "SDBXXHCUNZB"}, {
        "value": "山东曹县农村商业银行",
        "abbreviationName": "山东曹县农商",
        "code": "SDCXRCB"
    }, {"value": "山东昌乐农村商业银行", "abbreviationName": "山东昌乐农商", "code": "SDCLRCB"}, {
        "value": "山东昌邑农村商业银行",
        "abbreviationName": "山东昌邑农商",
        "code": "SDCYRCB"
    }, {"value": "山东成武汉源村镇银行", "abbreviationName": "山东成武汉源村镇银行", "code": "SDCWHYCUNZB"}, {
        "value": "山东成武农村商业银行",
        "abbreviationName": "山东成武农商",
        "code": "SDCWRCB"
    }, {"value": "山东茌平农村商业银行", "abbreviationName": "山东茌平农商", "code": "SDCPRCB"}, {
        "value": "山东单县农村商业银行",
        "abbreviationName": "山东单县农商",
        "code": "SDDXRCB"
    }, {"value": "山东定陶农村商业银行", "abbreviationName": "山东定陶农商", "code": "SDDTRCB"}, {
        "value": "山东东阿农村商业银行",
        "abbreviationName": "山东东阿农商",
        "code": "SDDARCB"
    }, {"value": "山东东明农村商业银行", "abbreviationName": "山东东明农商", "code": "SDDMRCB"}, {
        "value": "山东东平农村商业银行",
        "abbreviationName": "山东东平农商",
        "code": "SDDPRCB"
    }, {"value": "山东肥城民丰村镇银行", "abbreviationName": "山东肥城民丰村镇银行", "code": "SDFCMFCUNZB"}, {
        "value": "山东肥城农村商业银行",
        "abbreviationName": "山东肥城农商",
        "code": "SDFCRCB"
    }, {"value": "山东费县农村商业银行", "abbreviationName": "山东费县农商", "code": "SDFXRCB"}, {
        "value": "山东高密农村商业银行",
        "abbreviationName": "山东高密农商",
        "code": "SDGMRCB"
    }, {"value": "山东高青汇金村镇银行", "abbreviationName": "山东高青汇金村镇银行", "code": "SDGQHJCUNZB"}, {
        "value": "山东高青农村商业银行",
        "abbreviationName": "山东高青农商",
        "code": "SDGQRCB"
    }, {"value": "山东高唐农村商业银行", "abbreviationName": "山东高唐农商", "code": "SDGTRCB"}, {
        "value": "山东冠县齐丰村镇银行",
        "abbreviationName": "山东冠县齐丰村镇银行",
        "code": "SDGXQFCUNZB"
    }, {"value": "山东广饶农村商业银行", "abbreviationName": "山东广饶农商", "code": "SDGRRCB"}, {
        "value": "山东海阳农村商业银行",
        "abbreviationName": "山东海阳农商",
        "code": "SDHYRCB"
    }, {"value": "山东桓台农村商业银行", "abbreviationName": "山东桓台农商", "code": "SDHTRCB"}, {
        "value": "山东惠民农村商业银行",
        "abbreviationName": "山东惠民农商",
        "code": "SDHMRCB"
    }, {"value": "山东惠民舜丰村镇银行", "abbreviationName": "山东惠民舜丰村镇银行", "code": "SDHMSFCUNZB"}, {
        "value": "山东济宁兖州农村商业银行",
        "abbreviationName": "山东济宁兖州农商",
        "code": "SDJNYZRCB"
    }, {"value": "山东济阳农村商业银行", "abbreviationName": "山东济阳农商", "code": "SDJIYRCB"}, {
        "value": "山东嘉祥农村商业银行",
        "abbreviationName": "山东嘉祥农商",
        "code": "SDJIAXRCB"
    }, {"value": "山东金乡蓝海村镇银行", "abbreviationName": "山东金乡蓝海村镇银行", "code": "SDJXLHCUNZB"}, {
        "value": "山东金乡农村商业银行",
        "abbreviationName": "山东金乡农商",
        "code": "SDJXRCB"
    }, {"value": "山东莒南村镇银行", "abbreviationName": "山东莒南村镇银行", "code": "SDJNCUNZB"}, {
        "value": "山东莒南农村商业银行",
        "abbreviationName": "山东莒南农商",
        "code": "SDJNRCB"
    }, {"value": "山东莒县农村商业银行", "abbreviationName": "山东莒县农商", "code": "SDJUXRCB"}, {
        "value": "山东巨野农村商业银行",
        "abbreviationName": "山东巨野农商",
        "code": "SDJYRCB"
    }, {"value": "山东鄄城农村商业银行", "abbreviationName": "山东鄄城农商", "code": "SDYCRCB"}, {
        "value": "山东垦利农村商业银行",
        "abbreviationName": "山东垦利农商",
        "code": "SDKLRCB"
    }, {"value": "山东莱山齐丰村镇银行", "abbreviationName": "山东莱山齐丰村镇银行", "code": "SDLSQFCUNZB"}, {
        "value": "山东莱芜农村商业银行",
        "abbreviationName": "山东莱芜农商",
        "code": "SDLWRCB"
    }, {"value": "山东莱阳农村商业银行", "abbreviationName": "山东莱阳农商", "code": "SDLYRCB"}, {
        "value": "山东莱州农村商业银行",
        "abbreviationName": "山东莱州农商",
        "code": "SDLAIZRCB"
    }, {"value": "山东兰陵村镇银行", "abbreviationName": "山东兰陵村镇银行", "code": "SDLLCUNZB"}, {
        "value": "山东兰陵农村商业银行",
        "abbreviationName": "山东兰陵农商",
        "code": "SDLLRCB"
    }, {"value": "山东乐陵农村商业银行", "abbreviationName": "山东乐陵农商", "code": "SDLELRCB"}, {
        "value": "山东历城圆融村镇银行",
        "abbreviationName": "山东历城圆融村镇银行",
        "code": "SDLCYRCUNZB"
    }, {"value": "山东利津农村商业银行", "abbreviationName": "山东利津农商", "code": "SDLJRCB"}, {
        "value": "山东利津舜丰村镇银行",
        "abbreviationName": "山东利津舜丰村镇银行",
        "code": "SDLJSFCUNZB"
    }, {"value": "山东梁山民丰村镇银行", "abbreviationName": "山东梁山民丰村镇银行", "code": "SDLSMFCUNZB"}, {
        "value": "山东梁山农村商业银行",
        "abbreviationName": "山东梁山农商",
        "code": "SDLSRCB"
    }, {"value": "山东聊城润昌农村商业银行", "abbreviationName": "山东聊城润昌农商", "code": "SDLCRCRCB"}, {
        "value": "山东临清农村商业银行",
        "abbreviationName": "山东临清农商",
        "code": "SDLQRCB"
    }, {"value": "山东临朐聚丰村镇银行", "abbreviationName": "山东临朐聚丰村镇银行", "code": "SDLQJFCUNZB"}, {
        "value": "山东临朐农村商业银行",
        "abbreviationName": "山东临朐农商",
        "code": "SDLQURCB"
    }, {"value": "山东临沭农村商业银行", "abbreviationName": "山东临沭农商", "code": "SDLINSRCB"}, {
        "value": "山东临沂河东农村商业银行",
        "abbreviationName": "山东临沂河东农商",
        "code": "SDLYHDRCB"
    }, {"value": "山东临沂兰山农村商业银行", "abbreviationName": "山东临沂兰山农商", "code": "SDLYLSRCB"}, {
        "value": "山东临沂罗庄农村商业银行",
        "abbreviationName": "山东临沂罗庄农商",
        "code": "SDLYLZRCB"
    }, {"value": "山东临邑农村商业银行", "abbreviationName": "山东临邑农商", "code": "SDLYIRCB"}, {
        "value": "山东临淄汇金村镇银行",
        "abbreviationName": "山东临淄汇金村镇银行",
        "code": "SDLZHJCUNZB"
    }, {"value": "山东临淄农村商业银行", "abbreviationName": "山东临淄农商", "code": "SDLZRCB"}, {
        "value": "山东龙口农村商业银行",
        "abbreviationName": "山东龙口农商",
        "code": "SDLKRCB"
    }, {"value": "山东蒙阴农村商业银行", "abbreviationName": "山东蒙阴农商", "code": "SDMYRCB"}, {
        "value": "山东蒙阴齐丰村镇银行",
        "abbreviationName": "山东蒙阴齐丰村镇银行",
        "code": "SDMYQFCUNZB"
    }, {"value": "山东宁津农村商业银行", "abbreviationName": "山东宁津农商", "code": "SDNJRCB"}, {
        "value": "山东宁阳农村商业银行",
        "abbreviationName": "山东宁阳农商",
        "code": "SDNYRCB"
    }, {"value": "山东蓬莱农村商业银行", "abbreviationName": "山东蓬莱农商", "code": "SDPLRCB"}, {
        "value": "山东平邑汉源村镇银行",
        "abbreviationName": "山东平邑汉源村镇银行",
        "code": "SDPYHYCUNZB"
    }, {"value": "山东平邑农村商业银行", "abbreviationName": "山东平邑农商", "code": "SDPYIRCB"}, {
        "value": "山东平阴农村商业银行",
        "abbreviationName": "山东平阴农商",
        "code": "SDPYINRCB"
    }, {"value": "山东平原农村商业银行", "abbreviationName": "山东平原农商", "code": "SDPYRCB"}, {
        "value": "山东栖霞农村商业银行",
        "abbreviationName": "山东栖霞农商",
        "code": "SDQXRCB"
    }, {"value": "山东齐河农村商业银行", "abbreviationName": "山东齐河农商", "code": "SDQHRCB"}, {
        "value": "山东青州农村商业银行",
        "abbreviationName": "山东青州农商",
        "code": "SDQZRCB"
    }, {"value": "山东庆云农村商业银行", "abbreviationName": "山东庆云农商", "code": "SDQYRCB"}, {
        "value": "山东曲阜农村商业银行",
        "abbreviationName": "山东曲阜农商",
        "code": "SDQFRCB"
    }, {"value": "山东荣成汇丰村镇银行", "abbreviationName": "山东荣成汇丰村镇银行", "code": "SDRCHFCUNZB"}, {
        "value": "山东荣成农村商业银行",
        "abbreviationName": "山东荣成农商",
        "code": "SDRCRCB"
    }, {"value": "山东乳山农村商业银行", "abbreviationName": "山东乳山农商", "code": "SDRSRCB"}, {
        "value": "山东商河汇金村镇银行",
        "abbreviationName": "山东商河汇金村镇银行",
        "code": "SDSHHJCUNZB"
    }, {"value": "山东商河农村商业银行", "abbreviationName": "山东商河农商", "code": "SDSHRCB"}, {
        "value": "山东莘县农村商业银行",
        "abbreviationName": "山东莘县农商",
        "code": "SDSXRCB"
    }, {"value": "山东省农村信用社联合社", "abbreviationName": "山东农信社", "code": "SDNXS"}, {
        "value": "山东寿光农村商业银行",
        "abbreviationName": "山东寿光农商",
        "code": "SDSGRCB"
    }, {"value": "山东泗水农村商业银行", "abbreviationName": "山东泗水农商", "code": "SDSSRCB"}, {
        "value": "山东泗水齐丰村镇银行",
        "abbreviationName": "山东泗水齐丰村镇银行",
        "code": "SDSSQFCUNZB"
    }, {"value": "山东郯城汉源村镇银行", "abbreviationName": "山东郯城汉源村镇银行", "code": "SDZCHYCUNZB"}, {
        "value": "山东郯城农村商业银行",
        "abbreviationName": "山东郯城农商",
        "code": "SDTCRCB"
    }, {"value": "山东滕州农村商业银行", "abbreviationName": "山东滕州农商", "code": "SDTZRCB"}, {
        "value": "山东威海农村商业银行",
        "abbreviationName": "山东威海农商",
        "code": "SDWHRCB"
    }, {"value": "山东微山农村商业银行", "abbreviationName": "山东微山农商", "code": "SDWEISRCB"}, {
        "value": "山东文登农村商业银行",
        "abbreviationName": "山东文登农商",
        "code": "SDWDRCB"
    }, {"value": "山东汶上农村商业银行", "abbreviationName": "山东汶上农商", "code": "SDWSRCB"}, {
        "value": "山东无棣农村商业银行",
        "abbreviationName": "山东无棣农商",
        "code": "SDWLIRCB"
    }, {"value": "山东五莲农村商业银行", "abbreviationName": "山东五莲农商", "code": "SDWLRCB"}, {
        "value": "山东武城农村商业银行",
        "abbreviationName": "山东武城农商",
        "code": "SDWCRCB"
    }, {"value": "山东夏津农村商业银行", "abbreviationName": "山东夏津农商", "code": "SDXJRCB"}, {
        "value": "山东新泰农村商业银行",
        "abbreviationName": "山东新泰农商",
        "code": "SDXTRCB"
    }, {"value": "山东新泰齐丰村镇银行", "abbreviationName": "山东新泰齐丰村镇银行", "code": "SDXTQFCUNZB"}, {
        "value": "山东阳谷农村商业银行",
        "abbreviationName": "山东阳谷农商",
        "code": "SDYGRCB"
    }, {"value": "山东阳信农村商业银行", "abbreviationName": "山东阳信农商", "code": "SDYXRCB"}, {
        "value": "山东沂南蓝海村镇银行",
        "abbreviationName": "山东沂南蓝海村镇银行",
        "code": "SDYNLHCUNZB"
    }, {"value": "山东沂南农村商业银行", "abbreviationName": "山东沂南农商", "code": "SDYNRCB"}, {
        "value": "山东沂水农村商业银行",
        "abbreviationName": "山东沂水农商",
        "code": "SDYSRCB"
    }, {"value": "山东沂源农村商业银行", "abbreviationName": "山东沂源农商", "code": "SDYYRCB"}, {
        "value": "山东鱼台农村商业银行",
        "abbreviationName": "山东鱼台农商",
        "code": "SDYTRCB"
    }, {"value": "山东禹城农村商业银行", "abbreviationName": "山东禹城农商", "code": "SDYUCRCB"}, {
        "value": "山东郓城农村商业银行",
        "abbreviationName": "山东郓城农商",
        "code": "SDYUNCRCB"
    }, {"value": "山东沾化青云村镇银行", "abbreviationName": "山东沾化青云村镇银行", "code": "SDZHQYCUNZB"}, {
        "value": "山东张店农村商业银行",
        "abbreviationName": "山东张店农商",
        "code": "SDZDRCB"
    }, {"value": "山东章丘农村商业银行", "abbreviationName": "山东章丘农商", "code": "SDZQRCB"}, {
        "value": "山东长岛农村商业银行",
        "abbreviationName": "山东长岛农商",
        "code": "SDCDRCB"
    }, {"value": "山东招远农村商业银行", "abbreviationName": "山东招远农商", "code": "SDZYRCB"}, {
        "value": "山东芝罘齐丰村镇银行",
        "abbreviationName": "山东芝罘齐丰村镇银行",
        "code": "SDZZQFCUNZB"
    }, {"value": "山东周村农村商业银行", "abbreviationName": "山东周村农商", "code": "SDZCRCB"}, {
        "value": "山东周村青隆村镇银行",
        "abbreviationName": "山东周村青隆村镇银行",
        "code": "SDZCQLCUNZB"
    }, {"value": "山东诸城农村商业银行", "abbreviationName": "山东诸城农商", "code": "SDZHUCRCB"}, {
        "value": "山东邹城农村商业银行",
        "abbreviationName": "山东邹城农商",
        "code": "SDZOUCRCB"
    }, {"value": "山东邹平农村商业银行", "abbreviationName": "山东邹平农商", "code": "SDZPRCB"}, {
        "value": "山东邹平青隆村镇银行",
        "abbreviationName": "山东邹平青隆村镇银行",
        "code": "SDZPQLCUNZB"
    }, {"value": "山西安泽农村商业银行", "abbreviationName": "山西安泽农商", "code": "SXAZRCB"}, {
        "value": "山西保德农村商业银行",
        "abbreviationName": "山西保德农商",
        "code": "SXBDRCB"
    }, {"value": "山西大宁农村商业银行", "abbreviationName": "山西大宁农商", "code": "SXDNRCB"}, {
        "value": "山西定襄农村商业银行",
        "abbreviationName": "山西定襄农商",
        "code": "SXDXRCB"
    }, {"value": "山西繁峙农村商业银行", "abbreviationName": "山西繁峙农商", "code": "SXFZRCB"}, {
        "value": "山西汾阳农村商业银行",
        "abbreviationName": "山西汾阳农商",
        "code": "SXFYRCB"
    }, {"value": "山西浮山农村商业银行", "abbreviationName": "山西浮山农商", "code": "SXFSRCB"}, {
        "value": "山西高平农村商业银行",
        "abbreviationName": "山西高平农商",
        "code": "SXGPRCB"
    }, {"value": "山西古交农村商业银行", "abbreviationName": "山西古交农商", "code": "SXGJRCB"}, {
        "value": "山西古县农村商业银行",
        "abbreviationName": "山西古县农商",
        "code": "SXGXRCB"
    }, {"value": "山西和顺农村商业银行", "abbreviationName": "山西和顺农商", "code": "SXHESRCB"}, {
        "value": "山西河津农村商业银行",
        "abbreviationName": "山西河津农商",
        "code": "SXHJRCB"
    }, {"value": "山西河曲农村商业银行", "abbreviationName": "山西河曲农商", "code": "SXHQRCB"}, {
        "value": "山西洪洞农村商业银行",
        "abbreviationName": "山西洪洞农商",
        "code": "SXHDRCB"
    }, {"value": "山西侯马农村商业银行", "abbreviationName": "山西侯马农商", "code": "SXHMRCB"}, {
        "value": "山西壶关农村商业银行",
        "abbreviationName": "山西壶关农商",
        "code": "SXHGRCB"
    }, {"value": "山西怀仁农村商业银行", "abbreviationName": "山西怀仁农商", "code": "SXHRRCB"}, {
        "value": "山西浑源农村商业银行",
        "abbreviationName": "山西浑源农商",
        "code": "SHXHYRCB"
    }, {"value": "山西霍州农村商业银行", "abbreviationName": "山西霍州农商", "code": "SXHZRCB"}, {
        "value": "山西吉县农村商业银行",
        "abbreviationName": "山西吉县农商",
        "code": "SXJIXRCB"
    }, {"value": "山西稷山农村商业银行", "abbreviationName": "山西稷山农商", "code": "SXSSRCB"}, {
        "value": "山西绛县农村商业银行",
        "abbreviationName": "山西绛县农商",
        "code": "SXJXRCB"
    }, {"value": "山西交城农村商业银行", "abbreviationName": "山西交城农商", "code": "SXJCRCB"}, {
        "value": "山西介休农村商业银行",
        "abbreviationName": "山西介休农商",
        "code": "SXJIEXRCB"
    }, {"value": "山西静乐农村商业银行", "abbreviationName": "山西静乐农商", "code": "SXJLRCB"}, {
        "value": "山西岢岚农村商业银行",
        "abbreviationName": "山西岢岚农商",
        "code": "SXKLRCB"
    }, {"value": "山西岚县农村商业银行", "abbreviationName": "山西岚县农商", "code": "SXLANXRCB"}, {
        "value": "山西黎城农村商业银行",
        "abbreviationName": "山西黎城农商",
        "code": "SXLICRCB"
    }, {"value": "山西临猗农村商业银行", "abbreviationName": "山西临猗农商", "code": "SXLYRCB"}, {
        "value": "山西灵丘农村商业银行",
        "abbreviationName": "山西灵丘农商",
        "code": "SXLQRCB"
    }, {"value": "山西灵石农村商业银行", "abbreviationName": "山西灵石农商", "code": "SXLSRCB"}, {
        "value": "山西柳林农村商业银行",
        "abbreviationName": "山西柳林农商",
        "code": "SXLLRCB"
    }, {"value": "山西潞城农村商业银行", "abbreviationName": "山西潞城农商", "code": "SXLCRCB"}, {
        "value": "山西吕梁农村商业银行",
        "abbreviationName": "山西吕梁农商",
        "code": "SXLVLRCB"
    }, {"value": "山西宁武农村商业银行", "abbreviationName": "山西宁武农商", "code": "SXNWRCB"}, {
        "value": "山西偏关农村商业银行",
        "abbreviationName": "山西偏关农商",
        "code": "SXPGRCB"
    }, {"value": "山西平定农村商业银行", "abbreviationName": "山西平定农商", "code": "SXPDRCB"}, {
        "value": "山西平陆农村商业银行",
        "abbreviationName": "山西平陆农商",
        "code": "SXPLRCB"
    }, {"value": "山西平顺农村商业银行", "abbreviationName": "山西平顺农商", "code": "SXPSRCB"}, {
        "value": "山西平遥农村商业银行",
        "abbreviationName": "山西平遥农商",
        "code": "SXPYRCB"
    }, {"value": "山西蒲县农村商业银行", "abbreviationName": "山西蒲县农商", "code": "SXPXRCB"}, {
        "value": "山西祁县农村商业银行",
        "abbreviationName": "山西祁县农商",
        "code": "SXQIXRCB"
    }, {"value": "山西沁水农村商业银行", "abbreviationName": "山西沁水农商", "code": "SXQSRCB"}, {
        "value": "山西沁县农村商业银行",
        "abbreviationName": "山西沁县农商",
        "code": "SXQINXRCB"
    }, {"value": "山西沁源农村商业银行", "abbreviationName": "山西沁源农商", "code": "SXQINYRCB"}, {
        "value": "山西清徐农村商业银行",
        "abbreviationName": "山西清徐农商",
        "code": "SXQXRCB"
    }, {"value": "山西曲沃农村商业银行", "abbreviationName": "山西曲沃农商", "code": "SXQWRCB"}, {
        "value": "山西芮城农村商业银行",
        "abbreviationName": "山西芮城农商",
        "code": "SXRCRCB"
    }, {"value": "山西山阴农村商业银行", "abbreviationName": "山西山阴农商", "code": "SXSYIRCB"}, {
        "value": "山西神池农村商业银行",
        "abbreviationName": "山西神池农商",
        "code": "SXSCRCB"
    }, {"value": "山西省农村信用社联合社", "abbreviationName": "山西农信社", "code": "SHXNXS"}, {
        "value": "山西寿阳农村商业银行",
        "abbreviationName": "山西寿阳农商",
        "code": "SXSYRCB"
    }, {"value": "山西太谷农村商业银行", "abbreviationName": "山西太谷农商", "code": "SXTGRCB"}, {
        "value": "山西屯留农村商业银行",
        "abbreviationName": "山西屯留农商",
        "code": "SXTLRCB"
    }, {"value": "山西万荣农村商业银行", "abbreviationName": "山西万荣农商", "code": "SXWRRCB"}, {
        "value": "山西闻喜农村商业银行",
        "abbreviationName": "山西闻喜农商",
        "code": "SXWXRCB"
    }, {"value": "山西五台农村商业银行", "abbreviationName": "山西五台农商", "code": "SXWTRCB"}, {
        "value": "山西五寨农村商业银行",
        "abbreviationName": "山西五寨农商",
        "code": "SXWZRCB"
    }, {"value": "山西武乡农村商业银行", "abbreviationName": "山西武乡农商", "code": "SXWUXRCB"}, {
        "value": "山西昔阳农村商业银行",
        "abbreviationName": "山西昔阳农商",
        "code": "SXXIYRCB"
    }, {"value": "山西隰县农村商业银行", "abbreviationName": "山西隰县农商", "code": "SXXIXRCB"}, {
        "value": "山西夏县农村商业银行",
        "abbreviationName": "山西夏县农商",
        "code": "SXXXRCB"
    }, {"value": "山西乡宁农村商业银行", "abbreviationName": "山西乡宁农商", "code": "SXXNRCB"}, {
        "value": "山西襄汾农村商业银行",
        "abbreviationName": "山西襄汾农商",
        "code": "SXXFRCB"
    }, {"value": "山西襄垣农村商业银行", "abbreviationName": "山西襄垣农商", "code": "SXXYRCB"}, {
        "value": "山西孝义农村商业银行",
        "abbreviationName": "山西孝义农商",
        "code": "SXXYIRCB"
    }, {"value": "山西忻州农村商业银行", "abbreviationName": "山西忻州农商", "code": "SXXZRCB"}, {
        "value": "山西新绛农村商业银行",
        "abbreviationName": "山西新绛农商",
        "code": "SXXJRCB"
    }, {"value": "山西兴县农村商业银行", "abbreviationName": "山西兴县农商", "code": "SXXINGXRCB"}, {
        "value": "山西阳城农村商业银行",
        "abbreviationName": "山西阳城农商",
        "code": "SXYCRCB"
    }, {"value": "山西阳曲农村商业银行", "abbreviationName": "山西阳曲农商", "code": "SXYQRCB"}, {
        "value": "山西尧都农村商业银行",
        "abbreviationName": "山西尧都农商",
        "code": "SXYDRCB"
    }, {"value": "山西应县农村商业银行", "abbreviationName": "山西应县农商", "code": "SXYIXRCB"}, {
        "value": "山西永和农村商业银行",
        "abbreviationName": "山西永和农商",
        "code": "SXYHRCB"
    }, {"value": "山西永济农村商业银行", "abbreviationName": "山西永济农商", "code": "SXYJRCB"}, {
        "value": "山西右玉农村商业银行",
        "abbreviationName": "山西右玉农商",
        "code": "SXYYRCB"
    }, {"value": "山西盂县农村商业银行", "abbreviationName": "山西盂县农商", "code": "SXYXRCB"}, {
        "value": "山西榆次农村商业银行",
        "abbreviationName": "山西榆次农商",
        "code": "SXYUCRCB"
    }, {"value": "山西榆社农村商业银行", "abbreviationName": "山西榆社农商", "code": "SXYSRCB"}, {
        "value": "山西垣曲农村商业银行",
        "abbreviationName": "山西垣曲农商",
        "code": "SXYQURCB"
    }, {"value": "山西原平农村商业银行", "abbreviationName": "山西原平农商", "code": "SXYPRCB"}, {
        "value": "山西云州农村商业银行",
        "abbreviationName": "山西云州农商",
        "code": "SXYZRCB"
    }, {"value": "山西运城农村商业银行", "abbreviationName": "山西运城农商", "code": "SXYUNCRCB"}, {
        "value": "山西泽州农村商业银行",
        "abbreviationName": "山西泽州农商",
        "code": "SXZZRCB"
    }, {"value": "山西长治黎都农村商业银行", "abbreviationName": "山西长治黎都农商", "code": "SXCZLDRCB"}, {
        "value": "山西长子农村商业银行",
        "abbreviationName": "山西长子农商",
        "code": "SXCZRCB"
    }, {"value": "山西左权农村商业银行", "abbreviationName": "山西左权农商", "code": "SXZQRCB"}, {
        "value": "山西左云农村商业银行",
        "abbreviationName": "山西左云农商",
        "code": "SXZUOYRCB"
    }, {"value": "山阴县太行村镇银行", "abbreviationName": "山阴县太行村镇银行", "code": "SYXTXCUNZB"}, {
        "value": "陕西安塞农村商业银行",
        "abbreviationName": "陕西安塞农商",
        "code": "SXASRCB"
    }, {"value": "陕西白河农村商业银行", "abbreviationName": "陕西白河农商", "code": "SXBHRCB"}, {
        "value": "陕西宝鸡金台农村商业银行",
        "abbreviationName": "陕西宝鸡金台农商",
        "code": "SXBJJTRCB"
    }, {"value": "陕西宝鸡渭滨农村商业银行", "abbreviationName": "陕西宝鸡渭滨农商", "code": "SXBJWBRCB"}, {
        "value": "陕西彬县农村商业银行",
        "abbreviationName": "陕西彬县农商",
        "code": "SXBXRCB"
    }, {"value": "陕西彬州农村商业银行", "abbreviationName": "陕西彬州农商", "code": "SXBZRCB"}, {
        "value": "陕西丹凤农村商业银行",
        "abbreviationName": "陕西丹凤农商",
        "code": "SXDFRCB"
    }, {"value": "陕西定边农村商业银行", "abbreviationName": "陕西定边农商", "code": "SXDBRCB"}, {
        "value": "陕西凤县农村商业银行",
        "abbreviationName": "陕西凤县农商",
        "code": "SXFXRCB"
    }, {"value": "陕西凤翔农村商业银行", "abbreviationName": "陕西凤翔农商", "code": "SXFXIANGRCB"}, {
        "value": "陕西佛坪农村商业银行",
        "abbreviationName": "陕西佛坪农商",
        "code": "SXFPRCB"
    }, {"value": "陕西府谷农村商业银行", "abbreviationName": "陕西府谷农商", "code": "SXFGRCB"}, {
        "value": "陕西富平汇发村镇银行",
        "abbreviationName": "陕西富平汇发村镇银行",
        "code": "SXFPHFCUNZB"
    }, {"value": "陕西富县农村合作银行", "abbreviationName": "陕西富县农村合作银行", "code": "SXFXRCU"}, {
        "value": "陕西甘泉农村商业银行",
        "abbreviationName": "陕西甘泉农商",
        "code": "SXGQRCB"
    }, {"value": "陕西韩城农村商业银行", "abbreviationName": "陕西韩城农商", "code": "SXHCRCB"}, {
        "value": "陕西汉阴农村商业银行",
        "abbreviationName": "陕西汉阴农商",
        "code": "SXHYRCB"
    }, {"value": "陕西汉中南郑汇发村镇银行", "abbreviationName": "陕西汉中南郑汇发村镇银行", "code": "SXHZNZHFCUNZB"}, {
        "value": "陕西户县海丝村镇银行",
        "abbreviationName": "陕西户县海丝村镇银行",
        "code": "SXHXHSCUNZB"
    }, {"value": "陕西佳县农村商业银行", "abbreviationName": "陕西佳县农商", "code": "SXIJXRCB"}, {
        "value": "陕西泾阳泰隆村镇银行",
        "abbreviationName": "陕西泾阳泰隆村镇银行",
        "code": "SXJYTLCUNZB"
    }, {"value": "陕西靖边农村商业银行", "abbreviationName": "陕西靖边农商", "code": "SXJBRCB"}, {
        "value": "陕西岚皋农村商业银行",
        "abbreviationName": "陕西岚皋农商",
        "code": "SXLGRCB"
    }, {"value": "陕西蓝田农村商业银行", "abbreviationName": "陕西蓝田农商", "code": "SXLTRCB"}, {
        "value": "陕西临潼海丝村镇银行",
        "abbreviationName": "陕西临潼海丝村镇银行",
        "code": "SXLZHSCUNZB"
    }, {"value": "陕西麟游农村商业银行", "abbreviationName": "陕西麟游农商", "code": "SXILYRCB"}, {
        "value": "陕西陇县农村商业银行",
        "abbreviationName": "陕西陇县农商",
        "code": "SXLXRCB"
    }, {"value": "陕西陇县长银村镇银行", "abbreviationName": "陕西陇县长银村镇银行", "code": "SXLXCYCUNZB"}, {
        "value": "陕西洛川农村商业银行",
        "abbreviationName": "陕西洛川农商",
        "code": "SXILCRCB"
    }, {"value": "陕西洛南阳光村镇银行", "abbreviationName": "陕西洛南阳光村镇银行", "code": "SXLNYGCUNZB"}, {
        "value": "陕西眉县农村商业银行",
        "abbreviationName": "陕西眉县农商",
        "code": "SXMXRCB"
    }, {"value": "陕西眉县泰隆村镇银行", "abbreviationName": "陕西眉县泰隆村镇银行", "code": "SXMXTLCUNZB"}, {
        "value": "陕西米脂农村商业银行",
        "abbreviationName": "陕西米脂农商",
        "code": "SXMZRCB"
    }, {"value": "陕西南郑农村商业银行", "abbreviationName": "陕西南郑农商", "code": "SXNZRCB"}, {
        "value": "陕西宁陕农村商业银行",
        "abbreviationName": "陕西宁陕农商",
        "code": "SXNSRCB"
    }, {"value": "陕西平利农村商业银行", "abbreviationName": "陕西平利农商", "code": "SXIPLRCB"}, {
        "value": "陕西岐山农村商业银行",
        "abbreviationName": "陕西岐山农商",
        "code": "SXQISRCB"
    }, {"value": "陕西岐山长银村镇银行", "abbreviationName": "陕西岐山长银村镇银行", "code": "SXQSCYCUNZB"}, {
        "value": "陕西千阳农村商业银行",
        "abbreviationName": "陕西千阳农商",
        "code": "SXQYRCB"
    }, {"value": "陕西秦农农村商业银行", "abbreviationName": "陕西秦农农商", "code": "SXQNRCB"}, {
        "value": "陕西清涧农村商业银行",
        "abbreviationName": "陕西清涧农商",
        "code": "SXQJRCB"
    }, {"value": "陕西三原海丝村镇银行", "abbreviationName": "陕西三原海丝村镇银行", "code": "SXSYHSCUNZB"}, {
        "value": "陕西山阳农村商业银行",
        "abbreviationName": "陕西山阳农商",
        "code": "SXISYRCB"
    }, {"value": "陕西商南聚利村镇银行", "abbreviationName": "陕西商南聚利村镇银行", "code": "SXSNJLCUNZB"}, {
        "value": "陕西商南农村商业银行",
        "abbreviationName": "陕西商南农商",
        "code": "SXSNRCB"
    }, {"value": "陕西神木农村商业银行", "abbreviationName": "陕西神木农商", "code": "SXSMRCB"}, {
        "value": "陕西省农村信用社联合社",
        "abbreviationName": "陕西农信社",
        "code": "SXNXS"
    }, {"value": "陕西石泉农村商业银行", "abbreviationName": "陕西石泉农商", "code": "SXSQRCB"}, {
        "value": "陕西绥德农村商业银行",
        "abbreviationName": "陕西绥德农商",
        "code": "SXSDRCB"
    }, {"value": "陕西太白农村商业银行", "abbreviationName": "陕西太白农商", "code": "SXTBRCB"}, {
        "value": "陕西太白长银村镇银行",
        "abbreviationName": "陕西太白长银村镇银行",
        "code": "SXTBCYCUNZB"
    }, {"value": "陕西吴堡农村商业银行", "abbreviationName": "陕西吴堡农商", "code": "SXWBRCB"}, {
        "value": "陕西吴起汇发村镇银行",
        "abbreviationName": "陕西吴起汇发村镇银行",
        "code": "SXWQHFCUNZB"
    }, {"value": "陕西吴起农村合作银行", "abbreviationName": "陕西吴起农村合作银行", "code": "SXWQRCU"}, {
        "value": "陕西西乡农村商业银行",
        "abbreviationName": "陕西西乡农商",
        "code": "SXIXXRCB"
    }, {"value": "陕西咸阳秦都农村商业银行", "abbreviationName": "陕西咸阳秦都农商", "code": "SXXYQDRCB"}, {
        "value": "陕西咸阳渭城汇发村镇银行",
        "abbreviationName": "陕西咸阳渭城汇发村镇银行",
        "code": "SXXYWCHFCUNZB"
    }, {"value": "陕西咸阳渭城农村商业银行", "abbreviationName": "陕西咸阳渭城农商", "code": "SXXYWCRCB"}, {
        "value": "陕西旬阳农村商业银行",
        "abbreviationName": "陕西旬阳农商",
        "code": "SXIXYRCB"
    }, {"value": "陕西旬阳泰隆村镇银行", "abbreviationName": "陕西旬阳泰隆村镇银行", "code": "SXXYTLCUNZB"}, {
        "value": "陕西杨凌农村商业银行",
        "abbreviationName": "陕西杨凌农商",
        "code": "SXYLRCB"
    }, {"value": "陕西榆林横山汇发村镇银行", "abbreviationName": "陕西榆林横山汇发村镇银行", "code": "SXYLHSHFCUNZB"}, {
        "value": "陕西榆林农村商业银行",
        "abbreviationName": "陕西榆林农商",
        "code": "SXYLYYRCB"
    }, {"value": "陕西柞水聚利村镇银行", "abbreviationName": "陕西柞水聚利村镇银行", "code": "SXZSJLCUNZB"}, {
        "value": "陕西柞水农村商业银行",
        "abbreviationName": "陕西柞水农商",
        "code": "SXZSRCB"
    }, {"value": "陕西长武农村商业银行", "abbreviationName": "陕西长武农商", "code": "SXCWRCB"}, {
        "value": "陕西镇安农村商业银行",
        "abbreviationName": "陕西镇安农商",
        "code": "SXZARCB"
    }, {"value": "陕西镇巴农村商业银行", "abbreviationName": "陕西镇巴农商", "code": "SXZBRCB"}, {
        "value": "陕西镇坪农村商业银行",
        "abbreviationName": "陕西镇坪农商",
        "code": "SXZPRCB"
    }, {"value": "陕西周至农村商业银行", "abbreviationName": "陕西周至农商", "code": "SXZZHRCB"}, {
        "value": "陕西周至农科村镇银行",
        "abbreviationName": "陕西周至农科村镇银行",
        "code": "SXZZNKCUNZB"
    }, {"value": "陕西子长农村商业银行", "abbreviationName": "陕西子长农商", "code": "SXZCRCB"}, {
        "value": "陕西子洲农村商业银行",
        "abbreviationName": "陕西子洲农商",
        "code": "SXIZZRCB"
    }, {"value": "陕西紫阳农村商业银行", "abbreviationName": "陕西紫阳农商", "code": "SXZYRCB"}, {
        "value": "汕头潮阳融和村镇银行",
        "abbreviationName": "汕头潮阳融和村镇银行",
        "code": "STCYRHCUNZB"
    }, {"value": "汕头海湾农村商业银行", "abbreviationName": "汕头海湾农商", "code": "STHWRCB"}, {
        "value": "汕头龙湖长江村镇银行",
        "abbreviationName": "汕头龙湖长江村镇银行",
        "code": "STLHCJCUNZB"
    }, {"value": "汕尾农村商业银行", "abbreviationName": "汕尾农商", "code": "SWRCB"}, {
        "value": "鄯善中成村镇银行",
        "abbreviationName": "鄯善中成村镇银行",
        "code": "ZSZCCUNZB"
    }, {"value": "商丘华商农村商业银行", "abbreviationName": "商丘华商农商", "code": "SQHSRCB"}, {
        "value": "上蔡惠民村镇银行",
        "abbreviationName": "上蔡惠民村镇银行",
        "code": "SCAIHMCUNZB"
    }, {"value": "上海宝山富民村镇银行", "abbreviationName": "上海宝山富民村镇银行", "code": "SHBSFMCUNZB"}, {
        "value": "上海宝山扬子村镇银行",
        "abbreviationName": "上海宝山扬子村镇银行",
        "code": "SHBSYZCUNZB"
    }, {"value": "上海崇明沪农商村镇银行", "abbreviationName": "上海崇明沪农商村镇银行", "code": "SHCMHNSCUNZB"}, {
        "value": "上海奉贤浦发村镇银行",
        "abbreviationName": "上海奉贤浦发村镇银行",
        "code": "SHFXPFCUNZB"
    }, {"value": "上海华瑞银行股份有限公司", "abbreviationName": "上海华瑞", "code": "SHRB"}, {
        "value": "上海嘉定洪都村镇银行",
        "abbreviationName": "上海嘉定洪都村镇银行",
        "code": "SHJDHDCUNZB"
    }, {"value": "上海嘉定民生村镇银行", "abbreviationName": "上海嘉定民生村镇银行", "code": "SHJDMSCUNZB"}, {
        "value": "上海金山惠民村镇银行",
        "abbreviationName": "上海金山惠民村镇银行",
        "code": "SHJSHMCUNZB"
    }, {"value": "上海闵行上银村镇银行", "abbreviationName": "上海闵行上银村镇银行", "code": "SHZXSYCUNZB"}, {
        "value": "上海农村商业银行",
        "abbreviationName": "上海农商",
        "code": "SHRCB"
    }, {"value": "上海浦东发展银行", "abbreviationName": "浦发", "code": "SPDB"}, {
        "value": "上海浦东恒通村镇银行",
        "abbreviationName": "上海浦东恒通村镇银行",
        "code": "SHPDHTCUNZB"
    }, {"value": "上海浦东江南村镇银行", "abbreviationName": "上海浦东江南村镇银行", "code": "SHPDJNCUNZB"}, {
        "value": "上海青浦惠金村镇银行",
        "abbreviationName": "上海青浦惠金村镇银行",
        "code": "SHQPHJCUNZB"
    }, {"value": "上海商业银行", "abbreviationName": "上海商业", "code": "SHCB"}, {
        "value": "上海松江富明村镇银行",
        "abbreviationName": "上海松江富明村镇银行",
        "code": "SHSJFMCUNZB"
    }, {"value": "上海松江民生村镇银行", "abbreviationName": "上海松江民生村镇银行", "code": "SHSJMSCUNZB"}, {
        "value": "上海银行",
        "abbreviationName": "上海",
        "code": "SHYH"
    }, {"value": "上杭中成村镇银行", "abbreviationName": "上杭中成村镇银行", "code": "SHZCCUNZB"}, {
        "value": "上饶农村商业银行",
        "abbreviationName": "上饶农商",
        "code": "SRRCB"
    }, {"value": "上饶银行", "abbreviationName": "上饶", "code": "SRB"}, {
        "value": "尚志惠鑫村镇银行",
        "abbreviationName": "尚志惠鑫村镇银行",
        "code": "SZHXCUNZB"
    }, {"value": "韶山光大村镇银行", "abbreviationName": "韶山光大村镇银行", "code": "SSGDCUNZB"}, {
        "value": "邵武刺桐红村镇银行",
        "abbreviationName": "邵武刺桐红村镇银行",
        "code": "SWCTHCUNZB"
    }, {"value": "邵阳农村商业银行", "abbreviationName": "邵阳农商", "code": "HNSYRCB"}, {
        "value": "绍兴银行",
        "abbreviationName": "绍兴",
        "code": "SXYH"
    }, {"value": "涉县齐鲁村镇银行", "abbreviationName": "涉县齐鲁村镇银行", "code": "SXQLCUNZB"}, {
        "value": "莘县青隆村镇银行",
        "abbreviationName": "莘县青隆村镇银行",
        "code": "ZXQLCUNZB"
    }, {"value": "深泽利丰村镇银行", "abbreviationName": "深泽利丰村镇银行", "code": "SZLFCUNZB"}, {
        "value": "深圳宝安桂银村镇银行",
        "abbreviationName": "深圳宝安桂银村镇银行",
        "code": "SZBAGYCUNZB"
    }, {"value": "深圳宝安融兴村镇银行", "abbreviationName": "深圳宝安融兴村镇银行", "code": "SZBARXCUNZB"}, {
        "value": "深圳福田银座村镇银行",
        "abbreviationName": "深圳福田银座村镇银行",
        "code": "FTYZCUNZB"
    }, {"value": "深圳光明沪农商村镇银行", "abbreviationName": "深圳光明沪农商村镇银行", "code": "SZGMHNSCUNZB"}, {
        "value": "深圳龙岗鼎业村镇银行",
        "abbreviationName": "深圳龙岗鼎业村镇银行",
        "code": "SZLGDYCUNZB"
    }, {"value": "深圳龙华新华村镇银行", "abbreviationName": "深圳龙华新华村镇银行", "code": "SZLHXHCUNZB"}, {
        "value": "深圳罗湖蓝海村镇银行",
        "abbreviationName": "深圳罗湖蓝海村镇银行",
        "code": "SZLHLHCUNZB"
    }, {"value": "深圳南山宝生村镇银行", "abbreviationName": "深圳南山宝生村镇银行", "code": "SZNSBSCUNZB"}, {
        "value": "深圳农村商业银行",
        "abbreviationName": "深圳农商",
        "code": "SZRCB"
    }, {"value": "深圳坪山珠江村镇银行", "abbreviationName": "深圳坪山珠江村镇银行", "code": "SZPSZJCUNZB"}, {
        "value": "深圳前海微众银行",
        "abbreviationName": "微众",
        "code": "WEBANK"
    }, {"value": "深州丰源村镇银行", "abbreviationName": "深州丰源村镇银行", "code": "SZFYCUNZB"}, {
        "value": "什邡思源村镇银行",
        "abbreviationName": "什邡思源村镇银行",
        "code": "SZSYCUNZB"
    }, {"value": "神池县河东村镇银行", "abbreviationName": "神池县河东村镇银行", "code": "SCXHDCUNZB"}, {
        "value": "神农架楚农商村镇银行",
        "abbreviationName": "神农架楚农商村镇银行",
        "code": "SNJCNSCUNZB"
    }, {"value": "沈阳法库富民村镇银行", "abbreviationName": "沈阳法库富民村镇银行", "code": "SYFKFMCUNZB"}, {
        "value": "沈阳康平抚银村镇银行",
        "abbreviationName": "沈阳康平抚银村镇银行",
        "code": "SYKPFYCUNZB"
    }, {"value": "沈阳辽中富民村镇银行", "abbreviationName": "沈阳辽中富民村镇银行", "code": "SYLZFMCUNZB"}, {
        "value": "沈阳农村商业银行",
        "abbreviationName": "沈阳农商",
        "code": "SHENYRCB"
    }, {"value": "沈阳沈北富民村镇银行", "abbreviationName": "沈阳沈北富民村镇银行", "code": "SYSBFMCUNZB"}, {
        "value": "沈阳新民富民村镇银行",
        "abbreviationName": "沈阳新民富民村镇银行",
        "code": "SYXMFMCUNZB"
    }, {"value": "沈阳于洪永安村镇银行", "abbreviationName": "沈阳于洪永安村镇银行", "code": "SYYHYACUNZB"}, {
        "value": "盛京银行",
        "abbreviationName": "盛京",
        "code": "SJYH"
    }, {"value": "施秉金鼎村镇银行", "abbreviationName": "施秉金鼎村镇银行", "code": "SBJDCUNZB"}, {
        "value": "石河子国民村镇银行",
        "abbreviationName": "石河子国民村镇银行",
        "code": "SHZGMCUNZB"
    }, {"value": "石家庄汇融农村合作银行", "abbreviationName": "石家庄汇融农村合作银行", "code": "SJZHRRCU"}, {
        "value": "石家庄鹿泉农村商业银行",
        "abbreviationName": "石家庄鹿泉农商",
        "code": "SJZLQRCB"
    }, {"value": "石家庄栾城齐鲁村镇银行", "abbreviationName": "石家庄栾城齐鲁村镇银行", "code": "SJZLCQLCUNZB"}, {
        "value": "石家庄新华恒升村镇银行",
        "abbreviationName": "石家庄新华恒升村镇银行",
        "code": "SJZXHHSCUNZB"
    }, {"value": "石门沪农商村镇银行", "abbreviationName": "石门沪农商村镇银行", "code": "SMHNSCUNZB"}, {
        "value": "石阡长征村镇银行",
        "abbreviationName": "石阡长征村镇银行",
        "code": "SQCZCUNZB"
    }, {"value": "石首楚农商村镇银行", "abbreviationName": "石首楚农商村镇银行", "code": "SSCNSCUNZB"}, {
        "value": "石嘴山市大武口石银村镇银行",
        "abbreviationName": "石嘴山市大武口石银村镇银行",
        "code": "SZSSDWKSYCUNZB"
    }, {"value": "石嘴山银行", "abbreviationName": "石嘴山", "code": "SZSYH"}, {
        "value": "始兴大众村镇银行",
        "abbreviationName": "始兴大众村镇银行",
        "code": "SXDZCUNZB"
    }, {"value": "寿光张农商村镇银行", "abbreviationName": "寿光张农商村镇银行", "code": "SGZNSCUNZB"}, {
        "value": "寿宁刺桐红村镇银行",
        "abbreviationName": "寿宁刺桐红村镇银行",
        "code": "SNCTHCUNZB"
    }, {"value": "寿阳县汇都村镇银行", "abbreviationName": "寿阳县汇都村镇银行", "code": "SYXHDCUNZB"}, {
        "value": "舒兰吉银村镇银行",
        "abbreviationName": "舒兰吉银村镇银行",
        "code": "SHULJYCUNZB"
    }, {"value": "双城惠民村镇银行", "abbreviationName": "双城惠民村镇银行", "code": "SCHMCUNZB"}, {
        "value": "双峰沪农商村镇银行",
        "abbreviationName": "双峰沪农商村镇银行",
        "code": "SFHNSCUNZB"
    }, {"value": "双辽吉银村镇银行", "abbreviationName": "双辽吉银村镇银行", "code": "SLJYCUNZB"}, {
        "value": "水城蒙银村镇银行",
        "abbreviationName": "水城蒙银村镇银行",
        "code": "SCMYCUNZB"
    }, {"value": "顺德农村商业银行", "abbreviationName": "顺德农商", "code": "SDRCB"}, {
        "value": "朔州农村商业银行",
        "abbreviationName": "朔州农商",
        "code": "SXSZRCB"
    }, {"value": "朔州市朔城区蒙银村镇银行", "abbreviationName": "朔州市朔城区蒙银村镇银行", "code": "SZSSCQMYCUNZB"}, {
        "value": "思南长征村镇银行",
        "abbreviationName": "思南长征村镇银行",
        "code": "SNCZCUNZB"
    }, {"value": "四川安岳农村商业银行", "abbreviationName": "四川安岳农商", "code": "SCAYRCB"}, {
        "value": "四川安州农村商业银行",
        "abbreviationName": "四川安州农商",
        "code": "SCAZRCB"
    }, {"value": "四川北川羌族自治县富民村镇银行", "abbreviationName": "四川北川羌族自治县富民村镇银行", "code": "SCBCQZZZXFMCUNZB"}, {
        "value": "四川苍溪农村商业银行",
        "abbreviationName": "四川苍溪农商",
        "code": "SCCXRCB"
    }, {"value": "四川成都龙泉驿稠州村镇银行", "abbreviationName": "四川成都龙泉驿稠州村镇银行", "code": "SCCDLQZCZCUNZB"}, {
        "value": "四川成都蒲江民富村镇银行",
        "abbreviationName": "四川成都蒲江民富村镇银行",
        "code": "SCCDPJMFCUNZB"
    }, {"value": "四川大英农村商业银行", "abbreviationName": "四川大英农商", "code": "SCDYRCB"}, {
        "value": "四川大竹农村商业银行",
        "abbreviationName": "四川大竹农商",
        "code": "SCDZRCB"
    }, {"value": "四川大竹渝农商村镇银行", "abbreviationName": "四川大竹渝农商村镇银行", "code": "SCDZYNSCUNZB"}, {
        "value": "四川丹棱农村商业银行",
        "abbreviationName": "四川丹棱农商",
        "code": "SCDLRCB"
    }, {"value": "四川峨眉山农村商业银行", "abbreviationName": "四川峨眉山农商", "code": "SCEMSRCB"}, {
        "value": "四川富顺农村商业银行",
        "abbreviationName": "四川富顺农商",
        "code": "SCFSRCB"
    }, {"value": "四川高县农村商业银行", "abbreviationName": "四川高县农商", "code": "SCGAOXRCB"}, {
        "value": "四川珙县农村商业银行",
        "abbreviationName": "四川珙县农商",
        "code": "SCGXRCB"
    }, {"value": "四川古蔺农村商业银行", "abbreviationName": "四川古蔺农商", "code": "SCGLRCB"}, {
        "value": "四川广汉农村商业银行",
        "abbreviationName": "四川广汉农商",
        "code": "SCGHRCB"
    }, {"value": "四川广元农村商业银行", "abbreviationName": "四川广元农商", "code": "SCGYRCB"}, {
        "value": "四川合江农村商业银行",
        "abbreviationName": "四川合江农商",
        "code": "SCHJRCB"
    }, {"value": "四川华蓥农村商业银行", "abbreviationName": "四川华蓥农商", "code": "SCHYRCB"}, {
        "value": "四川犍为农村商业银行",
        "abbreviationName": "四川犍为农商",
        "code": "SCJWRCB"
    }, {"value": "四川简阳农村商业银行", "abbreviationName": "四川简阳农商", "code": "SCJYRCB"}, {
        "value": "四川剑阁农村商业银行",
        "abbreviationName": "四川剑阁农商",
        "code": "SCJGRCB"
    }, {"value": "四川江安农村商业银行", "abbreviationName": "四川江安农商", "code": "SCJARCB"}, {
        "value": "四川江油华夏村镇银行",
        "abbreviationName": "四川江油华夏村镇银行",
        "code": "SCJYHXCUNZB"
    }, {"value": "四川江油农村商业银行", "abbreviationName": "四川江油农商", "code": "SCJYORCB"}, {
        "value": "四川阆中农村商业银行",
        "abbreviationName": "四川阆中农商",
        "code": "SCLZRCB"
    }, {"value": "四川乐至农村商业银行", "abbreviationName": "四川乐至农商", "code": "SCLEZRCB"}, {
        "value": "四川邻水农村商业银行",
        "abbreviationName": "四川邻水农商",
        "code": "SCLSRCB"
    }, {"value": "四川隆昌农村商业银行", "abbreviationName": "四川隆昌农商", "code": "SCCLRCB"}, {
        "value": "四川泸县农村商业银行",
        "abbreviationName": "四川泸县农商",
        "code": "SCLXRCB"
    }, {"value": "四川罗江农村商业银行", "abbreviationName": "四川罗江农商", "code": "SCLJRCB"}, {
        "value": "四川绵竹农村商业银行",
        "abbreviationName": "四川绵竹农商",
        "code": "SCMZRCB"
    }, {"value": "四川名山锦程村镇银行", "abbreviationName": "四川名山锦程村镇银行", "code": "SCMSJCCUNZB"}, {
        "value": "四川南部农村商业银行",
        "abbreviationName": "四川南部农商",
        "code": "SCNBRCB"
    }, {"value": "四川内江农村商业银行", "abbreviationName": "四川内江农商", "code": "SCNJRCB"}, {
        "value": "四川蓬安农村商业银行",
        "abbreviationName": "四川蓬安农商",
        "code": "SCPARCB"
    }, {"value": "四川蓬溪农村商业银行", "abbreviationName": "四川蓬溪农商", "code": "SCPXRCB"}, {
        "value": "四川平武农村商业银行",
        "abbreviationName": "四川平武农商",
        "code": "SCPWRCB"
    }, {"value": "四川屏山农村商业银行", "abbreviationName": "四川屏山农商", "code": "SCPSRCB"}, {
        "value": "四川青川农村商业银行",
        "abbreviationName": "四川青川农商",
        "code": "SCQCRCB"
    }, {"value": "四川青神农村商业银行", "abbreviationName": "四川青神农商", "code": "SCQSRCB"}, {
        "value": "四川渠县农村商业银行",
        "abbreviationName": "四川渠县农商",
        "code": "SCQXRCB"
    }, {"value": "四川仁寿农村商业银行", "abbreviationName": "四川仁寿农商", "code": "SCRSRCB"}, {
        "value": "四川三台农村商业银行",
        "abbreviationName": "四川三台农商",
        "code": "SCSTRCB"
    }, {"value": "四川射洪农村商业银行", "abbreviationName": "四川射洪农商", "code": "SCSHRCB"}, {
        "value": "四川什邡农村商业银行",
        "abbreviationName": "四川什邡农商",
        "code": "SCSFRCB"
    }, {"value": "四川省农村信用社联合社", "abbreviationName": "四川农信社", "code": "SCNXS"}, {
        "value": "四川石棉农村商业银行",
        "abbreviationName": "四川石棉农商",
        "code": "SCSMRCB"
    }, {"value": "四川天府银行", "abbreviationName": "四川天府", "code": "CGNB"}, {
        "value": "四川天全农村商业银行",
        "abbreviationName": "四川天全农商",
        "code": "SCTQRCB"
    }, {"value": "四川万源农村商业银行", "abbreviationName": "四川万源农商", "code": "SCWANYRCB"}, {
        "value": "四川旺苍农村商业银行",
        "abbreviationName": "四川旺苍农商",
        "code": "SCWCRCB"
    }, {"value": "四川威远农村商业银行", "abbreviationName": "四川威远农商", "code": "SCWYRCB"}, {
        "value": "四川武胜农村商业银行",
        "abbreviationName": "四川武胜农商",
        "code": "SCWSRCB"
    }, {"value": "四川西充农村商业银行", "abbreviationName": "四川西充农商", "code": "SCXCRCB"}, {
        "value": "四川新网银行",
        "abbreviationName": "新网",
        "code": "XWB"
    }, {"value": "四川兴文石海农村商业银行", "abbreviationName": "四川兴文石海农商", "code": "SCXWSHRCB"}, {
        "value": "四川叙永农村商业银行",
        "abbreviationName": "四川叙永农商",
        "code": "SCXYRCB"
    }, {"value": "四川宣汉农村商业银行", "abbreviationName": "四川宣汉农商", "code": "SCXHRCB"}, {
        "value": "四川仪陇惠民村镇银行",
        "abbreviationName": "四川仪陇惠民村镇银行",
        "code": "SCYLHMCUNZB"
    }, {"value": "四川仪陇农村商业银行", "abbreviationName": "四川仪陇农商", "code": "SCYLRCB"}, {
        "value": "四川宜宾金江农村商业银行",
        "abbreviationName": "四川宜宾金江农商",
        "code": "SCYBJJRCB"
    }, {"value": "四川银行", "abbreviationName": "四川", "code": "SCBANK"}, {
        "value": "四川营山农村商业银行",
        "abbreviationName": "四川营山农商",
        "code": "SCYSRCB"
    }, {"value": "四川岳池农村商业银行", "abbreviationName": "四川岳池农商", "code": "SCYCRCB"}, {
        "value": "四川筠连农村商业银行",
        "abbreviationName": "四川筠连农商",
        "code": "SCJLRCB"
    }, {"value": "四川长宁竹海农村商业银行", "abbreviationName": "四川长宁竹海农商", "code": "SCCNZHRCB"}, {
        "value": "四川中江农村商业银行",
        "abbreviationName": "四川中江农商",
        "code": "SCZJRCB"
    }, {"value": "四川梓潼农村商业银行", "abbreviationName": "四川梓潼农商", "code": "SCZTRCB"}, {
        "value": "四平辽河蛟银村镇银行",
        "abbreviationName": "四平辽河蛟银村镇银行",
        "code": "SPLHZYCUNZB"
    }, {"value": "四平铁东德丰村镇银行", "abbreviationName": "四平铁东德丰村镇银行", "code": "SPTDDFCUNZB"}, {
        "value": "四平铁西敦银村镇银行",
        "abbreviationName": "四平铁西敦银村镇银行",
        "code": "SPTXDYCUNZB"
    }, {"value": "四子王蒙银村镇银行", "abbreviationName": "四子王蒙银村镇银行", "code": "SZWMYCUNZB"}, {
        "value": "松桃长征村镇银行",
        "abbreviationName": "松桃长征村镇银行",
        "code": "STCZCUNZB"
    }, {"value": "松原宁江惠民村镇银行", "abbreviationName": "松原宁江惠民村镇银行", "code": "SYNJHMCUNZB"}, {
        "value": "嵩明沪农商村镇银行",
        "abbreviationName": "嵩明沪农商村镇银行",
        "code": "ZMHNSCUNZB"
    }, {"value": "苏州农村商业银行", "abbreviationName": "苏州农商", "code": "SUZRCB"}, {
        "value": "苏州吴中珠江村镇银行",
        "abbreviationName": "苏州吴中珠江村镇银行",
        "code": "SZWZZJCUNZB"
    }, {"value": "苏州银行", "abbreviationName": "苏州", "code": "SZYH"}, {
        "value": "睢县德商村镇银行",
        "abbreviationName": "睢县德商村镇银行",
        "code": "ZXDSCUNZB"
    }, {"value": "绥阳黔北村镇银行", "abbreviationName": "绥阳黔北村镇银行", "code": "SYQBCUNZB"}, {
        "value": "绥中长丰村镇银行",
        "abbreviationName": "绥中长丰村镇银行",
        "code": "SZCFCUNZB"
    }, {"value": "随县楚农商村镇银行", "abbreviationName": "随县楚农商村镇银行", "code": "SXCNSCUNZB"}, {
        "value": "遂川洪都村镇银行",
        "abbreviationName": "遂川洪都村镇银行",
        "code": "SCHDCUNZB"
    }, {"value": "遂宁安居融兴村镇银行", "abbreviationName": "遂宁安居融兴村镇银行", "code": "SNAJRXCUNZB"}, {
        "value": "遂宁农村商业银行",
        "abbreviationName": "遂宁农商",
        "code": "SNRCB"
    }, {"value": "遂宁市商业银行", "abbreviationName": "遂宁", "code": "SNSCCB"}, {
        "value": "遂平中原村镇银行",
        "abbreviationName": "遂平中原村镇银行",
        "code": "SPZYCUNZB"
    }, {"value": "塔城津汇村镇银行", "abbreviationName": "塔城津汇村镇银行", "code": "TCJHCUNZB"}, {
        "value": "塔城昆仑村镇银行",
        "abbreviationName": "塔城昆仑村镇银行",
        "code": "TCKLCUNZB"
    }, {"value": "台江富民村镇银行", "abbreviationName": "台江富民村镇银行", "code": "TJFMCUNZB"}, {
        "value": "台前德商村镇银行",
        "abbreviationName": "台前德商村镇银行",
        "code": "TQDSCUNZB"
    }, {"value": "台湾土地银行", "abbreviationName": "台湾土地", "code": "TWTDB"}, {
        "value": "台湾银行",
        "abbreviationName": "台湾",
        "code": "TWYH"
    }, {"value": "台湾中小企业银行", "abbreviationName": "台湾中小企业", "code": "TWZXQYB"}, {
        "value": "台州银行",
        "abbreviationName": "台州",
        "code": "TZYH"
    }, {"value": "太仓民生村镇银行", "abbreviationName": "太仓民生村镇银行", "code": "TAICMSCUNZB"}, {
        "value": "太仓农村商业银行",
        "abbreviationName": "太仓农商",
        "code": "TCRCB"
    }, {"value": "太谷县兴泰村镇银行", "abbreviationName": "太谷县兴泰村镇银行", "code": "TGXXTCUNZB"}, {
        "value": "太仆寺旗鑫源村镇银行",
        "abbreviationName": "太仆寺旗鑫源村镇银行",
        "code": "TPSQZYCUNZB"
    }, {"value": "太原农村商业银行", "abbreviationName": "太原农商", "code": "TYRCB"}, {
        "value": "太原市尖草坪区信都村镇银行",
        "abbreviationName": "太原市尖草坪区信都村镇银行",
        "code": "TYSJCPQXDCUNZB"
    }, {"value": "泰安岱岳农村商业银行", "abbreviationName": "泰安岱岳农商", "code": "TADYRCB"}, {
        "value": "泰安沪农商村镇银行",
        "abbreviationName": "泰安沪农商村镇银行",
        "code": "TAHNSCUNZB"
    }, {"value": "泰安泰山农村商业银行", "abbreviationName": "泰安泰山农商", "code": "TATSRCB"}, {
        "value": "泰安银行",
        "abbreviationName": "泰安",
        "code": "TACCB"
    }, {"value": "泰国汇商银行", "abbreviationName": "泰国汇商", "code": "SIAMCB"}, {
        "value": "泰国泰京银行",
        "abbreviationName": "泰国泰京",
        "code": "TGTJB"
    }, {"value": "泰州姜堰锡州村镇银行", "abbreviationName": "泰州姜堰锡州村镇银行", "code": "TZJYXZCUNZB"}, {
        "value": "唐山市丰南舜丰村镇银行",
        "abbreviationName": "唐山市丰南舜丰村镇银行",
        "code": "TSSFNSFCUNZB"
    }, {"value": "唐山市开平汇金村镇银行", "abbreviationName": "唐山市开平汇金村镇银行", "code": "TSSKPHJCUNZB"}, {
        "value": "唐山银行",
        "abbreviationName": "唐山",
        "code": "TSYH"
    }, {"value": "唐县汇泽村镇银行", "abbreviationName": "唐县汇泽村镇银行", "code": "TXHZCUNZB"}, {
        "value": "洮南惠民村镇银行",
        "abbreviationName": "洮南惠民村镇银行",
        "code": "ZNHMCUNZB"
    }, {"value": "腾冲民生村镇银行", "abbreviationName": "腾冲民生村镇银行", "code": "TENGCMSCUNZB"}, {
        "value": "天津宝坻浦发村镇银行",
        "abbreviationName": "天津宝坻浦发村镇银行",
        "code": "TJBZPFCUNZB"
    }, {"value": "天津滨海德商村镇银行", "abbreviationName": "天津滨海德商村镇银行", "code": "TJBHDSCUNZB"}, {
        "value": "天津滨海惠民村镇银行",
        "abbreviationName": "天津滨海惠民村镇银行",
        "code": "TJBHHMCUNZB"
    }, {"value": "天津滨海江淮村镇银行", "abbreviationName": "天津滨海江淮村镇银行", "code": "TJBJJHCUNZB"}, {
        "value": "天津滨海农村商业银行",
        "abbreviationName": "天津滨海农商",
        "code": "TJBHB"
    }, {"value": "天津滨海扬子村镇银行", "abbreviationName": "天津滨海扬子村镇银行", "code": "TJBHYZCUNZB"}, {
        "value": "天津华明村镇银行",
        "abbreviationName": "天津华明村镇银行",
        "code": "TJHMCUNZB"
    }, {"value": "天津金城银行", "abbreviationName": "天津金城", "code": "TJJCB"}, {
        "value": "天津津南村镇银行",
        "abbreviationName": "天津津南村镇银行",
        "code": "TJJNCUNZB"
    }, {"value": "天津静海新华村镇银行", "abbreviationName": "天津静海新华村镇银行", "code": "TJJHXHCUNZB"}, {
        "value": "天津宁河村镇银行",
        "abbreviationName": "天津宁河村镇银行",
        "code": "TJNHCUNZB"
    }, {"value": "天津农村商业银行", "abbreviationName": "天津农商", "code": "TJRCB"}, {
        "value": "天津市北辰村镇银行",
        "abbreviationName": "天津市北辰村镇银行",
        "code": "TJSBCCUNZB"
    }, {"value": "天津市蓟州村镇银行", "abbreviationName": "天津市蓟州村镇银行", "code": "TJSJZCUNZB"}, {
        "value": "天津武清村镇银行",
        "abbreviationName": "天津武清村镇银行",
        "code": "TJWQCUNZB"
    }, {"value": "天津银行", "abbreviationName": "天津", "code": "TJYH"}, {
        "value": "天水麦积农村合作银行",
        "abbreviationName": "天水麦积农村合作银行",
        "code": "TSMJRCU"
    }, {"value": "天水麦积融兴村镇银行", "abbreviationName": "天水麦积融兴村镇银行", "code": "TSMJRXCUNZB"}, {
        "value": "天水秦州农村合作银行",
        "abbreviationName": "天水秦州农村合作银行",
        "code": "TSQZRCU"
    }, {"value": "天水秦州长银村镇银行", "abbreviationName": "天水秦州长银村镇银行", "code": "TSQZCYCUNZB"}, {
        "value": "天水市秦安众信村镇银行",
        "abbreviationName": "天水市秦安众信村镇银行",
        "code": "TSSQAZXCUNZB"
    }, {"value": "天长民生村镇银行", "abbreviationName": "天长民生村镇银行", "code": "TCMSCUNZB"}, {
        "value": "天镇县河东村镇银行",
        "abbreviationName": "天镇县河东村镇银行",
        "code": "TZXHDCUNZB"
    }, {"value": "田东北部湾村镇银行", "abbreviationName": "田东北部湾村镇银行", "code": "TDBBWCUNZB"}, {
        "value": "田阳兴阳村镇银行",
        "abbreviationName": "田阳兴阳村镇银行",
        "code": "TYXYCUNZB"
    }, {"value": "铁岭农商村镇银行", "abbreviationName": "铁岭农商村镇银行", "code": "TLNSCUNZB"}, {
        "value": "铁岭新星村镇银行",
        "abbreviationName": "铁岭新星村镇银行",
        "code": "TLXXCUNZB"
    }, {"value": "铁岭银行", "abbreviationName": "铁岭", "code": "TLYH"}, {
        "value": "铁门关津汇村镇银行",
        "abbreviationName": "铁门关津汇村镇银行",
        "code": "TMGJHCUNZB"
    }, {"value": "通城惠民村镇银行", "abbreviationName": "通城惠民村镇银行", "code": "TCHMCUNZB"}, {
        "value": "通化东昌榆银村镇银行",
        "abbreviationName": "通化东昌榆银村镇银行",
        "code": "THDCYYCUNZB"
    }, {"value": "通化二道江瑞丰村镇银行", "abbreviationName": "通化二道江瑞丰村镇银行", "code": "THEDJRFCUNZB"}, {
        "value": "通化农村商业银行股份有限公司",
        "abbreviationName": "通化农商",
        "code": "THRCB"
    }, {"value": "通化融达村镇银行", "abbreviationName": "通化融达村镇银行", "code": "THRDCUNZB"}, {
        "value": "通辽金谷村镇银行",
        "abbreviationName": "通辽金谷村镇银行",
        "code": "TLJGCUNZB"
    }, {"value": "通辽奈曼农村合作银行", "abbreviationName": "通辽奈曼农村合作银行", "code": "TLNMRCU"}, {
        "value": "通山楚农商村镇银行",
        "abbreviationName": "通山楚农商村镇银行",
        "code": "TSCNSCUNZB"
    }, {"value": "通许融信村镇银行", "abbreviationName": "通许融信村镇银行", "code": "TXRXCUNZB"}, {
        "value": "通榆农商村镇银行",
        "abbreviationName": "通榆农商村镇银行",
        "code": "TYNSCUNZB"
    }, {"value": "同江汇鑫村镇银行", "abbreviationName": "同江汇鑫村镇银行", "code": "TJHXCUNZB"}, {
        "value": "铜川耀州新华村镇银行",
        "abbreviationName": "铜川耀州新华村镇银行",
        "code": "TCYZXHCUNZB"
    }, {"value": "铜川印台恒通村镇银行", "abbreviationName": "铜川印台恒通村镇银行", "code": "TCYTHTCUNZB"}, {
        "value": "铜鼓九银村镇银行",
        "abbreviationName": "铜鼓九银村镇银行",
        "code": "TGJYCUNZB"
    }, {"value": "铜陵农村商业银行", "abbreviationName": "铜陵农商", "code": "TLRCB"}, {
        "value": "铜陵皖江农村商业银行",
        "abbreviationName": "铜陵皖江农商",
        "code": "TLWJRCB"
    }, {"value": "铜仁丰源村镇银行", "abbreviationName": "铜仁丰源村镇银行", "code": "TRFYCUNZB"}, {
        "value": "铜仁农村商业银行",
        "abbreviationName": "铜仁农商",
        "code": "TRRCB"
    }, {"value": "铜仁万山长征村镇银行", "abbreviationName": "铜仁万山长征村镇银行", "code": "TRWSCZCUNZB"}, {
        "value": "潼南民生村镇银行",
        "abbreviationName": "潼南民生村镇银行",
        "code": "ZNMSCUNZB"
    }, {"value": "突泉蒙银村镇银行", "abbreviationName": "突泉蒙银村镇银行", "code": "TQMYCUNZB"}, {
        "value": "图们敦银村镇银行",
        "abbreviationName": "图们敦银村镇银行",
        "code": "TMDYCUNZB"
    }, {"value": "土默特右旗蒙银村镇银行", "abbreviationName": "土默特右旗蒙银村镇银行", "code": "TMTYQMYCUNZB"}, {
        "value": "土默特左旗金谷村镇银行",
        "abbreviationName": "土默特左旗金谷村镇银行",
        "code": "TMTZQJGCUNZB"
    }, {"value": "团风楚农商村镇银行", "abbreviationName": "团风楚农商村镇银行", "code": "TFCNSCUNZB"}, {
        "value": "屯留县三禾村镇银行",
        "abbreviationName": "屯留县三禾村镇银行",
        "code": "TLXSHCUNZB"
    }, {"value": "瓦房店长兴村镇银行", "abbreviationName": "瓦房店长兴村镇银行", "code": "WFDCXCUNZB"}, {
        "value": "万安洪都村镇银行",
        "abbreviationName": "万安洪都村镇银行",
        "code": "WAHDCUNZB"
    }, {"value": "万年稻源村镇银行", "abbreviationName": "万年稻源村镇银行", "code": "WNHHCUNZB"}, {
        "value": "万宁金谷村镇银行",
        "abbreviationName": "万宁金谷村镇银行",
        "code": "WNGMCUNZB"
    }, {"value": "万荣县汇民村镇银行", "abbreviationName": "万荣县汇民村镇银行", "code": "WRXHMCUNZB"}, {
        "value": "汪清和润村镇银行",
        "abbreviationName": "汪清和润村镇银行",
        "code": "WQHRCUNZB"
    }, {"value": "望都中成村镇银行", "abbreviationName": "望都中成村镇银行", "code": "WDZCCUNZB"}, {
        "value": "望江新华村镇银行",
        "abbreviationName": "望江新华村镇银行",
        "code": "WJXHCUNZB"
    }, {"value": "望谟富民村镇银行", "abbreviationName": "望谟富民村镇银行", "code": "WZFMCUNZB"}, {
        "value": "威海富民村镇银行",
        "abbreviationName": "威海富民村镇银行",
        "code": "WHFMCUNZB"
    }, {"value": "威海蓝海银行", "abbreviationName": "威海蓝海", "code": "WHLHB"}, {
        "value": "威海市商业银行",
        "abbreviationName": "威海",
        "code": "WHCCB"
    }, {"value": "威宁富民村镇银行", "abbreviationName": "威宁富民村镇银行", "code": "WNFMCUNZB"}, {
        "value": "威县邢农商村镇银行",
        "abbreviationName": "威县邢农商村镇银行",
        "code": "WXXNSCUNZB"
    }, {"value": "微山北海村镇银行", "abbreviationName": "微山北海村镇银行", "code": "WSBHCUNZB"}, {
        "value": "围场满族蒙古族自治县华商村镇银行",
        "abbreviationName": "围场满族蒙古族自治县华商村镇银行",
        "code": "WCMZMGZZZXHSCUNZB"
    }, {"value": "潍坊农村商业银行", "abbreviationName": "潍坊农商", "code": "WFRCB"}, {
        "value": "潍坊市寒亭区蒙银村镇银行",
        "abbreviationName": "潍坊市寒亭区蒙银村镇银行",
        "code": "WFSHTQMYCUNZB"
    }, {"value": "潍坊市奎文区中成村镇银行", "abbreviationName": "潍坊市奎文区中成村镇银行", "code": "WFSKWQZCCUNZB"}, {
        "value": "潍坊市潍城区北海村镇银行",
        "abbreviationName": "潍坊市潍城区北海村镇银行",
        "code": "WFSWCQBHCUNZB"
    }, {"value": "潍坊银行", "abbreviationName": "潍坊", "code": "WFYH"}, {
        "value": "卫辉富民村镇银行",
        "abbreviationName": "卫辉富民村镇银行",
        "code": "WHUIFMCUNZB"
    }, {"value": "尉犁达西冀银村镇银行", "abbreviationName": "尉犁达西冀银村镇银行", "code": "WLDXJYCUNZB"}, {
        "value": "尉氏合益村镇银行",
        "abbreviationName": "尉氏合益村镇银行",
        "code": "WSHYCUNZB"
    }, {"value": "蔚县银泰村镇银行", "abbreviationName": "蔚县银泰村镇银行", "code": "WXYTCUNZB"}, {
        "value": "魏县齐鲁村镇银行",
        "abbreviationName": "魏县齐鲁村镇银行",
        "code": "WXQLCUNZB"
    }, {"value": "温县齐鲁村镇银行", "abbreviationName": "温县齐鲁村镇银行", "code": "WENXQLCUNZB"}, {
        "value": "温州民商银行",
        "abbreviationName": "温州民商",
        "code": "WZMSYH"
    }, {"value": "温州银行股份有限公司", "abbreviationName": "温州", "code": "WZYH"}, {
        "value": "文安县惠民村镇银行",
        "abbreviationName": "文安县惠民村镇银行",
        "code": "WAXHMCUNZB"
    }, {"value": "文昌大众村镇银行", "abbreviationName": "文昌大众村镇银行", "code": "WCDZCUNZB"}, {
        "value": "文山富宁长江村镇银行",
        "abbreviationName": "文山富宁长江村镇银行",
        "code": "WSFNCJCUNZB"
    }, {"value": "文山广南长江村镇银行", "abbreviationName": "文山广南长江村镇银行", "code": "WSGNCJCUNZB"}, {
        "value": "文山马关长江村镇银行",
        "abbreviationName": "文山马关长江村镇银行",
        "code": "WSMGCJCUNZB"
    }, {"value": "文山民丰村镇银行", "abbreviationName": "文山民丰村镇银行", "code": "WSMFCUNZB"}, {
        "value": "文山丘北长江村镇银行",
        "abbreviationName": "文山丘北长江村镇银行",
        "code": "WSQBCJCUNZB"
    }, {"value": "文山砚山长江村镇银行", "abbreviationName": "文山砚山长江村镇银行", "code": "WSYSCJCUNZB"}, {
        "value": "文水县润都村镇银行",
        "abbreviationName": "文水县润都村镇银行",
        "code": "WSXRDCUNZB"
    }, {"value": "闻喜县晋融村镇银行", "abbreviationName": "闻喜县晋融村镇银行", "code": "WXXJRCUNZB"}, {
        "value": "翁牛特立农村镇银行",
        "abbreviationName": "翁牛特立农村镇银行",
        "code": "WNTLNCUNZB"
    }, {"value": "瓮安富民村镇银行", "abbreviationName": "瓮安富民村镇银行", "code": "WAFMCUNZB"}, {
        "value": "乌海千里山河套村镇银行",
        "abbreviationName": "乌海千里山河套村镇银行",
        "code": "WHQLSHTCUNZB"
    }, {"value": "乌海市海勃湾黄河村镇银行", "abbreviationName": "乌海市海勃湾黄河村镇银行", "code": "WHSHBWHHCUNZB"}, {
        "value": "乌海市乌拉特村镇银行",
        "abbreviationName": "乌海市乌拉特村镇银行",
        "code": "WHSWLTCUNZB"
    }, {"value": "乌海银行", "abbreviationName": "乌海", "code": "WHYH"}, {
        "value": "乌拉特前旗大众村镇银行",
        "abbreviationName": "乌拉特前旗大众村镇银行",
        "code": "WLTQQDZCUNZB"
    }, {"value": "乌拉特中旗蒙银村镇银行", "abbreviationName": "乌拉特中旗蒙银村镇银行", "code": "WLTZQMYCUNZB"}, {
        "value": "乌兰察布农村商业银行",
        "abbreviationName": "乌兰察布农商",
        "code": "WLCBRCB"
    }, {"value": "乌兰察布市集宁蒙商村镇银行", "abbreviationName": "乌兰察布市集宁蒙商村镇银行", "code": "WLCBSJNBSCUNZB"}, {
        "value": "乌鲁木齐米东浦发村镇银行",
        "abbreviationName": "乌鲁木齐米东浦发村镇银行",
        "code": "WLMQMDPFCUNZB"
    }, {"value": "乌鲁木齐县利丰村镇银行", "abbreviationName": "乌鲁木齐县利丰村镇银行", "code": "WLMQXLFCUNZB"}, {
        "value": "乌鲁木齐银行",
        "abbreviationName": "乌鲁木齐",
        "code": "WLMQYH"
    }, {"value": "乌审旗蒙商村镇银行", "abbreviationName": "乌审旗蒙商村镇银行", "code": "WSQBSCUNZB"}, {
        "value": "乌苏利丰村镇银行",
        "abbreviationName": "乌苏利丰村镇银行",
        "code": "WSLFCUNZB"
    }, {"value": "无棣中成村镇银行", "abbreviationName": "无棣中成村镇银行", "code": "WZZCCUNZB"}, {
        "value": "无为徽银村镇银行",
        "abbreviationName": "无为徽银村镇银行",
        "code": "WWHYCUNZB"
    }, {"value": "无锡农村商业银行", "abbreviationName": "无锡农商", "code": "WXRCB"}, {
        "value": "无锡锡商银行",
        "abbreviationName": "无锡锡商",
        "code": "WXXSB"
    }, {"value": "芜湖津盛农村商业银行", "abbreviationName": "芜湖津盛农商", "code": "WHJSRCB"}, {
        "value": "芜湖扬子农村商业银行",
        "abbreviationName": "芜湖扬子农商",
        "code": "WHYZRCB"
    }, {"value": "芜湖圆融村镇银行", "abbreviationName": "芜湖圆融村镇银行", "code": "WHYHCUNZB"}, {
        "value": "吴桥融信村镇银行",
        "abbreviationName": "吴桥融信村镇银行",
        "code": "WQRXCUNZB"
    }, {"value": "吴忠市滨河村镇银行", "abbreviationName": "吴忠市滨河村镇银行", "code": "WZSBHCUNZB"}, {
        "value": "五常惠民村镇银行",
        "abbreviationName": "五常惠民村镇银行",
        "code": "WCHMCUNZB"
    }, {"value": "五大连池惠丰村镇银行", "abbreviationName": "五大连池惠丰村镇银行", "code": "WDLCHFCUNZB"}, {
        "value": "五峰金谷村镇银行",
        "abbreviationName": "五峰金谷村镇银行",
        "code": "WFJGCUNZB"
    }, {"value": "五华惠民村镇银行", "abbreviationName": "五华惠民村镇银行", "code": "WHHMCUNZB"}, {
        "value": "五家渠国民村镇银行",
        "abbreviationName": "五家渠国民村镇银行",
        "code": "WJQGMCUNZB"
    }, {"value": "五台莱商村镇银行", "abbreviationName": "五台莱商村镇银行", "code": "WTLSCUNZB"}, {
        "value": "五原蒙银村镇银行",
        "abbreviationName": "五原蒙银村镇银行",
        "code": "WYMYCUNZB"
    }, {"value": "武安村镇银行", "abbreviationName": "武安村镇银行", "code": "WACUNZB"}, {
        "value": "武城圆融村镇银行",
        "abbreviationName": "武城圆融村镇银行",
        "code": "WCYRCUNZB"
    }, {"value": "武川立农村镇银行", "abbreviationName": "武川立农村镇银行", "code": "WCLNCUNZB"}, {
        "value": "武冈发展村镇银行",
        "abbreviationName": "武冈发展村镇银行",
        "code": "WGBSCUNZB"
    }, {"value": "武汉东西湖扬子村镇银行", "abbreviationName": "武汉东西湖扬子村镇银行", "code": "WHDXHYZCUNZB"}, {
        "value": "武汉江夏民生村镇银行",
        "abbreviationName": "武汉江夏民生村镇银行",
        "code": "WHJXMSCUNZB"
    }, {"value": "武汉农村商业银行", "abbreviationName": "武汉农商", "code": "WHRCB"}, {
        "value": "武汉众邦银行",
        "abbreviationName": "武汉众邦",
        "code": "WHZBB"
    }, {"value": "武隆融兴村镇银行", "abbreviationName": "武隆融兴村镇银行", "code": "WLRXCUNZB"}, {
        "value": "武宁恒通村镇银行",
        "abbreviationName": "武宁恒通村镇银行",
        "code": "WNHTCUNZB"
    }, {"value": "武强家银村镇银行", "abbreviationName": "武强家银村镇银行", "code": "WQJYCUNZB"}, {
        "value": "武威农村商业银行",
        "abbreviationName": "武威农商",
        "code": "WWRCB"
    }, {"value": "武乡县泽都村镇银行", "abbreviationName": "武乡县泽都村镇银行", "code": "WXXZDCUNZB"}, {
        "value": "武夷山本富村镇银行",
        "abbreviationName": "武夷山本富村镇银行",
        "code": "WYSBFCUNZB"
    }, {"value": "武邑邢农商村镇银行", "abbreviationName": "武邑邢农商村镇银行", "code": "WYXNSCUNZB"}, {
        "value": "武陟射阳村镇银行",
        "abbreviationName": "武陟射阳村镇银行",
        "code": "WZSYCUNZB"
    }, {"value": "舞阳玉川村镇银行", "abbreviationName": "舞阳玉川村镇银行", "code": "WYYCCUNZB"}, {
        "value": "西安高陵阳光村镇银行",
        "abbreviationName": "西安高陵阳光村镇银行",
        "code": "XAGLYGCUNZB"
    }, {"value": "西安鄠邑农村商业银行", "abbreviationName": "西安鄠邑农商", "code": "XAHYRCB"}, {
        "value": "西安雁塔恒通村镇银行",
        "abbreviationName": "西安雁塔恒通村镇银行",
        "code": "XAYTHTCUNZB"
    }, {"value": "西安银行", "abbreviationName": "西安", "code": "XAYH"}, {
        "value": "西安长安新华村镇银行",
        "abbreviationName": "西安长安新华村镇银行",
        "code": "XACAXHCUNZB"
    }, {"value": "西班牙对外银行", "abbreviationName": "西班牙对外银行", "code": "BBVA"}, {
        "value": "西班牙桑坦德银行",
        "abbreviationName": "西班牙桑坦德",
        "code": "SANTANDER"
    }, {"value": "西藏堆龙民泰村镇银行", "abbreviationName": "西藏堆龙民泰村镇银行", "code": "XZDLMTCUNZB"}, {
        "value": "西藏银行",
        "abbreviationName": "西藏",
        "code": "XICYH"
    }, {"value": "西昌金信村镇银行", "abbreviationName": "西昌金信村镇银行", "code": "XCJXCUNZB"}, {
        "value": "西丰鹿城村镇银行",
        "abbreviationName": "西丰鹿城村镇银行",
        "code": "XFLCCUNZB"
    }, {"value": "西平中原村镇银行", "abbreviationName": "西平中原村镇银行", "code": "XPCFCUNZB"}, {
        "value": "西双版纳勐海长江村镇银行",
        "abbreviationName": "西双版纳勐海长江村镇银行",
        "code": "XSBNZHCJCUNZB"
    }, {"value": "西双版纳勐腊长江村镇银行", "abbreviationName": "西双版纳勐腊长江村镇银行", "code": "XSBNZLCJCUNZB"}, {
        "value": "西乌珠穆沁蒙商惠丰村镇银行",
        "abbreviationName": "西乌珠穆沁蒙商惠丰村镇银行",
        "code": "XWZMQBSHFCUNZB"
    }, {"value": "息烽发展村镇银行", "abbreviationName": "息烽发展村镇银行", "code": "XFBSQLCUNZB"}, {
        "value": "浠水楚农商村镇银行",
        "abbreviationName": "浠水楚农商村镇银行",
        "code": "XSCNSCUNZB"
    }, {"value": "锡林浩特农村合作银行", "abbreviationName": "锡林浩特农村合作银行", "code": "XLHTRCU"}, {
        "value": "隰县新田村镇银行",
        "abbreviationName": "隰县新田村镇银行",
        "code": "ZXXTCUNZB"
    }, {"value": "峡江洪都村镇银行", "abbreviationName": "峡江洪都村镇银行", "code": "XJHDCUNZB"}, {
        "value": "霞浦刺桐红村镇银行",
        "abbreviationName": "霞浦刺桐红村镇银行",
        "code": "XPCTHCUNZB"
    }, {"value": "夏津胶东村镇银行", "abbreviationName": "夏津胶东村镇银行", "code": "XJJDCUNZB"}, {
        "value": "夏县河东村镇银行",
        "abbreviationName": "夏县河东村镇银行",
        "code": "XXHDCUNZB"
    }, {"value": "仙桃楚农商村镇银行", "abbreviationName": "仙桃楚农商村镇银行", "code": "XTCNSCUNZB"}, {
        "value": "献县融和村镇银行",
        "abbreviationName": "献县融和村镇银行",
        "code": "XXRHCUNZB"
    }, {"value": "香河益民村镇银行", "abbreviationName": "香河益民村镇银行", "code": "XHYMCUNZB"}, {
        "value": "湘潭农村商业银行",
        "abbreviationName": "湘潭农商",
        "code": "XTRCB"
    }, {"value": "湘西长行村镇银行", "abbreviationName": "湘西长行村镇银行", "code": "XXCXCUNZB"}, {
        "value": "湘乡市村镇银行",
        "abbreviationName": "湘乡市村镇银行",
        "code": "XXSCUNZB"
    }, {"value": "襄城汇浦村镇银行", "abbreviationName": "襄城汇浦村镇银行", "code": "XCHPCUNZB"}, {
        "value": "襄汾县万都村镇银行",
        "abbreviationName": "襄汾县万都村镇银行",
        "code": "XFXWDCUNZB"
    }, {"value": "襄垣县融汇村镇银行", "abbreviationName": "襄垣县融汇村镇银行", "code": "XYXRHCUNZB"}, {
        "value": "象山国民村镇银行",
        "abbreviationName": "象山国民村镇银行",
        "code": "XSGMCUNZB"
    }, {"value": "孝昌本富村镇银行", "abbreviationName": "孝昌本富村镇银行", "code": "XCBFCUNZB"}, {
        "value": "辛集齐鲁村镇银行",
        "abbreviationName": "辛集齐鲁村镇银行",
        "code": "XJQLCUNZB"
    }, {"value": "忻州市忻府区秀都村镇银行", "abbreviationName": "忻州市忻府区秀都村镇银行", "code": "XZSXFQXDCUNZB"}, {
        "value": "新安融兴村镇银行",
        "abbreviationName": "新安融兴村镇银行",
        "code": "XARXCUNZB"
    }, {"value": "新都桂城村镇银行", "abbreviationName": "新都桂城村镇银行", "code": "XDGCCUNZB"}, {
        "value": "新韩银行（中国）有限公司",
        "abbreviationName": "新韩",
        "code": "XHYH"
    }, {"value": "新疆阿克苏农村商业银行", "abbreviationName": "新疆阿克苏农商", "code": "XJAKSRCB"}, {
        "value": "新疆阿勒泰农村商业银行",
        "abbreviationName": "新疆阿勒泰农商",
        "code": "XJALTRCB"
    }, {"value": "新疆阿瓦提农村商业银行", "abbreviationName": "新疆阿瓦提农商", "code": "XJAWTRCB"}, {
        "value": "新疆北屯农村商业银行",
        "abbreviationName": "新疆北屯农商",
        "code": "XJBTRCB"
    }, {"value": "新疆博湖农村商业银行", "abbreviationName": "新疆博湖农商", "code": "XJBHRCB"}, {
        "value": "新疆博乐农村商业银行",
        "abbreviationName": "新疆博乐农商",
        "code": "XJBLRCB"
    }, {"value": "新疆布尔津喀纳斯农村商业银行", "abbreviationName": "新疆布尔津喀纳斯农商", "code": "XJBEJKNSRCB"}, {
        "value": "新疆昌吉农村商业银行",
        "abbreviationName": "新疆昌吉农商",
        "code": "XJCJRCB"
    }, {"value": "新疆阜康农村商业银行", "abbreviationName": "新疆阜康农商", "code": "XJFKRCB"}, {
        "value": "新疆富蕴农村商业银行",
        "abbreviationName": "新疆富蕴农商",
        "code": "XJFYRCB"
    }, {"value": "新疆呼图壁农村商业银行", "abbreviationName": "新疆呼图壁农商", "code": "XJHTBRCB"}, {
        "value": "新疆汇和银行",
        "abbreviationName": "新疆汇和",
        "code": "XJHHB"
    }, {"value": "新疆霍城农村商业银行", "abbreviationName": "新疆霍城农商", "code": "XJHCRCB"}, {
        "value": "新疆吉木萨尔农村商业银行",
        "abbreviationName": "新疆吉木萨尔农商",
        "code": "XJJMSERCB"
    }, {"value": "新疆建新成功村镇银行", "abbreviationName": "新疆建新成功村镇银行", "code": "XJJXCGCUNZB"}, {
        "value": "新疆喀什农村商业银行",
        "abbreviationName": "新疆喀什农商",
        "code": "XJKSRCB"
    }, {"value": "新疆库尔勒富民村镇银行", "abbreviationName": "新疆库尔勒富民村镇银行", "code": "XJKELFMCUNZB"}, {
        "value": "新疆库尔勒农村商业银行",
        "abbreviationName": "新疆库尔勒农商",
        "code": "XJKELRCB"
    }, {"value": "新疆轮台农村商业银行", "abbreviationName": "新疆轮台农商", "code": "XJLTRCB"}, {
        "value": "新疆绿洲国民村镇银行",
        "abbreviationName": "新疆绿洲国民村镇银行",
        "code": "XJLZGMCUNZB"
    }, {"value": "新疆玛纳斯农村商业银行", "abbreviationName": "新疆玛纳斯农商", "code": "XJMNSRCB"}, {
        "value": "新疆木垒农村商业银行",
        "abbreviationName": "新疆木垒农商",
        "code": "XJMLRCB"
    }, {"value": "新疆奇台农村商业银行", "abbreviationName": "新疆奇台农商", "code": "XJQTRCB"}, {
        "value": "新疆沙湾农村商业银行",
        "abbreviationName": "新疆沙湾农商",
        "code": "XJSWRCB"
    }, {"value": "新疆沙雅农村商业银行", "abbreviationName": "新疆沙雅农商", "code": "XJSYRCB"}, {
        "value": "新疆鄯善农村商业银行",
        "abbreviationName": "新疆鄯善农商",
        "code": "XJSSRB"
    }, {"value": "新疆石河子交银村镇银行", "abbreviationName": "新疆石河子交银村镇银行", "code": "XJSHZJYCUNZB"}, {
        "value": "新疆石河子农村合作银行",
        "abbreviationName": "新疆石河子农村合作银行",
        "code": "XJSHZRCU"
    }, {"value": "新疆塔城农村商业银行", "abbreviationName": "新疆塔城农商", "code": "XJTCRCB"}, {
        "value": "新疆天山农村商业银行",
        "abbreviationName": "新疆天山农商",
        "code": "XJTSRCB"
    }, {"value": "新疆维吾尔自治区农村信用社联合社", "abbreviationName": "新疆农信社", "code": "XJNXS"}, {
        "value": "新疆尉犁农村商业银行",
        "abbreviationName": "新疆尉犁农商",
        "code": "XJYLIRCB"
    }, {"value": "新疆温宿农村商业银行", "abbreviationName": "新疆温宿农商", "code": "XJWSURCB"}, {
        "value": "新疆乌鲁木齐农村商业银行",
        "abbreviationName": "新疆乌鲁木齐农商",
        "code": "XJWLMQRCB"
    }, {"value": "新疆乌什农村商业银行", "abbreviationName": "新疆乌什农商", "code": "XJWUSRCB"}, {
        "value": "新疆乌苏农村商业银行",
        "abbreviationName": "新疆乌苏农商",
        "code": "XJWSRCB"
    }, {"value": "新疆新源农村商业银行", "abbreviationName": "新疆新源农商", "code": "XJXYRCB"}, {
        "value": "新疆伊犁农村商业银行",
        "abbreviationName": "新疆伊犁农商",
        "code": "XJYLRCB"
    }, {"value": "新疆伊宁农村商业银行", "abbreviationName": "新疆伊宁农商", "code": "XJYNRCB"}, {
        "value": "新疆银行",
        "abbreviationName": "新疆",
        "code": "XJB"
    }, {"value": "新疆昭苏农村商业银行", "abbreviationName": "新疆昭苏农商", "code": "XJZSRCB"}, {
        "value": "新绛县新田村镇银行",
        "abbreviationName": "新绛县新田村镇银行",
        "code": "XZXXTCUNZB"
    }, {"value": "新津珠江村镇银行", "abbreviationName": "新津珠江村镇银行", "code": "XJZJCUNZB"}, {
        "value": "新联商业银行",
        "abbreviationName": "新联",
        "code": "XLSYYY"
    }, {"value": "新密郑银村镇银行", "abbreviationName": "新密郑银村镇银行", "code": "XMZYCUNZB"}, {
        "value": "新乡中原村镇银行",
        "abbreviationName": "新乡中原村镇银行",
        "code": "XXZYCUNZB"
    }, {"value": "新余孔目江成功村镇银行", "abbreviationName": "新余孔目江成功村镇银行", "code": "XYKMJCGCUNZB"}, {
        "value": "新余农村商业银行",
        "abbreviationName": "新余农商",
        "code": "XYRCB"
    }, {"value": "新余渝水湘淮村镇银行", "abbreviationName": "新余渝水湘淮村镇银行", "code": "XYYSXHCUNZB"}, {
        "value": "新郑郑银村镇银行",
        "abbreviationName": "新郑郑银村镇银行",
        "code": "XZZYCUNZB"
    }, {"value": "信阳平桥中原村镇银行", "abbreviationName": "信阳平桥中原村镇银行", "code": "XYPQZYCUNZB"}, {
        "value": "信阳珠江村镇银行",
        "abbreviationName": "信阳珠江村镇银行",
        "code": "XINYZJCUNZB"
    }, {"value": "星展银行", "abbreviationName": "星展", "code": "DBSBANK"}, {
        "value": "邢台县邢农商村镇银行",
        "abbreviationName": "邢台县邢农商村镇银行",
        "code": "XTXXNSCUNZB"
    }, {"value": "邢台银行", "abbreviationName": "邢台", "code": "XTYH"}, {
        "value": "行唐利丰村镇银行",
        "abbreviationName": "行唐利丰村镇银行",
        "code": "XTLFCUNZB"
    }, {"value": "荥阳利丰村镇银行", "abbreviationName": "荥阳利丰村镇银行", "code": "XYLFCUNZB"}, {
        "value": "兴安盟科尔沁蒙商村镇银行",
        "abbreviationName": "兴安盟科尔沁蒙商村镇银行",
        "code": "XAMKEQBSCUNZB"
    }, {"value": "兴城长兴村镇银行", "abbreviationName": "兴城长兴村镇银行", "code": "XCCXCUNZB"}, {
        "value": "兴福村镇银行",
        "abbreviationName": "兴福村镇银行",
        "code": "XFCUNZB"
    }, {"value": "兴和蒙商村镇银行", "abbreviationName": "兴和蒙商村镇银行", "code": "XHBSCUNZB"}, {
        "value": "兴化苏南村镇银行",
        "abbreviationName": "兴化苏南村镇银行",
        "code": "XHSNCUNZB"
    }, {"value": "兴宁珠江村镇银行", "abbreviationName": "兴宁珠江村镇银行", "code": "XNZJCUNZB"}, {
        "value": "兴仁振兴村镇银行",
        "abbreviationName": "兴仁振兴村镇银行",
        "code": "XRZXCUNZB"
    }, {"value": "兴山本富村镇银行", "abbreviationName": "兴山本富村镇银行", "code": "XSBFCUNZB"}, {
        "value": "兴县汇泽村镇银行",
        "abbreviationName": "兴县汇泽村镇银行",
        "code": "XXHZCUNZB"
    }, {"value": "兴业银行", "abbreviationName": "兴业", "code": "CIB"}, {
        "value": "兴义万丰村镇银行",
        "abbreviationName": "兴义万丰村镇银行",
        "code": "XYWFCUNZB"
    }, {"value": "雄县丰源村镇银行", "abbreviationName": "雄县丰源村镇银行", "code": "XXFYCUNZB"}, {
        "value": "修水九银村镇银行",
        "abbreviationName": "修水九银村镇银行",
        "code": "XSJYCUNZB"
    }, {"value": "修文江海村镇银行", "abbreviationName": "修文江海村镇银行", "code": "XWJHCUNZB"}, {
        "value": "徐州农村商业银行",
        "abbreviationName": "徐州农商",
        "code": "XZRCB"
    }, {"value": "许昌农村商业银行", "abbreviationName": "许昌农商", "code": "XCRCB"}, {
        "value": "许昌新浦村镇银行",
        "abbreviationName": "许昌新浦村镇银行",
        "code": "XCXPCUNZB"
    }, {"value": "宣城皖南农村商业银行", "abbreviationName": "宣城皖南农商", "code": "XCWNRCB"}, {
        "value": "宣汉诚民村镇银行",
        "abbreviationName": "宣汉诚民村镇银行",
        "code": "XHCMCUNZB"
    }, {"value": "宣化中成村镇银行", "abbreviationName": "宣化中成村镇银行", "code": "XHZCCUNZB"}, {
        "value": "寻甸中成村镇银行",
        "abbreviationName": "寻甸中成村镇银行",
        "code": "XDZCCUNZB"
    }, {"value": "雅安农村商业银行", "abbreviationName": "雅安农商", "code": "YARCB"}, {
        "value": "雅安市商业银行",
        "abbreviationName": "雅安",
        "code": "YASCCB"
    }, {"value": "雅安雨城惠民村镇银行", "abbreviationName": "雅安雨城惠民村镇银行", "code": "YAYCHMCUNZB"}, {
        "value": "烟台福山珠江村镇银行",
        "abbreviationName": "烟台福山珠江村镇银行",
        "code": "YTFSZJCUNZB"
    }, {"value": "烟台农村商业银行", "abbreviationName": "烟台农商", "code": "YTRCB"}, {
        "value": "烟台银行",
        "abbreviationName": "烟台",
        "code": "YTYH"
    }, {"value": "鄢陵郑银村镇银行", "abbreviationName": "鄢陵郑银村镇银行", "code": "ZLZYCUNZB"}, {
        "value": "延安农村商业银行",
        "abbreviationName": "延安农商",
        "code": "YANRCB"
    }, {"value": "延边农村商业银行", "abbreviationName": "延边农商", "code": "YBRCB"}, {
        "value": "延吉和润村镇银行",
        "abbreviationName": "延吉和润村镇银行",
        "code": "YJHRCUNZB"
    }, {"value": "延寿融兴村镇银行", "abbreviationName": "延寿融兴村镇银行", "code": "YSRXCUNZB"}, {
        "value": "沿河长征村镇银行",
        "abbreviationName": "沿河长征村镇银行",
        "code": "YHCZCUNZB"
    }, {"value": "兖州中成村镇银行", "abbreviationName": "兖州中成村镇银行", "code": "SZZCCUNZB"}, {
        "value": "偃师融兴村镇银行",
        "abbreviationName": "偃师融兴村镇银行",
        "code": "ZSRXCUNZB"
    }, {"value": "扬中恒丰村镇银行", "abbreviationName": "扬中恒丰村镇银行", "code": "YZHFCUNZB"}, {
        "value": "扬州广陵中成村镇银行",
        "abbreviationName": "扬州广陵中成村镇银行",
        "code": "YZGLZCCUNZB"
    }, {"value": "扬州仪征玉丰村镇银行", "abbreviationName": "扬州仪征玉丰村镇银行", "code": "JSYZBSCUNZB"}, {
        "value": "阳城县三禾村镇银行",
        "abbreviationName": "阳城县三禾村镇银行",
        "code": "YCXSHCUNZB"
    }, {"value": "阳高县兴都村镇银行", "abbreviationName": "阳高县兴都村镇银行", "code": "YGXXDCUNZB"}, {
        "value": "阳谷沪农商村镇银行",
        "abbreviationName": "阳谷沪农商村镇银行",
        "code": "YGHNSCUNZB"
    }, {"value": "阳江阳春长江村镇银行", "abbreviationName": "阳江阳春长江村镇银行", "code": "YJYCCJCUNZB"}, {
        "value": "阳曲县汇民村镇银行",
        "abbreviationName": "阳曲县汇民村镇银行",
        "code": "YQXHMCUNZB"
    }, {"value": "阳泉农村商业银行", "abbreviationName": "阳泉农商", "code": "YQRCB"}, {
        "value": "阳泉市商业银行",
        "abbreviationName": "阳泉",
        "code": "YQSCCB"
    }, {"value": "阳新汉银村镇银行", "abbreviationName": "阳新汉银村镇银行", "code": "YXHYCUNZB"}, {
        "value": "阳信河海村镇银行",
        "abbreviationName": "阳信河海村镇银行",
        "code": "YXHHCUNZB"
    }, {"value": "伊川齐鲁村镇银行", "abbreviationName": "伊川齐鲁村镇银行", "code": "YICQLCUNZB"}, {
        "value": "伊春农村商业银行",
        "abbreviationName": "伊春农商",
        "code": "YICRCB"
    }, {"value": "伊金霍洛金谷村镇银行", "abbreviationName": "伊金霍洛金谷村镇银行", "code": "YJHLJGCUNZB"}, {
        "value": "伊金霍洛六菱村镇银行",
        "abbreviationName": "伊金霍洛六菱村镇银行",
        "code": "YJHLLLCUNZB"
    }, {"value": "伊犁国民村镇银行", "abbreviationName": "伊犁国民村镇银行", "code": "YLGMCUNZB"}, {
        "value": "伊通榆银村镇银行",
        "abbreviationName": "伊通榆银村镇银行",
        "code": "YTYYCUNZB"
    }, {"value": "依安润生村镇银行", "abbreviationName": "依安润生村镇银行", "code": "YARSCUNZB"}, {
        "value": "依兰惠鑫村镇银行",
        "abbreviationName": "依兰惠鑫村镇银行",
        "code": "YLHXCUNZB"
    }, {"value": "沂源博商村镇银行", "abbreviationName": "沂源博商村镇银行", "code": "YYBSCUNZB"}, {
        "value": "宜宾农村商业银行",
        "abbreviationName": "宜宾农商",
        "code": "YIBRCB"
    }, {"value": "宜宾市商业银行", "abbreviationName": "宜宾", "code": "YBSCCB"}, {
        "value": "宜宾兴宜村镇银行",
        "abbreviationName": "宜宾兴宜村镇银行",
        "code": "YBXYCUNZB"
    }, {"value": "宜春农村商业银行", "abbreviationName": "宜春农商", "code": "YCRCB"}, {
        "value": "宜都民生村镇银行",
        "abbreviationName": "宜都民生村镇银行",
        "code": "YDMSCUNZB"
    }, {"value": "宜黄抚商村镇银行", "abbreviationName": "宜黄抚商村镇银行", "code": "YHFSCUNZB"}, {
        "value": "宜兴阳羡村镇银行",
        "abbreviationName": "宜兴阳羡村镇银行",
        "code": "YXYXCUNZB"
    }, {"value": "宜章长行村镇银行", "abbreviationName": "宜章长行村镇银行", "code": "YZCXCUNZB"}, {
        "value": "宜州深通村镇银行",
        "abbreviationName": "宜州深通村镇银行",
        "code": "YZSTCUNZB"
    }, {"value": "弋阳蓝海村镇银行", "abbreviationName": "弋阳蓝海村镇银行", "code": "ZYLHCUNZB"}, {
        "value": "益阳农村商业银行",
        "abbreviationName": "益阳农商",
        "code": "YYRCB"
    }, {"value": "意大利联合圣保罗银行", "abbreviationName": "意大利联合圣保罗", "code": "YDLLHSBL"}, {
        "value": "意大利裕信银行",
        "abbreviationName": "意大利裕信",
        "code": "UNICREDITO"
    }, {"value": "银川掌政石银村镇银行", "abbreviationName": "银川掌政石银村镇银行", "code": "YCZZSYCUNZB"}, {
        "value": "印度国家银行",
        "abbreviationName": "印度国家",
        "code": "INDIASB"
    }, {"value": "印度尼西亚曼底利银行", "abbreviationName": "印度尼西亚曼底利", "code": "YDNXYMDLB"}, {
        "value": "印江长征村镇银行",
        "abbreviationName": "印江长征村镇银行",
        "code": "YJCZCUNZB"
    }, {"value": "应城融兴村镇银行", "abbreviationName": "应城融兴村镇银行", "code": "YCRXCUNZB"}, {
        "value": "应县金都村镇银行",
        "abbreviationName": "应县金都村镇银行",
        "code": "YXJDCUNZB"
    }, {"value": "英国巴克莱银行有限公司", "abbreviationName": "英国巴克莱", "code": "YGBLKYH"}, {
        "value": "鹰潭农村商业银行",
        "abbreviationName": "鹰潭农商",
        "code": "YINGTRCB"
    }, {"value": "鹰潭月湖恒通村镇银行", "abbreviationName": "鹰潭月湖恒通村镇银行", "code": "YTYHHTCUNZB"}, {
        "value": "营口宏诚村镇银行",
        "abbreviationName": "营口宏诚村镇银行",
        "code": "YKHCCUNZB"
    }, {"value": "营口农村商业银行", "abbreviationName": "营口农商", "code": "YKRCB"}, {
        "value": "营口融生农村商业银行",
        "abbreviationName": "营口融生农商",
        "code": "YKRSRCB"
    }, {"value": "营口沿海银行", "abbreviationName": "营口沿海", "code": "YKYHYH"}, {
        "value": "营口银行",
        "abbreviationName": "营口",
        "code": "YKYH"
    }, {"value": "永城齐鲁村镇银行", "abbreviationName": "永城齐鲁村镇银行", "code": "YCQLCUNZB"}, {
        "value": "永丰洪都村镇银行",
        "abbreviationName": "永丰洪都村镇银行",
        "code": "YFHDCUNZB"
    }, {"value": "永丰银行", "abbreviationName": "永丰", "code": "SINOPAC"}, {
        "value": "永吉吉庆村镇银行",
        "abbreviationName": "永吉吉庆村镇银行",
        "code": "YJJQCUNZB"
    }, {"value": "永济市三禾村镇银行", "abbreviationName": "永济市三禾村镇银行", "code": "YJSSHCUNZB"}, {
        "value": "永靖县金城村镇银行",
        "abbreviationName": "永靖县金城村镇银行",
        "code": "YJXJCCUNZB"
    }, {"value": "永隆银行有限公司", "abbreviationName": "永隆", "code": "WINGLBANK"}, {
        "value": "永清吉银村镇银行",
        "abbreviationName": "永清吉银村镇银行",
        "code": "YQJYCUNZB"
    }, {"value": "永新庐陵村镇银行", "abbreviationName": "永新庐陵村镇银行", "code": "YXLLCUNZB"}, {
        "value": "永兴沪农商村镇银行",
        "abbreviationName": "永兴沪农商村镇银行",
        "code": "YXHNSCUNZB"
    }, {"value": "永修浔银村镇银行", "abbreviationName": "永修浔银村镇银行", "code": "YXZYCUNZB"}, {
        "value": "永州农村商业银行",
        "abbreviationName": "永州农商",
        "code": "YZRCB"
    }, {"value": "友利银行（中国）有限公司", "abbreviationName": "友利", "code": "YLYH"}, {
        "value": "右玉县长青村镇银行",
        "abbreviationName": "右玉县长青村镇银行",
        "code": "YYXCQCUNZB"
    }, {"value": "余干恒通村镇银行", "abbreviationName": "余干恒通村镇银行", "code": "YGHTCUNZB"}, {
        "value": "余姚通济村镇银行",
        "abbreviationName": "余姚通济村镇银行",
        "code": "YYTJCUNZB"
    }, {"value": "盂县汇民村镇银行", "abbreviationName": "盂县汇民村镇银行", "code": "YXHMCUNZB"}, {
        "value": "鱼台青隆村镇银行",
        "abbreviationName": "鱼台青隆村镇银行",
        "code": "YTQLCUNZB"
    }, {"value": "榆林榆阳民生村镇银行", "abbreviationName": "榆林榆阳民生村镇银行", "code": "YLYYMSCUNZB"}, {
        "value": "榆树融兴村镇银行",
        "abbreviationName": "榆树融兴村镇银行",
        "code": "YUSRXCUNZB"
    }, {"value": "榆中浦发村镇银行", "abbreviationName": "榆中浦发村镇银行", "code": "YZPFCUNZB"}, {
        "value": "虞城通商村镇银行",
        "abbreviationName": "虞城通商村镇银行",
        "code": "YCTSCUNZB"
    }, {"value": "禹城胶东村镇银行", "abbreviationName": "禹城胶东村镇银行", "code": "YCJDCUNZB"}, {
        "value": "禹州新民生村镇银行",
        "abbreviationName": "禹州新民生村镇银行",
        "code": "YZXMSCUNZB"
    }, {"value": "玉屏长征村镇银行", "abbreviationName": "玉屏长征村镇银行", "code": "YPCZCUNZB"}, {
        "value": "玉山三清山村镇银行",
        "abbreviationName": "玉山三清山村镇银行",
        "code": "YSSQSCUNZB"
    }, {"value": "玉山银行", "abbreviationName": "玉山", "code": "YSYH"}, {
        "value": "玉田大商村镇银行",
        "abbreviationName": "玉田大商村镇银行",
        "code": "YTDSCUNZB"
    }, {"value": "玉溪澄江中成村镇银行", "abbreviationName": "玉溪澄江中成村镇银行", "code": "YXCJZCCUNZB"}, {
        "value": "玉溪红塔村镇银行",
        "abbreviationName": "玉溪红塔村镇银行",
        "code": "YXHTCUNZB"
    }, {"value": "元氏信融村镇银行", "abbreviationName": "元氏信融村镇银行", "code": "YSXRCUNZB"}, {
        "value": "沅江浦发村镇银行",
        "abbreviationName": "沅江浦发村镇银行",
        "code": "YJPFCUNZB"
    }, {"value": "垣曲县河东村镇银行", "abbreviationName": "垣曲县河东村镇银行", "code": "YQXHDCUNZB"}, {
        "value": "原平市汇民村镇银行",
        "abbreviationName": "原平市汇民村镇银行",
        "code": "YPSHMCUNZB"
    }, {"value": "远安金谷村镇银行", "abbreviationName": "远安金谷村镇银行", "code": "YAJGCUNZB"}, {
        "value": "云安惠民村镇银行",
        "abbreviationName": "云安惠民村镇银行",
        "code": "YAHMCUNZB"
    }, {"value": "云浮新兴东盈村镇银行", "abbreviationName": "云浮新兴东盈村镇银行", "code": "YFXXDYCUNZB"}, {
        "value": "云梦楚农商村镇银行",
        "abbreviationName": "云梦楚农商村镇银行",
        "code": "YMCNSCUNZB"
    }, {"value": "云南安宁稠州村镇银行", "abbreviationName": "云南安宁稠州村镇银行", "code": "YNANCZCUNZB"}, {
        "value": "云南宾川农村商业银行",
        "abbreviationName": "云南宾川农商",
        "code": "YNBCRCB"
    }, {"value": "云南昌宁农村商业银行", "abbreviationName": "云南昌宁农商", "code": "YNCNRCB"}, {
        "value": "云南澄江农村商业银行",
        "abbreviationName": "云南澄江农商",
        "code": "YNCJRCB"
    }, {"value": "云南楚雄农村商业银行", "abbreviationName": "云南楚雄农商", "code": "YNCXRCB"}, {
        "value": "云南大理农村商业银行",
        "abbreviationName": "云南大理农商",
        "code": "YNDLRCB"
    }, {"value": "云南大理渝农商村镇银行", "abbreviationName": "云南大理渝农商村镇银行", "code": "YNDLYNSCUNZB"}, {
        "value": "云南大姚农村商业银行",
        "abbreviationName": "云南大姚农商",
        "code": "YNDYRCB"
    }, {"value": "云南洱源农村商业银行", "abbreviationName": "云南洱源农商", "code": "YNEYRCB"}, {
        "value": "云南凤庆农村商业银行",
        "abbreviationName": "云南凤庆农商",
        "code": "YNFQRCB"
    }, {"value": "云南广南农村商业银行", "abbreviationName": "云南广南农商", "code": "YNGNRCB"}, {
        "value": "云南河口农村商业银行",
        "abbreviationName": "云南河口农商",
        "code": "YNHKRCB"
    }, {"value": "云南鹤庆农村商业银行", "abbreviationName": "云南鹤庆农商", "code": "YNHQRCB"}, {
        "value": "云南鹤庆渝农商村镇银行",
        "abbreviationName": "云南鹤庆渝农商村镇银行",
        "code": "YNHQYNSCUNZB"
    }, {"value": "云南红塔银行", "abbreviationName": "云南红塔", "code": "YNHTBANK"}, {
        "value": "云南华宁农村商业银行",
        "abbreviationName": "云南华宁农商",
        "code": "YNHNRCB"
    }, {"value": "云南会泽农村商业银行", "abbreviationName": "云南会泽农商", "code": "YNHZRCB"}, {
        "value": "云南建水农村商业银行",
        "abbreviationName": "云南建水农商",
        "code": "YNJSRCB"
    }, {"value": "云南剑川农村商业银行", "abbreviationName": "云南剑川农商", "code": "YNJCRCB"}, {
        "value": "云南景东农村商业银行",
        "abbreviationName": "云南景东农商",
        "code": "YNJDRCB"
    }, {"value": "云南景洪农村商业银行", "abbreviationName": "云南景洪农商", "code": "YNJHRCB"}, {
        "value": "云南梁河农村商业银行",
        "abbreviationName": "云南梁河农商",
        "code": "YNLHRCB"
    }, {"value": "云南临沧临翔农村商业银行", "abbreviationName": "云南临沧临翔农商", "code": "YNLCLXRCB"}, {
        "value": "云南龙陵农村商业银行",
        "abbreviationName": "云南龙陵农商",
        "code": "YNLONGLRCB"
    }, {"value": "云南隆阳农村商业银行", "abbreviationName": "云南隆阳农商", "code": "YNLYRCB"}, {
        "value": "云南陇川农村商业银行",
        "abbreviationName": "云南陇川农商",
        "code": "YNLCRCB"
    }, {"value": "云南陆良农村商业银行", "abbreviationName": "云南陆良农商", "code": "YNLLRCB"}, {
        "value": "云南禄丰农村商业银行",
        "abbreviationName": "云南禄丰农商",
        "code": "YNLFRCB"
    }, {"value": "云南罗平农村商业银行", "abbreviationName": "云南罗平农商", "code": "YNLPRCB"}, {
        "value": "云南麻栗坡农村商业银行",
        "abbreviationName": "云南麻栗坡农商",
        "code": "YNMLPRCB"
    }, {"value": "云南马关农村商业银行", "abbreviationName": "云南马关农商", "code": "YNMGRCB"}, {
        "value": "云南马龙北银村镇银行",
        "abbreviationName": "云南马龙北银村镇银行",
        "code": "YNMLBYCUNZB"
    }, {"value": "云南芒市农村商业银行", "abbreviationName": "云南芒市农商", "code": "YNMSRCB"}, {
        "value": "云南蒙自农村商业银行",
        "abbreviationName": "云南蒙自农商",
        "code": "YNMZRCB"
    }, {"value": "云南勐腊农村商业银行", "abbreviationName": "云南勐腊农商", "code": "YNMLRCB"}, {
        "value": "云南孟连农村商业银行",
        "abbreviationName": "云南孟连农商",
        "code": "YNMLIRCB"
    }, {"value": "云南弥渡农村商业银行", "abbreviationName": "云南弥渡农商", "code": "YNMDRCB"}, {
        "value": "云南弥勒农村商业银行",
        "abbreviationName": "云南弥勒农商",
        "code": "YNMILRCB"
    }, {"value": "云南南华农村商业银行", "abbreviationName": "云南南华农商", "code": "YNNHRCB"}, {
        "value": "云南宁蒗农村商业银行",
        "abbreviationName": "云南宁蒗农商",
        "code": "YNNLRCB"
    }, {"value": "云南普洱思茅农村商业银行", "abbreviationName": "云南普洱思茅农商", "code": "YNPESMRCB"}, {
        "value": "云南瑞丽南屏农村商业银行",
        "abbreviationName": "云南瑞丽南屏农商",
        "code": "YNRLNPRCB"
    }, {"value": "云南省农村信用社联合社", "abbreviationName": "云南农信社", "code": "YNNXS"}, {
        "value": "云南施甸农村商业银行",
        "abbreviationName": "云南施甸农商",
        "code": "YNSDRCB"
    }, {"value": "云南石屏北银村镇银行", "abbreviationName": "云南石屏北银村镇银行", "code": "YNSPBYCUNZB"}, {
        "value": "云南双柏农村商业银行",
        "abbreviationName": "云南双柏农商",
        "code": "YNSBRCB"
    }, {"value": "云南水富农村商业银行", "abbreviationName": "云南水富农商", "code": "YNSFRCB"}, {
        "value": "云南嵩明农村商业银行",
        "abbreviationName": "云南嵩明农商",
        "code": "YNSMRCB"
    }, {"value": "云南腾冲农村商业银行", "abbreviationName": "云南腾冲农商", "code": "YNTCRCB"}, {
        "value": "云南通海农村商业银行",
        "abbreviationName": "云南通海农商",
        "code": "YNTHRCB"
    }, {"value": "云南威信农村商业银行", "abbreviationName": "云南威信农商", "code": "YNWXRCB"}, {
        "value": "云南巍山农村商业银行",
        "abbreviationName": "云南巍山农商",
        "code": "YNWSRCB"
    }, {"value": "云南文山市农村商业银行", "abbreviationName": "云南文山市农商", "code": "YNWSSRCB"}, {
        "value": "云南西山北银村镇银行",
        "abbreviationName": "云南西山北银村镇银行",
        "code": "YNXSBYCUNZB"
    }, {"value": "云南西山渝农商村镇银行", "abbreviationName": "云南西山渝农商村镇银行", "code": "YNXSYNSCUNZB"}, {
        "value": "云南香格里拉渝农商村镇银行",
        "abbreviationName": "云南香格里拉渝农商村镇银行",
        "code": "YNXGLLYNSCUNZB"
    }, {"value": "云南祥云农村商业银行", "abbreviationName": "云南祥云农商", "code": "YNXYRCB"}, {
        "value": "云南祥云渝农商村镇银行",
        "abbreviationName": "云南祥云渝农商村镇银行",
        "code": "YNXYYNSCUNZB"
    }, {"value": "云南新平北银村镇银行", "abbreviationName": "云南新平北银村镇银行", "code": "YNXPBYCUNZB"}, {
        "value": "云南新平农村商业银行",
        "abbreviationName": "云南新平农商",
        "code": "YNXPRCB"
    }, {"value": "云南寻甸农村商业银行", "abbreviationName": "云南寻甸农商", "code": "YNXDRCB"}, {
        "value": "云南砚山农村商业银行",
        "abbreviationName": "云南砚山农商",
        "code": "YNYSHRCB"
    }, {"value": "云南彝良农村商业银行", "abbreviationName": "云南彝良农商", "code": "YNYILRCB"}, {
        "value": "云南易门农村商业银行",
        "abbreviationName": "云南易门农商",
        "code": "YNYMRCB"
    }, {"value": "云南盈江农村商业银行", "abbreviationName": "云南盈江农商", "code": "YNYJRCB"}, {
        "value": "云南永平农村商业银行",
        "abbreviationName": "云南永平农商",
        "code": "YNYPRCB"
    }, {"value": "云南永胜农村商业银行", "abbreviationName": "云南永胜农商", "code": "YNYSRCB"}, {
        "value": "云南玉龙农村商业银行",
        "abbreviationName": "云南玉龙农商",
        "code": "YNYULRCB"
    }, {"value": "云南玉溪红塔农村商业银行", "abbreviationName": "云南玉溪红塔农商", "code": "YNYXHTRCB"}, {
        "value": "云南元江北银村镇银行",
        "abbreviationName": "云南元江北银村镇银行",
        "code": "YNYJBYCUNZB"
    }, {"value": "云南元谋农村商业银行", "abbreviationName": "云南元谋农商", "code": "YNYUANMRCB"}, {
        "value": "云南元阳农村商业银行",
        "abbreviationName": "云南元阳农商",
        "code": "YNYYRCB"
    }, {"value": "云南云龙农村商业银行", "abbreviationName": "云南云龙农商", "code": "YNYLRCB"}, {
        "value": "云南云县农村商业银行",
        "abbreviationName": "云南云县农商",
        "code": "YNYXRCB"
    }, {"value": "云南昭通昭阳农村商业银行", "abbreviationName": "云南昭通昭阳农商", "code": "YNZTZYRCB"}, {
        "value": "云霄润发村镇银行",
        "abbreviationName": "云霄润发村镇银行",
        "code": "YXRFCUNZB"
    }, {"value": "郧西楚农商村镇银行", "abbreviationName": "郧西楚农商村镇银行", "code": "YXICNSCUNZB"}, {
        "value": "郧县楚农商村镇银行",
        "abbreviationName": "郧县楚农商村镇银行",
        "code": "YXCNSCUNZB"
    }, {"value": "筠连中成村镇银行", "abbreviationName": "筠连中成村镇银行", "code": "ZLZCCUNZB"}, {
        "value": "郓城北海村镇银行",
        "abbreviationName": "郓城北海村镇银行",
        "code": "ZCBHCUNZB"
    }, {"value": "赞皇隆兴村镇银行", "abbreviationName": "赞皇隆兴村镇银行", "code": "ZHLXCUNZB"}, {
        "value": "枣强丰源村镇银行",
        "abbreviationName": "枣强丰源村镇银行",
        "code": "ZQFYCUNZB"
    }, {"value": "枣庄农村商业银行", "abbreviationName": "枣庄农商", "code": "ZZRCB"}, {
        "value": "枣庄银行",
        "abbreviationName": "枣庄",
        "code": "ZAZYH"
    }, {"value": "泽州浦发村镇银行", "abbreviationName": "泽州浦发村镇银行", "code": "ZZPFCUNZB"}, {
        "value": "扎赉特蒙银村镇银行",
        "abbreviationName": "扎赉特蒙银村镇银行",
        "code": "ZZTMYCUNZB"
    }, {"value": "扎兰屯蒙银村镇银行", "abbreviationName": "扎兰屯蒙银村镇银行", "code": "ZLTMYCUNZB"}, {
        "value": "渣打银行（中国）有限责任公司",
        "abbreviationName": "渣打",
        "code": "SCB"
    }, {"value": "湛江廉江长江村镇银行", "abbreviationName": "湛江廉江长江村镇银行", "code": "ZJLJCJCUNZB"}, {
        "value": "湛江农村商业银行",
        "abbreviationName": "湛江农商",
        "code": "ZJRCB"
    }, {"value": "张北信达村镇银行", "abbreviationName": "张北信达村镇银行", "code": "ZBXDCUNZB"}, {
        "value": "张家界农村商业银行",
        "abbreviationName": "张家界农商",
        "code": "ZJJRCB"
    }, {"value": "张家口崇礼邢农商村镇银行", "abbreviationName": "张家口崇礼邢农商村镇银行", "code": "ZJKCLXNSCUNZB"}, {
        "value": "张家口农村商业银行",
        "abbreviationName": "张家口农商",
        "code": "ZJKRCB"
    }, {"value": "张家口万全家银村镇银行", "abbreviationName": "张家口万全家银村镇银行", "code": "ZJKWQJYCUNZB"}, {
        "value": "张家口宣化家银村镇银行",
        "abbreviationName": "张家口宣化家银村镇银行",
        "code": "ZJKXHJYCUNZB"
    }, {"value": "张家口银行", "abbreviationName": "张家口", "code": "ZJKYH"}, {
        "value": "张掖农村商业银行",
        "abbreviationName": "张掖农商",
        "code": "ZYRCB"
    }, {"value": "章丘齐鲁村镇银行", "abbreviationName": "章丘齐鲁村镇银行", "code": "ZQQLCUNZB"}, {
        "value": "彰化商业银行",
        "abbreviationName": "彰化",
        "code": "ZHB"
    }, {"value": "漳浦民生村镇银行", "abbreviationName": "漳浦民生村镇银行", "code": "ZPMSCUNZB"}, {
        "value": "樟树顺银村镇银行",
        "abbreviationName": "樟树顺银村镇银行",
        "code": "ZSSYCUNZB"
    }, {"value": "长安银行", "abbreviationName": "长安", "code": "CAYH"}, {
        "value": "长白山农村商业银行",
        "abbreviationName": "长白山农商",
        "code": "CBSRCB"
    }, {"value": "长白榆银村镇银行", "abbreviationName": "长白榆银村镇银行", "code": "CBYYCUNZB"}, {
        "value": "长城华西银行",
        "abbreviationName": "长城华西",
        "code": "GWB"
    }, {"value": "长春朝阳和润村镇银行", "abbreviationName": "长春朝阳和润村镇银行", "code": "CCCYHRCUNZB"}, {
        "value": "长春二道农商村镇银行",
        "abbreviationName": "长春二道农商村镇银行",
        "code": "CCEDNSCUNZB"
    }, {"value": "长春发展农村商业银行", "abbreviationName": "长春发展农商", "code": "CCFZRCB"}, {
        "value": "长春高新惠民村镇银行",
        "abbreviationName": "长春高新惠民村镇银行",
        "code": "CCGXHMCUNZB"
    }, {"value": "长春经开融丰村镇银行", "abbreviationName": "长春经开融丰村镇银行", "code": "CCJKRFCUNZB"}, {
        "value": "长春净月榆银村镇银行",
        "abbreviationName": "长春净月榆银村镇银行",
        "code": "CCJYYYCUNZB"
    }, {"value": "长春宽城融汇村镇银行", "abbreviationName": "长春宽城融汇村镇银行", "code": "CCKCRHCUNZB"}, {
        "value": "长春绿园融泰村镇银行",
        "abbreviationName": "长春绿园融泰村镇银行",
        "code": "CCLYRTCUNZB"
    }, {"value": "长春南关惠民村镇银行", "abbreviationName": "长春南关惠民村镇银行", "code": "CCNGHMCUNZB"}, {
        "value": "长春农村商业银行",
        "abbreviationName": "长春农商",
        "code": "CCRCB"
    }, {"value": "长春双阳吉银村镇银行", "abbreviationName": "长春双阳吉银村镇银行", "code": "CCSYJYCUNZB"}, {
        "value": "长葛轩辕村镇银行",
        "abbreviationName": "长葛轩辕村镇银行",
        "code": "CGXYCUNZB"
    }, {"value": "长岭蛟银村镇银行", "abbreviationName": "长岭蛟银村镇银行", "code": "CLZYCUNZB"}, {
        "value": "长宁中成村镇银行",
        "abbreviationName": "长宁中成村镇银行",
        "code": "CNZCCUNZB"
    }, {"value": "长沙农村商业银行", "abbreviationName": "长沙农商", "code": "CSHARCB"}, {
        "value": "长沙星沙沪农商村镇银行",
        "abbreviationName": "长沙星沙沪农商村镇银行",
        "code": "CSXSHNSCUNZB"
    }, {"value": "长沙银行", "abbreviationName": "长沙", "code": "CSCB"}, {
        "value": "长顺富民村镇银行",
        "abbreviationName": "长顺富民村镇银行",
        "code": "CSFMCUNZB"
    }, {"value": "长汀汀州红村镇银行", "abbreviationName": "长汀汀州红村镇银行", "code": "CTTZHCUNZB"}, {
        "value": "长垣民生村镇银行",
        "abbreviationName": "长垣民生村镇银行",
        "code": "CYMSCUNZB"
    }, {"value": "长治潞州农村商业银行", "abbreviationName": "长治潞州农商", "code": "CZLZRCB"}, {
        "value": "长治市上党区泰都村镇银行",
        "abbreviationName": "长治市上党区泰都村镇银行",
        "code": "CZXTDCUNZB"
    }, {"value": "长治银行", "abbreviationName": "长治", "code": "CHANGZYH"}, {
        "value": "长治漳泽农村商业银行",
        "abbreviationName": "长治漳泽农商",
        "code": "CZZZRCB"
    }, {"value": "长子县融汇村镇银行", "abbreviationName": "长子县融汇村镇银行", "code": "CZRHCUNZB"}, {
        "value": "招商银行",
        "abbreviationName": "招行",
        "code": "CMBCHINA"
    }, {"value": "昭通昭阳富滇村镇银行", "abbreviationName": "昭通昭阳富滇村镇银行", "code": "ZTZYFDCUNZB"}, {
        "value": "兆丰国际商业银行",
        "abbreviationName": "兆丰国际",
        "code": "ZFGJB"
    }, {"value": "肇庆农村商业银行", "abbreviationName": "肇庆农商", "code": "ZQRCB"}, {
        "value": "柘城黄淮村镇银行",
        "abbreviationName": "柘城黄淮村镇银行",
        "code": "ZCHHCUNZB"
    }, {"value": "柘荣刺桐红村镇银行", "abbreviationName": "柘荣刺桐红村镇银行", "code": "ZRCTHCUNZB"}, {
        "value": "浙江安吉交银村镇银行",
        "abbreviationName": "浙江安吉交银村镇银行",
        "code": "ZJAJJYCUNZB"
    }, {"value": "浙江安吉农村商业银行", "abbreviationName": "浙江安吉农商", "code": "ZJAJRCB"}, {
        "value": "浙江苍南农村商业银行",
        "abbreviationName": "浙江苍南农商",
        "code": "ZJCNRCB"
    }, {"value": "浙江常山联合村镇银行", "abbreviationName": "浙江常山联合村镇银行", "code": "ZJCSLHCUNZB"}, {
        "value": "浙江常山农村商业银行",
        "abbreviationName": "浙江常山农商",
        "code": "ZJCSRCB"
    }, {"value": "浙江稠州商业银行", "abbreviationName": "浙江稠州", "code": "CZCB"}, {
        "value": "浙江淳安农村商业银行",
        "abbreviationName": "浙江淳安农商",
        "code": "ZJCARCB"
    }, {"value": "浙江岱山稠州村镇银行", "abbreviationName": "浙江岱山稠州村镇银行", "code": "ZJZSCZCUNZB"}, {
        "value": "浙江岱山农村商业银行",
        "abbreviationName": "浙江岱山农商",
        "code": "ZJDSRCB"
    }, {"value": "浙江德清湖商村镇银行", "abbreviationName": "浙江德清湖商村镇银行", "code": "ZJDQHSCUNZB"}, {
        "value": "浙江德清农村商业银行",
        "abbreviationName": "浙江德清农商",
        "code": "ZJDQRCB"
    }, {"value": "浙江定海德商村镇银行", "abbreviationName": "浙江定海德商村镇银行", "code": "ZJDHDSCUNZB"}, {
        "value": "浙江东阳富民村镇银行",
        "abbreviationName": "浙江东阳富民村镇银行",
        "code": "ZJDYFMCUNZB"
    }, {"value": "浙江东阳农村商业银行", "abbreviationName": "浙江东阳农商", "code": "ZJDYRCB"}, {
        "value": "浙江洞头富民村镇银行",
        "abbreviationName": "浙江洞头富民村镇银行",
        "code": "ZJDTFMCUNZB"
    }, {"value": "浙江富阳恒通村镇银行", "abbreviationName": "浙江富阳恒通村镇银行", "code": "ZJFYHTCUNZB"}, {
        "value": "浙江富阳农村商业银行",
        "abbreviationName": "浙江富阳农商",
        "code": "ZJFYRCB"
    }, {"value": "浙江海宁德商村镇银行", "abbreviationName": "浙江海宁德商村镇银行", "code": "ZJHNDSCUNZB"}, {
        "value": "浙江海宁农村商业银行",
        "abbreviationName": "浙江海宁农商",
        "code": "ZJHNRCB"
    }, {"value": "浙江海盐湖商村镇银行", "abbreviationName": "浙江海盐湖商村镇银行", "code": "ZJHYHSCUNZB"}, {
        "value": "浙江海盐农村商业银行",
        "abbreviationName": "浙江海盐农商",
        "code": "ZJHYRCB"
    }, {"value": "浙江杭州余杭农村商业银行", "abbreviationName": "浙江杭州余杭农商", "code": "HZYHRCB"}, {
        "value": "浙江禾城农村商业银行",
        "abbreviationName": "浙江禾城农商",
        "code": "ZJHCRCB"
    }, {"value": "浙江嘉善联合村镇银行", "abbreviationName": "浙江嘉善联合村镇银行", "code": "ZJJSLHCUNZB"}, {
        "value": "浙江嘉善农村商业银行",
        "abbreviationName": "浙江嘉善农商",
        "code": "ZJJIASRCB"
    }, {"value": "浙江建德湖商村镇银行", "abbreviationName": "浙江建德湖商村镇银行", "code": "ZJJDHSCUNZB"}, {
        "value": "浙江建德农村商业银行",
        "abbreviationName": "浙江建德农商",
        "code": "ZJJDRCB"
    }, {"value": "浙江江山农村商业银行", "abbreviationName": "浙江江山农商", "code": "ZJJSRCB"}, {
        "value": "浙江金华成泰农村商业银行",
        "abbreviationName": "浙江金华成泰农商",
        "code": "ZJJHCTRCB"
    }, {"value": "浙江缙云联合村镇银行", "abbreviationName": "浙江缙云联合村镇银行", "code": "ZJZYLHCUNZB"}, {
        "value": "浙江缙云农村商业银行",
        "abbreviationName": "浙江缙云农商",
        "code": "ZJJYRCB"
    }, {"value": "浙江景宁农村商业银行", "abbreviationName": "浙江景宁农商", "code": "ZJJNRCB"}, {
        "value": "浙江景宁银座村镇银行",
        "abbreviationName": "浙江景宁银座村镇银行",
        "code": "JNYZCUNZB"
    }, {"value": "浙江开化农村商业银行", "abbreviationName": "浙江开化农商", "code": "ZJKHRCB"}, {
        "value": "浙江柯桥联合村镇银行",
        "abbreviationName": "浙江柯桥联合村镇银行",
        "code": "ZJKQLHCUNZB"
    }, {"value": "浙江兰溪农村商业银行", "abbreviationName": "浙江兰溪农商", "code": "ZJLXRCB"}, {
        "value": "浙江兰溪越商村镇银行",
        "abbreviationName": "浙江兰溪越商村镇银行",
        "code": "ZJLXYSCUNZB"
    }, {"value": "浙江乐清联合村镇银行", "abbreviationName": "浙江乐清联合村镇银行", "code": "ZJLQLHCUNZB"}, {
        "value": "浙江乐清农村商业银行",
        "abbreviationName": "浙江乐清农商",
        "code": "ZJLQRCB"
    }, {"value": "浙江丽水莲都农村商业银行", "abbreviationName": "浙江丽水莲都农商", "code": "ZJLSLDRCB"}, {
        "value": "浙江临安农村商业银行",
        "abbreviationName": "浙江临安农商",
        "code": "ZJLARCB"
    }, {"value": "浙江临安中信村镇银行", "abbreviationName": "浙江临安中信村镇银行", "code": "ZJLAZXCUNZB"}, {
        "value": "浙江临海湖商村镇银行",
        "abbreviationName": "浙江临海湖商村镇银行",
        "code": "ZJLHHSCUNZB"
    }, {"value": "浙江临海农村商业银行", "abbreviationName": "浙江临海农商", "code": "ZJLHRCB"}, {
        "value": "浙江龙港农村商业银行",
        "abbreviationName": "浙江龙港农商",
        "code": "ZJLGRCB"
    }, {"value": "浙江龙泉民泰村镇银行", "abbreviationName": "浙江龙泉民泰村镇银行", "code": "ZJLQMTCUNZB"}, {
        "value": "浙江龙泉农村商业银行",
        "abbreviationName": "浙江龙泉农商",
        "code": "ZJLQUANRCB"
    }, {"value": "浙江龙游农村商业银行", "abbreviationName": "浙江龙游农商", "code": "ZJLYRCB"}, {
        "value": "浙江龙游义商村镇银行",
        "abbreviationName": "浙江龙游义商村镇银行",
        "code": "ZJLYYSCUNZB"
    }, {"value": "浙江民泰商业银行", "abbreviationName": "民泰", "code": "MINTAIBANK"}, {
        "value": "浙江南浔农村商业银行",
        "abbreviationName": "浙江南浔农商",
        "code": "ZJNXRCB"
    }, {"value": "浙江磐安农村商业银行", "abbreviationName": "浙江磐安农商", "code": "ZJPARCB"}, {
        "value": "浙江磐安婺商村镇银行",
        "abbreviationName": "浙江磐安婺商村镇银行",
        "code": "ZJPAZSCUNZB"
    }, {"value": "浙江平湖工银村镇银行", "abbreviationName": "浙江平湖工银村镇银行", "code": "ZJPHGYCUNZB"}, {
        "value": "浙江平湖农村商业银行",
        "abbreviationName": "浙江平湖农商",
        "code": "ZJPHRCB"
    }, {"value": "浙江平阳农村商业银行", "abbreviationName": "浙江平阳农商", "code": "ZJPYRCB"}, {
        "value": "浙江平阳浦发村镇银行",
        "abbreviationName": "浙江平阳浦发村镇银行",
        "code": "ZJPYPFCUNZB"
    }, {"value": "浙江浦江嘉银村镇银行", "abbreviationName": "浙江浦江嘉银村镇银行", "code": "ZJPJJYCUNZB"}, {
        "value": "浙江浦江农村商业银行",
        "abbreviationName": "浙江浦江农商",
        "code": "ZJPJRCB"
    }, {"value": "浙江青田农村商业银行", "abbreviationName": "浙江青田农商", "code": "ZJQTRCB"}, {
        "value": "浙江庆元农村商业银行",
        "abbreviationName": "浙江庆元农商",
        "code": "ZJQYRCB"
    }, {"value": "浙江庆元泰隆村镇银行", "abbreviationName": "浙江庆元泰隆村镇银行", "code": "ZJQYTLCUNZB"}, {
        "value": "浙江衢州柯城农村商业银行",
        "abbreviationName": "浙江衢州柯城农商",
        "code": "ZJQZKCRCB"
    }, {"value": "浙江衢州衢江农村商业银行", "abbreviationName": "浙江衢州衢江农商", "code": "ZJQZQJRCB"}, {
        "value": "浙江衢州衢江上银村镇银行",
        "abbreviationName": "浙江衢州衢江上银村镇银行",
        "code": "ZJZZZJSYCUNZB"
    }, {"value": "浙江瑞安湖商村镇银行", "abbreviationName": "浙江瑞安湖商村镇银行", "code": "ZJRAHSCUNZB"}, {
        "value": "浙江瑞安农村商业银行",
        "abbreviationName": "浙江瑞安农商",
        "code": "ZJRARCB"
    }, {"value": "浙江三门农村商业银行", "abbreviationName": "浙江三门农商", "code": "ZJSMRCB"}, {
        "value": "浙江三门银座村镇银行",
        "abbreviationName": "浙江三门银座村镇银行",
        "code": "SMYZCUNZB"
    }, {"value": "浙江上虞富民村镇银行", "abbreviationName": "浙江上虞富民村镇银行", "code": "ZJSYFMCUNZB"}, {
        "value": "浙江上虞农村商业银行",
        "abbreviationName": "浙江上虞农商",
        "code": "ZJSYRCB"
    }, {"value": "浙江绍兴恒信农村商业银行", "abbreviationName": "浙江绍兴恒信农商", "code": "ZJSXHXRCB"}, {
        "value": "浙江绍兴瑞丰农村商业银行",
        "abbreviationName": "浙江绍兴瑞丰农商",
        "code": "ZJSXRFRCB"
    }, {"value": "浙江省农村信用社联合社", "abbreviationName": "浙江农信社", "code": "ZJNXS"}, {
        "value": "浙江嵊泗农村商业银行",
        "abbreviationName": "浙江嵊泗农商",
        "code": "ZJSSRCB"
    }, {"value": "浙江嵊州农村商业银行", "abbreviationName": "浙江嵊州农商", "code": "ZJSZRCB"}, {
        "value": "浙江嵊州瑞丰村镇银行",
        "abbreviationName": "浙江嵊州瑞丰村镇银行",
        "code": "ZJSZRFCUNZB"
    }, {"value": "浙江松阳恒通村镇银行", "abbreviationName": "浙江松阳恒通村镇银行", "code": "ZJSYHTCUNZB"}, {
        "value": "浙江松阳农村商业银行",
        "abbreviationName": "浙江松阳农商",
        "code": "ZJSONGYRCB"
    }, {"value": "浙江遂昌富民村镇银行", "abbreviationName": "浙江遂昌富民村镇银行", "code": "ZJSCFMCUNZB"}, {
        "value": "浙江遂昌农村商业银行",
        "abbreviationName": "浙江遂昌农商",
        "code": "ZJSCRCB"
    }, {"value": "浙江台州黄岩恒升村镇银行", "abbreviationName": "浙江台州黄岩恒升村镇银行", "code": "ZJTZHYHSCUNZB"}, {
        "value": "浙江台州黄岩农村商业银行",
        "abbreviationName": "浙江台州黄岩农商",
        "code": "ZJTZHYRCB"
    }, {"value": "浙江台州椒江农村商业银行", "abbreviationName": "浙江台州椒江农商", "code": "ZJTZJJRCB"}, {
        "value": "浙江台州路桥富民村镇银行",
        "abbreviationName": "浙江台州路桥富民村镇银行",
        "code": "ZJTZLQFMCUNZB"
    }, {"value": "浙江台州路桥农村商业银行", "abbreviationName": "浙江台州路桥农商", "code": "ZJTZLQRCB"}, {
        "value": "浙江泰隆商业银行",
        "abbreviationName": "泰隆",
        "code": "ZJTLCCB"
    }, {"value": "浙江泰顺农村商业银行", "abbreviationName": "浙江泰顺农商", "code": "ZJTSRCB"}, {
        "value": "浙江泰顺温银村镇银行",
        "abbreviationName": "浙江泰顺温银村镇银行",
        "code": "ZJTSWYCUNZB"
    }, {"value": "浙江天台民生村镇银行", "abbreviationName": "浙江天台民生村镇银行", "code": "ZJTTMSCUNZB"}, {
        "value": "浙江天台农村商业银行",
        "abbreviationName": "浙江天台农商",
        "code": "ZJTTRCB"
    }, {"value": "浙江桐庐恒丰村镇银行", "abbreviationName": "浙江桐庐恒丰村镇银行", "code": "ZJTLHFCUNZB"}, {
        "value": "浙江桐庐农村商业银行",
        "abbreviationName": "浙江桐庐农商",
        "code": "ZJTLRCB"
    }, {"value": "浙江桐乡民泰村镇银行", "abbreviationName": "浙江桐乡民泰村镇银行", "code": "ZJTXMTCUNZB"}, {
        "value": "浙江桐乡农村商业银行",
        "abbreviationName": "浙江桐乡农商",
        "code": "ZJTXRCB"
    }, {"value": "浙江网商银行股份有限公司", "abbreviationName": "网商", "code": "ZJWS"}, {
        "value": "浙江温岭联合村镇银行",
        "abbreviationName": "浙江温岭联合村镇银行",
        "code": "ZJWLLHCUNZB"
    }, {"value": "浙江温岭农村商业银行", "abbreviationName": "浙江温岭农商", "code": "ZJWLRCB"}, {
        "value": "浙江温州洞头农村商业银行",
        "abbreviationName": "浙江温州洞头农商",
        "code": "ZJWZDTRCB"
    }, {"value": "浙江温州龙湾农村商业银行", "abbreviationName": "浙江温州龙湾农商", "code": "ZJWZLWRCB"}, {
        "value": "浙江温州鹿城农村商业银行",
        "abbreviationName": "浙江温州鹿城农商",
        "code": "ZJWZLCRCB"
    }, {"value": "浙江温州瓯海农村商业银行", "abbreviationName": "浙江温州瓯海农商", "code": "ZJWZOHRCB"}, {
        "value": "浙江文成北银村镇银行",
        "abbreviationName": "浙江文成北银村镇银行",
        "code": "ZJWCBYCUNZB"
    }, {"value": "浙江文成农村商业银行", "abbreviationName": "浙江文成农商", "code": "ZJWCRCB"}, {
        "value": "浙江武义农村商业银行",
        "abbreviationName": "浙江武义农商",
        "code": "ZJWYRCB"
    }, {"value": "浙江仙居富民村镇银行", "abbreviationName": "浙江仙居富民村镇银行", "code": "ZJXJFMCUNZB"}, {
        "value": "浙江仙居农村商业银行",
        "abbreviationName": "浙江仙居农商",
        "code": "ZJXJRCB"
    }, {"value": "浙江萧山湖商村镇银行", "abbreviationName": "浙江萧山湖商村镇银行", "code": "ZJXSHSCUNZB"}, {
        "value": "浙江萧山农村商业银行",
        "abbreviationName": "浙江萧山农商",
        "code": "ZJXSRCB"
    }, {"value": "浙江新昌农村商业银行", "abbreviationName": "浙江新昌农商", "code": "ZJXCRCB"}, {
        "value": "浙江新昌浦发村镇银行",
        "abbreviationName": "浙江新昌浦发村镇银行",
        "code": "ZJXCPFCUNZB"
    }, {"value": "浙江秀洲德商村镇银行", "abbreviationName": "浙江秀洲德商村镇银行", "code": "ZJXZDSCUNZB"}, {
        "value": "浙江义乌联合村镇银行",
        "abbreviationName": "浙江义乌联合村镇银行",
        "code": "ZJYWLHCUNZB"
    }, {"value": "浙江义乌农村商业银行", "abbreviationName": "浙江义乌农商", "code": "ZJYWRCB"}, {
        "value": "浙江永嘉恒升村镇银行",
        "abbreviationName": "浙江永嘉恒升村镇银行",
        "code": "ZJYJHSCUNZB"
    }, {"value": "浙江永嘉农村商业银行", "abbreviationName": "浙江永嘉农商", "code": "ZJYJRCB"}, {
        "value": "浙江永康农村商业银行",
        "abbreviationName": "浙江永康农商",
        "code": "ZJYKRCB"
    }, {"value": "浙江永康农银村镇银行", "abbreviationName": "浙江永康农银村镇银行", "code": "ZJYKNYCUNZB"}, {
        "value": "浙江余杭德商村镇银行",
        "abbreviationName": "浙江余杭德商村镇银行",
        "code": "ZJYHDSCUNZB"
    }, {"value": "浙江玉环农村商业银行", "abbreviationName": "浙江玉环农商", "code": "ZJYHRCB"}, {
        "value": "浙江玉环永兴村镇银行",
        "abbreviationName": "浙江玉环永兴村镇银行",
        "code": "ZJYHYXCUNZB"
    }, {"value": "浙江云和联合村镇银行", "abbreviationName": "浙江云和联合村镇银行", "code": "ZJYHLHCUNZB"}, {
        "value": "浙江云和农村商业银行",
        "abbreviationName": "浙江云和农商",
        "code": "ZJYHERCB"
    }, {"value": "浙江长兴联合村镇银行", "abbreviationName": "浙江长兴联合村镇银行", "code": "ZJCXLHCUNZB"}, {
        "value": "浙江长兴农村商业银行",
        "abbreviationName": "浙江长兴农商",
        "code": "ZJCXRCB"
    }, {"value": "浙江舟山定海海洋农村商业银行", "abbreviationName": "浙江舟山定海海洋农商", "code": "ZJZSDHHYRCB"}, {
        "value": "浙江舟山普陀稠州村镇银行",
        "abbreviationName": "浙江舟山普陀稠州村镇银行",
        "code": "ZJZSPTCZCUNZB"
    }, {"value": "浙江舟山普陀农村商业银行", "abbreviationName": "浙江舟山普陀农商", "code": "ZJZSPTRCB"}, {
        "value": "浙江诸暨联合村镇银行",
        "abbreviationName": "浙江诸暨联合村镇银行",
        "code": "ZJZZLHCUNZB"
    }, {"value": "浙江诸暨农村商业银行", "abbreviationName": "浙江诸暨农商", "code": "ZJZJRCB"}, {
        "value": "浙商银行",
        "abbreviationName": "浙商",
        "code": "CZ"
    }, {"value": "贞丰兴贞村镇银行", "abbreviationName": "贞丰兴贞村镇银行", "code": "ZFXZCUNZB"}, {
        "value": "镇江润州长江村镇银行",
        "abbreviationName": "镇江润州长江村镇银行",
        "code": "ZJRZCJCUNZB"
    }, {"value": "镇宁汇商村镇银行", "abbreviationName": "镇宁汇商村镇银行", "code": "ZNHSCUNZB"}, {
        "value": "正定恒升村镇银行",
        "abbreviationName": "正定恒升村镇银行",
        "code": "ZDHSCUNZB"
    }, {"value": "正蓝旗汇泽村镇银行", "abbreviationName": "正蓝旗汇泽村镇银行", "code": "ZLQHZCUNZB"}, {
        "value": "正阳玉川村镇银行",
        "abbreviationName": "正阳玉川村镇银行",
        "code": "ZYYCCUNZB"
    }, {"value": "郑州金水厦农商村镇银行", "abbreviationName": "郑州金水厦农商村镇银行", "code": "ZZJSSNSCUNZB"}, {
        "value": "郑州农村商业银行",
        "abbreviationName": "郑州农商",
        "code": "ZHENGZRCB"
    }, {"value": "郑州银行", "abbreviationName": "郑州", "code": "ZHENGZYH"}, {
        "value": "郑州珠江村镇银行",
        "abbreviationName": "郑州珠江村镇银行",
        "code": "ZZZJCUNZB"
    }, {"value": "枝江汉银村镇银行", "abbreviationName": "枝江汉银村镇银行", "code": "ZJHYCUNZB"}, {
        "value": "织金惠民村镇银行",
        "abbreviationName": "织金惠民村镇银行",
        "code": "ZJHMCUNZB"
    }, {"value": "志丹民生村镇银行", "abbreviationName": "志丹民生村镇银行", "code": "ZDMSCUNZB"}, {
        "value": "中德住房储蓄银行有限责任公司",
        "abbreviationName": "中德住房储蓄",
        "code": "SGB"
    }, {"value": "中国工商银行", "abbreviationName": "工行", "code": "ICBC"}, {
        "value": "中国光大银行",
        "abbreviationName": "光大",
        "code": "CEB"
    }, {"value": "中国建设银行", "abbreviationName": "建行", "code": "CCB"}, {
        "value": "中国进出口银行",
        "abbreviationName": "进出口",
        "code": "EXIMBANK"
    }, {"value": "中国民生银行", "abbreviationName": "民生", "code": "CMBC"}, {
        "value": "中国农业发展银行",
        "abbreviationName": "农发",
        "code": "NYFZYH"
    }, {"value": "中国农业银行", "abbreviationName": "农行", "code": "ABC"}, {
        "value": "中国信托商业银行",
        "abbreviationName": "中国信托商业银行",
        "code": "CTBCBANK"
    }, {"value": "中国银行", "abbreviationName": "中行", "code": "BOC"}, {
        "value": "中国邮政储蓄银行",
        "abbreviationName": "邮储",
        "code": "PSBC"
    }, {"value": "中江融兴村镇银行", "abbreviationName": "中江融兴村镇银行", "code": "ZJRXCUNZB"}, {
        "value": "中牟郑银村镇银行",
        "abbreviationName": "中牟郑银村镇银行",
        "code": "ZMZYCUNZB"
    }, {"value": "中山东凤珠江村镇银行", "abbreviationName": "中山东凤珠江村镇银行", "code": "ZSDFZJCUNZB"}, {
        "value": "中山古镇南粤村镇银行",
        "abbreviationName": "中山古镇南粤村镇银行",
        "code": "ZSGZNYCUNZB"
    }, {"value": "中山农村商业银行", "abbreviationName": "中山农商", "code": "ZSRCB"}, {
        "value": "中山小榄村镇银行",
        "abbreviationName": "中山小榄村镇银行",
        "code": "ZSXZCUNZB"
    }, {"value": "中卫香山村镇银行", "abbreviationName": "中卫香山村镇银行", "code": "ZWXSCUNZB"}, {
        "value": "中信百信银行",
        "abbreviationName": "中信百信",
        "code": "HXBXB"
    }, {"value": "中信银行", "abbreviationName": "中信", "code": "ECITIC"}, {
        "value": "中阳县太行村镇银行",
        "abbreviationName": "中阳县太行村镇银行",
        "code": "ZYXTXCUNZB"
    }, {"value": "中银富登村镇银行", "abbreviationName": "中银富登村镇银行", "code": "ZYFDCUNZB"}, {
        "value": "中原银行",
        "abbreviationName": "中原",
        "code": "ZYYH"
    }, {"value": "钟祥民生村镇银行", "abbreviationName": "钟祥民生村镇银行", "code": "ZXMSCUNZB"}, {
        "value": "重庆巴南浦发村镇银行",
        "abbreviationName": "重庆巴南浦发村镇银行",
        "code": "ZQBNPFCUNZB"
    }, {"value": "重庆北碚稠州村镇银行", "abbreviationName": "重庆北碚稠州村镇银行", "code": "ZQBZCZCUNZB"}, {
        "value": "重庆璧山工银村镇银行",
        "abbreviationName": "重庆璧山工银村镇银行",
        "code": "ZQZSGYCUNZB"
    }, {"value": "重庆大足汇丰村镇银行", "abbreviationName": "重庆大足汇丰村镇银行", "code": "ZQDZHFCUNZB"}, {
        "value": "重庆丰都汇丰村镇银行",
        "abbreviationName": "重庆丰都汇丰村镇银行",
        "code": "ZQFDHFCUNZB"
    }, {"value": "重庆富民银行", "abbreviationName": "重庆富民", "code": "CQFMYH"}, {
        "value": "重庆江北恒丰村镇银行",
        "abbreviationName": "重庆江北恒丰村镇银行",
        "code": "ZQJBHFCUNZB"
    }, {"value": "重庆江津石银村镇银行", "abbreviationName": "重庆江津石银村镇银行", "code": "ZQJJSYCUNZB"}, {
        "value": "重庆九龙坡民泰村镇银行",
        "abbreviationName": "重庆九龙坡民泰村镇银行",
        "code": "ZQJLPMTCUNZB"
    }, {"value": "重庆开州泰业村镇银行", "abbreviationName": "重庆开州泰业村镇银行", "code": "KXTYCUNZB"}, {
        "value": "重庆梁平澳新村镇银行",
        "abbreviationName": "重庆梁平澳新村镇银行",
        "code": "ZQLPAXCUNZB"
    }, {"value": "重庆南川石银村镇银行", "abbreviationName": "重庆南川石银村镇银行", "code": "ZQNCSYCUNZB"}, {
        "value": "重庆农村商业银行",
        "abbreviationName": "重庆农商",
        "code": "CQRCB"
    }, {"value": "重庆彭水民泰村镇银行", "abbreviationName": "重庆彭水民泰村镇银行", "code": "ZQPSMTCUNZB"}, {
        "value": "重庆黔江银座村镇银行",
        "abbreviationName": "重庆黔江银座村镇银行",
        "code": "QJYZCUNZB"
    }, {"value": "重庆荣昌汇丰村镇银行", "abbreviationName": "重庆荣昌汇丰村镇银行", "code": "ZQRCHFCUNZB"}, {
        "value": "重庆三峡银行",
        "abbreviationName": "重庆三峡",
        "code": "CQSXYH"
    }, {"value": "重庆市大渡口融兴村镇银行", "abbreviationName": "重庆市大渡口融兴村镇银行", "code": "ZQSDDKRXCUNZB"}, {
        "value": "重庆市沙坪坝融兴村镇银行",
        "abbreviationName": "重庆市沙坪坝融兴村镇银行",
        "code": "ZQSSPBRXCUNZB"
    }, {"value": "重庆市酉阳融兴村镇银行", "abbreviationName": "重庆市酉阳融兴村镇银行", "code": "ZQSYYRXCUNZB"}, {
        "value": "重庆铜梁浦发村镇银行",
        "abbreviationName": "重庆铜梁浦发村镇银行",
        "code": "ZQTLPFCUNZB"
    }, {"value": "重庆秀山北银村镇银行", "abbreviationName": "重庆秀山北银村镇银行", "code": "ZQXSBYCUNZB"}, {
        "value": "重庆银行",
        "abbreviationName": "重庆",
        "code": "CQYH"
    }, {"value": "重庆永川北银村镇银行", "abbreviationName": "重庆永川北银村镇银行", "code": "ZQYCBYCUNZB"}, {
        "value": "重庆渝北银座村镇银行",
        "abbreviationName": "重庆渝北银座村镇银行",
        "code": "YBYZCUNZB"
    }, {"value": "重庆云阳恒丰村镇银行", "abbreviationName": "重庆云阳恒丰村镇银行", "code": "ZQYYHFCUNZB"}, {
        "value": "重庆忠县稠州村镇银行",
        "abbreviationName": "重庆忠县稠州村镇银行",
        "code": "ZQZXCZCUNZB"
    }, {"value": "周口农村商业银行", "abbreviationName": "周口农商", "code": "ZKRCB"}, {
        "value": "周宁刺桐红村镇银行",
        "abbreviationName": "周宁刺桐红村镇银行",
        "code": "ZNCTHCUNZB"
    }, {"value": "珠海横琴村镇银行", "abbreviationName": "珠海横琴村镇银行", "code": "ZHHQCUNZB"}, {
        "value": "珠海华润银行",
        "abbreviationName": "珠海华润",
        "code": "ZHCCB"
    }, {"value": "珠海南屏村镇银行", "abbreviationName": "珠海南屏村镇银行", "code": "ZHNPCUNZB"}, {
        "value": "珠海农村商业银行",
        "abbreviationName": "珠海农商",
        "code": "ZHRCB"
    }, {"value": "株洲农村商业银行", "abbreviationName": "株洲农商", "code": "ZHUZRCB"}, {
        "value": "株洲县融兴村镇银行",
        "abbreviationName": "株洲县融兴村镇银行",
        "code": "ZZXRXCUNZB"
    }, {"value": "竹山楚农商村镇银行", "abbreviationName": "竹山楚农商村镇银行", "code": "ZSCNSCUNZB"}, {
        "value": "竹溪楚农商村镇银行",
        "abbreviationName": "竹溪楚农商村镇银行",
        "code": "ZXCNSCUNZB"
    }, {"value": "驻马店农村商业银行", "abbreviationName": "驻马店农商", "code": "ZMDRCB"}, {
        "value": "庄河汇通村镇银行",
        "abbreviationName": "庄河汇通村镇银行",
        "code": "ZHHTCUNZB"
    }, {"value": "准格尔旗蒙商村镇银行", "abbreviationName": "准格尔旗蒙商村镇银行", "code": "ZGEQBSCUNZB"}, {
        "value": "涿鹿利丰村镇银行",
        "abbreviationName": "涿鹿利丰村镇银行",
        "code": "ZLLFCUNZB"
    }, {"value": "涿州中成村镇银行", "abbreviationName": "涿州中成村镇银行", "code": "ZZZCCUNZB"}, {
        "value": "卓资蒙银村镇银行",
        "abbreviationName": "卓资蒙银村镇银行",
        "code": "ZZMYCUNZB"
    }, {"value": "资溪九银村镇银行", "abbreviationName": "资溪九银村镇银行", "code": "ZXJYCUNZB"}, {
        "value": "资兴浦发村镇银行",
        "abbreviationName": "资兴浦发村镇银行",
        "code": "ZXPFCUNZB"
    }, {"value": "资阳民生村镇银行", "abbreviationName": "资阳民生村镇银行", "code": "ZYMSCUNZB"}, {
        "value": "资阳农村商业银行",
        "abbreviationName": "资阳农商",
        "code": "ZIYRCB"
    }, {"value": "淄博博山北海村镇银行", "abbreviationName": "淄博博山北海村镇银行", "code": "ZBBSBHCUNZB"}, {
        "value": "淄博博山农村商业银行",
        "abbreviationName": "淄博博山农商",
        "code": "ZBBSRCB"
    }, {"value": "淄博淄川北海村镇银行", "abbreviationName": "淄博淄川北海村镇银行", "code": "ZBZCBHCUNZB"}, {
        "value": "淄博淄川农村商业银行",
        "abbreviationName": "淄博淄川农商",
        "code": "ZBZCRCB"
    }, {"value": "紫云富民村镇银行", "abbreviationName": "紫云富民村镇银行", "code": "ZYFMCUNZB"}, {
        "value": "自贡农村商业银行",
        "abbreviationName": "自贡农商",
        "code": "ZGRCB"
    }, {"value": "自贡银行股份有限公司", "abbreviationName": "自贡", "code": "ZGCCB"}, {
        "value": "自贡中成村镇银行",
        "abbreviationName": "自贡中成村镇银行",
        "code": "ZGZCCUNZB"
    }, {"value": "邹平浦发村镇银行", "abbreviationName": "邹平浦发村镇银行", "code": "ZPPFCUNZB"}, {
        "value": "遵化融和村镇银行",
        "abbreviationName": "遵化融和村镇银行",
        "code": "ZHRHCUNZB"
    }, {"value": "遵义播州汇隆村镇银行", "abbreviationName": "遵义播州汇隆村镇银行", "code": "ZYBZHLCUNZB"}, {
        "value": "遵义红花岗富民村镇银行",
        "abbreviationName": "遵义红花岗富民村镇银行",
        "code": "ZYHHGFMCUNZB"
    }, {"value": "遵义汇川黔兴村镇银行", "abbreviationName": "遵义汇川黔兴村镇银行", "code": "ZYHCQXCUNZB"}, {
        "value": "遵义市商业银行",
        "abbreviationName": "遵义",
        "code": "ZYCCB"
    }, {"value": "遵义新蒲长征村镇银行", "abbreviationName": "遵义新蒲长征村镇银行", "code": "ZYXPCZCUNZB"}, {
        "value": "左云县长青村镇银行",
        "abbreviationName": "左云县长青村镇银行",
        "code": "ZYXCQCUNZB"
    }]



// WEBPACK FOOTER //
// ./src/utils/bankData.js